webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	__webpack_require__(182);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(11);
	var react_router_1 = __webpack_require__(241);
	var Analytics_1 = __webpack_require__(972);
	var App_1 = __webpack_require__(973);
	var Approval_1 = __webpack_require__(974);
	var DeviceTest_1 = __webpack_require__(976);
	var ErrorComponent_1 = __webpack_require__(977);
	var GlanceDraftRedirect_1 = __webpack_require__(1005);
	var GlanceDrafts_1 = __webpack_require__(1006);
	var GlanceStudioApp_1 = __webpack_require__(981);
	var InternalApprovalGlances_1 = __webpack_require__(984);
	var LoginComponent_1 = __webpack_require__(985);
	var Logout_1 = __webpack_require__(986);
	var ModeratorGlances_1 = __webpack_require__(987);
	var Notification_1 = __webpack_require__(988);
	var PartnerGlances_1 = __webpack_require__(989);
	var PeekView_1 = __webpack_require__(990);
	var react_redux_1 = __webpack_require__(24);
	var Publishers_1 = __webpack_require__(992);
	var ResetPassword_1 = __webpack_require__(993);
	var segmentQuery_1 = __webpack_require__(1017);
	var Segments_1 = __webpack_require__(995);
	var UploadCsv_1 = __webpack_require__(996);
	var UploadFile_1 = __webpack_require__(997);
	var configureStore_1 = __webpack_require__(1020);
	var store = configureStore_1["default"]({}); // You can also pass in an initialState here
	// Commented out ("let HTML app be HTML app!")
	window.addEventListener('DOMContentLoaded', function () {
	    var rootEl = document.getElementById('root');
	    if (rootEl) {
	        ReactDOM.render(React.createElement(react_redux_1.Provider, { store: store },
	            React.createElement(react_router_1.Router, { history: react_router_1.hashHistory },
	                React.createElement(react_router_1.Route, { path: "/device/test", component: DeviceTest_1["default"] }),
	                React.createElement(react_router_1.Route, { path: "/password/generate", component: ResetPassword_1["default"] }),
	                React.createElement(react_router_1.Route, { path: "/", component: GlanceStudioApp_1["default"] },
	                    React.createElement(react_router_1.Route, { path: "/login", component: LoginComponent_1["default"] }),
	                    React.createElement(react_router_1.Route, { path: "/logout", component: Logout_1["default"] }),
	                    React.createElement(react_router_1.Route, { component: App_1["default"] },
	                        React.createElement(react_router_1.Route, { path: "/partner" },
	                            React.createElement(react_router_1.IndexRoute, { component: PartnerGlances_1["default"] }),
	                            React.createElement(react_router_1.Route, { path: "/partner/:partnerId/settings", component: Logout_1["default"] }),
	                            React.createElement(react_router_1.Route, { path: "/partner/:partnerId", component: PartnerGlances_1["default"] }),
	                            React.createElement(react_router_1.Route, { path: "/partner/:partnerId/published", component: PartnerGlances_1["default"] },
	                                React.createElement(react_router_1.Route, { path: "/partner/:partnerId/published/:region/:regionName/", component: PartnerGlances_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/partner/:partnerId/published/:region/:regionName/:filter/:filterName", component: PartnerGlances_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/partner/:partnerId/published/:region/:regionName/:filter/:filterName/:type/:typeName", component: PartnerGlances_1["default"] })),
	                            React.createElement(react_router_1.Route, { path: "/partner/:partnerId/glance/:id/:action", component: Approval_1["default"] })),
	                        React.createElement(react_router_1.Route, { path: "/peek/:type(/:id)", component: PeekView_1["default"] }),
	                        React.createElement(react_router_1.Route, { path: "/drafts/draftIds/:draftIds", component: GlanceDraftRedirect_1["default"] }),
	                        React.createElement(react_router_1.Route, { path: "/error", component: ErrorComponent_1["default"] }),
	                        React.createElement(react_router_1.Route, { path: "/:role" },
	                            React.createElement(react_router_1.IndexRoute, { component: GlanceDrafts_1["default"] }),
	                            React.createElement(react_router_1.Route, { path: "/:role/drafts", component: GlanceDrafts_1["default"] },
	                                React.createElement(react_router_1.Route, { path: "/:role/drafts/draftIds/:draftIds", component: GlanceDrafts_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/drafts/type/:typeName/:type", component: GlanceDrafts_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/drafts/type/:typeName/:type/category/:category", component: GlanceDrafts_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/drafts/type/:typeName/:type/category/:category/time/:time", component: GlanceDrafts_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState", component: GlanceDrafts_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState/partner/:partner", component: GlanceDrafts_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState/partner/:partner/partnerRegion/:partnerRegion/regionFilter/:regionFilter", component: GlanceDrafts_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState/partner/:partner", component: GlanceDrafts_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState/partner/:partner/partnerRegion/:partnerRegion/regionFilter/:regionFilter", component: GlanceDrafts_1["default"] })),
	                            React.createElement(react_router_1.Route, { path: "/:role/published", component: ModeratorGlances_1["default"] },
	                                React.createElement(react_router_1.Route, { path: "/:role/published/:partnerId/:partnerName", component: ModeratorGlances_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/published/:partnerId/:partnerName/:region/:regionName", component: ModeratorGlances_1["default"] })),
	                            React.createElement(react_router_1.Route, { path: "/:role/internalApproval", component: InternalApprovalGlances_1["default"] },
	                                React.createElement(react_router_1.Route, { path: "/:role/internalApproval/:region/:regionName", component: InternalApprovalGlances_1["default"] })),
	                            React.createElement(react_router_1.Route, { path: "/:role/analytics", component: Analytics_1["default"] },
	                                React.createElement(react_router_1.Route, { path: "/:role/analytics/:partnerId/:partnerName", component: Analytics_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/analytics/:partnerId/:partnerName/:region/:regionName", component: Analytics_1["default"] })),
	                            React.createElement(react_router_1.Route, { path: "/:role/publishers", component: Publishers_1["default"] },
	                                React.createElement(react_router_1.Route, { path: "/:role/publishers/:partnerId/:partnerName", component: Publishers_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/publishers/:partnerId/:partnerName/:region/:regionName", component: Publishers_1["default"] })),
	                            React.createElement(react_router_1.Route, { path: "/:role/segments", component: Segments_1["default"] },
	                                React.createElement(react_router_1.Route, { path: "/:role/segments/:partnerId/:partnerName", component: Segments_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/segments/:partnerId/:partnerName/:region/:regionName", component: Segments_1["default"] })),
	                            React.createElement(react_router_1.Route, { path: "/:role/segment-query", component: segmentQuery_1["default"] }),
	                            React.createElement(react_router_1.Route, { path: "/:role/uploadCsv", component: UploadCsv_1["default"] },
	                                React.createElement(react_router_1.Route, { path: "/:role/uploadCsv/:partnerId/:partnerName", component: UploadCsv_1["default"] }),
	                                React.createElement(react_router_1.Route, { path: "/:role/uploadCsv/:partnerId/:partnerName/:region/:regionName", component: UploadCsv_1["default"] })),
	                            React.createElement(react_router_1.Route, { path: "/:role/uploadFile", component: UploadFile_1["default"] }),
	                            React.createElement(react_router_1.Route, { path: "/:role/notification-settings", component: Notification_1["default"] })))))), rootEl);
	    }
	});
	$(document).ready(function () {
	    console.log('Glance webapp is ready to be initialised.');
	});


/***/ },

/***/ 17:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var _a, _b;
	var Constants_1 = __webpack_require__(111);
	var Clock_1 = __webpack_require__(151);
	var types_1 = __webpack_require__(125);
	var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var months = [
	    'Jan',
	    'Feb',
	    'Mar',
	    'Apr',
	    'May',
	    'Jun',
	    'July',
	    'Aug',
	    'Sep',
	    'Oct',
	    'Nov',
	    'Dec',
	];
	var millnames = ['', ' K', ' M', ' B', ' T'];
	exports.typeMap = {
	    WALLPAPER: 1,
	    STORY: 2,
	    RESERVED_STORY: 3,
	    SPONSORED: 4
	};
	exports.durationUnitMap = {
	    HOURS: 0,
	    DAYS: 1
	};
	exports.glanceMetaStateMap = {
	    INMOBI_APPROVED: 0,
	    STUDIO_APPROVED: 1,
	    PARTNER_APPROVED: 2,
	    PARTNER_REJECTED: 3,
	    PARTNER_REMOVED: 4,
	    INMOBI_REMOVED: 5,
	    STUDIO_REMOVED: 6,
	    INTERNAL_PENDING: 7,
	    INTERNAL_APPROVED: 8,
	    INTERNAL_REJECTED: 9
	};
	exports.modeViewMap = {
	    ANY: 0,
	    DEFAULT: 1,
	    BINGE: 2,
	    HIGHLIGHTS: 3,
	    GAME_REWARDED: 4
	};
	exports.regionMap = {
	    US: 1,
	    IN: 2,
	    CN: 3,
	    KR: 4,
	    ID: 5,
	    HK: 6,
	    KH: 7,
	    MM: 8,
	    MO: 9,
	    MY: 10,
	    PH: 11,
	    PK: 12,
	    RU: 13,
	    SG: 14,
	    TH: 15,
	    TW: 16,
	    VN: 17,
	    LK: 18,
	    LA: 19,
	    KE: 20,
	    MA: 21,
	    BD: 22,
	    NP: 23,
	    AU: 24,
	    NZ: 25,
	    MX: 26,
	    BR: 27,
	    CO: 28,
	    JP: 29,
	    AT: 30,
	    DE: 31,
	    NG: 32,
	    GB: 33,
	    ISLAMIC: 97,
	    NON_ISLAMIC: 98,
	    GLOBAL: 99,
	    NO_REGION: 100,
	    ALL_REGION: 101
	};
	exports.typeFilters = {
	    0: ['WALLPAPER', 'STORY', 'SPONSORED'],
	    1: ['WALLPAPER'],
	    2: ['STORY'],
	    3: ['SPONSORED'],
	    4: ['NEWS'],
	    5: ['FEATURE'],
	    6: ['GLANCETV']
	};
	exports.expiryFilters = ['ALL', 'ACTIVE', 'EXPIRED'];
	exports.stateFilters = {
	    0: ['STUDIO_APPROVED', 'INTERNAL_APPROVED'],
	    1: ['PARTNER_APPROVED', 'STUDIO_PAUSED'],
	    2: ['PARTNER_REJECTED'],
	    3: ['PARTNER_REMOVED', 'STUDIO_REMOVED']
	};
	exports.stateFiltersInternal = {
	    0: ['INTERNAL_PENDING'],
	    1: ['INTERNAL_APPROVED', 'PARTNER_APPROVED'],
	    2: ['INTERNAL_REJECTED']
	};
	exports.regionFilters = {
	    1: 'US',
	    2: 'IN',
	    3: 'CN',
	    4: 'KR',
	    5: 'ID',
	    6: 'HK',
	    7: 'KH',
	    8: 'MM',
	    9: 'MO',
	    10: 'MY',
	    11: 'PH',
	    12: 'PK',
	    13: 'RU',
	    14: 'SG',
	    15: 'TH',
	    16: 'TW',
	    17: 'VN',
	    18: 'LK',
	    19: 'LA',
	    20: 'KE',
	    21: 'MA',
	    22: 'BD',
	    23: 'NP',
	    24: 'AU',
	    25: 'NZ',
	    26: 'MX',
	    27: 'BR',
	    28: 'CO',
	    29: 'JP',
	    97: 'ISLAMIC',
	    98: 'NON_ISLAMIC',
	    99: 'GLOBAL',
	    100: 'NO_REGION',
	    101: 'ALL_REGION'
	};
	exports.regionNames = (_a = {},
	    _a[24 /* AU */] = 'Australia',
	    _a[3 /* CN */] = 'China',
	    _a[2 /* IN */] = 'India',
	    _a[1 /* US */] = 'USA',
	    _a[4 /* KR */] = 'Korea',
	    _a[5 /* ID */] = 'Indonesia',
	    _a[6 /* HK */] = 'Hong Kong',
	    _a[7 /* KH */] = 'Cambodia',
	    _a[8 /* MM */] = 'Myanmar',
	    _a[9 /* MO */] = 'Macau',
	    _a[10 /* MY */] = 'Malaysia',
	    _a[11 /* PH */] = 'Philippines',
	    _a[12 /* PK */] = 'Pakistan',
	    _a[13 /* RU */] = 'Russia',
	    _a[14 /* SG */] = 'Singapore',
	    _a[15 /* TH */] = 'Thailand',
	    _a[16 /* TW */] = 'Taiwan',
	    _a[17 /* VN */] = 'Vietnam',
	    _a[18 /* LK */] = 'Sri Lanka',
	    _a[19 /* LA */] = 'Laos',
	    _a[20 /* KE */] = 'Kenya',
	    _a[21 /* MA */] = 'Morocco',
	    _a[22 /* BD */] = 'Bangladesh',
	    _a[23 /* NP */] = 'Nepal',
	    _a[25 /* NZ */] = 'New Zealand',
	    _a[32 /* NG */] = 'Nigeria',
	    _a[33 /* GB */] = 'Great Britain',
	    _a[31 /* DE */] = 'Germany',
	    _a[30 /* AT */] = 'Austria',
	    _a[99 /* GLOBAL */] = 'Global',
	    _a[97 /* ISLAMIC */] = 'Islamic',
	    _a[98 /* NON_ISLAMIC */] = 'Non Islamic',
	    _a[26 /* MX */] = 'Mexico',
	    _a[27 /* BR */] = 'Brazil',
	    _a[28 /* CO */] = 'Colombia',
	    _a[29 /* JP */] = 'Japan',
	    _a);
	exports.roleNames = (_b = {},
	    _b[0 /* ADMIN */] = 'admin',
	    _b[1 /* CURATOR */] = 'curator',
	    _b[3 /* DESIGNER */] = 'designer',
	    _b[2 /* MODERATOR */] = 'moderator',
	    _b[4 /* PARTNER */] = 'partner',
	    _b);
	exports.allRegions = [
	    3 /* CN */,
	    4 /* KR */,
	    24 /* AU */,
	    25 /* NZ */,
	    11 /* PH */,
	    14 /* SG */,
	    2 /* IN */,
	    7 /* KH */,
	    8 /* MM */,
	    1 /* US */,
	    15 /* TH */,
	    17 /* VN */,
	    5 /* ID */,
	    10 /* MY */,
	    99 /* GLOBAL */,
	    6 /* HK */,
	    18 /* LK */,
	    19 /* LA */,
	    21 /* MA */,
	    20 /* KE */,
	    22 /* BD */,
	    23 /* NP */,
	    16 /* TW */,
	    13 /* RU */,
	    12 /* PK */,
	    97 /* ISLAMIC */,
	    98 /* NON_ISLAMIC */,
	    26 /* MX */,
	    27 /* BR */,
	    28 /* CO */,
	    29 /* JP */,
	    30 /* AT */,
	    31 /* DE */,
	    32 /* NG */,
	    33 /* GB */,
	];
	exports.MONTHS = [
	    'Jan',
	    'Feb',
	    'Mar',
	    'Apr',
	    'May',
	    'Jun',
	    'Jul',
	    'Aug',
	    'Sep',
	    'Oct',
	    'Nov',
	    'Dec',
	];
	exports.PARTNERS_WITH_RELAXED_EXPIRY = [
	    Constants_1.Partners.TEST_PARTNER_ID,
	    Constants_1.Partners.OPPO_PARTNER_ID,
	    Constants_1.Partners.OPPO_API_PARTNER_ID,
	    Constants_1.Partners.VIVO_PARTNER_ID,
	];
	exports.DEV_ENVS = ['dev', 'localhost'];
	var Utils = /** @class */ (function () {
	    function Utils() {
	    }
	    Utils.getReadableAbsoluteTime = function (epoch) {
	        if (!epoch || epoch === 0) {
	            return '';
	        }
	        var current = new Date(0);
	        current.setUTCSeconds(epoch);
	        var date = new Date(current);
	        var dateString = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
	        var minuteString = date.getMinutes() >= 10
	            ? '' + date.getMinutes()
	            : '0' + date.getMinutes();
	        var hourString = date.getHours() >= 10 ? '' + date.getHours() : '0' + date.getHours();
	        return (hourString +
	            ':' +
	            minuteString +
	            ', ' +
	            days[date.getDay()] +
	            ' ' +
	            months[date.getMonth()] +
	            ' ' +
	            dateString +
	            ' ' +
	            date.getFullYear());
	    };
	    Utils.getReadableRelativeTime = function (relativeTime) {
	        if (!relativeTime) {
	            return '';
	        }
	        var dateString = relativeTime.date >= 10 ? relativeTime.date : '0' + relativeTime.date;
	        var minuteString = relativeTime.minute >= 10
	            ? '' + relativeTime.minute
	            : '0' + relativeTime.minute;
	        var hourString = relativeTime.hour >= 10
	            ? '' + relativeTime.hour
	            : '0' + relativeTime.hour;
	        return (hourString +
	            ': ' +
	            minuteString +
	            ', ' +
	            months[relativeTime.month - 1] +
	            ' ' +
	            dateString +
	            ' ' +
	            relativeTime.year);
	    };
	    // returns data in yyyy-mm-dd format
	    Utils.getDateInYyyyMmDd = function (date) {
	        return date.toISOString().split('T')[0];
	    };
	    Utils.getReadableNumber = function (number) {
	        if (!number) {
	            return '';
	        }
	        var base = 1000;
	        var e = Math.floor(Math.log(number) / Math.log(base));
	        return Math.floor(number / Math.pow(base, e)) + ' ' + millnames[e];
	    };
	    Utils.getImageUrl = function (cdnPrefix, image, type) {
	        if (image) {
	            var imageUrl_1 = cdnPrefix + 'wallpaper/' + image.id + '.webp';
	            image.imageMetas.forEach(function (meta) {
	                if (meta.type === type) {
	                    imageUrl_1 = Utils.getImagePath(cdnPrefix, image.id, meta);
	                }
	            });
	            return imageUrl_1;
	        }
	        return null;
	    };
	    Utils.getImageUrlForSpaces = function (cdnPrefix, image) {
	        if (image && image.imageMap) {
	            var imagePath = image.imageMap.baseImage
	                ? image.imageMap.baseImage
	                : image.imageMap.l0Large
	                    ? image.imageMap.l0Large
	                    : image.imageMap.l0Medium
	                        ? image.imageMap.l0Medium
	                        : image.imageMap.lPlus;
	            return cdnPrefix + imagePath;
	        }
	        return null;
	    };
	    Utils.getImagePath = function (cdnPrefix, imageId, meta) {
	        switch (meta.type) {
	            case 2 /* BLUR */:
	                return cdnPrefix + 'blur/' + imageId + '.webp';
	            case 0 /* LEGACY */:
	                return cdnPrefix + 'wallpaper/' + imageId + '.webp';
	            case 4 /* STUDIO_ORIGINAL */:
	                return (cdnPrefix +
	                    'original/' +
	                    meta.width +
	                    'x' +
	                    meta.height +
	                    '/' +
	                    imageId +
	                    '.jpg');
	            case 3 /* ORIGINAL */:
	                return (cdnPrefix +
	                    'dynamic/' +
	                    meta.width +
	                    'x' +
	                    meta.height +
	                    '/' +
	                    imageId +
	                    '.webp');
	            default:
	                return cdnPrefix + 'wallpaper/' + imageId + '.webp';
	        }
	    };
	    Utils.getBubbleImagePath = function (imagePath) {
	        return Constants_1["default"].CDN_PREFIX + imagePath;
	    };
	    Utils.readableAttribution = function (attribution) {
	        if (!attribution) {
	            return null;
	        }
	        if (attribution.source) {
	            return attribution.source;
	        }
	        return null;
	    };
	    Utils.openNewTab = function (url) {
	        window.open(url, '_blank');
	    };
	    Utils.truncate = function (string, length) {
	        if (string.length < length) {
	            return string;
	        }
	        else {
	            var suffix = '...';
	            return string.substring(0, length - suffix.length) + suffix;
	        }
	    };
	    Utils.getReadableRegionName = function (region) {
	        if (exports.regionNames[region]) {
	            return exports.regionNames[region];
	        }
	        else {
	            console.error('What the hell! You forgot to add region specific values here');
	            return '';
	        }
	    };
	    Utils.getReadableRoleName = function (role) {
	        if (exports.roleNames[role]) {
	            return exports.roleNames[role];
	        }
	        else {
	            console.error('Incorrect or missing role name');
	            return '';
	        }
	    };
	    Utils.getEpochFinalInSecs = function (glanceTime) {
	        var startDate;
	        if (glanceTime.startTime.absoluteTime) {
	            var startEpoch = glanceTime.startTime.absoluteTime.timeInSecs * 1000;
	            return startEpoch / 1000;
	        }
	        else {
	            var relativeTime = glanceTime.startTime.relativeTime;
	            startDate = new Date(relativeTime.year, relativeTime.month - 1, relativeTime.date, relativeTime.hour, relativeTime.minute, 0, 0);
	            return startDate.getTime() / 1000;
	        }
	    };
	    Utils.getStartDate = function (region, glanceTime) {
	        var timezone = this.getTimezone(region);
	        var startDate;
	        if (glanceTime.startTime.absoluteTime) {
	            var startEpoch = glanceTime.startTime.absoluteTime.timeInSecs * 1000;
	            startDate = new Date(startEpoch);
	            startDate.setHours(startDate.getUTCHours() + timezone.hours);
	            startDate.setMinutes(startDate.getUTCMinutes() + timezone.minutes);
	        }
	        else {
	            var relativeTime = glanceTime.startTime.relativeTime;
	            startDate = new Date(relativeTime.year, relativeTime.month - 1, relativeTime.date, relativeTime.hour, relativeTime.minute, 0, 0);
	        }
	        return startDate;
	    };
	    Utils.getTimezone = function (region) {
	        switch (region) {
	            case 3 /* CN */:
	                return Clock_1.chinaTimezone;
	            case 2 /* IN */:
	                return Clock_1.indiaTimezone;
	            case 1 /* US */:
	                return Clock_1.usTimezone;
	            case 4 /* KR */:
	                return Clock_1.krTimezone;
	            case 5 /* ID */:
	                return Clock_1.idTimezone;
	            case 99 /* GLOBAL */:
	                return Clock_1.utcTimeZone;
	            case 97 /* ISLAMIC */:
	                return Clock_1.utcTimeZone;
	            case 98 /* NON_ISLAMIC */:
	                return Clock_1.utcTimeZone;
	            default:
	                return Clock_1.utcTimeZone;
	        }
	    };
	    Utils.isExpired = function (glanceTime, timezone) {
	        if (glanceTime.startTime.absoluteTime) {
	            return (glanceTime.startTime.absoluteTime.timeInSecs * 1000 +
	                Utils.getMillis(glanceTime.duration) <
	                new Date().getTime());
	        }
	        else {
	            var relativeTime = glanceTime.startTime.relativeTime;
	            var startDate = new Date(relativeTime.year, relativeTime.month - 1, relativeTime.date, relativeTime.hour, relativeTime.minute, 0, 0);
	            var newDate = new Date(startDate);
	            newDate.setUTCFullYear(relativeTime.year);
	            newDate.setUTCMonth(relativeTime.month - 1);
	            newDate.setUTCDate(relativeTime.date);
	            newDate.setUTCHours(relativeTime.hour);
	            newDate.setUTCMinutes(relativeTime.minute);
	            newDate.setUTCSeconds(0);
	            newDate.setUTCMilliseconds(0);
	            var startEpochFinalInSecs = startDate.getTime() / 1000;
	            var currentdate = new Date();
	            return (startEpochFinalInSecs + Utils.getMillis(glanceTime.duration) / 1000 <
	                Math.floor(currentdate.getTime() / 1000));
	        }
	    };
	    Utils.getOffsetDifference = function (currentOffset, timezone) {
	        console.log(currentOffset, timezone);
	        currentOffset = -1 * currentOffset;
	        if (currentOffset < 0) {
	            if (timezone.hours < 0) {
	                return timezone.hours * 60 + timezone.minutes - currentOffset;
	            }
	            else {
	                return (Math.abs(currentOffset) +
	                    Math.abs(timezone.hours * 60 + timezone.minutes));
	            }
	        }
	        else {
	            if (timezone.hours < 0) {
	                return (Math.abs(currentOffset) +
	                    Math.abs(timezone.hours * 60 + timezone.minutes));
	            }
	            else {
	                return timezone.hours * 60 + timezone.minutes - currentOffset;
	            }
	        }
	    };
	    Utils.getMillis = function (duration) {
	        if (duration) {
	            if (duration.unit === 1 /* DAYS */) {
	                return duration.length * 24 * 60 * 60 * 1000;
	            }
	            else if (duration.unit === 0 /* HOURS */) {
	                return duration.length * 60 * 60 * 1000;
	            }
	            else if (duration.unit === 2 /* MINUTES */) {
	                return duration.length * 60 * 1000;
	            }
	            else if (duration.unit === 3 /* SECONDS */) {
	                return duration.length * 1000;
	            }
	        }
	        return 0;
	    };
	    Utils.getUserLevelExpiry = function (duration) {
	        if (duration !== null && duration !== undefined) {
	            if (duration.unit === 1 /* DAYS */) {
	                return duration.length + " " + (duration.length > 1 ? 'days' : 'day');
	            }
	            else if (duration.unit === 0 /* HOURS */) {
	                return duration.length + " " + (duration.length > 1 ? 'hours' : 'hour');
	            }
	        }
	    };
	    Utils.getPeekLink = function (data) {
	        if (data.peek) {
	            if (data.peek.video) {
	                var meta = data.peek.video.video.meta;
	                if (meta.facebook) {
	                    return 'https://facebook.com/' + meta.facebook.id;
	                }
	                else if (meta.youtube) {
	                    return 'https://youtu.be/' + meta.youtube.id;
	                }
	                if (meta.instagram) {
	                    return 'https://www.instagram.com/p/' + meta.instagram.id;
	                }
	                if (meta.youku) {
	                    return 'http://v.youku.com/v_show/id_' + meta.youku.id + '.html';
	                }
	            }
	            else if (data.peek.article) {
	                return data.peek.article.cta.url;
	            }
	        }
	        return null;
	    };
	    Utils.getSummary = function (data) {
	        if (data.peek) {
	            if (data.peek.article) {
	                return data.peek.article.summary;
	            }
	            else if (data.peek.video) {
	                return data.peek.video.summary;
	            }
	            else if (data.peek.webpeek) {
	                return data.peek.webpeek.summary;
	            }
	            else if (data.peek.nativeVideoPeek) {
	                return data.peek.nativeVideoPeek.summary;
	            }
	        }
	        return null;
	    };
	    Utils.getDomainPrefix = function () {
	        var href = window.location.href;
	        var start = href.indexOf('://');
	        start = start === -1 ? 0 : start + 3;
	        var end = href.indexOf('.');
	        end = end === -1 ? href.indexOf(': ', start) : end;
	        end = end === -1 ? href.indexOf('/') : end;
	        var domainPrefix = href.substr(start, end - start);
	        if (domainPrefix === 'studio') {
	            return 'Curators';
	        }
	        else {
	            return 'Partners';
	        }
	    };
	    Utils.debounce = function (func, delay) {
	        var debounceTimer;
	        return function () {
	            var context = this;
	            var args = arguments;
	            clearTimeout(debounceTimer);
	            debounceTimer = setTimeout(function () { return func.apply(context, args); }, delay);
	        };
	    };
	    Utils.parseGlancePairs = function (pairs) {
	        if (Array.isArray(pairs)) {
	            pairs.forEach(function (pair) {
	                if (pair.data && pair.data.type) {
	                    pair.data.type = exports.typeMap[pair.data.type];
	                }
	                if (pair.data && pair.data.renderSessionProperties) {
	                    pair.data.renderSessionProperties = (pair.data.renderSessionProperties || []).map(function (type) {
	                        return exports.modeViewMap[type];
	                    });
	                }
	                if (pair.metas) {
	                    var partners_1 = [];
	                    var partnerExperiments_1 = [];
	                    if (Array.isArray(pair.metas)) {
	                        pair.meta = pair.metas[0];
	                        pair.metas.forEach(function (m) {
	                            var partnerId = m.partnerId, experiments = m.experiments;
	                            partners_1.push(partnerId);
	                            var partnerExpObj = {
	                                partnerId: partnerId,
	                                experiments: experiments
	                            };
	                            partnerExperiments_1.push(partnerExpObj);
	                        });
	                        pair.meta.partnerIds = partners_1;
	                        pair.meta.partnerExperiments = partnerExperiments_1;
	                    }
	                }
	                pair.meta.region = exports.regionMap[pair.meta.region];
	                pair.meta.state = exports.glanceMetaStateMap[pair.meta.state];
	                if (pair.meta.glanceTime) {
	                    if (pair.meta.glanceTime.duration) {
	                        pair.meta.glanceTime.duration.unit =
	                            exports.durationUnitMap[pair.meta.glanceTime.duration.unit];
	                    }
	                    if (pair.meta.glanceTime.userLevelDuration) {
	                        pair.meta.glanceTime.userLevelDuration.unit =
	                            exports.durationUnitMap[pair.meta.glanceTime.userLevelDuration.unit];
	                    }
	                }
	            });
	        }
	    };
	    Utils.isExpiryRelaxed = function (partnerIds) {
	        return partnerIds.every(function (partnerId) { return exports.PARTNERS_WITH_RELAXED_EXPIRY.indexOf(partnerId) >= 0; });
	    };
	    Utils.validURL = function (str) {
	        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
	            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
	            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
	            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*', 'i'); // port and path
	        return !!pattern.test(str);
	    };
	    Utils.isValidBeaconURL = function (beaconUrl, beaconType, beaconPartner) {
	        var isBeaconURLError = false;
	        var hostName;
	        if (beaconUrl) {
	            hostName = new URL(beaconUrl).hostname;
	        }
	        switch (beaconPartner) {
	            case 'Appsflyer':
	                if (beaconType === types_1.BeaconType.RENDER &&
	                    !(hostName === 'impression.appsflyer.com')) {
	                    isBeaconURLError = true;
	                }
	                else if (beaconType === types_1.BeaconType.CTA &&
	                    !(hostName === 'app.appsflyer.com')) {
	                    isBeaconURLError = true;
	                }
	                break;
	            case 'Branch':
	                if (beaconType === types_1.BeaconType.RENDER &&
	                    !(hostName === 'impression.link' || hostName === 'impression')) {
	                    isBeaconURLError = true;
	                }
	                break;
	            case 'Kochava':
	                if (beaconType === types_1.BeaconType.RENDER &&
	                    !(hostName === 'imp.control.kochava.com')) {
	                    isBeaconURLError = true;
	                }
	                else if (beaconType === types_1.BeaconType.CTA &&
	                    !(hostName === 'control.kochava.com')) {
	                    isBeaconURLError = true;
	                }
	                break;
	            case 'DCM':
	                if (beaconType === types_1.BeaconType.RENDER &&
	                    !(beaconUrl.includes('trackimp') &&
	                        beaconUrl.includes('ord=$IMP_ID') &&
	                        beaconUrl.includes('dc_rdid=$GPID'))) {
	                    isBeaconURLError = true;
	                }
	                else if (beaconType === types_1.BeaconType.CTA &&
	                    !(beaconUrl.includes('trackclk') &&
	                        beaconUrl.includes('ord=$IMP_ID') &&
	                        beaconUrl.includes('dc_rdid=$GPID'))) {
	                    isBeaconURLError = true;
	                }
	                break;
	            case 'Sizemek':
	                if (beaconType === types_1.BeaconType.RENDER &&
	                    !(beaconUrl.includes('cn=display') &&
	                        beaconUrl.includes('ord=$IMP_ID'))) {
	                    isBeaconURLError = true;
	                }
	                else if (beaconType === types_1.BeaconType.CTA &&
	                    !(beaconUrl.includes('cn=trd') && beaconUrl.includes('ord=$IMP_ID'))) {
	                    isBeaconURLError = true;
	                }
	                break;
	            case 'DV':
	                if (beaconType === types_1.BeaconType.RENDER &&
	                    !(hostName === 'tps.doubleverify.com')) {
	                    isBeaconURLError = true;
	                }
	                break;
	            case 'Neilson':
	                if (beaconType === types_1.BeaconType.RENDER &&
	                    !(hostName.includes('imrworldwide') &&
	                        beaconUrl.includes('c9=devid,$GPID&c13=asid,P471A0E0B-BD0B-4A3B-98AC-AE7C8F9765BD&uoo=$LIMIT_AD_TRACKING&r=$IMP_CB'))) {
	                    isBeaconURLError = true;
	                }
	                else if (beaconType === types_1.BeaconType.CTA &&
	                    !beaconUrl.includes('c9=devid,$GPID&c13=asid,P471A0E0B-BD0B-4A3B-98AC-AE7C8F9765BD&uoo=$LIMIT_AD_TRACKING&r=$IMP_CB')) {
	                    isBeaconURLError = true;
	                }
	                break;
	            default:
	                break;
	        }
	        return isBeaconURLError;
	    };
	    Utils.getEnvDetails = function () {
	        var hostName = window.location.hostname;
	        if (exports.DEV_ENVS.some(function (el) { return hostName.includes(el); })) {
	            return 'dev';
	        }
	        if (hostName.includes('staging')) {
	            return 'staging';
	        }
	        return 'prod';
	    };
	    Utils.getParameterByName = function (name, url) {
	        if (url === void 0) { url = window.location.href; }
	        var nameStr = name.replace(/[\[\]]/g, '\\$&');
	        var regex = new RegExp('[?&]' + nameStr + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
	        if (!results)
	            return null;
	        if (!results[2])
	            return '';
	        return decodeURIComponent(results[2].replace(/\+/g, ' '));
	    };
	    //should be removed when we deprecate renderSessionMode
	    Utils.getRenderSessionData = function (data) {
	        if (data) {
	            var renderSessionMode = data.renderSessionMode;
	            var renderSessionProperties = data.renderSessionProperties || [];
	            renderSessionProperties = renderSessionProperties.filter(function (item) { return item != 3 /* HIGHLIGHTS */; });
	            if (renderSessionProperties && renderSessionProperties.length) {
	                return renderSessionProperties;
	            }
	            else if (renderSessionMode == 3 /* HIGHLIGHTS */) {
	                return [2 /* BINGE */];
	            }
	            else if (renderSessionMode == 2 /* BINGE */ ||
	                renderSessionMode == 1 /* DEFAULT */) {
	                return [renderSessionMode];
	            }
	            else if (renderSessionMode == 0 /* ANY */) {
	                return [1 /* DEFAULT */, 2 /* BINGE */];
	            }
	            else {
	                return [];
	            }
	        }
	        return [];
	    };
	    Utils.getGambitUrl = function () {
	        var currentUrl = '';
	        switch (window.location.hostname) {
	            case 'studio-staging.glance.inmobi.com':
	                currentUrl = Constants_1["default"].GAMBIT_URL_STAGING;
	                break;
	            case 'studio.glance.inmobi.com':
	                currentUrl = Constants_1["default"].GAMBIT_URL_PROD;
	                break;
	            default:
	                currentUrl = Constants_1["default"].GAMBIT_URL_DEV;
	                break;
	        }
	        return currentUrl;
	    };
	    Utils.getBucketPriority = function (priority) {
	        var priorityValue = priority.toLowerCase();
	        switch (priorityValue) {
	            case 'house':
	                return 0 /* HOUSE */;
	            case 'sponsorship':
	                return 4 /* SPONSORSHIP */;
	            case 'high_priority':
	                return 3 /* HIGH_PRIORITY */;
	            case 'low_priority':
	                return 2 /* LOW_PRIORITY */;
	            case 'price_priority':
	                return 1 /* PRICE_PRIORITY */;
	            default:
	                return null;
	        }
	    };
	    Utils.getFormattedTime = function (unixTime) {
	        var date = new Date(unixTime * 1000);
	        var day = date.getDate();
	        var month = exports.MONTHS[date.getMonth()];
	        var year = date.getFullYear();
	        var hours = date.getHours();
	        var minute = date.getMinutes();
	        return month + " " + day + ", " + year + " " + hours + ":" + minute + " IST";
	    };
	    Utils.getContextualEmojiUrl = function () {
	        var currentUrl = '';
	        switch (window.location.hostname) {
	            case 'studio-staging.glance.inmobi.com':
	                currentUrl = Constants_1["default"].CONTEXTUAL_EMOJI_STAGING;
	                break;
	            case 'studio.glance.inmobi.com':
	                currentUrl = Constants_1["default"].CONTEXTUAL_EMOJI_PROD;
	                break;
	            default:
	                currentUrl = Constants_1["default"].CONTEXTUAL_EMOJI_DEV;
	                break;
	        }
	        return currentUrl;
	    };
	    Utils.getCookieValueByName = function (cookieName) {
	        var cookies = document.cookie.split(';');
	        for (var count = 0; count < cookies.length; count++) {
	            var _a = cookies[count].split('='), key = _a[0], value = _a[1];
	            if (key.trim() === cookieName)
	                return value;
	        }
	        return null;
	    };
	    Utils.updateUrlParams = function (url, params) {
	        try {
	            var urlObject = new URL(url);
	            var queryParams_1 = new URLSearchParams(urlObject.search);
	            Object.entries(params).map(function (_a) {
	                var param = _a[0], value = _a[1];
	                queryParams_1.set(param, value.toString());
	            });
	            urlObject.search = queryParams_1.toString();
	            return urlObject.toString();
	        }
	        catch (error) {
	            console.log(error);
	        }
	        return url;
	    };
	    Utils.convertTo3pLite = function (url) {
	        try {
	            return url.replace(/\/newz(?=\/(?!shp|lite|cards|nic|fast-cards|video-lite))/g, '/newz/shp');
	        }
	        catch (error) {
	            console.error('Error updating newz URL:', error);
	        }
	        return url;
	    };
	    return Utils;
	}());
	exports["default"] = Utils;


/***/ },

/***/ 32:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	exports.__esModule = true;
	var gl = __webpack_require__(67);
	var Utils_1 = __webpack_require__(17);
	var RestService = /** @class */ (function () {
	    function RestService() {
	    }
	    RestService.getStudioAppConfig = function (callback) {
	        RestService.confClient
	            .getStudioAppConfig(function () { })
	            .done(function (result) {
	            // console.log(result)
	            callback(result);
	        })
	            .fail(function (result) {
	            console.error(result);
	            callback(null);
	        });
	    };
	    RestService.logout = function () {
	        return RestService.authClient.logout();
	    };
	    RestService.loginUsingEmailAndPassword = function (username, password, callback) {
	        RestService.authClient
	            .loginUsingEmailAndPassword(username, password, function () { })
	            .done(function (result) {
	            // console.log(result)
	            callback(result);
	        })
	            .fail(function (result) {
	            console.error(result);
	            callback(null);
	        });
	    };
	    RestService.loginUsingMicrosoftAuth = function (token, callback) {
	        RestService.authClient
	            .loginUsingMicrosoft(token, function () { })
	            .done(function (result) {
	            callback(result);
	        })
	            .fail(function (result) {
	            console.error(result);
	            callback(null);
	        });
	    };
	    RestService.loginUsingGoogleAuth = function (token, callback) {
	        RestService.authClient
	            .loginUsingGoogleAuth(token, function () { })
	            .done(function (result) {
	            // console.log(result)
	            callback(result);
	        })
	            .fail(function (result) {
	            console.error(result);
	            callback(null);
	        });
	    };
	    RestService.getPartnerPublishedGlances = function (payload) {
	        return new Promise(function (resolve, reject) {
	            var createdAfterSeconds = payload.createdAfterSeconds, limit = payload.limit, offset = payload.offset, type = payload.type, state = payload.state, partner = payload.partner, region = payload.region, search = payload.search, expired = payload.expired, languages = payload.languages;
	            var pagination = {
	                limit: limit,
	                offset: offset,
	                search: search
	            };
	            RestService.partnerClient
	                .search(new gl.PartnerPairSearchQuery({
	                partner: partner,
	                region: region,
	                state: state,
	                glanceType: type,
	                createdAfterInSecs: createdAfterSeconds,
	                expired: expired,
	                pagination: pagination,
	                languages: languages
	            }), function () { })
	                .done(function (result) {
	                resolve(result);
	            })
	                .fail(function (result) {
	                RestService.handlerError(result);
	                reject(result);
	            });
	        });
	    };
	    RestService.getGlances = function (payload) {
	        return new Promise(function (resolve, reject) {
	            var createdAfterSeconds = payload.createdAfterSeconds, limit = payload.limit, offset = payload.offset, type = payload.type, state = payload.state, partner = payload.partner, region = payload.region, search = payload.search, expired = payload.expired;
	            var pagination = {
	                limit: limit,
	                offset: offset,
	                search: search
	            };
	            RestService.dataClient
	                .search(new gl.GlancePairSearchQuery({
	                partner: partner,
	                region: region,
	                state: state,
	                glanceType: type,
	                createdAfterInSecs: createdAfterSeconds,
	                expired: expired,
	                pagination: pagination
	            }), function () { })
	                .done(function (result) {
	                console.log(result);
	                resolve(result);
	            })
	                .fail(function (result) {
	                console.error(result);
	                RestService.handlerError(result);
	                reject(result);
	            });
	        });
	    };
	    RestService.getLiveGlancesBetweenTime = function (partner, region, startAtGreaterThan, startAtLessThan, callback) {
	        RestService.dataClient
	            .search(new gl.GlancePairSearchQuery({
	            partner: partner,
	            region: region,
	            startsAt: startAtGreaterThan,
	            endsAt: startAtLessThan
	        }), function () { })
	            .done(function (result) {
	            console.log(result);
	            callback(result.pairs);
	        })
	            .fail(function (result) {
	            console.error(result);
	            RestService.handlerError(result);
	            callback(null);
	        });
	    };
	    RestService.removePartnerPublishedGlance = function (partner, region, id, callback) {
	        RestService.dataClient
	            .removeMeta(partner, region, id, function () { })
	            .done(function (result) {
	            callback(true);
	        })
	            .fail(function (result) {
	            console.error(result);
	            callback(false);
	        });
	    };
	    RestService.removePartnerPublishedGlances = function (partner, region, ids, callback) {
	        RestService.dataClient
	            .removeMetas(partner, region, ids, function () { })
	            .done(function (result) {
	            callback(true);
	        })
	            .fail(function (result) {
	            console.error(result);
	            callback(false);
	        });
	    };
	    RestService.getPublishedGlances = function (region, partner, callback) {
	        RestService.partnerClient
	            .search(new gl.PartnerPairSearchQuery({
	            region: region,
	            partner: partner
	        }), function () { })
	            .done(function (result) {
	            callback(result.pairs);
	        })
	            .fail(function (result) {
	            console.error(result);
	            // RestService.handlerError(result)
	            callback([]);
	        });
	    };
	    RestService.removeGlance = function (region, id, partner, callback) {
	        RestService.partnerClient
	            .removeMeta(region, id, partner, function () { })
	            .done(function (result) {
	            callback(true);
	        })
	            .fail(function (result) {
	            console.error(result);
	            // RestService.handlerError(result)
	            callback(false);
	        });
	    };
	    RestService.removeGlances = function (region, ids, partner, callback) {
	        console.log('removeGlances', region, ids);
	        RestService.partnerClient
	            .removeMetas(region, ids, partner, function () { })
	            .done(function (result) {
	            console.log('removeGlances', true);
	            callback(true);
	        })
	            .fail(function (result) {
	            console.error(result);
	            // RestService.handlerError(result)
	            callback(false);
	        });
	    };
	    RestService.approveGlance = function (region, id, partner, callback) {
	        RestService.partnerClient
	            .approveGlance(region, id, partner, function () { })
	            .done(function (result) {
	            callback(result.data);
	        })
	            .fail(function (result) {
	            console.error(result);
	            // RestService.handlerError(result)
	            callback(null);
	        });
	    };
	    RestService.approveGlances = function (region, ids, partner, callback) {
	        RestService.partnerClient
	            .approveGlances(region, ids, partner, function () { })
	            .done(function (result) {
	            callback(true);
	        })
	            .fail(function (result) {
	            console.error(result);
	            // RestService.handlerError(result)
	            callback(false);
	        });
	    };
	    RestService.rejectGlance = function (region, id, partner, callback) {
	        RestService.partnerClient
	            .rejectGlance(region, id, partner, function () { })
	            .done(function (result) {
	            callback(result.data);
	        })
	            .fail(function (result) {
	            console.error(result);
	            // RestService.handlerError(result)
	            callback(null);
	        });
	    };
	    RestService.rejectGlances = function (region, ids, partner, callback) {
	        RestService.partnerClient
	            .rejectGlances(region, ids, partner, function () { })
	            .done(function (result) {
	            callback(true);
	        })
	            .fail(function (result) {
	            console.error(result);
	            callback(false);
	        });
	    };
	    RestService.createDraftFromLink = function (link, cardType, testMode, callback) {
	        RestService.draftClient
	            .createFromUrl(link, new gl.TargetDeviceProperties({
	            targetDevice: cardType == 1 ? 0 /* MOBILE */ : 1 /* ANDROID_TV */
	        }), testMode, function () { })
	            .done(function (result) {
	            callback(result.draft);
	        })
	            .fail(function (result) {
	            console.error(result);
	            RestService.handlerError(result);
	            callback(null);
	        });
	    };
	    RestService.createDraftFromImage = function (imageId, cardType, callback) {
	        RestService.draftClient
	            .createFromImage(imageId, function () { })
	            .done(function (result) {
	            callback(result.draft);
	        })
	            .fail(function (result) {
	            console.error(result);
	            RestService.handlerError(result);
	            callback(null);
	        });
	    };
	    RestService.getAllDrafts = function (payload) {
	        return new Promise(function (resolve, reject) {
	            var createdAfterSeconds = payload.createdAfterSeconds, categoryIds = payload.categoryIds, offset = payload.offset, limit = payload.limit, type = payload.type, storyType = payload.storyType, publisherId = payload.publisherId;
	            var pagination = {
	                offset: offset,
	                limit: limit,
	                search: ''
	            };
	            var glanceType = type;
	            RestService.draftClient
	                .searchDrafts(new gl.GlanceDraftSearchQuery({
	                createdAfterInSecs: createdAfterSeconds,
	                pagination: pagination,
	                glanceType: glanceType,
	                categoryIds: categoryIds,
	                publisherId: publisherId,
	                storyType: storyType
	            }), function () { })
	                .done(function (result) {
	                console.log(result);
	                resolve(result);
	            })
	                .fail(function (result) {
	                console.error(result);
	                reject(result);
	            });
	        });
	    };
	    RestService.getDraftsByIds = function (draftIds, callback) {
	        RestService.draftClient
	            .searchDrafts(new gl.GlanceDraftSearchQuery({
	            draftIds: draftIds
	        }), function () { })
	            .done(function (result) {
	            console.log(result);
	            callback(result.drafts);
	        })
	            .fail(function (result) {
	            console.error(result);
	            callback(null);
	        });
	    };
	    RestService.checkDraftById = function (draftId) {
	        return __awaiter(this, void 0, void 0, function () {
	            var responsePromise, timerPromise;
	            return __generator(this, function (_a) {
	                responsePromise = new Promise(function (resolve) {
	                    RestService.draftClient.get(draftId, resolve);
	                });
	                timerPromise = new Promise(function (_, rej) { return setTimeout(function () { return rej('timeOutError'); }, 5000); });
	                return [2 /*return*/, Promise.race([responsePromise, timerPromise]).then(function (res) {
	                        return res.draft === null;
	                    })];
	            });
	        });
	    };
	    RestService.getDraftsByPartnerAndRegion = function (payload) {
	        return new Promise(function (resolve, reject) {
	            var partner = payload.partner, createdAfterSeconds = payload.createdAfterSeconds, region = payload.region, offset = payload.offset, limit = payload.limit, type = payload.type, isPublished = payload.isPublished, categoryIds = payload.categoryIds, storyType = payload.storyType;
	            var pagination = {
	                offset: offset,
	                limit: limit,
	                search: ''
	            };
	            RestService.draftClient
	                .getMetasForDrafts(new gl.GlanceDraftMetaSearchQuery({
	                partner: partner,
	                region: region,
	                createdAfterInSecs: createdAfterSeconds,
	                pagination: pagination,
	                glanceType: type,
	                publishedOnly: isPublished,
	                categoryIds: categoryIds,
	                storyType: storyType
	            }), function () { })
	                .done(function (result) {
	                console.log(result);
	                resolve(result);
	            })
	                .fail(function (result) {
	                console.error(result);
	                reject(null);
	            });
	        });
	    };
	    RestService.saveDraft = function (draft, callback) {
	        RestService.draftClient
	            .update(draft, function () { })
	            .done(function (result) {
	            // console.log(result.draft)
	            if (callback) {
	                callback(result.draft);
	            }
	        })
	            .fail(function (result) {
	            console.error(result);
	            RestService.handlerError(result);
	            if (callback) {
	                callback(null);
	            }
	        });
	    };
	    RestService.overrideDraft = function (draft, callback) {
	        RestService.dataClient
	            .overrideData(draft, function () { })
	            .done(function (result) {
	            console.log(result);
	            if (callback) {
	                callback(null);
	            }
	        })
	            .fail(function (result) {
	            console.error(result);
	            RestService.handlerError(result);
	            if (callback) {
	                callback(result);
	            }
	        });
	    };
	    RestService.removeDraft = function (id, callback) {
	        RestService.draftClient
	            .remove(id, function () { })
	            .done(function (result) {
	            console.log(result);
	        })
	            .fail(function (result) {
	            console.error(result);
	            RestService.handlerError(result);
	            callback(result);
	        });
	    };
	    RestService.glancePauseRequest = function (glanceIds, pause, callback) {
	        RestService.dataClient
	            .pauseGlance(new gl.GlancePauseRequest({
	            ids: glanceIds,
	            pause: pause
	        }), function () { })
	            .done(function (result) {
	            callback(result);
	        })
	            .fail(function (result) {
	            console.error(result);
	            RestService.handlerError(result);
	            callback([]);
	        });
	    };
	    RestService.getPublishMeta = function (id, callback) {
	        RestService.draftClient
	            .getPublishedMeta(id, function () { })
	            .done(function (result) {
	            console.log(result);
	            callback(result.metas);
	        })
	            .fail(function (result) {
	            console.error(result);
	            // RestService.handlerError(result)
	            callback(null);
	        });
	    };
	    RestService.getDraftToPublishMeta = function (ids, callback) {
	        RestService.draftClient
	            .getPublishedMetaForDrafts(ids, function () { })
	            .done(function (result) {
	            // console.log(result)
	            callback(result.draftToMetaMap);
	        })
	            .fail(function (result) {
	            console.error(result);
	            // RestService.handlerError(result)
	            callback(null);
	        });
	    };
	    RestService.publishDraft = function (draftId, region, partners, glanceTime, experiments, segmentRulesList, isPartedGlance, partingSchedule, callback) {
	        if (segmentRulesList === void 0) { segmentRulesList = []; }
	        var regions = [];
	        var ruleIdsList = [];
	        segmentRulesList
	            .map(function (segment) { return segment !== null && segment.map(function (s) { return s.ruleId; }); })
	            .filter(function (ele) { return ele !== null; })
	            .map(function (rules) { return ruleIdsList.push({ ruleIdlist: rules }); });
	        partners.forEach(function (partner) {
	            regions.push(new gl.RegionRequest({
	                partner: partner,
	                region: region,
	                glanceTime: glanceTime,
	                experiments: experiments,
	                ruleIds: [],
	                ruleIdsList: ruleIdsList,
	                isPartedGlance: isPartedGlance,
	                partingSchedule: partingSchedule
	            }));
	        });
	        RestService.dataClient
	            .publish(new gl.PublishRequest({
	            draftId: draftId,
	            regions: regions
	        }), function () { })
	            .done(function (result) {
	            console.log(result);
	            callback(result, null);
	        })
	            .fail(function (result) {
	            console.error(result);
	            RestService.handlerError(result);
	            callback(null, result);
	        });
	    };
	    RestService.uploadImage = function (image, callback) {
	        return __awaiter(this, void 0, void 0, function () {
	            var fd, result, image_1, error_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        console.log(image);
	                        fd = new FormData();
	                        fd.append('file', image);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, $.ajax({
	                                type: 'POST',
	                                url: '/upload',
	                                contentType: false,
	                                processData: false,
	                                data: fd
	                            })];
	                    case 2:
	                        result = _a.sent();
	                        image_1 = result;
	                        callback(image_1);
	                        return [3 /*break*/, 4];
	                    case 3:
	                        error_1 = _a.sent();
	                        console.error(error_1);
	                        RestService.handlerError(error_1);
	                        callback(null);
	                        return [3 /*break*/, 4];
	                    case 4: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    RestService.uploadBubbleImage = function (image) {
	        return __awaiter(this, void 0, void 0, function () {
	            var data, response, error_2;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        data = new FormData();
	                        data.append('file', image);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, $.ajax({
	                                method: 'POST',
	                                url: "/bubbleUpload",
	                                contentType: false,
	                                processData: false,
	                                data: data,
	                                dataType: 'text'
	                            })];
	                    case 2:
	                        response = _a.sent();
	                        return [2 /*return*/, response];
	                    case 3:
	                        error_2 = _a.sent();
	                        console.error(error_2);
	                        return [3 /*break*/, 4];
	                    case 4: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    RestService.uploadCsv = function (csv) {
	        return __awaiter(this, void 0, void 0, function () {
	            var fd, error_3;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        console.log(csv);
	                        fd = new FormData();
	                        fd.append('file', csv);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, $.ajax({
	                                type: 'POST',
	                                url: '/uploadCsv',
	                                contentType: false,
	                                processData: false,
	                                data: fd
	                            })];
	                    case 2:
	                        _a.sent();
	                        return [3 /*break*/, 4];
	                    case 3:
	                        error_3 = _a.sent();
	                        console.error(error_3);
	                        RestService.handlerError(error_3);
	                        return [3 /*break*/, 4];
	                    case 4: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    RestService.getSegments = function (callback) {
	        $.ajax({
	            type: 'GET',
	            url: '/rest/api/v0/segment/getall',
	            contentType: false,
	            processData: false,
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                console.error(response);
	                RestService.handlerError(response);
	                callback(null);
	            }
	        });
	    };
	    RestService.addSegment = function (newSegment, callback) {
	        $.ajax({
	            type: 'POST',
	            dataType: 'json',
	            contentType: 'application/json',
	            url: '/rest/api/v0/segment/add',
	            data: JSON.stringify(newSegment),
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                RestService.handlerError(response);
	                console.error(response);
	            }
	        });
	    };
	    RestService.getBubbles = function (callback) {
	        $.ajax({
	            type: 'GET',
	            url: '/rest/api/v0/bubble/getBubble/',
	            contentType: false,
	            processData: false,
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                console.error(response);
	                RestService.handlerError(response);
	                callback(null);
	            }
	        });
	    };
	    RestService.addUpdateBubble = function (bubbleData, callback) {
	        $.ajax({
	            type: 'POST',
	            dataType: 'json',
	            contentType: 'application/json',
	            url: '/rest/api/v0/bubble/updateBubble/ ',
	            data: JSON.stringify(bubbleData),
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                RestService.handlerError(response);
	                console.error(response);
	            }
	        });
	    };
	    RestService.getEUs = function (callback) {
	        $.ajax({
	            type: 'GET',
	            contentType: 'application/json',
	            url: '/rest/api/v0/javelin/eu',
	            success: function (euResponse) {
	                callback(euResponse);
	            },
	            error: function (response) {
	                RestService.handlerError(response);
	                console.error(response);
	            }
	        });
	    };
	    RestService.generateHash = function (string, callback) {
	        RestService.authClient
	            .generatePasswordHash(string, function () { })
	            .done(function (result) {
	            console.log(result);
	            callback(result, null);
	        })
	            .fail(function (result) {
	            console.error(result);
	            RestService.handlerError(result);
	            callback(null, result);
	        });
	    };
	    RestService.handlerError = function (result) {
	        Utils_1["default"].openNewTab('/#/error?html=' + encodeURIComponent(result.responseText));
	    };
	    RestService.getEmojis = function (auth, callback) {
	        $.ajax({
	            type: 'GET',
	            url: Utils_1["default"].getContextualEmojiUrl() + "/api/v1/emojis",
	            headers: {
	                Authorization: auth
	            },
	            contentType: false,
	            processData: false,
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (error) {
	                RestService.handlerError(error);
	                callback(null);
	            }
	        });
	    };
	    RestService.getDraftEmojiMapping = function (auth, draftId, callback) {
	        $.ajax({
	            type: 'GET',
	            url: Utils_1["default"].getContextualEmojiUrl() + "/api/v1/glance-emojis?glanceIds=" + draftId,
	            headers: {
	                Authorization: auth
	            },
	            contentType: false,
	            processData: false,
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (error) {
	                RestService.handlerError(error);
	                callback(null);
	            }
	        });
	    };
	    RestService.submitEmoji = function (auth, payload, callback) {
	        console.log('Rest service', payload);
	        $.ajax({
	            type: 'POST',
	            url: Utils_1["default"].getContextualEmojiUrl() + "/api/v1/glance-emojis",
	            headers: {
	                Authorization: auth
	            },
	            contentType: 'application/json',
	            processData: false,
	            data: JSON.stringify(payload),
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                RestService.handlerError(response);
	                console.error(response);
	            }
	        });
	    };
	    RestService.uploadEmoji = function (auth, emojis, callback, errorCallback) {
	        $.ajax({
	            type: 'POST',
	            url: Utils_1["default"].getContextualEmojiUrl() + "/api/v1/emojis",
	            headers: {
	                Authorization: auth
	            },
	            contentType: false,
	            processData: false,
	            data: emojis,
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                errorCallback(JSON.parse(response.responseText));
	            }
	        });
	    };
	    RestService.getCDNData = function (callback, url) {
	        $.ajax({
	            type: 'GET',
	            url: url,
	            contentType: false,
	            processData: false,
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (error) {
	                callback(null);
	            }
	        });
	    };
	    RestService.authClient = new gl.AuthServiceClient(new gl.Thrift.Protocol(new gl.Thrift.Transport('/auth')));
	    RestService.partnerClient = new gl.PartnerServiceClient(new gl.Thrift.Protocol(new gl.Thrift.Transport('/api/glance/partner')));
	    RestService.draftClient = new gl.GlanceDraftServiceClient(new gl.Thrift.Protocol(new gl.Thrift.Transport('/api/glance/draft')));
	    RestService.confClient = new gl.GlanceConfigServiceClient(new gl.Thrift.Protocol(new gl.Thrift.Transport('/api/config')));
	    RestService.dataClient = new gl.GlanceDataServiceClient(new gl.Thrift.Protocol(new gl.Thrift.Transport('/api/glance/data')));
	    return RestService;
	}());
	exports["default"] = RestService;


/***/ },

/***/ 83:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var Utils_1 = __webpack_require__(17);
	var JerseyRestApiService = /** @class */ (function () {
	    function JerseyRestApiService() {
	    }
	    JerseyRestApiService.getAllActivePublishers = function (callback) {
	        $.ajax({
	            type: 'GET',
	            url: '/rest/api/v0/publisher/getallactive',
	            contentType: false,
	            processData: false,
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                console.error(response);
	                JerseyRestApiService.handlerError(response);
	                callback(null);
	            }
	        });
	    };
	    JerseyRestApiService.getSegmentQueries = function () {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'GET',
	                url: "/rest/api/v0/segmentquery/all",
	                contentType: false,
	                processData: false,
	                success: function (segmentQueries) {
	                    resolve(segmentQueries);
	                },
	                error: function (error) {
	                    console.error(error);
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.getAllSegmentSource = function () {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'GET',
	                url: '/rest/api/v0/value/segment-source/all',
	                contentType: false,
	                processData: false,
	                success: function (segmentSources) {
	                    resolve(segmentSources);
	                },
	                error: function (error) {
	                    console.error(error);
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.getAllSegmentTargets = function () {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'GET',
	                url: '/rest/api/v0/value/segment-target/all',
	                contentType: false,
	                processData: false,
	                success: function (segmentTargets) {
	                    resolve(segmentTargets);
	                },
	                error: function (error) {
	                    console.error(error);
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.addSegmentQuery = function (payload) {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'POST',
	                url: '/rest/api/v0/segmentquery/add',
	                data: JSON.stringify(payload),
	                contentType: 'application/json',
	                success: function (dataResponse) {
	                    resolve(dataResponse);
	                },
	                error: function (error) {
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.updateSegmentQuery = function (payload) {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'POST',
	                url: '/rest/api/v0/segmentquery/update',
	                data: JSON.stringify(payload),
	                contentType: 'application/json',
	                success: function (dataResponse) {
	                    resolve(dataResponse);
	                },
	                error: function (error) {
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.getAllDrafts = function (payload) {
	        return new Promise(function (resolve, reject) {
	            var _a = payload.limit, limit = _a === void 0 ? 10 : _a, _b = payload.offset, offset = _b === void 0 ? 0 : _b, categoryIds = payload.categoryIds, publisherId = payload.publisherId, createdAfterSeconds = payload.createdAfterSeconds, type = payload.type;
	            $.ajax({
	                type: 'POST',
	                url: "/rest/api/v0/glancestore/draft",
	                contentType: 'application/json',
	                data: JSON.stringify({
	                    categoryIds: categoryIds,
	                    publisherId: publisherId,
	                    createdAfterSeconds: createdAfterSeconds,
	                    type: type,
	                    limit: limit,
	                    offset: offset
	                }),
	                success: function (drafts) {
	                    var results = drafts.results;
	                    resolve(results);
	                },
	                error: function (error) {
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.getDraftsByPartnerAndRegion = function (payload) {
	        return new Promise(function (resolve, reject) {
	            var _a = payload.limit, limit = _a === void 0 ? 10 : _a, _b = payload.offset, offset = _b === void 0 ? 0 : _b, categoryIds = payload.categoryIds, publisherId = payload.publisherId, createdAfterSeconds = payload.createdAfterSeconds, type = payload.type, partnerId = payload.partnerId, region = payload.region, isPublished = payload.isPublished;
	            $.ajax({
	                type: 'POST',
	                url: "/rest/api/v0/glancestore/draft/meta",
	                contentType: 'application/json',
	                data: JSON.stringify({
	                    categoryIds: categoryIds,
	                    createdAfterSeconds: createdAfterSeconds,
	                    type: type,
	                    limit: limit,
	                    offset: offset,
	                    partnerId: partnerId,
	                    region: region,
	                    isPublished: isPublished,
	                    publisherId: publisherId
	                }),
	                success: function (drafts) {
	                    var results = drafts.results;
	                    resolve(results);
	                },
	                error: function (error) {
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.getGlances = function (data, successCallback, errorCallback) {
	        var _a = data.limit, limit = _a === void 0 ? 10 : _a, _b = data.offset, offset = _b === void 0 ? 0 : _b;
	        var partnerId = data.partnerId, search = data.search, type = data.type, state = data.state, region = data.region, isExpiry = data.isExpiry;
	        $.ajax({
	            type: 'POST',
	            url: "/rest/api/v0/glancestore/pair",
	            contentType: 'application/json',
	            data: JSON.stringify({
	                partnerId: partnerId,
	                search: search,
	                type: type,
	                state: state,
	                region: region,
	                isExpiry: isExpiry,
	                limit: limit,
	                offset: offset
	            }),
	            success: function (glances) {
	                successCallback(glances);
	            },
	            error: function (error) {
	                errorCallback(error);
	            }
	        });
	    };
	    JerseyRestApiService.getInternalGlances = function (data, successCallback, errorCallback) {
	        var search = data.search, type = data.type, state = data.state, region = data.region, isExpiry = data.isExpiry, categoryIds = data.categoryIds, publisherId = data.publisherId, storyType = data.storyType, limit = data.limit, offset = data.offset, isWebpeek = data.isWebpeek;
	        $.ajax({
	            type: 'POST',
	            url: "/rest/api/v0/glancestore/data/meta",
	            contentType: 'application/json',
	            data: JSON.stringify({
	                search: search,
	                type: type,
	                state: state,
	                region: region,
	                isExpiry: isExpiry,
	                limit: limit,
	                offset: offset,
	                categoryIds: categoryIds,
	                publisherId: publisherId,
	                storyType: storyType,
	                isWebpeek: isWebpeek
	            }),
	            success: function (glances) {
	                successCallback(glances);
	            },
	            error: function (error) {
	                errorCallback(error);
	            }
	        });
	    };
	    JerseyRestApiService.approveInternalGlances = function (region, glanceIds, callback) {
	        $.ajax({
	            type: 'POST',
	            url: "/rest/api/v0/internal/approval/approve?region" + region,
	            contentType: 'application/json',
	            data: JSON.stringify(glanceIds),
	            success: function (dataResponse) {
	                callback(true);
	            },
	            error: function (response) {
	                console.error(response);
	                JerseyRestApiService.handlerError(response);
	                callback(false);
	            }
	        });
	    };
	    JerseyRestApiService.rejectInternalGlances = function (region, rejectReason, glanceIds, callback) {
	        $.ajax({
	            type: 'POST',
	            url: "/rest/api/v0/internal/approval/reject?region=" + region + "&rejectReason=" + rejectReason,
	            contentType: 'application/json',
	            data: JSON.stringify(glanceIds),
	            success: function (dataResponse) {
	                callback(true);
	            },
	            error: function (response) {
	                console.error(response);
	                JerseyRestApiService.handlerError(response);
	                callback(false);
	            }
	        });
	    };
	    JerseyRestApiService.uploadFileToBlob = function (payload) {
	        var folderPath = payload.folderPath, subFolderPath = payload.subFolderPath, formData = payload.formData;
	        var append = subFolderPath === '-1' ? '' : "/" + subFolderPath;
	        var path = "" + folderPath + append;
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'POST',
	                url: "/rest/api/v0/upload/file?path=" + (path + '/'),
	                processData: false,
	                contentType: false,
	                data: formData,
	                success: function (response, textStatus, xhr) {
	                    resolve({ message: response, statusCode: xhr.status });
	                },
	                error: function (XMLHttpRequest, textStatus, errorThrown) {
	                    reject(XMLHttpRequest.statusText);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.targetUserNotification = function (payload) {
	        var formData = payload.formData;
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'POST',
	                url: "/rest/api/v0/fcm/user/file",
	                processData: false,
	                contentType: false,
	                data: formData,
	                success: function (response) {
	                    resolve(response);
	                },
	                error: function (XMLHttpRequest, textStatus, errorThrown) {
	                    reject(XMLHttpRequest.statusText);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.getAllPublishers = function (callback) {
	        $.ajax({
	            type: 'GET',
	            url: '/rest/api/v0/publisher/getall',
	            contentType: false,
	            processData: false,
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                console.error(response);
	                JerseyRestApiService.handlerError(response);
	                callback(null);
	            }
	        });
	    };
	    JerseyRestApiService.removePublisher = function (publisherId) {
	        $.ajax({
	            type: 'GET',
	            url: '/rest/api/v0/publisher/' + publisherId + '/remove',
	            contentType: false,
	            processData: false,
	            success: function (dataResponse) { },
	            error: function (response) {
	                console.error(response);
	                JerseyRestApiService.handlerError(response);
	            }
	        });
	    };
	    JerseyRestApiService.sendNotification = function (settings, callback) {
	        var requestData = JSON.stringify(settings);
	        $.ajax({
	            type: 'GET',
	            url: '/rest/api/v0/fcm/user/engage',
	            data: { userEngageNotification: requestData, view: settings.view },
	            success: function (dataResponse) {
	                console.log(dataResponse);
	                callback(dataResponse);
	            },
	            error: function (response) {
	                console.error(response);
	                JerseyRestApiService.handlerError(response);
	            }
	        });
	    };
	    JerseyRestApiService.addPublisher = function (newPublisher, callback) {
	        $.ajax({
	            type: 'GET',
	            url: '/rest/api/v0/publisher/add',
	            data: {
	                publisher: newPublisher
	            },
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                console.error(response);
	                JerseyRestApiService.handlerError(response);
	            }
	        });
	    };
	    JerseyRestApiService.updatePublisher = function (newPublisher, callback) {
	        $.ajax({
	            type: 'GET',
	            url: '/rest/api/v0/publisher/update',
	            data: {
	                publisher: newPublisher
	            },
	            success: function (dataResponse) {
	                callback(dataResponse);
	            },
	            error: function (response) {
	                console.error(response);
	                JerseyRestApiService.handlerError(response);
	            }
	        });
	    };
	    JerseyRestApiService.getCampaignObjectives = function () {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'GET',
	                url: "/rest/api/v0/value/campaign-objective/all",
	                contentType: false,
	                processData: false,
	                success: function (campaignObjectives) {
	                    resolve(campaignObjectives);
	                },
	                error: function (error) {
	                    console.error(error);
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.getSearchBubbles = function (val) {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'GET',
	                url: "/rest/api/v0/bubble/search?q=" + val + "&limit=10",
	                contentType: false,
	                processData: false,
	                success: function (data) {
	                    var filteredData = data.map(function (item) {
	                        var bubbleId = item.bubbleId, name = item.name, qualifier = item.qualifier, imagePath = item.imagePath, storyCount = item.storyCount, glanceType = item.glanceType, adCoefficient = item.adCoefficient, bucketPriority = item.bucketPriority, ecpm = item.ecpm;
	                        return {
	                            bubbleId: bubbleId,
	                            name: name,
	                            qualifier: qualifier,
	                            imagePath: imagePath,
	                            storyCount: storyCount,
	                            glanceType: glanceType,
	                            adCoefficient: adCoefficient,
	                            bucketPriority: bucketPriority,
	                            ecpm: ecpm
	                        };
	                    });
	                    resolve(filteredData);
	                },
	                error: function (error) {
	                    console.error(error);
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.getBubbleById = function (id) {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'GET',
	                url: "/rest/api/v0/bubble/?ids=" + id,
	                contentType: false,
	                processData: false,
	                success: function (data) {
	                    var transformedData = data.reduce(function (acc, val) {
	                        acc[val.bubbleId] = val;
	                        return acc;
	                    }, {});
	                    resolve(transformedData);
	                },
	                error: function (error) {
	                    console.error(error);
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.handlerError = function (result) {
	        Utils_1["default"].openNewTab('/#/error?html=' + encodeURIComponent(result.responseText));
	    };
	    JerseyRestApiService.getAvailableRank = function (bubbleId) {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'GET',
	                url: "/rest/api/v0/bubble/filledStorySlots?bubbleId=" + bubbleId,
	                contentType: false,
	                processData: false,
	                success: function (data) {
	                    resolve(data);
	                },
	                error: function (error) {
	                    console.error(error);
	                    reject(error);
	                }
	            });
	        });
	    };
	    JerseyRestApiService.getCityStates = function () {
	        return new Promise(function (resolve, reject) {
	            $.ajax({
	                type: 'GET',
	                url: "/rest/api/v0/targetingrules/all-defaults",
	                contentType: false,
	                processData: false,
	                success: function (data) {
	                    resolve(data);
	                },
	                error: function (error) {
	                    console.error(error);
	                    reject(error);
	                }
	            });
	        });
	    };
	    return JerseyRestApiService;
	}());
	exports["default"] = JerseyRestApiService;


/***/ },

/***/ 110:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(519);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(150)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/stripcomment-loader/index.js!./style.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/stripcomment-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 111:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var gl = __webpack_require__(67);
	var Constants = /** @class */ (function () {
	    function Constants() {
	    }
	    Constants.SERVER_END_POINT = 'http://localhost:8080/';
	    Constants.PARTNER_API_PATH = 'api/glance/partner/';
	    Constants.PUBLISH_API_PATH = 'api/glance/data/';
	    Constants.DRAFT_API_PATH = 'api/glance/draft/';
	    Constants.PARTNER = new gl.Partner({
	        partnerId: 'fa647c9e01a2defa9fdc483a9a3352d003cb003d',
	        name: 'ZTE'
	    });
	    Constants.CDN_PREFIX = 'https://gcs.dev.glance.com/public/';
	    // public static setCdnPrefix(value: string) {
	    //     Constants.CDN_PREFIX = value
	    // }
	    Constants.GAMBIT_URL_DEV = 'https://gambit-dev.glance.inmobi.com';
	    Constants.GAMBIT_URL_STAGING = 'https://gambit-staging.glance.inmobi.com';
	    Constants.GAMBIT_URL_PROD = 'https://gambit.glance.inmobi.com';
	    Constants.CONTEXTUAL_EMOJI_PROD = 'https://glance-tv-interaction.glance.inmobi.com';
	    Constants.CONTEXTUAL_EMOJI_STAGING = 'https://glance-tv-interaction-staging.glance.inmobi.com';
	    Constants.CONTEXTUAL_EMOJI_DEV = 'https://glance-tv-interaction-staging.glance.inmobi.com';
	    Constants.CONTENT_FOR_APPS = '#content_for_apps';
	    Constants.CONTENT_CARDS_ADMINS = [
	        'bharat.p',
	        'rohan.kini',
	        'jatin.choyal',
	        'nikhil.mukundan',
	        'premanand.maharana',
	        'puneet.aggarwal',
	        'ram.prasad',
	        'suman.reddy',
	        'gaurav.saini',
	    ];
	    Constants.BEACON_PARTNERS = [
	        'Appsflyer',
	        'Branch',
	        'Firebase',
	        'Kochava',
	        'DCM',
	        'Sizemek',
	        'DV',
	        'Neilson',
	        'None'
	    ];
	    return Constants;
	}());
	var Partners = /** @class */ (function () {
	    function Partners() {
	    }
	    Partners.SAMSUNG_ANDROID_PARTNER_ID = '16b66d7123dd588670e011bbb88bec9c0a27359c';
	    Partners.TEST_PARTNER_ID = 'test-partner-id';
	    Partners.VIVO_PARTNER_ID = 'feb4e5ad0039fee86e4870dd3ca88c28a8ee1a1e';
	    Partners.OPPO_PARTNER_ID = 'd1f143bd74d8977c781204281564a93f';
	    Partners.OPPO_API_PARTNER_ID = 'b27cbb02e015198844783efe6db1d580';
	    Partners.TRANSSION_PARTNER_ID = "b366fc7948b55d41976cf3014f616f6f";
	    return Partners;
	}());
	exports.Partners = Partners;
	exports["default"] = Constants;


/***/ },

/***/ 125:
/***/ function(module, exports) {

	"use strict";
	exports.__esModule = true;
	var TypeFilter;
	(function (TypeFilter) {
	    TypeFilter[TypeFilter["ALL"] = 0] = "ALL";
	    TypeFilter[TypeFilter["WALLPAPER"] = 1] = "WALLPAPER";
	    TypeFilter[TypeFilter["STORY"] = 2] = "STORY";
	    TypeFilter[TypeFilter["SPONSORED"] = 3] = "SPONSORED";
	    TypeFilter[TypeFilter["NEWS"] = 4] = "NEWS";
	    TypeFilter[TypeFilter["FEATURE"] = 5] = "FEATURE";
	    TypeFilter[TypeFilter["GLANCETV"] = 6] = "GLANCETV";
	})(TypeFilter = exports.TypeFilter || (exports.TypeFilter = {}));
	var PublishFilter;
	(function (PublishFilter) {
	    PublishFilter[PublishFilter["ALL"] = 0] = "ALL";
	    PublishFilter[PublishFilter["UNPUBLISHED"] = 1] = "UNPUBLISHED";
	    PublishFilter[PublishFilter["PUBLISHED"] = 2] = "PUBLISHED";
	})(PublishFilter = exports.PublishFilter || (exports.PublishFilter = {}));
	var RegionFilter;
	(function (RegionFilter) {
	    RegionFilter[RegionFilter["ANY"] = 0] = "ANY";
	    RegionFilter[RegionFilter["SPECIFIC"] = 1] = "SPECIFIC";
	})(RegionFilter = exports.RegionFilter || (exports.RegionFilter = {}));
	var SortItem;
	(function (SortItem) {
	    SortItem[SortItem["PRIORITY_ASC"] = 0] = "PRIORITY_ASC";
	    SortItem[SortItem["PRIORITY_DESC"] = 1] = "PRIORITY_DESC";
	    SortItem[SortItem["DEFAULT"] = 2] = "DEFAULT";
	})(SortItem = exports.SortItem || (exports.SortItem = {}));
	var BeaconType;
	(function (BeaconType) {
	    BeaconType[BeaconType["RENDER"] = 0] = "RENDER";
	    BeaconType[BeaconType["VIDEO"] = 1] = "VIDEO";
	    BeaconType[BeaconType["CTA"] = 2] = "CTA";
	    BeaconType[BeaconType["PEEK"] = 3] = "PEEK";
	    BeaconType[BeaconType["LIKE"] = 4] = "LIKE";
	    BeaconType[BeaconType["SHARE"] = 5] = "SHARE";
	    BeaconType[BeaconType["HOLD"] = 6] = "HOLD";
	    BeaconType[BeaconType["APP_SUBMIT"] = 7] = "APP_SUBMIT";
	    BeaconType[BeaconType["INSTALL_NOW"] = 8] = "INSTALL_NOW";
	    BeaconType[BeaconType["INSTALL_LATER"] = 9] = "INSTALL_LATER";
	    BeaconType[BeaconType["INSTALL_COMPLETE"] = 10] = "INSTALL_COMPLETE";
	    BeaconType[BeaconType["APP_OPEN"] = 11] = "APP_OPEN";
	    BeaconType[BeaconType["VIDEO_STARTED"] = 12] = "VIDEO_STARTED";
	    BeaconType[BeaconType["GLANCE_STARTED"] = 13] = "GLANCE_STARTED";
	    BeaconType[BeaconType["PRIVIEW_TAP"] = 14] = "PRIVIEW_TAP";
	    BeaconType[BeaconType["VIDEO_VIEWED"] = 15] = "VIDEO_VIEWED";
	    BeaconType[BeaconType["GLANCE_VIEWED"] = 16] = "GLANCE_VIEWED";
	})(BeaconType = exports.BeaconType || (exports.BeaconType = {}));


/***/ },

/***/ 151:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var _a;
	var React = __webpack_require__(1);
	exports.utcTimeZone = {
	    city: 'GreenWich',
	    code: 'UTC',
	    hours: 0,
	    minutes: 0
	};
	exports.usTimezone = {
	    city: 'New York',
	    code: 'EST',
	    hours: -5,
	    minutes: 0
	};
	exports.chinaTimezone = {
	    city: 'Beijing',
	    code: 'CST',
	    hours: 8,
	    minutes: 0
	};
	exports.indiaTimezone = {
	    city: 'Calcutta',
	    code: 'IST',
	    hours: 5,
	    minutes: 30
	};
	exports.krTimezone = {
	    city: 'Seoul',
	    code: 'KST',
	    hours: 9,
	    minutes: 0
	};
	exports.idTimezone = {
	    city: 'Jakarta',
	    code: 'IWST',
	    hours: 7,
	    minutes: 0
	};
	exports.defaultTimezone = exports.utcTimeZone;
	exports.regionTimeZones = (_a = {},
	    _a[3 /* CN */] = ['CST-B'],
	    _a[24 /* AU */] = ['UTC'],
	    _a[22 /* BD */] = ['UTC'],
	    _a[6 /* HK */] = ['UTC'],
	    _a[20 /* KE */] = ['UTC'],
	    _a[25 /* NZ */] = ['UTC'],
	    _a[19 /* LA */] = ['UTC'],
	    _a[18 /* LK */] = ['UTC'],
	    _a[21 /* MA */] = ['UTC'],
	    _a[23 /* NP */] = ['UTC'],
	    _a[12 /* PK */] = ['UTC'],
	    _a[13 /* RU */] = ['UTC'],
	    _a[16 /* TW */] = ['UTC'],
	    _a[17 /* VN */] = ['UTC'],
	    _a[7 /* KH */] = ['UTC'],
	    _a[11 /* PH */] = ['UTC'],
	    _a[14 /* SG */] = ['UTC'],
	    _a[8 /* MM */] = ['UTC'],
	    _a[15 /* TH */] = ['UTC'],
	    _a[10 /* MY */] = ['UTC'],
	    _a[2 /* IN */] = ['IST'],
	    _a[1 /* US */] = [
	        'PST',
	        // 'MST',
	        'CST',
	        'EST',
	    ],
	    _a[4 /* KR */] = ['KST'],
	    _a[5 /* ID */] = ['IWST', 'ICST', 'IEST'],
	    _a[99 /* GLOBAL */] = ['UTC'],
	    _a[97 /* ISLAMIC */] = ['UTC'],
	    _a[98 /* NON_ISLAMIC */] = ['UTC'],
	    _a[26 /* MX */] = ['UTC'],
	    _a[27 /* BR */] = ['UTC'],
	    _a[28 /* CO */] = ['UTC'],
	    _a[29 /* JP */] = ['UTC'],
	    _a[30 /* AT */] = ['UTC'],
	    _a[31 /* DE */] = ['UTC'],
	    _a[32 /* NG */] = ['UTC'],
	    _a[33 /* GB */] = ['UTC'],
	    _a[-1] = ['UTC'],
	    _a);
	exports.timeZonesMap = new Map();
	//UTC as default
	exports.timeZonesMap.set('UTC', {
	    city: 'GreenWich',
	    code: 'UTC',
	    hours: 0,
	    minutes: 0
	});
	//India Timezones
	exports.timeZonesMap.set('IST', {
	    city: 'Calcutta',
	    code: 'IST',
	    hours: 5,
	    minutes: 30
	});
	//China Timezones
	exports.timeZonesMap.set('CST-B', {
	    city: 'Beijing',
	    code: 'CST',
	    hours: 8,
	    minutes: 0
	});
	//US Timezones
	exports.timeZonesMap.set('EST', {
	    city: 'New York',
	    code: 'EST',
	    hours: -5,
	    minutes: 0
	});
	exports.timeZonesMap.set('CST', {
	    city: 'Chicago',
	    code: 'CST',
	    hours: -6,
	    minutes: 0
	});
	// timeZonesMap.set('MST', {city: 'Salt Lake City',code: 'MST', hours: -7, minutes: 0})
	exports.timeZonesMap.set('PST', {
	    city: 'Los Angeles',
	    code: 'PST',
	    hours: -8,
	    minutes: 0
	});
	//Korea Timezones
	exports.timeZonesMap.set('KST', { city: 'Seoul', code: 'KST', hours: 9, minutes: 0 });
	//Indonesia Timezones
	exports.timeZonesMap.set('IWST', {
	    city: 'Jakarta',
	    code: 'IWST',
	    hours: 7,
	    minutes: 0
	});
	exports.timeZonesMap.set('ICST', {
	    city: 'Makassar',
	    code: 'ICST',
	    hours: 8,
	    minutes: 0
	});
	exports.timeZonesMap.set('IEST', {
	    city: 'Manokwari',
	    code: 'IEST',
	    hours: 9,
	    minutes: 0
	});
	var ClockWithTimezone = /** @class */ (function (_super) {
	    __extends(ClockWithTimezone, _super);
	    function ClockWithTimezone(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {};
	        return _this;
	    }
	    ClockWithTimezone.prototype.componentWillMount = function () {
	        this.setTime();
	    };
	    ClockWithTimezone.prototype.componentDidMount = function () {
	        var _this = this;
	        var timerID = setInterval(function () { return _this.setTime(); }, 1000 * 60);
	        this.setState(__assign({}, this.state, { timerId: timerID }));
	    };
	    ClockWithTimezone.prototype.componentWillUnmount = function () {
	        clearInterval(this.state.timerId);
	    };
	    ClockWithTimezone.prototype.getTimezone = function () {
	        return this.props.timezone ? this.props.timezone : exports.defaultTimezone;
	    };
	    ClockWithTimezone.prototype.setTime = function () {
	        var timezone = this.getTimezone();
	        var currentdate = new Date();
	        currentdate.setHours(currentdate.getUTCHours() + timezone.hours);
	        currentdate.setMinutes(currentdate.getUTCMinutes() + timezone.minutes);
	        var hoursNumber = currentdate.getHours();
	        // correct for number over 24, and negatives
	        // if ( hoursNumber >= 24 ){ hoursNumber -= 24; }
	        // if ( hoursNumber < 0   ){ hoursNumber += 12; }
	        // add leading zero, first convert hours to string
	        var hours = hoursNumber + '';
	        if (hours.length == 1) {
	            hours = '0' + hours;
	        }
	        // minutes are the same on every time zone
	        var minutesNumber = currentdate.getMinutes();
	        // add leading zero, first convert hours to string
	        var minutes = minutesNumber + '';
	        if (minutes.length == 1) {
	            minutes = '0' + minutes;
	        }
	        this.setState(__assign({}, this.state, { hours: hours, minutes: minutes }));
	    };
	    ClockWithTimezone.prototype.render = function () {
	        var timezone = this.getTimezone();
	        return (React.createElement("span", { style: this.props.customStyle },
	            timezone.city,
	            ' ',
	            React.createElement("span", { style: { backgroundColor: 'rgba(0,0, 0, 0.3)', padding: '5px' } },
	                this.state.hours,
	                ":",
	                this.state.minutes,
	                " ",
	                timezone.code)));
	    };
	    return ClockWithTimezone;
	}(React.Component));
	exports.ClockWithTimezone = ClockWithTimezone;
	exports["default"] = ClockWithTimezone;


/***/ },

/***/ 152:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var Dropzone = __webpack_require__(390);
	var React = __webpack_require__(1);
	var styles = {
	    draftStyle: {
	        margin: 'auto',
	        padding: '4px',
	        objectFit: 'contain',
	        width: '50px',
	        height: 'fit-content'
	    },
	    imageHeightAuto: {
	        margin: 'auto',
	        padding: '4px',
	        objectFit: 'contain',
	        width: '50px',
	        height: 'auto'
	    },
	    bubbleCreateStyle: {
	        margin: 'auto',
	        width: '116px',
	        height: '130px',
	        padding: '3px',
	        objectFit: 'contain'
	    },
	    bubbleEditStyle: {
	        margin: 'auto',
	        width: '150px',
	        height: '168.1px',
	        padding: '3px',
	        objectFit: 'contain'
	    }
	};
	var ImageDropzone = /** @class */ (function (_super) {
	    __extends(ImageDropzone, _super);
	    function ImageDropzone() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ImageDropzone.prototype.render = function () {
	        var _a = this.props, onDrop = _a.onDrop, width = _a.width, height = _a.height, imgUrl = _a.imgUrl, style = _a.style, custom_ref = _a.custom_ref, disableClick = _a.disableClick, flex = _a.flex, text = _a.text, bubbleCreate = _a.bubbleCreate, bubbleEdit = _a.bubbleEdit, draftImageHeight = _a.draftImageHeight;
	        return (React.createElement(Dropzone, { onDrop: onDrop, ref: custom_ref, multiple: false, style: __assign({ width: width ? width : '100%', height: height ? height : '100%', border: '2px dashed rgb(102, 102, 102)' }, style), accept: 'image/*', disableClick: disableClick },
	            React.createElement("div", { className: "text-center", style: { verticalAlign: 'center' } },
	                React.createElement("div", { style: flex ? { display: 'inline-flex' } : null }, text ? (React.createElement("div", { style: { margin: 'auto' } }, text)) : (React.createElement("img", { src: imgUrl ? imgUrl : '../../assets/images/no_img.png', style: bubbleCreate
	                        ? styles.bubbleCreateStyle
	                        : bubbleEdit
	                            ? styles.bubbleEditStyle
	                            : draftImageHeight
	                                ? styles.imageHeightAuto
	                                : styles.draftStyle }))))));
	    };
	    return ImageDropzone;
	}(React.Component));
	exports.ImageDropzone = ImageDropzone;
	exports["default"] = ImageDropzone;


/***/ },

/***/ 153:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var style = {
	    container: {
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        height: '80vh'
	    }
	};
	var EmptyMessage = function (props) {
	    var _a = props.message, message = _a === void 0 ? '' : _a;
	    return (React.createElement("div", { style: style.container },
	        React.createElement("h1", null, message)));
	};
	exports["default"] = EmptyMessage;


/***/ },

/***/ 154:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var RefreshIndicator_1 = __webpack_require__(324);
	var style = {
	    container: {
	        position: 'relative',
	        textAlign: 'center',
	        display: 'flex',
	        flexFlow: 'column',
	        justifyContent: 'center',
	        alignItems: 'center'
	    },
	    refresh: {
	        display: 'inline-block',
	        position: 'relative'
	    }
	};
	var Loader = function (props) {
	    var show = props.show, children = props.children, _a = props.message, message = _a === void 0 ? '' : _a, noHeight = props.noHeight;
	    var minHeight = noHeight ? '300px' : '80vh';
	    var styles = __assign({}, style.container, { minHeight: minHeight });
	    return (React.createElement("div", null, show ? (React.createElement("div", { style: styles },
	        React.createElement("div", null,
	            React.createElement(RefreshIndicator_1["default"], { size: 40, left: 10, top: 0, status: 'loading', style: style.refresh })),
	        React.createElement("h1", null, message))) : (children)));
	};
	exports["default"] = Loader;


/***/ },

/***/ 182:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 246:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var material_ui_1 = __webpack_require__(38);
	var colors_1 = __webpack_require__(18);
	var GlanceCard_1 = __webpack_require__(978);
	var Utils_1 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var articleIcon = React.createElement(material_ui_1.FontIcon, { className: 'material-icons' }, "web");
	var videoIcon = React.createElement(material_ui_1.FontIcon, { className: 'material-icons' }, "play_circle_outline");
	var styles = {
	    button: {
	        marginTop: '0px'
	    },
	    stateLabel: {
	        borderRadius: '50px',
	        display: 'inline-block',
	        padding: '5px',
	        color: '#fff',
	        position: 'absolute',
	        right: 0,
	        zIndex: 3,
	        fontSize: '10px'
	    },
	    deleteButton: {
	        color: colors_1.red500,
	        background: colors_1.red300
	    },
	    removedGlanceBackground: {
	        backgroundColor: '#E8E8E8'
	    },
	    selectButton: {
	        color: colors_1.black,
	        background: colors_1.grey300
	    },
	    selectedButton: {
	        color: colors_1.green500,
	        background: colors_1.green300
	    },
	    selectedGlanceCard: {
	        backgroundColor: colors_1.cyan100
	    },
	    articleButton: {},
	    nativeButton: {
	        backgroundColor: '#3b5998',
	        color: '#8b9dc3'
	    },
	    facebookButton: {
	        backgroundColor: '#3b5998',
	        color: '#8b9dc3'
	    },
	    youtubeButton: {
	        backgroundColor: '#cc181e',
	        color: '#f1f1f1'
	    },
	    instaButton: {
	        backgroundColor: '#125688',
	        color: '#f1f1f1'
	    },
	    youkuButton: {
	        backgroundColor: '#EE4023',
	        color: '#06A6E0'
	    }
	};
	var Glance = /** @class */ (function (_super) {
	    __extends(Glance, _super);
	    function Glance(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            openDetailsDialog: false
	        };
	        _this.openDetailsDialog = _this.openDetailsDialog.bind(_this);
	        _this.closeDetailsDialog = _this.closeDetailsDialog.bind(_this);
	        _this.onSelect = _this.onSelect.bind(_this);
	        return _this;
	    }
	    Glance.prototype.onSelect = function () {
	        var selected = !this.props.selected;
	        this.props.onSelect(selected);
	    };
	    Glance.prototype.openDetailsDialog = function () {
	        this.setState(__assign({}, this.state, { openDetailsDialog: true }));
	    };
	    Glance.prototype.closeDetailsDialog = function () {
	        this.setState(__assign({}, this.state, { openDetailsDialog: false }));
	    };
	    Glance.prototype.render = function () {
	        var isMetaArray = false;
	        if ('partnerIds' in this.props.glance.meta) {
	            isMetaArray = true;
	        }
	        var data = this.props.glance.data;
	        var meta = this.props.glance.meta;
	        var partner = this.props.partner ? this.props.partner.name : '';
	        var selected = this.props.selected;
	        var selectButton = (isMetaArray
	            ? (meta.state == 7 /* INTERNAL_PENDING */)
	            : (meta.state == 1 /* STUDIO_APPROVED */
	                || meta.state == 0 /* INMOBI_APPROVED */
	                || meta.state == 8 /* INTERNAL_APPROVED */
	                || meta.state == 2 /* PARTNER_APPROVED */ || !meta.state)) ? (React.createElement(material_ui_1.Checkbox, { label: '', style: { position: 'absolute' }, key: 'select_button', checked: this.props.selected, onCheck: this.onSelect })) : null;
	        var moreDetailsButton = (React.createElement(material_ui_1.RaisedButton, { key: 'more_details', onClick: this.openDetailsDialog, label: 'Details', primary: true, style: styles.button, icon: React.createElement(material_ui_1.FontIcon, { className: 'material-icons' }, "info"), fullWidth: !this.state.openDetailsDialog }));
	        var closeDetailsButton = (React.createElement(material_ui_1.RaisedButton, { key: 'close_details', onClick: this.closeDetailsDialog, label: 'Close', primary: true, style: styles.button, fullWidth: !this.state.openDetailsDialog, icon: React.createElement(material_ui_1.FontIcon, { className: 'material-icons' }, "close") }));
	        var glanceActions = [];
	        var glanceDialogActions = [];
	        var peekButton;
	        var getUpdatedUrl = function (url) {
	            if (partner === 'Transsion') {
	                var convertedUrl = Utils_1["default"].convertTo3pLite(url);
	                return Utils_1["default"].updateUrlParams(convertedUrl, { utm_medium: 'trans' });
	            }
	            return url;
	        };
	        if (data.peek) {
	            if (data.peek.article) {
	                peekButton = (React.createElement(material_ui_1.RaisedButton, { key: 'peek_article', onClick: function () { Utils_1["default"].openNewTab(getUpdatedUrl(data.peek.article.cta.url)); }, label: 'Read', secondary: true, style: __assign({}, styles.button), buttonStyle: styles.articleButton, icon: articleIcon, fullWidth: !this.state.openDetailsDialog }));
	            }
	            else if (data.peek.nativeVideoPeek && data.peek.nativeVideoPeek.videoUrl) {
	                peekButton = (React.createElement(material_ui_1.RaisedButton, { key: 'peek_facebook', onClick: function () { Utils_1["default"].openNewTab('/#/peek/native?url=' + encodeURIComponent(data.peek.nativeVideoPeek.videoUrl)); }, label: 'Video', primary: true, style: __assign({}, styles.button), buttonStyle: styles.nativeButton, icon: videoIcon, fullWidth: !this.state.openDetailsDialog }));
	            }
	            else if (data.peek.video) {
	                var videoMeta_1 = data.peek.video.video.meta;
	                if (videoMeta_1.facebook) {
	                    peekButton = (React.createElement(material_ui_1.RaisedButton, { key: 'peek_facebook', onClick: function () { Utils_1["default"].openNewTab('/#/peek/facebook/' + videoMeta_1.facebook.id); }, label: 'Facebook', primary: true, style: __assign({}, styles.button), buttonStyle: styles.facebookButton, icon: videoIcon, fullWidth: !this.state.openDetailsDialog }));
	                }
	                else if (videoMeta_1.youtube) {
	                    peekButton = (React.createElement(material_ui_1.RaisedButton, { key: 'peek_youtube', onClick: function () { Utils_1["default"].openNewTab('/#/peek/youtube/' + videoMeta_1.youtube.id); }, label: 'Youtube', primary: true, style: __assign({}, styles.button), buttonStyle: styles.youtubeButton, icon: videoIcon, fullWidth: !this.state.openDetailsDialog }));
	                }
	                else if (videoMeta_1.instagram) {
	                    peekButton = (React.createElement(material_ui_1.RaisedButton, { key: 'peek_insta', onClick: function () { Utils_1["default"].openNewTab('/#/peek/instagram/' + videoMeta_1.instagram.id); }, label: 'Instagram', primary: true, style: __assign({}, styles.button), buttonStyle: styles.instaButton, icon: videoIcon, fullWidth: !this.state.openDetailsDialog }));
	                }
	                else if (videoMeta_1.youku) {
	                    peekButton = (React.createElement(material_ui_1.RaisedButton, { key: 'peek_insta', onClick: function () { Utils_1["default"].openNewTab('/#/peek/youku/' + videoMeta_1.youku.id); }, label: 'Youku', primary: true, style: __assign({}, styles.button), buttonStyle: styles.youkuButton, icon: videoIcon, fullWidth: !this.state.openDetailsDialog }));
	                }
	            }
	        }
	        var stateButtonLabel;
	        if (isMetaArray) {
	            switch (meta.state) {
	                case 7 /* INTERNAL_PENDING */:
	                    stateButtonLabel = 'Approval Pending';
	                    styles.stateLabel.background = colors_1.orange500;
	                    break;
	                case 8 /* INTERNAL_APPROVED */:
	                case 2 /* PARTNER_APPROVED */:
	                    stateButtonLabel = 'Approved';
	                    styles.stateLabel.background = colors_1.green500;
	                    break;
	                case 9 /* INTERNAL_REJECTED */:
	                    stateButtonLabel = 'Rejected';
	                    styles.stateLabel.background = colors_1.red500;
	                    break;
	                default:
	                    stateButtonLabel = 'Approved';
	                    styles.stateLabel.background = colors_1.green500;
	                    break;
	            }
	        }
	        else {
	            switch (meta.state) {
	                case 1 /* STUDIO_APPROVED */:
	                case 0 /* INMOBI_APPROVED */:
	                case 8 /* INTERNAL_APPROVED */:
	                    stateButtonLabel = 'Approval Pending';
	                    styles.stateLabel.background = colors_1.orange500;
	                    break;
	                case 2 /* PARTNER_APPROVED */:
	                    stateButtonLabel = 'Approved';
	                    styles.stateLabel.background = colors_1.green500;
	                    break;
	                case 3 /* PARTNER_REJECTED */:
	                    stateButtonLabel = 'Rejected';
	                    styles.stateLabel.background = colors_1.red500;
	                    break;
	                case 4 /* PARTNER_REMOVED */:
	                    stateButtonLabel = 'Removed by partner';
	                    styles.stateLabel.background = colors_1.red500;
	                    break;
	                case 6 /* STUDIO_REMOVED */:
	                case 5 /* INMOBI_REMOVED */:
	                    stateButtonLabel = 'Removed by InMobi Studio';
	                    styles.stateLabel.background = colors_1.red500;
	                    break;
	                default:
	                    stateButtonLabel = 'Approved';
	                    styles.stateLabel.background = colors_1.green500;
	                    break;
	            }
	        }
	        var stateButton = (React.createElement("div", { key: 'state_button', style: styles.stateLabel }, stateButtonLabel));
	        if (peekButton) {
	            glanceActions.push(peekButton);
	            glanceDialogActions.push(peekButton);
	        }
	        glanceActions.push(moreDetailsButton);
	        if (selectButton) {
	            glanceActions.push(selectButton);
	        }
	        glanceActions.push(stateButton);
	        glanceDialogActions.push(closeDetailsButton);
	        var applicableActions = [stateButton];
	        if (selectButton !== null) {
	            applicableActions.push(selectButton);
	        }
	        return (React.createElement("div", { style: { height: '100%' } },
	            React.createElement(GlanceCard_1["default"], { data: this.props.glance, customStyle: selected ? styles.selectedGlanceCard : (meta.removed ? styles.removedGlanceBackground : {}), actions: glanceActions, region: this.props.region, partner: this.props.partner, studioAppConfig: this.props.studioAppConfig }),
	            React.createElement(material_ui_1.Dialog, { modal: false, open: this.state.openDetailsDialog, onRequestClose: this.closeDetailsDialog, contentStyle: { width: '80%', maxWidth: '1400px', margin: '0px auto' }, autoScrollBodyContent: false, actions: glanceDialogActions },
	                React.createElement(GlanceCard_1["default"], { data: this.props.glance, actions: applicableActions, customStyle: { margin: '0px auto' }, detailedView: true, region: this.props.region, partner: this.props.partner, studioAppConfig: this.props.studioAppConfig }))));
	    };
	    return Glance;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(Glance);


/***/ },

/***/ 247:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var colors_1 = __webpack_require__(18);
	exports.highPriorityBackgroundColor = colors_1.red700;
	exports.highPriorityLabelColor = colors_1.red50;
	exports.skipSummaryBackgroundColor = colors_1.red700;
	exports.skipSummaryLabelColor = colors_1.red50;
	exports.styles = {
	    servingCappingWrapper: {
	        display: 'flex',
	        justifyContent: 'space-between',
	        alignItems: 'baseline',
	        marginRight: '25px'
	    },
	    chipStyle: {
	        display: 'flex',
	        flexDirection: 'row',
	        justifyContent: 'center'
	    },
	    titleText: {
	        fontWeight: 800,
	        color: '#01BCD4'
	    },
	    countryContainer: {
	        padding: '15px',
	        marginBottom: '15px'
	    },
	    selectedCountry: {
	        display: 'inline-block',
	        background: colors_1.blue500,
	        color: 'white',
	        borderRadius: '15px',
	        padding: '5px 10px',
	        cursor: 'pointer',
	        marginRight: '3px',
	        fontSize: '11px'
	    },
	    unSelectedCountry: {
	        display: 'inline-block',
	        background: colors_1.grey50,
	        color: 'black',
	        borderRadius: '15px',
	        padding: '5px 10px',
	        cursor: 'pointer',
	        marginRight: '3px',
	        fontSize: '11px'
	    },
	    readableChip: {
	        margin: 1,
	        display: 'inline-block',
	        borderRadius: '1em',
	        fontSize: '0.9em'
	    },
	    clickableChip: {
	        margin: 1,
	        display: 'inline-block'
	    },
	    highPriority: {
	        //margin: 1,
	        background: exports.highPriorityBackgroundColor,
	        color: exports.highPriorityLabelColor,
	        display: 'inline-block',
	        borderRadius: '1em',
	        fontSize: '0.9em'
	    },
	    highPriorityButton: {
	        background: exports.highPriorityBackgroundColor,
	        color: exports.highPriorityLabelColor
	    },
	    spanLabel: {
	        color: colors_1.grey500
	    },
	    minWidthNone: {
	        minWidth: 'none'
	    },
	    width10: {
	        width: '10%',
	        maxWidth: 'none'
	    },
	    width17: {
	        width: '17%',
	        maxWidth: 'none'
	    },
	    width20: {
	        width: '20%',
	        maxWidth: 'none'
	    },
	    width25: {
	        width: '25%',
	        maxWidth: 'none'
	    },
	    width33: {
	        width: '33%',
	        maxWidth: 'none'
	    },
	    width40: {
	        width: '40%',
	        maxWidth: 'none'
	    },
	    width45: {
	        width: '45%',
	        maxWidth: 'none'
	    },
	    width50: {
	        width: '50%',
	        maxWidth: 'none'
	    },
	    width65: {
	        width: '65%',
	        maxWidth: 'none'
	    },
	    width75: {
	        width: '75%',
	        maxWidth: 'none'
	    },
	    width80: {
	        width: '80%',
	        maxWidth: 'none'
	    },
	    width83: {
	        width: '83%',
	        maxWidth: 'none'
	    },
	    width100: {
	        width: '100%',
	        maxWidth: 'none'
	    },
	    width110: {
	        width: '110%',
	        maxWidth: 'none'
	    },
	    inputStyle: {
	        color: '#505050',
	        fontSize: '0.9em'
	    },
	    textareaStyle: {
	        color: '#505050',
	        fontSize: '0.9em'
	    },
	    spacedRow: {
	        display: 'flex',
	        justifyContent: 'space-between',
	        alignItems: 'baseline'
	    },
	    detailsFull: {
	        // flexDirection: 'column',
	        display: 'inline-block',
	        width: '90%'
	    },
	    leftDiv: {
	        display: 'block',
	        width: '70%'
	    },
	    detailsLeft: {
	        flexDirection: 'column',
	        width: '40%',
	        padding: '5px'
	    },
	    detailsMiddle: {
	        flexDirection: 'column',
	        width: '50%',
	        padding: '5px'
	    },
	    detailsLeftAndMiddle: {
	        flexDirection: 'column',
	        width: '80%',
	        padding: '5px'
	    },
	    detailsRight: {
	        flexDirection: 'column',
	        width: '10%',
	        padding: '5px'
	    },
	    rightTopCornerDiv: {
	        position: 'absolute',
	        right: 0,
	        top: 0,
	        color: colors_1.grey500,
	        padding: '5px'
	    },
	    rightBottomCornerDiv: {
	        position: 'absolute',
	        bottom: 0,
	        right: 0,
	        color: colors_1.grey500,
	        padding: '5px'
	    },
	    form: {
	        display: 'flex',
	        flexWrap: 'wrap'
	    },
	    flag: {
	        margin: 2,
	        display: 'inline-block',
	        width: '25%',
	        minWidth: 'none'
	    },
	    flagButton: {
	        marginLeft: '2px',
	        cursor: 'pointer',
	        float: 'right'
	    },
	    actionButton: {
	        margin: '2px auto',
	        display: 'block',
	        height: 'inherit',
	        padding: '6px'
	    },
	    marginTopLeft: {
	        margin: '-8px 0 0 -23px'
	    },
	    marginBottomOnly: {
	        marginBottom: '10px'
	    },
	    marginTopOnly: {
	        marginTop: '10px'
	    },
	    hearts: {
	    // backgroundImage: "url('" + '../../../assets/images/' + 'heart_gray.png' + "')",
	    // backgroundRepeat: 'no-repeat',
	    // backgroundPosition: 'right center'
	    },
	    tableHeader: {
	    // fontSize: '16px',
	    // color: 'rgba(0, 0, 0, 0.3)',
	    // textAlign: 'left',
	    // wordWrap: 'break-word',
	    // paddingLeft: '0px'
	    },
	    tooltipStyle: {
	        wrapper: {
	            zIndex: 1,
	            cursor: 'arrow'
	        },
	        tooltip: {
	            backgroundColor: '#808080',
	            borderRadius: '10px',
	            minWidth: '180px',
	            textAlign: 'center',
	            padding: '2px'
	        },
	        content: {
	            backgroundColor: '#808080',
	            color: '#FFFFFF',
	            display: 'inline-block',
	            fontSize: '0.9em',
	            paddind: '0'
	        },
	        arrow: {
	            borderTop: 'solid #808080 5px'
	        },
	        gap: {}
	    },
	    dropdownHeader: {
	        color: '#b2b2b2'
	    },
	    disclaimer: {
	        display: 'inline-block',
	        margin: '0 20px',
	        color: 'red'
	    },
	    alertMessage: {
	        color: '#E0B32D',
	        display: 'flex',
	        alignItems: 'flex-start'
	    },
	    emojiImg: {
	        height: '32px',
	        width: '32px'
	    },
	    emojiEditWrapper: {
	        backgroundColor: 'rgba(0, 0, 0, 0.38)',
	        borderRadius: '100px',
	        height: '48px',
	        width: '48px',
	        display: 'flex',
	        alignItems: 'center'
	    },
	    emojiHoverWrapper: {
	        position: 'absolute',
	        visibility: 'hidden'
	    },
	    popoverStyle: {
	        height: '436px',
	        width: '312px',
	        borderRadius: '10px',
	        backgroundColor: 'white'
	    },
	    popoverhr: {
	        width: '100%',
	        marginTop: '12px',
	        marginBottom: '14px'
	    },
	    popoverUpper: {
	        display: 'flex',
	        alignItems: 'center',
	        paddingTop: '14px',
	        justifyContent: 'center'
	    },
	    fileuploadImg: {
	        position: 'absolute',
	        right: '18px',
	        top: '13px'
	    },
	    popoverEmojimr: {
	        marginBottom: '3px',
	        marginRight: '3px'
	    },
	    popoverCenter: {
	        width: '280px',
	        display: 'flex',
	        flexDirection: 'column',
	        height: '340px',
	        overflowY: 'scroll'
	    },
	    contextualEmoji: {
	        height: '100%',
	        width: '48px',
	        marginRight: '7px',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	    },
	    popoverEmojiContainer: {
	        width: '100%',
	        display: 'flex',
	        alignItems: 'center',
	        flexDirection: 'column'
	    },
	    popoverButtonContainer: {
	        display: 'flex',
	        justifyContent: 'space-between',
	        alignItems: 'center',
	        width: '280px',
	        height: '52px'
	    },
	    popoverCancelBtn: {
	        border: '1.2px solid #C2C2C2',
	        borderRadius: '4px',
	        width: '136px',
	        height: '36px',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	    },
	    popoverReplaceBtn: {
	        background: '#2A97FF',
	        borderRadius: '4px',
	        width: '136px',
	        height: '36px',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        color: 'white',
	        border: 'none'
	    },
	    emojiErrorCont: {
	        minWidth: '320px',
	        height: '68px',
	        border: '1px solid rgba(235, 87, 87, 1)',
	        borderRadius: '6px',
	        display: 'flex',
	        alignItems: 'center'
	    },
	    errorBold: {
	        fontFamily: 'Roboto',
	        fontWeight: 600,
	        fontSize: '16px',
	        lineHeight: '20px'
	    },
	    errorMessage: {
	        fontFamily: 'Roboto',
	        fontWeight: 400,
	        fontSize: '14px',
	        lineHeight: '20px',
	        color: 'rgba(0, 0, 0, 0.38)'
	    },
	    errorCont: {
	        paddingLeft: '14.67px'
	    },
	    errorBorder: {
	        borderRadius: '100px',
	        border: '1px solid rgba(235, 87, 87, 1)'
	    },
	    emojiUploadErrorMessageContainer: {
	        // paddingTop: '5px',
	        paddingBottom: '5px'
	    },
	    emojiUploadErrorMessage: {
	        fontSize: '14px',
	        color: '#eb5757',
	        textAlign: 'left'
	    },
	    emojiPopoverContainer: {
	        display: 'flex',
	        flexFlow: 'wrap'
	    },
	    emojiStyling: {
	        position: 'relative',
	        marginRight: '3px',
	        marginBottom: '3px'
	    },
	    emojiInnerMargin: {
	        marginRight: '3px',
	        marginBottom: '3px'
	    },
	    chosenEmoji: {
	        position: 'absolute',
	        bottom: 0,
	        right: '3px'
	    },
	    emojiHeading: {
	        fontSize: '14px',
	        lineHeight: '16px',
	        fontWeight: 'normal',
	        color: '#616161'
	    },
	    euGroup: {
	        fontSize: '16px',
	        lineHeight: '16px',
	        fontWeight: 'normal',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'space-between',
	        width: '100%'
	    },
	    euCountry: {
	        fontSize: '16px',
	        lineHeight: '16px',
	        fontWeight: 'bold',
	        minWidth: '20%',
	        margin: 0
	    }
	};


/***/ },

/***/ 426:
/***/ function(module, exports) {

	"use strict";
	exports.__esModule = true;
	exports.FETCH_STUDIO_APP_CONF_SUCCESS = 'FETCH_STUDIO_APP_CONF_SUCCESS';
	exports.FETCH_STUDIO_APP_CONF_HAS_ERRORED = 'FETCH_STUDIO_APP_CONF_HAS_ERRORED';
	exports.FETCH_STUDIO_APP_CONF_IS_LOADING = 'FETCH_STUDIO_APP_CONF_IS_LOADING';


/***/ },

/***/ 427:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var actionTypes_1 = __webpack_require__(426);
	var RestService_1 = __webpack_require__(32);
	function itemsHasErrored(bool) {
	    return {
	        type: actionTypes_1.FETCH_STUDIO_APP_CONF_HAS_ERRORED
	    };
	}
	exports.itemsHasErrored = itemsHasErrored;
	function itemsIsLoading(bool) {
	    return {
	        type: actionTypes_1.FETCH_STUDIO_APP_CONF_IS_LOADING
	    };
	}
	exports.itemsIsLoading = itemsIsLoading;
	function itemsFetchDataSuccess(conf) {
	    return {
	        type: actionTypes_1.FETCH_STUDIO_APP_CONF_SUCCESS,
	        studioAppConfig: conf
	    };
	}
	exports.itemsFetchDataSuccess = itemsFetchDataSuccess;
	function fetchStudioAppConfig() {
	    return function (dispatch) {
	        dispatch(itemsIsLoading(true));
	        try {
	            RestService_1["default"].getStudioAppConfig(function (conf) {
	                dispatch(itemsIsLoading(false));
	                dispatch(itemsFetchDataSuccess(conf));
	            });
	        }
	        catch (err) {
	            dispatch(itemsHasErrored(true));
	        }
	    };
	}
	exports.fetchStudioAppConfig = fetchStudioAppConfig;


/***/ },

/***/ 428:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var Clock_1 = __webpack_require__(151);
	var material_ui_1 = __webpack_require__(38);
	var RadioButton_1 = __webpack_require__(99);
	var colors_1 = __webpack_require__(18);
	var Chip_1 = __webpack_require__(137);
	var material_ui_chip_input_1 = __webpack_require__(191);
	var DatePicker_1 = __webpack_require__(203);
	var Divider_1 = __webpack_require__(117);
	var Subheader_1 = __webpack_require__(139);
	var TextField_1 = __webpack_require__(56);
	var TimePicker_1 = __webpack_require__(337);
	var Toggle_1 = __webpack_require__(338);
	var FlatButton_1 = __webpack_require__(49);
	var Dialog_1 = __webpack_require__(55);
	var Utils_1 = __webpack_require__(17);
	var PartingTimeSelection_1 = __webpack_require__(1014);
	var styles = {
	    subheader: {
	        lineHeight: '1em'
	    },
	    width100: {
	        width: '100%',
	        maxWidth: 'none'
	    },
	    chipWrapper: {
	        display: 'flex',
	        flexWrap: 'wrap'
	    },
	    chip: {
	        margin: 3
	    },
	    durationWrapper: {
	        display: 'flex',
	        flexWrap: 'wrap'
	    },
	    radioButton: {
	        margin: 'auto 10px',
	        width: 'auto'
	    },
	    dateTimeStyle: {
	        display: 'inline-block',
	        flexGrow: 100
	    },
	    inputStyle: {
	        color: '#505050',
	        fontSize: '0.9em'
	    },
	    iframe: {
	        height: '100vh',
	        width: '100%',
	        border: 'none'
	    },
	    ruleDialog: {
	        maxWidth: 'none'
	    },
	    divider: {
	        marginTop: '12px',
	        marginBottom: '8px'
	    }
	};
	var StartTimeType;
	(function (StartTimeType) {
	    StartTimeType[StartTimeType["NOW"] = 0] = "NOW";
	    StartTimeType[StartTimeType["MANUAL"] = 1] = "MANUAL";
	})(StartTimeType = exports.StartTimeType || (exports.StartTimeType = {}));
	var DSPPartners = ['Xiaomi', 'Realme', 'Samsung DLSS', 'Samsung Android'];
	var GlanceRegionPublish = /** @class */ (function (_super) {
	    __extends(GlanceRegionPublish, _super);
	    function GlanceRegionPublish(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleCreateRule = function (index) {
	            _this.setState(__assign({}, _this.state, { openRule: true, currentTargetingRule: index }));
	        };
	        _this.closeCreateRule = function () {
	            _this.setState(__assign({}, _this.state, { openRule: false }));
	        };
	        _this.handleSegmentRuleChange = function (value, isAdd, index) {
	            _this.props.onSegmentRuleSelected(value, isAdd, index);
	        };
	        _this.handleAddNewRule = function () {
	            var currentLength = _this.state.targetingRulesLength;
	            if (currentLength < 5) {
	                _this.setState(__assign({}, _this.state, { targetingRulesLength: currentLength + 1 }));
	            }
	        };
	        _this.handleDeleteRule = function (index) {
	            _this.props.onTargetingRuleDeleted(index);
	            var currentLength = _this.state.targetingRulesLength;
	            _this.setState(__assign({}, _this.state, { targetingRulesLength: currentLength - 1 }));
	        };
	        _this.receiveMessage = function (event) {
	            if (event.data.value) {
	                _this.props.addSegmentRuleFromGambit(event.data.value);
	                _this.handleSegmentRuleChange(event.data.value, true, _this.state.currentTargetingRule);
	                _this.setState(__assign({}, _this.state, { openRule: false }));
	            }
	        };
	        _this.handlePartingDataChange = function (day, index, startTime, endTime) {
	            var partingSchedule = _this.state.partingSchedule;
	            partingSchedule[day][index] = { startTime: startTime, endTime: endTime };
	            _this.setState(__assign({}, _this.state, { partingSchedule: partingSchedule }));
	            _this.props.onPartingTimeUpdate(true, partingSchedule);
	        };
	        _this.handleRemoveSlot = function (day, index) {
	            var partingSchedule = _this.state.partingSchedule;
	            if (index > -1) {
	                partingSchedule[day].splice(index, 1);
	            }
	            _this.setState(__assign({}, _this.state, { partingSchedule: partingSchedule }));
	            _this.props.onPartingTimeUpdate(true, partingSchedule);
	        };
	        var partnerIdPartnerMetaMap = new Map();
	        _this.props.partnerMetas.forEach(function (partner) {
	            partnerIdPartnerMetaMap.set(partner.partnerId, partner);
	        });
	        _this.state = {
	            durationType: 1 /* DAYS */,
	            startTimeType: StartTimeType.NOW,
	            partnerIdPartnerMetaMap: partnerIdPartnerMetaMap,
	            openRule: false,
	            partingSchedule: {
	                MONDAY: [{ startTime: 8, endTime: 10 }, { startTime: 16, endTime: 18 }],
	                TUESDAY: [{ startTime: 8, endTime: 10 }, { startTime: 16, endTime: 18 }],
	                WEDNESDAY: [{ startTime: 8, endTime: 10 }, { startTime: 16, endTime: 18 }],
	                THURSDAY: [{ startTime: 8, endTime: 10 }, { startTime: 16, endTime: 18 }],
	                FRIDAY: [{ startTime: 8, endTime: 10 }, { startTime: 16, endTime: 18 }],
	                SATURDAY: [{ startTime: 8, endTime: 11 }, { startTime: 16, endTime: 20 }],
	                SUNDAY: [{ startTime: 8, endTime: 11 }, { startTime: 16, endTime: 20 }]
	            },
	            targetingRulesLength: _this.props.regionPublishMeta.selectedSegmentRulesList &&
	                _this.props.regionPublishMeta.selectedSegmentRulesList.length > 0
	                ? _this.props.regionPublishMeta.selectedSegmentRulesList.length
	                : 2,
	            currentTargetingRule: 0
	        };
	        _this.canPartnerPublish = _this.canPartnerPublish.bind(_this);
	        _this.getVariantName = _this.getVariantName.bind(_this);
	        _this.isVariantInSelectedExperiments = _this.isVariantInSelectedExperiments.bind(_this);
	        return _this;
	    }
	    GlanceRegionPublish.prototype.canPartnerPublish = function (value) {
	        var response = false;
	        if (!this.props.draft && this.props.isSettingsView)
	            return true;
	        if (this.props.draft.type != 4 /* SPONSORED */) {
	            response = true;
	        }
	        else {
	            var partnerMeta = this.state.partnerIdPartnerMetaMap.get(value.partnerId);
	            if (!partnerMeta) {
	                response = false;
	            }
	            else {
	                response = partnerMeta.isSponsoredEnabled ? partnerMeta.isSponsoredEnabled : false;
	            }
	        }
	        return response;
	    };
	    GlanceRegionPublish.prototype.getExperiment = function (experimentId) {
	        return this.props.experiments.get(experimentId);
	    };
	    GlanceRegionPublish.prototype.getVariantName = function (experimentId, variantId) {
	        var experiment = this.props.experiments.get(experimentId);
	        if (experiment) {
	            if (experiment.control.id == variantId) {
	                return experiment.control.name;
	            }
	            experiment.variants.forEach(function (variant) {
	                if (variant.id == variantId) {
	                    return variant.name;
	                }
	            });
	        }
	        return 'INVALID VARIANT';
	    };
	    GlanceRegionPublish.prototype.isVariantInSelectedExperiments = function (variantId) {
	        var regionPublishMeta = this.props.regionPublishMeta;
	        if (regionPublishMeta.selectedExperimentMetas && regionPublishMeta.selectedExperimentMetas.length > 0) {
	            var flag = regionPublishMeta.selectedExperimentMetas.map(function (variant) {
	                if (variant.variantId == variantId) {
	                    return true;
	                }
	            });
	            return flag.includes(true);
	        }
	        return false;
	    };
	    GlanceRegionPublish.prototype.componentDidMount = function () {
	        window.addEventListener('message', this.receiveMessage, false);
	        //for now..
	        if (this.props.regionPublishMeta.partingSchedule)
	            this.setState(__assign({}, this.state, { partingSchedule: this.props.regionPublishMeta.partingSchedule }));
	    };
	    GlanceRegionPublish.prototype.componentWillUnmount = function () {
	        window.removeEventListener('message', function () {
	            console.log('Listener destroyed');
	        });
	    };
	    GlanceRegionPublish.prototype.render = function () {
	        var _this = this;
	        var regionPublishMeta = this.props.regionPublishMeta;
	        var _a = this.props.regionPublishMeta.selectedSegmentRulesList, selectedSegmentRulesNew = _a === void 0 ? [] : _a;
	        var defaultValues = this.props.defaultValues;
	        var userLevelDefaultValues = this.props.userLevelDefaultValues;
	        var durationUnit = regionPublishMeta.durationUnit ? regionPublishMeta.durationUnit : defaultValues.durationUnit;
	        var duration = regionPublishMeta.duration ? regionPublishMeta.duration : defaultValues.duration;
	        var startTimeType = regionPublishMeta.startTimeType ? regionPublishMeta.startTimeType : defaultValues.startTimeType;
	        var startDate = regionPublishMeta.startDate ? regionPublishMeta.startDate : defaultValues.startDate;
	        var startTime = regionPublishMeta.startTime ? regionPublishMeta.startTime : defaultValues.startTime;
	        var userLevelDurationEnabled = userLevelDefaultValues.enabled;
	        var isPartedGlance = regionPublishMeta.isPartedGlance;
	        var partingSchedule = regionPublishMeta.partingSchedule || this.state.partingSchedule;
	        var userLevelDurationUnit = regionPublishMeta.userLevelDurationUnit ? regionPublishMeta.userLevelDurationUnit : userLevelDefaultValues.durationUnit;
	        var userLevelDuration = regionPublishMeta.userLevelDuration ? regionPublishMeta.userLevelDuration : userLevelDefaultValues.duration;
	        var filteredABMappings = regionPublishMeta.abMappings.filter(function (abMapping) { return abMapping.partnerId == regionPublishMeta.publishToSelected; });
	        var experimentOptions = [];
	        var selectedExperimentMeta = null;
	        var selectedExperiment = null;
	        if (this.props.regionPublishMeta.selectedExperiments) {
	            if (this.props.regionPublishMeta.selectedExperiments.length == 0) {
	                selectedExperimentMeta = {
	                    id: null,
	                    variantId: null
	                };
	                selectedExperiment = null;
	            }
	            else {
	                selectedExperimentMeta = this.props.regionPublishMeta.selectedExperiments[0];
	                selectedExperiment = this.getExperiment(selectedExperimentMeta.id);
	            }
	        }
	        if (this.props.experiments) {
	            this.props.experiments.forEach(function (experiment, id) {
	                experimentOptions.push(React.createElement(material_ui_1.MenuItem, { value: id, primaryText: experiment.name, key: 'experiment_' + id }));
	            });
	        }
	        return (React.createElement("div", { style: { marginTop: '1em' } },
	            this.props.isSettingsView ? '' :
	                React.createElement("div", { style: styles.chipWrapper },
	                    React.createElement("div", { style: { margin: 'auto 0px' } }, "Published Partners: "),
	                    regionPublishMeta.publishedTo && regionPublishMeta.publishedTo.length > 0 ?
	                        regionPublishMeta.publishedTo.map(function (partner) {
	                            return (React.createElement(Chip_1["default"], { style: styles.chip, key: 'selected' + partner.partnerId + _this.props.region, backgroundColor: colors_1.blue300 }, partner.name));
	                        }) : React.createElement(Chip_1["default"], { style: styles.chip }, " None ")),
	            React.createElement("br", null),
	            React.createElement("div", { style: styles.chipWrapper },
	                React.createElement("div", { style: { margin: 'auto 0px' } }, "Select Partners: "),
	                regionPublishMeta.partnerSources && regionPublishMeta.partnerSources.length > 0 ?
	                    regionPublishMeta.partnerSources
	                        .filter(function (e) { return !_this.props.isDspCampaign || DSPPartners.indexOf(e.value.name) != -1; })
	                        .map(function (source) {
	                        var isSelected = regionPublishMeta.publishTo ? regionPublishMeta.publishTo.indexOf(source) != -1 : false;
	                        return (_this.canPartnerPublish(source.value) ?
	                            React.createElement(Chip_1["default"], { style: styles.chip, key: 'inp' + source.value.partnerId + _this.props.region, backgroundColor: isSelected ? colors_1.blue300 : '', onTouchTap: function () {
	                                    isSelected ? _this.props.partnerRemoved(source.value, 0) :
	                                        _this.props.partnerAdded(source);
	                                } }, source.value.name) : '');
	                    })
	                    : React.createElement(Chip_1["default"], { style: styles.chip }, " All partners done!")),
	            React.createElement("br", null),
	            !this.props.isDspCampaign && React.createElement("div", null,
	                regionPublishMeta.publishTo != null && regionPublishMeta.publishTo.length > 0 ?
	                    React.createElement("div", null,
	                        React.createElement("div", { style: styles.chipWrapper },
	                            React.createElement("div", { style: { margin: 'auto 0px' } }, "Select Experiment: "),
	                            this.props.experiments ?
	                                React.createElement(material_ui_1.DropDownMenu, { value: this.props.regionPublishMeta.selectedExperiments
	                                        ? selectedExperimentMeta.id : null, onChange: function (e, i, value) { _this.props.experimentAdded(value); } },
	                                    React.createElement(material_ui_1.MenuItem, { value: null, primaryText: 'Click here select to an experiment', key: 'empty' }),
	                                    experimentOptions)
	                                : ''),
	                        React.createElement("div", { style: styles.chipWrapper },
	                            React.createElement("div", { style: { margin: 'auto 0px' } }, "Select Targeting Rules: "),
	                            new Array(this.state.targetingRulesLength).fill(0).map(function (value, index) {
	                                return (React.createElement("div", { style: { width: '100%' } },
	                                    React.createElement(material_ui_chip_input_1["default"], { key: "segmentRules" + index, hintText: 'Select Targeting Rules', style: { width: '40%', marginLeft: 20 }, value: selectedSegmentRulesNew[index] && selectedSegmentRulesNew[index].length > 0 ? selectedSegmentRulesNew[index] : [], dataSource: _this.props.segmentRules, dataSourceConfig: { text: 'name', value: 'ruleId' }, onRequestAdd: function (chip) { return _this.handleSegmentRuleChange(chip, true, index); }, onRequestDelete: function (chip) { return _this.handleSegmentRuleChange(chip, false, index); }, disabled: false }),
	                                    React.createElement(FlatButton_1["default"], { style: { position: 'absolute' }, label: 'Create Targeting Rule', primary: true, onClick: function () { return _this.handleCreateRule(index); } }),
	                                    React.createElement(FlatButton_1["default"], { style: { position: 'absolute', 'marginLeft': '20%' }, label: 'Delete Rule', primary: true, onClick: function () { return _this.handleDeleteRule(index); } })));
	                            }),
	                            React.createElement(FlatButton_1["default"], { disabled: this.state.targetingRulesLength === 5, label: 'Add New Rule (Max 5)', primary: true, onClick: this.handleAddNewRule }),
	                            React.createElement("label", { style: { 'fontWeight': 'bold', 'padding-top': '8px' } }, "Union within Rules and Intersection across rules")),
	                        React.createElement(Dialog_1["default"], { modal: false, open: this.state.openRule, onRequestClose: this.closeCreateRule, autoScrollBodyContent: true, contentStyle: styles.ruleDialog },
	                            React.createElement("iframe", { style: styles.iframe, src: Utils_1["default"].getGambitUrl() + "/segment-rule/create" })))
	                    : '',
	                regionPublishMeta.publishTo != null && regionPublishMeta.publishTo.length > 0 && regionPublishMeta.selectedExperiments != null && regionPublishMeta.selectedExperiments.length > 0 && selectedExperiment ?
	                    React.createElement("div", null,
	                        React.createElement("div", { style: styles.chipWrapper },
	                            React.createElement("div", { style: { margin: 'auto 0px' } }, "Select Experiment group: "),
	                            this.props.regionPublishMeta.selectedExperiments && this.props.regionPublishMeta.selectedExperiments.length > 0 ?
	                                selectedExperiment.variants.map(function (variant) {
	                                    var isSelected = _this.isVariantInSelectedExperiments(variant.id);
	                                    return (React.createElement(Chip_1["default"], { style: styles.chip, key: 'variant_' + selectedExperiment.id + '_' + variant.id, backgroundColor: isSelected ? colors_1.blue300 : '', onTouchTap: function () {
	                                            isSelected ? _this.props.variantRemoved(variant, selectedExperiment.id) :
	                                                _this.props.variantSelected(variant.id, selectedExperiment.id);
	                                        } }, variant.name));
	                                }) : '',
	                            React.createElement(Chip_1["default"], { style: styles.chip, key: 'control_variant_' + selectedExperiment.id + '_' + selectedExperiment.control.id, backgroundColor: this.isVariantInSelectedExperiments(selectedExperiment.control.id) ? colors_1.blue300 : '', onTouchTap: function () {
	                                    _this.isVariantInSelectedExperiments(selectedExperiment.control.id) ? _this.props.variantRemoved(selectedExperiment.control, selectedExperiment.id) :
	                                        _this.props.variantSelected(selectedExperiment.control.id, selectedExperiment.id);
	                                } }, selectedExperiment.control.name)))
	                    : '',
	                !this.props.shortTitleCheck ?
	                    React.createElement("div", { style: { display: 'flex', margin: '0px auto', color: colors_1.red500 } }, " Short title is mandatory for this partner ") : '',
	                !this.props.cheesySummaryCheck ?
	                    React.createElement("div", { style: { display: 'flex', margin: '0px auto', color: colors_1.red500 } }, " Cheesy summary is mandatory for this partner ") : '',
	                React.createElement("br", null),
	                React.createElement(Subheader_1["default"], { style: styles.subheader }, " Start Time "),
	                React.createElement("div", { style: styles.durationWrapper },
	                    React.createElement(RadioButton_1.RadioButtonGroup, { style: { margin: 'auto', display: 'flex', marginRight: '2em' }, name: 'Start Time', valueSelected: startTimeType, onChange: function (e, value) {
	                            _this.props.onStartTimeUpdate(value == '0' ? StartTimeType.NOW : StartTimeType.MANUAL, startDate, startTime);
	                        } },
	                        React.createElement(RadioButton_1.RadioButton, { value: StartTimeType.NOW, label: 'Now', style: styles.radioButton }),
	                        React.createElement(RadioButton_1.RadioButton, { value: StartTimeType.MANUAL, label: 'Manual', style: styles.radioButton })),
	                    React.createElement(DatePicker_1["default"], { key: 'start_date', hintText: 'Start Date', value: startDate, autoOk: true, onChange: function (_, date) {
	                            _this.props.onStartTimeUpdate(startTimeType, date, startTime);
	                        }, style: styles.dateTimeStyle, textFieldStyle: styles.width100, inputStyle: styles.inputStyle, disabled: startTimeType == StartTimeType.NOW }),
	                    React.createElement(TimePicker_1["default"], { key: 'start_time', hintText: 'Start Time', value: startTime, autoOk: true, onChange: function (_, date) {
	                            _this.props.onStartTimeUpdate(startTimeType, startDate, date);
	                        }, style: styles.dateTimeStyle, textFieldStyle: styles.width100, inputStyle: styles.inputStyle, format: '24hr', disabled: startTimeType == StartTimeType.NOW })),
	                React.createElement(Subheader_1["default"], { style: styles.subheader }, " Duration "),
	                React.createElement("div", { style: styles.durationWrapper },
	                    React.createElement(RadioButton_1.RadioButtonGroup, { style: { margin: 'auto', display: 'flex' }, name: 'Duration', valueSelected: durationUnit, onChange: function (e, value) {
	                            if (value == '0') {
	                                _this.props.onDurationUpdate(0 /* HOURS */, duration);
	                            }
	                            else if (value == '1') {
	                                _this.props.onDurationUpdate(1 /* DAYS */, duration);
	                            }
	                            else if (value == '2') {
	                                _this.props.onDurationUpdate(2 /* MINUTES */, duration);
	                            }
	                            else if (value == '3') {
	                                _this.props.onDurationUpdate(3 /* SECONDS */, duration);
	                            }
	                        } },
	                        React.createElement(RadioButton_1.RadioButton, { value: 0 /* HOURS */, label: 'Hours', style: styles.radioButton }),
	                        React.createElement(RadioButton_1.RadioButton, { value: 1 /* DAYS */, label: 'Days', style: styles.radioButton }),
	                        React.createElement(RadioButton_1.RadioButton, { value: 2 /* MINUTES */, label: 'Minutes', style: styles.radioButton }),
	                        React.createElement(RadioButton_1.RadioButton, { value: 3 /* SECONDS */, label: 'Seconds', style: styles.radioButton })),
	                    React.createElement(TextField_1["default"], { style: { flexGrow: 100, marginLeft: '2em' }, hintText: durationUnit == 0 /* HOURS */ ? 'Hours' : 'Days', type: 'number', value: duration, onChange: function (e, value) {
	                            return _this.props.onDurationUpdate(durationUnit, value ? parseInt(value) : null);
	                        } })),
	                React.createElement(Subheader_1["default"], { style: __assign({}, styles.subheader, { paddingTop: '1em' }) }, " Current Time "),
	                React.createElement("div", { style: styles.durationWrapper }, Clock_1.regionTimeZones[this.props.region].map(function (timezone) {
	                    return (React.createElement("div", { style: { margin: '15px auto' }, key: timezone },
	                        React.createElement(Clock_1.ClockWithTimezone, { key: timezone, customStyle: { margin: 'auto' }, timezone: Clock_1.timeZonesMap.get(timezone) })));
	                })),
	                React.createElement("div", null,
	                    React.createElement(Divider_1["default"], { style: styles.divider }),
	                    React.createElement(Subheader_1["default"], { style: styles.subheader }, " User Level Duration "),
	                    React.createElement(Toggle_1["default"], { label: userLevelDurationEnabled ? 'User level expiry enabled' : 'User level expiry disabled', labelPosition: 'right', defaultToggled: userLevelDurationEnabled, onToggle: function (e, checked) { return _this.props.onUserLevelDurationUpdate(checked, userLevelDurationUnit, userLevelDuration); } })),
	                React.createElement("div", { style: styles.durationWrapper },
	                    React.createElement(RadioButton_1.RadioButtonGroup, { style: { margin: 'auto', display: 'flex' }, name: 'UserLevelDuration', valueSelected: userLevelDurationUnit, onChange: function (e, value) {
	                            _this.props.onUserLevelDurationUpdate(true, value == '0' ? 0 /* HOURS */ : 1 /* DAYS */, userLevelDuration);
	                        } },
	                        React.createElement(RadioButton_1.RadioButton, { value: 0 /* HOURS */, label: 'Hours', style: styles.radioButton }),
	                        React.createElement(RadioButton_1.RadioButton, { value: 1 /* DAYS */, label: 'Days', style: styles.radioButton })),
	                    React.createElement(TextField_1["default"], { style: { flexGrow: 100, marginLeft: '2em' }, hintText: userLevelDurationUnit != 1 /* DAYS */ ? 'Hours' : 'Days', type: 'number', value: userLevelDuration, onChange: function (e, value) {
	                            return _this.props.onUserLevelDurationUpdate(true, userLevelDurationUnit, value ? parseInt(value) : null);
	                        } })),
	                React.createElement("div", null,
	                    React.createElement(Divider_1["default"], { style: styles.divider }),
	                    React.createElement(Subheader_1["default"], { style: styles.subheader }, " Time Targeting Scheduler "),
	                    React.createElement(Toggle_1["default"], { label: isPartedGlance ? 'Time targeting enabled' : 'Time targeting disabled', labelPosition: 'right', defaultToggled: isPartedGlance, onToggle: function (e, checked) { _this.props.onPartingTimeUpdate(checked, _this.state.partingSchedule); } })),
	                isPartedGlance &&
	                    React.createElement(PartingTimeSelection_1["default"], { isPartedGlance: isPartedGlance, partingSchedule: partingSchedule, handlePartingDataChange: this.handlePartingDataChange, handleRemoveSlot: this.handleRemoveSlot }))));
	    };
	    return GlanceRegionPublish;
	}(React.Component));
	exports.GlanceRegionPublish = GlanceRegionPublish;


/***/ },

/***/ 429:
/***/ function(module, exports) {

	"use strict";
	exports.__esModule = true;
	/**
	 * This function will return value of disable and the
	 * tooltipText for publsh button.
	 */
	exports.isArticle = function (draft) {
	    if (draft.peek == null) {
	        return false;
	    }
	    return !draft.peek.video && !draft.peek.nativeVideoUrl && !draft.peek.webPeekUrl && !draft.peek.liveVideoPeek;
	};
	exports.getPublishButtonAtributes = function (_a) {
	    var editable = _a.editable, draft = _a.glanceDraftData, studioAppConfig = _a.studioAppConfig, pristine = _a.pristine;
	    var userRole = studioAppConfig.currentToken.role;
	    var userLifeTimeFilter = draft.userLifeTimeFilter || {
	        startDay: null,
	        endDay: null
	    };
	    var startDay = userLifeTimeFilter.startDay;
	    // if editable is false, publish button has to disabled
	    if (!editable) {
	        return { disable: true, tooltip: 'This Glance is not editable' }; // its removed.
	    }
	    // if there is no draft image, the publish button has to disabled
	    if (!draft.image) {
	        return { disable: true, tooltip: 'Missing Image' };
	    }
	    else if (!draft.image.attribution || !draft.image.attribution.source) {
	        return { disable: true, tooltip: 'Missing Image Attribution' };
	    }
	    // if campaign is paused, publish button has to disabled
	    if (draft.paused) {
	        return { disable: true, tooltip: 'Draft Paused' };
	    }
	    // Disable publish if network type is missing
	    if (!(draft.userNetworkTypes && draft.userNetworkTypes.length)) {
	        return { disable: true, tooltip: 'Network type Missing' };
	    }
	    //Disable publish if ecpm is less than 1
	    if ((draft.campaignMeta && draft.campaignMeta.eCpm && draft.campaignMeta.eCpm < 0.01)) {
	        return { disable: true, tooltip: 'ECPM cannot be less than 0.01' };
	    }
	    //Disable publish if offlineShoppingZipUrl is not a .zip url
	    if (draft.shoppableData && draft.shoppableData.offlineShoppingZipUrl) {
	        var url = draft.shoppableData.offlineShoppingZipUrl.split("?")[0];
	        if (!url.endsWith(".zip")) {
	            return { disable: true, tooltip: "offlineShoppingZipUrl should end with .zip" };
	        }
	    }
	    // Disable publish if offlinePeekUrl is not a .zip url
	    if (draft.peek && draft.peek.offlinePeekUrl) {
	        var url = draft.peek.offlinePeekUrl.split("?")[0];
	        if (!url.endsWith(".zip")) {
	            return { disable: true, tooltip: "offlinePeekUrl should end with .zip" };
	        }
	    }
	    if (!(draft.renderSessionProperties && draft.renderSessionProperties.length)) {
	        return { disable: true, tooltip: 'Missing Session Mode' };
	    }
	    if (!pristine) {
	        return { disable: true };
	    }
	    if (draft.peek) {
	        if (!draft.peek.sourceName) {
	            return { disable: true, tooltip: 'Missing Peek SourceName' };
	        }
	        if (exports.isArticle(draft) && !(draft.peek.cta && draft.peek.cta.text)) {
	            return { disable: true, tooltip: 'Article must have CTA Text' };
	        }
	    }
	    switch (draft.type) {
	        case 2 /* STORY */:
	            if (!draft.categoryIds || draft.categoryIds.length == 0) {
	                return { disable: true, tooltip: 'Missing categories' };
	            }
	            break;
	        case 4 /* SPONSORED */:
	            // Publisher data is a mandatory field for SPONSORED GlanceType.
	            if (!draft.publisherData) {
	                return {
	                    disable: true,
	                    tooltip: 'Publisher Data is mandatory for Sponsored Glance'
	                };
	            }
	            break;
	        default:
	            break;
	    }
	    switch (userRole) {
	        case 2 /* MODERATOR */:
	            break;
	        case 0 /* ADMIN */:
	            break;
	        default:
	            return { disable: true, tooltip: 'Not Allowed' };
	    }
	    if (draft.userLifeTimeFilter &&
	        startDay !== null &&
	        startDay !== 8 &&
	        draft.userLifeTimeFilter.endDay === null) {
	        return { disable: true, tooltip: 'End Day Missing' };
	    }
	    return { disable: false };
	};


/***/ },

/***/ 518:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(66)();
	// imports
	
	
	// module
	exports.push([module.id, "svg{display:block;width:1em;height:1em;fill:currentColor}.select{position:relative;display:inline-block;min-width:350px;margin-bottom:2%;width:fit-content}.select ::focus{outline:0}.select ::focus.selection{box-shadow:0 0 1px 1px #00a9e0}.label{display:block;margin-bottom:6px;font-weight:600}.selection{position:relative;padding-bottom:5px;border-bottom:1px solid #ddd;background:#fff;padding-right:35px}.value{position:relative;display:inline-block;padding:5px 10px}.multiple{margin:5px 5px 0 0;background:#e0e0e0;border-radius:30px;padding:7px 30px 7px 10px}.delete{position:absolute;top:2px;right:0;display:block;padding:10px;font-size:10px;cursor:pointer}.placeholder{color:#89898991;font-size:16px}.arrow{top:5px;right:5px;display:block;padding:10px;font-size:10px;color:#898989}.arrow,.options{position:absolute}.options{z-index:2;top:100%;left:0;right:0;border:solid #ddd;border-width:0 1px;background:#fff}.option{padding:10px 15px;border-bottom:1px solid #ddd;cursor:pointer}.option.focused{background:#f5f5f5}.option.selected{border:1px solid #e0e0e0;margin:-1px -1px 0;background:#fff}.checkbox{content:\"\";vertical-align:top;display:inline-block;width:16px;height:16px;padding:2px;border:1px solid #ddd;border-radius:2px;margin:2px 12px 0 0;color:#fff;font-size:10px}.checkbox.selected{border-color:#007da6;background:#00a9e0}.disabled-item{cursor:not-allowed}", ""]);
	
	// exports


/***/ },

/***/ 519:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(66)();
	// imports
	
	
	// module
	exports.push([module.id, "#react-paginate{display:flex;justify-content:center;margin-top:2%;background-color:#e8e8e8}#react-paginate ul{padding-top:15px}#react-paginate li{display:inline-block;cursor:pointer}.previous_page{padding:5px 25px;border-right:2px solid #d3d3d3}.next_page{padding:5px 25px;border-left:2px solid #d3d3d3}#react-paginate a:hover:not(.active){background-color:#d3d3d3}#react-paginate a{display:inline-block;padding:5px 15px;margin:0 5px}.disabled{cursor:not-allowed!important}.active{background-color:#d3d3d3}.search,.searchInternal{width:100%;position:relative;display:flex}.searchTerm{width:100%;border:2px solid #00b4cc;border-right:none;padding:5px;height:33px;border-radius:5px 0 0 5px;outline:none;position:relative;padding-right:17%}.search div{right:21%}.search div,.searchInternal div{position:absolute;top:19%;color:#00b4cc}.searchInternal div{right:25%}.searchButton{width:43px;height:33px;border:1px solid #00b4cc;background:#00b4cc;text-align:center;color:#fff;border-radius:0 5px 5px 0;cursor:pointer}.wrap,.wrapInternal{position:absolute;top:26%;padding-left:5%;font-size:13px}.wrap{width:24%;right:-18%}.wrap.partner{width:30%;right:-30%}.wrap.partner.transsion{width:23%;right:-16%}.wrapInternal{width:30%;right:-25%}.center,.imageLabel{text-align:center}.center h1{color:#00bcd4}.upload{margin-left:31%;margin-top:4%;padding-top:1%;padding-left:9%}.center button{margin-top:1.5%}.center button,.upload{background-color:#00bcd4;color:#fff;height:51px;border:1px dotted dimgray;width:38%;border-radius:3px}.info{margin-top:3%;margin-bottom:25%}.dropDownMenu{margin-left:-7%}", ""]);
	
	// exports


/***/ },

/***/ 967:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(518);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(150)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stripcomment-loader/index.js!./style.css", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stripcomment-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 971:
/***/ function(module, exports) {

	"use strict";
	exports.__esModule = true;
	var Configuration = /** @class */ (function () {
	    function Configuration(timezone) {
	        this.timezone = timezone;
	    }
	    Configuration.prototype.getTimezone = function () {
	        return this.timezone;
	    };
	    Configuration.prototype.setTimezone = function (timezone) {
	        this.timezone = timezone;
	    };
	    Configuration.setConfiguration = function (configuration) {
	        Configuration.globalConfiguration = configuration;
	    };
	    Configuration.getConfiguration = function () {
	        return Configuration.globalConfiguration;
	    };
	    return Configuration;
	}());
	exports.Configuration = Configuration;
	exports["default"] = Configuration;


/***/ },

/***/ 972:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var glance_datatypes_1 = __webpack_require__(67);
	var Toolbar_1 = __webpack_require__(100);
	var CircularProgress_1 = __webpack_require__(317);
	var material_ui_datatables_1 = __webpack_require__(604);
	var DatePicker_1 = __webpack_require__(203);
	var DropDownMenu_1 = __webpack_require__(69);
	var MenuItem_1 = __webpack_require__(51);
	var RestService_1 = __webpack_require__(32);
	var Snackbar_1 = __webpack_require__(42);
	var Subheader_1 = __webpack_require__(139);
	var Utils_1 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var TABLE_COLUMNS = [
	    {
	        key: 'categories',
	        label: 'Categories'
	    }, {
	        key: 2 /* STORY */.toString() + '_' + 1 /* NEWS */.toString(),
	        label: 'News Story',
	        sortable: true
	    }, {
	        key: 2 /* STORY */.toString() + '_' + 2 /* FEATURE */.toString(),
	        label: 'Feature Story',
	        sortable: true
	    }, {
	        key: 2 /* STORY */.toString(),
	        label: 'Untagged Story',
	        sortable: true
	    }, {
	        key: 4 /* SPONSORED */.toString(),
	        label: 'Sponsored',
	        sortable: true
	    }, {
	        key: 1 /* WALLPAPER */.toString(),
	        label: 'Wallpaper',
	        sortable: true
	    }, {
	        key: 'total',
	        label: 'Total',
	        sortable: true
	    },
	];
	var DAILY_DIGEST_ID = '#daily_digest';
	var CategoryFilter;
	(function (CategoryFilter) {
	    CategoryFilter[CategoryFilter["ALL"] = 0] = "ALL";
	    CategoryFilter[CategoryFilter["DAILY_DIGEST"] = 1] = "DAILY_DIGEST";
	    CategoryFilter[CategoryFilter["NON_DAILY_DIGEST"] = 2] = "NON_DAILY_DIGEST";
	})(CategoryFilter || (CategoryFilter = {}));
	var Analytics = /** @class */ (function (_super) {
	    __extends(Analytics, _super);
	    function Analytics(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleSortOrderChange = function (key, order) {
	            var sign = 1 * (order == 'desc' ? -1 : 1);
	            var tableData = _this.state.tableData;
	            tableData.sort(function (a, b) {
	                return (sign * (a[key] - b[key]));
	            });
	            _this.setState(__assign({}, _this.state, { tableData: tableData }));
	        };
	        _this.handleDateChange = function (event, date) {
	            _this.setState(__assign({}, _this.state, { selectedDate: date, data: null, loadMessage: 'Loading live glances for ' + _this.state.partnerFilter.name
	                    + ' in ' + Utils_1["default"].getReadableRegionName(_this.state.regionFilter) + ' ...', showLoader: true }));
	            _this.fetchGlances(_this.state.partnerFilter, _this.state.regionFilter, date);
	        };
	        _this.state = {
	            partnerFilter: null,
	            regionFilters: null,
	            regionFilter: null,
	            openSnackbar: false,
	            snackbarMessage: '',
	            loadMessage: 'Select a partner and region to load',
	            selectedDate: new Date(),
	            tableData: [],
	            categoryFilter: CategoryFilter.ALL,
	            localFilterDisplay: 'none'
	        };
	        _this.pushFilterUrl = _this.pushFilterUrl.bind(_this);
	        _this.setPartner = _this.setPartner.bind(_this);
	        _this.setPartnerAndRegion = _this.setPartnerAndRegion.bind(_this);
	        _this.handlePartnerFilterChange = _this.handlePartnerFilterChange.bind(_this);
	        _this.handleRegionFilterChange = _this.handleRegionFilterChange.bind(_this);
	        _this.handleDateChange = _this.handleDateChange.bind(_this);
	        _this.matchCategoryFilter = _this.matchCategoryFilter.bind(_this);
	        _this.matchCategory = _this.matchCategory.bind(_this);
	        _this.fetchGlances = _this.fetchGlances.bind(_this);
	        _this.updateTableData = _this.updateTableData.bind(_this);
	        _this.closeSnackbar = _this.closeSnackbar.bind(_this);
	        _this.handleSortOrderChange = _this.handleSortOrderChange.bind(_this);
	        _this.handleCategoryFilterChange = _this.handleCategoryFilterChange.bind(_this);
	        _this.getTypeFromData = _this.getTypeFromData.bind(_this);
	        return _this;
	    }
	    Analytics.prototype.componentWillMount = function () {
	        var _this = this;
	        // TODO: now studioAppConfig will always have a default value this check needs to be changed
	        if (!this.props.studioAppConfig) {
	            this.props.history.push('/login');
	            window.location.reload();
	        }
	        console.log(this.props.params);
	        if (this.props.params && this.props.params.partnerName) {
	            var partnerName_1 = this.props.params.partnerName;
	            var region_1 = this.props.params.region;
	            this.props.studioAppConfig.partners.forEach(function (partner) {
	                if (partner.name == partnerName_1) {
	                    if (region_1) {
	                        _this.setPartnerAndRegion(partner, parseInt(region_1));
	                    }
	                    else {
	                        _this.setPartner(partner);
	                    }
	                }
	            });
	        }
	    };
	    Analytics.prototype.pushFilterUrl = function (partnerFilter, regionFilter) {
	        console.log(partnerFilter, regionFilter);
	        this.props.history.push('/' + this.props.params.role + '/analytics'
	            + (partnerFilter ? ('/' + partnerFilter.partnerId + '/' + encodeURIComponent(partnerFilter.name)
	                + (regionFilter ? ('/' + regionFilter + '/' + Utils_1["default"].getReadableRegionName(regionFilter)) : ''))
	                : ''));
	    };
	    Analytics.prototype.setPartner = function (value) {
	        if (value == null) {
	            this.setState(__assign({}, this.state, { partnerFilter: value, regionFilters: null, regionFilter: null, loadMessage: 'Select a partner and region', data: null }));
	        }
	        else {
	            var filteredRegions_1 = [];
	            this.props.studioAppConfig.partnerMetas.forEach(function (item) {
	                if (item.partnerId == value.partnerId) {
	                    item.supportedRegions.forEach(function (item) {
	                        filteredRegions_1.push(item);
	                    });
	                }
	            });
	            if (filteredRegions_1.length == 1) {
	                this.pushFilterUrl(value, filteredRegions_1[0]);
	                this.setPartnerAndRegion(value, filteredRegions_1[0]);
	            }
	            else {
	                this.setState(__assign({}, this.state, { partnerFilter: value, regionFilters: filteredRegions_1, regionFilter: null, loadMessage: 'Select a region', data: null }));
	            }
	        }
	    };
	    Analytics.prototype.setPartnerAndRegion = function (partner, region) {
	        var filteredRegions = [];
	        var partnerAutoApprove = false;
	        var isSponsoredEnabled = false;
	        if (partner) {
	            this.props.studioAppConfig.partnerMetas.forEach(function (item) {
	                if (item.partnerId == partner.partnerId) {
	                    partnerAutoApprove = item.autoApprove;
	                    isSponsoredEnabled = item.isSponsoredEnabled ? item.isSponsoredEnabled : false;
	                    item.supportedRegions.forEach(function (item) {
	                        filteredRegions.push(item);
	                    });
	                }
	            });
	        }
	        if (partner == null || !region) {
	            this.setState(__assign({}, this.state, { loadMessage: 'Select a partner and region', partnerFilter: null, regionFilter: null, regionFilters: filteredRegions, data: null }));
	            return;
	        }
	        else {
	            this.setState(__assign({}, this.state, { partnerFilter: partner, regionFilter: region, regionFilters: filteredRegions, loadMessage: 'Loading live glances for ' + partner.name + ' in ' + Utils_1["default"].getReadableRegionName(region) + ' ...', showLoader: true, data: null, localFilterDisplay: 'block' }));
	            this.fetchGlances(partner, region, this.state.selectedDate);
	        }
	    };
	    Analytics.prototype.fetchGlances = function (partner, region, date) {
	        var that = this;
	        var selectedDate = date;
	        var nextDate = new Date(selectedDate);
	        nextDate.setDate(selectedDate.getDate() + 1);
	        var startAtLessThan = new glance_datatypes_1.RelativeTime({
	            year: nextDate.getFullYear(),
	            month: nextDate.getMonth() + 1,
	            date: nextDate.getDate(),
	            hour: 0,
	            minute: 0
	        });
	        var startAtGreaterThan = new glance_datatypes_1.RelativeTime({
	            year: selectedDate.getFullYear(),
	            month: selectedDate.getMonth() + 1,
	            date: selectedDate.getDate(),
	            hour: 0,
	            minute: 0
	        });
	        RestService_1["default"].getLiveGlancesBetweenTime(partner, region, startAtGreaterThan, startAtLessThan, function (data) {
	            if (data == null) {
	                that.updateTableData(__assign({}, that.state, { snackbarMessage: 'Loading failed. Try refresh or Contant Glance Support.', openSnackbar: true, loadMessage: 'Loading failed. Try refresh or Contant Glance Support.', showLoader: false, data: null }));
	            }
	            else {
	                that.updateTableData(__assign({}, that.state, { data: data, snackbarMessage: 'Glances loaded', openSnackbar: true, loadMessage: null, showLoader: false }));
	            }
	        });
	    };
	    Analytics.prototype.handlePartnerFilterChange = function (event, index, value) {
	        this.pushFilterUrl(value, this.state.regionFilter);
	        window.location.reload();
	    };
	    Analytics.prototype.handleRegionFilterChange = function (event, index, value) {
	        this.pushFilterUrl(this.state.partnerFilter, value);
	        this.setPartnerAndRegion(this.state.partnerFilter, value);
	    };
	    Analytics.prototype.handleCategoryFilterChange = function (event, index, value) {
	        var that = this;
	        that.updateTableData(__assign({}, that.state, { categoryFilter: CategoryFilter[value] }));
	    };
	    Analytics.prototype.matchCategoryFilter = function (currentCategoryIds, categoryFilter) {
	        var result = false;
	        switch (categoryFilter) {
	            case CategoryFilter.NON_DAILY_DIGEST:
	                result = currentCategoryIds.indexOf(DAILY_DIGEST_ID) == -1;
	                break;
	            case CategoryFilter.DAILY_DIGEST:
	                result = currentCategoryIds.indexOf(DAILY_DIGEST_ID) > -1;
	                break;
	            case CategoryFilter.ALL:
	                result = true;
	                break;
	        }
	        return result;
	    };
	    Analytics.prototype.matchCategory = function (currentCategoryIds, requiredCategoryId) {
	        return currentCategoryIds != null && currentCategoryIds.indexOf(requiredCategoryId) > -1;
	    };
	    Analytics.prototype.getTypeFromData = function (data) {
	        var type = data.type.toString();
	        if (data.type == 2 /* STORY */ && data.storyType != null) {
	            if (data.storyType != null) {
	                type += ('_' + data.storyType.toString());
	            }
	        }
	        return type;
	    };
	    Analytics.prototype.updateTableData = function (newState) {
	        var _this = this;
	        console.log(newState);
	        if (newState.data) {
	            var tableData_1 = [];
	            this.props.studioAppConfig.categories.forEach(function (category) {
	                var typeCount = {};
	                var catTotal = 0;
	                newState.data.forEach(function (pair) {
	                    if (_this.matchCategoryFilter(pair.data.categoryIds, newState.categoryFilter)
	                        && _this.matchCategory(pair.data.categoryIds, category.id)) {
	                        var glanceType = _this.getTypeFromData(pair.data);
	                        glanceType in typeCount ? typeCount[glanceType]++ : typeCount[glanceType] = 1;
	                        catTotal++;
	                    }
	                });
	                var tableRow = {};
	                for (var key in typeCount) {
	                    tableRow[key] = typeCount[key];
	                }
	                tableRow['categories'] = category.displayName;
	                tableRow['total'] = catTotal;
	                if (!(1 /* WALLPAPER */.toString() in tableRow)) {
	                    tableRow[1 /* WALLPAPER */.toString()] = 0;
	                }
	                if (!(2 /* STORY */.toString() in tableRow)) {
	                    tableRow[2 /* STORY */.toString()] = 0;
	                }
	                if (!(4 /* SPONSORED */.toString() in tableRow)) {
	                    tableRow[4 /* SPONSORED */.toString()] = 0;
	                }
	                if (!((2 /* STORY */.toString() + '_' + 1 /* NEWS */.toString()) in tableRow)) {
	                    tableRow[2 /* STORY */.toString() + '_' + 1 /* NEWS */.toString()] = 0;
	                }
	                if (!((2 /* STORY */.toString() + '_' + 2 /* FEATURE */.toString()) in tableRow)) {
	                    tableRow[2 /* STORY */.toString() + '_' + 2 /* FEATURE */.toString()] = 0;
	                }
	                tableData_1.push(tableRow);
	            });
	            var tableRow_1 = {};
	            tableRow_1['categories'] = 'Any';
	            tableRow_1['total'] = newState.data.length;
	            tableRow_1[1 /* WALLPAPER */.toString()] = 0;
	            tableRow_1[2 /* STORY */.toString()] = 0;
	            tableRow_1[2 /* STORY */.toString() + '_' + 1 /* NEWS */.toString()] = 0;
	            tableRow_1[2 /* STORY */.toString() + '_' + 2 /* FEATURE */.toString()] = 0;
	            tableRow_1[4 /* SPONSORED */.toString()] = 0;
	            tableRow_1['total'] = 0;
	            newState.data.forEach(function (pair) {
	                if (_this.matchCategoryFilter(pair.data.categoryIds, newState.categoryFilter)) {
	                    tableRow_1[_this.getTypeFromData(pair.data)]++;
	                    tableRow_1['total']++;
	                }
	            });
	            tableData_1.push(tableRow_1);
	            this.setState(__assign({}, newState, { tableData: tableData_1 }));
	        }
	        else {
	            this.setState(__assign({}, newState, { tableData: null }));
	        }
	    };
	    Analytics.prototype.closeSnackbar = function () {
	        this.setState(__assign({}, this.state, { openSnackbar: false }));
	    };
	    Analytics.prototype.render = function () {
	        return (React.createElement("div", null,
	            !this.state.partnerFilter ?
	                React.createElement(Toolbar_1.Toolbar, { style: { marginTop: '2%' } },
	                    React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true },
	                        React.createElement(DropDownMenu_1["default"], { value: this.state.partnerFilter, onChange: this.handlePartnerFilterChange },
	                            React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Click here select to Partner', key: 'empty' }),
	                            this.props.studioAppConfig.partners.map(function (item, index) {
	                                return (React.createElement(MenuItem_1["default"], { value: item, primaryText: item.name, key: item.partnerId }));
	                            }))))
	                :
	                    React.createElement(Toolbar_1.Toolbar, { style: { marginTop: '2%' } },
	                        React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true },
	                            React.createElement(Toolbar_1.ToolbarTitle, { text: 'Filters', style: { marginLeft: '24px' } }),
	                            React.createElement(Toolbar_1.ToolbarSeparator, null),
	                            React.createElement(DropDownMenu_1["default"], { value: this.state.partnerFilter, onChange: this.handlePartnerFilterChange },
	                                React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Select Partner', key: 'empty' }),
	                                this.props.studioAppConfig.partners.map(function (item, index) {
	                                    return (React.createElement(MenuItem_1["default"], { value: item, primaryText: item.name, key: item.partnerId }));
	                                })),
	                            React.createElement(DropDownMenu_1["default"], { value: this.state.regionFilter, onChange: this.handleRegionFilterChange },
	                                React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Select Region', key: 'empty' }),
	                                this.state.regionFilters.map(function (item, index) {
	                                    return (React.createElement(MenuItem_1["default"], { value: item, primaryText: Utils_1["default"].getReadableRegionName(item), key: index }));
	                                })),
	                            React.createElement(DatePicker_1["default"], { style: { display: this.state.localFilterDisplay }, value: this.state.selectedDate, onChange: this.handleDateChange }),
	                            React.createElement(DropDownMenu_1["default"], { value: CategoryFilter[this.state.categoryFilter], onChange: this.handleCategoryFilterChange, style: { display: this.state.localFilterDisplay } }, Object.keys(CategoryFilter).filter(function (k) {
	                                return typeof CategoryFilter[k] === 'number';
	                            }).map(function (key, index) {
	                                return (React.createElement(MenuItem_1["default"], { value: key, primaryText: key, key: key }));
	                            })))),
	            this.state.data ?
	                (this.state.tableData && this.state.tableData.length > 0 ?
	                    React.createElement(material_ui_datatables_1["default"], { height: 'auto', selectable: false, showRowHover: true, columns: TABLE_COLUMNS, data: this.state.tableData, showCheckboxes: false, onSortOrderChange: this.handleSortOrderChange, page: 1, count: 100 })
	                    : React.createElement("h1", null, "No glances for selected filters")) : React.createElement("div", null,
	                React.createElement(Subheader_1["default"], null,
	                    React.createElement("h1", null,
	                        this.state.showLoader ? React.createElement(CircularProgress_1["default"], null) : '',
	                        this.state.loadMessage))),
	            React.createElement(Snackbar_1["default"], { open: this.state.openSnackbar, message: this.state.snackbarMessage, onRequestClose: this.closeSnackbar, autoHideDuration: 2000 })));
	    };
	    return Analytics;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(Analytics);


/***/ },

/***/ 973:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var Colors = __webpack_require__(18);
	var React = __webpack_require__(1);
	var Clock_1 = __webpack_require__(151);
	var AppBar_1 = __webpack_require__(308);
	var Configuration_1 = __webpack_require__(971);
	var CustomAppBar_1 = __webpack_require__(975);
	var Divider_1 = __webpack_require__(117);
	var Drawer_1 = __webpack_require__(318);
	var FontIcon_1 = __webpack_require__(50);
	var react_router_1 = __webpack_require__(241);
	var Menu_1 = __webpack_require__(206);
	var MenuItem_1 = __webpack_require__(51);
	var react_redux_1 = __webpack_require__(24);
	var draftsAction_1 = __webpack_require__(427);
	var styles = {
	    footer: {
	        marginTop: '5%',
	        textAlign: 'center',
	        width: '90%',
	        margin: '0 auto',
	        marginBottom: '2%'
	    }
	};
	var region = 1 /* US */;
	var App = /** @class */ (function (_super) {
	    __extends(App, _super);
	    function App(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            drawerOpen: false
	        };
	        _this.updatePathPrefix = _this.updatePathPrefix.bind(_this);
	        _this.handleToggle = _this.handleToggle.bind(_this);
	        return _this;
	    }
	    App.prototype.updatePathPrefix = function (path) {
	        var pathPrefix = '/partner';
	        var pathEnd = path.indexOf('/', 1);
	        //console.log(path, path.substr(1, pathEnd == -1 ? path.length -1  : pathEnd -1))
	        if (path.substr(1, pathEnd == -1 ? path.length - 1 : pathEnd - 1) ===
	            'moderator')
	            pathPrefix = '/moderator';
	        this.pathPrefix = pathPrefix;
	    };
	    App.prototype.componentDidMount = function () {
	        var path = this.props.location.pathname;
	        this.path = path;
	        this.updatePathPrefix(path);
	        var that = this;
	        var timezone = Clock_1.defaultTimezone;
	        if (region == 1 /* US */) {
	            timezone = Clock_1.usTimezone;
	        }
	        var configuration = new Configuration_1.Configuration(timezone);
	        Configuration_1.Configuration.setConfiguration(configuration);
	        // it was inside callback of RestService.getStudioAppConfig
	        that.setState(__assign({}, that.state, { configuration: configuration }));
	    };
	    App.prototype.handleToggle = function () {
	        this.setState(__assign({}, this.state, { drawerOpen: !this.state.drawerOpen }));
	    };
	    App.prototype.render = function () {
	        var _this = this;
	        var studioAppConfig = this.props.studioAppConfig;
	        var role = studioAppConfig.currentToken.role;
	        if (role === undefined) {
	            return null;
	        }
	        var shouldUpdateChildren = false;
	        if (this.props.location.pathname !== this.path) {
	            this.path = this.props.location.pathname;
	            this.updatePathPrefix(this.path);
	            shouldUpdateChildren = true;
	        }
	        var pathPrefix = this.pathPrefix;
	        var appTitle = 'Glance for Partners';
	        var menuItems = [];
	        var partnerIdToPartner = new Map();
	        var currentPartner;
	        if (studioAppConfig.currentToken.partners) {
	            studioAppConfig.currentToken.partners.forEach(function (partner) {
	                partnerIdToPartner.set(partner.partnerId, partner);
	            });
	        }
	        if (this.props.params && this.props.params.partnerId) {
	            appTitle = 'Glance for';
	            currentPartner = partnerIdToPartner.get(this.props.params.partnerId);
	        }
	        else {
	            currentPartner = partnerIdToPartner.values().next().value;
	        }
	        if (role != 4 /* PARTNER */) {
	            if (role == 0 /* ADMIN */ || role == 2 /* MODERATOR */) {
	                appTitle = 'Glance for Moderators';
	                pathPrefix = '/moderator';
	            }
	            else if (role == 1 /* CURATOR */) {
	                appTitle = 'Glance for Curators';
	                pathPrefix = '/curator';
	            }
	            else if (role == 3 /* DESIGNER */) {
	                appTitle = 'Glance for Designers';
	                pathPrefix = '/designer';
	            }
	            menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/drafts' }), key: "glance_drafts", onTouchTap: this.handleToggle, primaryText: "Drafts", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "drafts") }));
	            menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/analytics' }), key: "analytics", onTouchTap: this.handleToggle, primaryText: "Analytics", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "table_chart") }));
	            menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/segments' }), key: "segments", onTouchTap: this.handleToggle, primaryText: "Segments", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "pie_chart") }), React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/segment-query' }), key: "segment-query", onTouchTap: this.handleToggle, primaryText: "Segment Query", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "query_builder") }));
	            if (role == 0 /* ADMIN */) {
	                menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/publishers' }), key: "Publishers", onTouchTap: this.handleToggle, primaryText: "Publishers", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "publish") }));
	            }
	            menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/notification-settings' }), key: "notification_setting", onTouchTap: this.handleToggle, primaryText: "Notification", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "notifications") }));
	            menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/uploadFile' }), key: "upload_file", onTouchTap: this.handleToggle, primaryText: "Upload File", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "cloud_upload") }));
	            menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/uploadCsv' }), key: "upload_csv", onTouchTap: this.handleToggle, primaryText: "Upload CSV", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "cloud_upload") }));
	            menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/internalApproval' }), key: "internal_approval", onTouchTap: this.handleToggle, primaryText: "Internal Approval", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "done_outline") }));
	        }
	        else if (currentPartner) {
	            pathPrefix = pathPrefix + '/' + currentPartner.partnerId;
	        }
	        menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: pathPrefix + '/published' }), key: "live_glances", onTouchTap: this.handleToggle, primaryText: "Live Glances", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "live_tv") }));
	        // menuItems.push(
	        //   <MenuItem
	        //     containerElement={<Link to={pathPrefix + '/highlights'} />}
	        //     key="highlights"
	        //     onTouchTap={this.handleToggle}
	        //     primaryText="HighLights"
	        //     leftIcon={<FontIcon className="material-icons">highlight</FontIcon>}
	        //   />,
	        // );
	        menuItems.push(React.createElement(Divider_1["default"], { key: "divider" }));
	        // const avatar = studioAppConfig.currentToken.user.pictureUrl ?
	        //             <Avatar src={studioAppConfig.currentToken.user.pictureUrl}/> :
	        //             <Avatar> {studioAppConfig.currentToken.user.name.substr(0,1)} </Avatar>
	        menuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: '/logout' }), key: "logout", onTouchTap: this.handleToggle, primaryText: "Logout", leftIcon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "exit_to_app") }));
	        if (!this.childrenWithProps || shouldUpdateChildren) {
	            this.childrenWithProps = React.Children.map(this.props.children, function (child) {
	                return React.cloneElement(child, {
	                    region: region,
	                    conf: _this.state.configuration,
	                    partnerMap: partnerIdToPartner
	                }, null);
	            });
	        }
	        return (React.createElement("div", null,
	            React.createElement(AppBar_1["default"], { title: studioAppConfig.currentToken ? (React.createElement(CustomAppBar_1["default"], { history: this.props.history, title: appTitle, user: studioAppConfig.currentToken, partner: currentPartner, partnerMap: partnerIdToPartner })) : null, style: { position: 'fixed' }, onLeftIconButtonTouchTap: this.handleToggle }),
	            React.createElement(Drawer_1["default"], { open: this.state.drawerOpen, docked: false, onRequestChange: function (open) {
	                    console.log(open);
	                    _this.setState(__assign({}, _this.state, { drawerOpen: open }));
	                } },
	                React.createElement("div", { style: { backgroundColor: Colors.cyan500 }, onClick: this.handleToggle },
	                    React.createElement("img", { src: "../../../assets/images/logo_white.png", width: "70px", style: { margin: '0 auto', padding: '10px', display: 'block' } })),
	                React.createElement(Menu_1["default"], { style: { width: 'auto' } }, menuItems)),
	            React.createElement("div", { className: "", style: {
	                    paddingTop: '60px',
	                    width: '90%',
	                    maxWidth: '1400px',
	                    margin: '0 auto',
	                    marginBottom: '5%'
	                } }, this.childrenWithProps),
	            React.createElement("div", { className: "", style: styles.footer }, "Copyright \u00A9 2017 Glance. All Rights Reserved.")));
	    };
	    return App;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	var mapDispatchToProps = function (dispatch) {
	    return {
	        dispatchFetchStudioAppConfig: function () { return dispatch(draftsAction_1.fetchStudioAppConfig()); }
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(App);


/***/ },

/***/ 974:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var RestService_1 = __webpack_require__(32);
	var Utils_1 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var styles = {
	    image: {
	        padding: '5px',
	        width: 'auto',
	        margin: '5px auto',
	        boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
	        backgroundColor: 'rgb(255, 255, 255)',
	        display: 'block'
	    },
	    tagline: {
	        color: '#aaaaaa'
	    },
	    peekData: {
	        width: '50em',
	        margin: 'auto',
	        display: 'block'
	    },
	    summary: {
	        width: '50em',
	        margin: 'auto',
	        display: 'block'
	    }
	};
	var ApprovalState;
	(function (ApprovalState) {
	    ApprovalState[ApprovalState["APPROVING"] = 0] = "APPROVING";
	    ApprovalState[ApprovalState["APPROVED"] = 1] = "APPROVED";
	    ApprovalState[ApprovalState["REJECTING"] = 2] = "REJECTING";
	    ApprovalState[ApprovalState["REJECTED"] = 3] = "REJECTED";
	})(ApprovalState || (ApprovalState = {}));
	var Approval = /** @class */ (function (_super) {
	    __extends(Approval, _super);
	    function Approval(props) {
	        var _this = _super.call(this, props) || this;
	        var glanceId = _this.props.params.id;
	        var state;
	        var error;
	        if (_this.props.params.action == 'approve') {
	            state = ApprovalState.APPROVING;
	        }
	        else if ((_this.props.params.action == 'reject')) {
	            state = ApprovalState.REJECTING;
	        }
	        else {
	            error = 'Malformed URL. Contact Glance support if persists.';
	        }
	        _this.state = {
	            approvalState: state,
	            error: error,
	            glanceId: glanceId
	        };
	        return _this;
	    }
	    Approval.prototype.componentDidMount = function () {
	        var that = this;
	        var partner;
	        if (this.props.params && this.props.params.partnerId) {
	            partner = this.props.partnerMap.get(this.props.params.partnerId);
	        }
	        else if (this.props.partnerMap.size > 0) {
	            partner = this.props.partnerMap.values().next().value;
	        }
	        else {
	            partner = this.props.studioAppConfig.currentToken.partner;
	        }
	        if (this.state.approvalState == ApprovalState.APPROVING) {
	            RestService_1["default"].approveGlance(2 /* IN */, that.state.glanceId, partner, function (data) {
	                if (data) {
	                    that.setState(__assign({}, that.state, { data: data, approvalState: ApprovalState.APPROVED }));
	                }
	                else {
	                    that.setState(__assign({}, that.state, { error: 'Unable to approve glance, contact Glance support.' }));
	                }
	            });
	        }
	        else if (this.state.approvalState == ApprovalState.REJECTING) {
	            RestService_1["default"].rejectGlance(2 /* IN */, that.state.glanceId, partner, function (data) {
	                if (data) {
	                    that.setState(__assign({}, that.state, { data: data, approvalState: ApprovalState.REJECTED }));
	                }
	                else {
	                    that.setState(__assign({}, that.state, { error: 'Unable to reject glance, contact Glance support.' }));
	                }
	            });
	        }
	    };
	    Approval.prototype.render = function () {
	        var message;
	        if (this.state.error) {
	            message = this.state.error;
	        }
	        else {
	            switch (this.state.approvalState) {
	                case ApprovalState.APPROVING:
	                    message = 'Approving glance ...';
	                    break;
	                case ApprovalState.APPROVED:
	                    message = 'Glance approved.';
	                    break;
	                case ApprovalState.REJECTING:
	                    message = 'Rejecting glance ...';
	                    break;
	                case ApprovalState.REJECTED:
	                    message = 'Glance rejected.';
	                    break;
	            }
	        }
	        var elements = [];
	        elements.push(React.createElement("h1", { style: { textAlign: 'center' }, key: 'message' }, message));
	        if (this.state.data) {
	            var imageUrl = this.props.studioAppConfig.cdnPrefix + 'wallpaper/' + this.state.data.image.id + '.webp';
	            var tagline = this.state.data.peekData ? this.state.data.peekData.title : null;
	            var peekLink = Utils_1["default"].getPeekLink(this.state.data);
	            var summary = Utils_1["default"].getSummary(this.state.data);
	            elements.push(React.createElement("img", { key: 'image', id: 'image', style: styles.image, width: '225px', height: '400px', src: imageUrl }));
	            elements.push(React.createElement("div", { key: 'peekData', style: styles.peekData },
	                React.createElement("span", { className: 'tagline', style: styles.tagline }, "Tagline: "),
	                tagline,
	                React.createElement("br", null),
	                React.createElement("span", { className: 'tagline', style: styles.tagline }, "PeekLink: "),
	                " ",
	                React.createElement("a", { href: peekLink, target: '_blank' }, peekLink)), React.createElement("div", { key: 'summary', style: styles.summary },
	                React.createElement("span", { className: 'tagline', style: styles.tagline }, "Summary: "),
	                " ",
	                summary));
	        }
	        return (React.createElement("div", { style: { textAlign: 'center' } }, elements));
	    };
	    return Approval;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(Approval);


/***/ },

/***/ 975:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	var MediaQuery = __webpack_require__(123);
	var React = __webpack_require__(1);
	var Clock_1 = __webpack_require__(151);
	var Avatar_1 = __webpack_require__(200);
	var DropDownMenu_1 = __webpack_require__(69);
	var react_router_1 = __webpack_require__(241);
	var MenuItem_1 = __webpack_require__(51);
	var react_redux_1 = __webpack_require__(24);
	var lodash_1 = __webpack_require__(294);
	var styles = {
	    mainDiv: {
	        display: 'flex',
	        flexDirection: 'row',
	        height: 'inherit'
	    },
	    title: {
	        color: 'white',
	        display: 'inline-block',
	        float: 'left',
	        fontWeight: 400,
	        marginTop: '15px'
	    },
	    partnerMenu: {
	        color: 'white',
	        display: 'inline-block',
	        float: 'left',
	        fontWeight: 400,
	        marginTop: '2px',
	        marginLeft: '-10px',
	        fontSize: '24px'
	    },
	    clockDiv: {
	        display: 'inline-block',
	        margin: '0 auto'
	    },
	    clockSpan: {
	        fontSize: '16px',
	        display: 'inline-block',
	        margin: '0 10px'
	    },
	    userPic: {
	        display: 'inline-block',
	        float: 'right'
	    },
	    userName: {
	        fontSize: '20px',
	        paddingRight: '12px'
	    },
	    fontIcon: {
	        verticalAlign: 'middle'
	    }
	};
	var CustomAppBar = /** @class */ (function (_super) {
	    __extends(CustomAppBar, _super);
	    function CustomAppBar(props) {
	        var _this = _super.call(this, props) || this;
	        _this.changePartner = _this.changePartner.bind(_this);
	        return _this;
	    }
	    CustomAppBar.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, user = _a.user, _b = _a.partner, partner = _b === void 0 ? { partnerId: '', name: '' } : _b, partnerMap = _a.partnerMap, title = _a.title;
	        var pictureUrl = lodash_1.get(user, 'user.pictureUrl', '');
	        var name = lodash_1.get(user, 'user.name', '');
	        var avatar = pictureUrl ?
	            React.createElement(Avatar_1["default"], { src: pictureUrl }) :
	            React.createElement(Avatar_1["default"], null,
	                " ",
	                name.substr(0, 1),
	                " ");
	        var partnerMenuItems = [];
	        partnerMap.forEach(function (partnerItem) {
	            if (partnerItem.partnerId !== partner.partnerId) {
	                partnerMenuItems.push(React.createElement(MenuItem_1["default"], { containerElement: React.createElement(react_router_1.Link, { to: '/partner/' + partnerItem.partnerId }), primaryText: partnerItem.name, onClick: function () { return _this.changePartner(partnerItem.partnerId); }, value: partnerItem.partnerId }));
	            }
	        });
	        return (React.createElement("div", null,
	            React.createElement(MediaQuery, { query: '(min-device-width: 1224px)' },
	                React.createElement("div", { style: styles.mainDiv },
	                    React.createElement("h3", { style: styles.title }, title),
	                    partner && partner.partnerId ?
	                        React.createElement(DropDownMenu_1["default"], { value: 1, labelStyle: styles.partnerMenu },
	                            React.createElement(MenuItem_1["default"], { value: 1, containerElement: React.createElement(react_router_1.Link, { to: '/partner/' + partner.partnerId }), primaryText: partner.name, onClick: function () { return _this.changePartner(partner.partnerId); } }),
	                            partnerMenuItems)
	                        : null,
	                    React.createElement("div", { style: styles.clockDiv },
	                        React.createElement(Clock_1.ClockWithTimezone, { timezone: Clock_1.usTimezone, customStyle: styles.clockSpan }),
	                        React.createElement(Clock_1.ClockWithTimezone, { timezone: Clock_1.indiaTimezone, customStyle: styles.clockSpan }),
	                        React.createElement(Clock_1.ClockWithTimezone, { timezone: Clock_1.chinaTimezone, customStyle: styles.clockSpan }),
	                        React.createElement(Clock_1.ClockWithTimezone, { timezone: Clock_1.krTimezone, customStyle: styles.clockSpan }),
	                        React.createElement(Clock_1.ClockWithTimezone, { timezone: Clock_1.idTimezone, customStyle: styles.clockSpan })),
	                    React.createElement("div", { style: styles.userPic },
	                        React.createElement("span", { style: styles.userName }, name),
	                        avatar))),
	            React.createElement(MediaQuery, { query: '(max-device-width: 1224px)' },
	                React.createElement("div", { style: styles.mainDiv },
	                    React.createElement("h3", { style: styles.title }, title),
	                    partner ?
	                        React.createElement(DropDownMenu_1["default"], { value: 1, labelStyle: styles.partnerMenu },
	                            React.createElement(MenuItem_1["default"], { value: 1, containerElement: React.createElement(react_router_1.Link, { to: '/partner/' + partner.partnerId }), primaryText: partner.name, onClick: function () { return _this.changePartner(partner.partnerId); } }),
	                            partnerMenuItems)
	                        : '',
	                    React.createElement("div", { style: styles.clockDiv }),
	                    React.createElement("div", { style: styles.userPic }, avatar)))));
	    };
	    CustomAppBar.prototype.changePartner = function (value) {
	        this.props.history.push('/partner/' + value);
	        window.location.reload();
	    };
	    return CustomAppBar;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(CustomAppBar);


/***/ },

/***/ 976:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	var MediaQuery = __webpack_require__(123);
	var React = __webpack_require__(1);
	var DeviceTest = /** @class */ (function (_super) {
	    __extends(DeviceTest, _super);
	    function DeviceTest(props) {
	        return _super.call(this, props) || this;
	    }
	    DeviceTest.prototype.render = function () {
	        return (React.createElement("div", null,
	            React.createElement("div", null, "Device Test!"),
	            React.createElement(MediaQuery, { query: '(min-device-width: 1224px)' },
	                React.createElement("div", null, "You are a desktop or laptop"),
	                React.createElement(MediaQuery, { query: '(min-device-width: 1824px)' },
	                    React.createElement("div", null, "You also have a huge screen")),
	                React.createElement(MediaQuery, { query: '(max-width: 1224px)' },
	                    React.createElement("div", null, "You are sized like a tablet or mobile phone though"))),
	            React.createElement(MediaQuery, { query: '(max-device-width: 1224px)' },
	                React.createElement("div", null, "You are a tablet or mobile phone")),
	            React.createElement(MediaQuery, { query: '(orientation: portrait)' },
	                React.createElement("div", null, "You are portrait")),
	            React.createElement(MediaQuery, { query: '(orientation: landscape)' },
	                React.createElement("div", null, "You are landscape")),
	            React.createElement(MediaQuery, { query: '(min-resolution: 2dppx)' },
	                React.createElement("div", null, "You are retina"))));
	    };
	    return DeviceTest;
	}(React.Component));
	exports["default"] = DeviceTest;


/***/ },

/***/ 977:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	var React = __webpack_require__(1);
	function findGetParameter(parameterName) {
	    var result = null, tmp = [];
	    console.log(location);
	    location.href
	        .substr(location.href.indexOf('?') + 1)
	        .split('&')
	        .forEach(function (item) {
	        tmp = item.split('=');
	        if (tmp[0] === parameterName)
	            result = decodeURIComponent(tmp[1]);
	    });
	    console.log(result);
	    return result;
	}
	var ErrorComponent = /** @class */ (function (_super) {
	    __extends(ErrorComponent, _super);
	    function ErrorComponent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ErrorComponent.prototype.render = function () {
	        return (React.createElement("div", { style: { width: '90%', height: '0', margin: '0px auto', position: 'relative',
	                paddingBottom: '56.25%',
	                paddingTop: '25px' } },
	            React.createElement("iframe", { srcDoc: findGetParameter('html'), width: '500', style: {
	                    position: 'absolute',
	                    top: '5%',
	                    left: 0,
	                    width: '100%',
	                    height: '80%'
	                } })));
	    };
	    return ErrorComponent;
	}(React.Component));
	exports["default"] = ErrorComponent;


/***/ },

/***/ 978:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var Card_1 = __webpack_require__(201);
	var GlanceDetailsCard_1 = __webpack_require__(980);
	var GlanceWallpaperCard_1 = __webpack_require__(983);
	var material_ui_1 = __webpack_require__(38);
	var Utils_1 = __webpack_require__(17);
	var styles = {
	    cardTextDiv: {
	        padding: '5px',
	        display: 'flex',
	        margin: '0px auto',
	        maxHeight: '70vh',
	        overflow: 'auto'
	    },
	    glanceCard: {
	        height: '100%',
	        flexFlow: 'column',
	        display: 'flex'
	    },
	    wallpaperDiv: {
	        padding: '5px'
	    },
	    wallpaper: {
	        maxWidth: '60%',
	        display: 'block',
	        margin: '0px auto'
	    }
	};
	var GlanceCard = /** @class */ (function (_super) {
	    __extends(GlanceCard, _super);
	    function GlanceCard(props) {
	        return _super.call(this, props) || this;
	    }
	    GlanceCard.prototype.render = function () {
	        var renderSession = Utils_1["default"].getRenderSessionData(this.props.data.data);
	        var wallpaperWidth = this.props.detailedView ? '50%' : '100%';
	        var detailsWidth = this.props.detailedView ? '50%' : '100%';
	        var flexFlow = this.props.detailedView ? 'row' : 'column';
	        var userActions = this.props.actions ? this.props.actions.filter(function (action) { return action.key !== 'state_button' && action.key !== 'select_button'; }) : [];
	        var selectButton = this.props.actions ? this.props.actions.find(function (action) { return action.key === 'select_button'; }) : null;
	        var stateLabel = this.props.actions ? this.props.actions.find(function (action) { return action.key === 'state_button'; }) : null;
	        return (React.createElement(Card_1.Card, { style: __assign({}, this.props.customStyle, { height: '100%' }), containerStyle: styles.glanceCard },
	            React.createElement(Card_1.CardText, { style: { padding: '2px' } },
	                React.createElement("div", { className: 'display-flex', style: { margin: '0px auto', display: 'flex', flexFlow: flexFlow, position: 'relative' } },
	                    selectButton,
	                    React.createElement("div", { className: '', style: __assign({ width: wallpaperWidth, minHeight: '330px' }, styles.wallpaperDiv) },
	                        React.createElement(GlanceWallpaperCard_1["default"], { customStyle: styles.wallpaper, renderSessionProperties: renderSession, image: this.props.data.data.image, overlayImage: this.props.data.data.overlayImage, type: this.props.data.data.type, partner: this.props.partner, studioAppConfig: this.props.studioAppConfig, spaceData: this.props.data.data.spaceData, destinationIdentifier: this.props.data.data.destinationIdentifier })),
	                    stateLabel,
	                    React.createElement("div", { className: 'display-flex', style: __assign({ width: detailsWidth }, styles.cardTextDiv) },
	                        React.createElement(GlanceDetailsCard_1["default"], { glance: this.props.data, detailedView: this.props.detailedView, region: this.props.region, partner: this.props.partner, studioAppConfig: this.props.studioAppConfig })))),
	            userActions.length > 0 ?
	                React.createElement(material_ui_1.GridList, { cols: userActions.length, padding: 5, cellHeight: 'auto', style: { flex: 1, alignItems: 'flex-end' } }, userActions)
	                : ''));
	    };
	    return GlanceCard;
	}(React.Component));
	exports["default"] = GlanceCard;


/***/ },

/***/ 979:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var material_ui_1 = __webpack_require__(38);
	var colors_1 = __webpack_require__(18);
	var material_ui_chip_input_1 = __webpack_require__(191);
	var Utils_1 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var styles = {
	    clickableChip: {
	        margin: 1,
	        display: 'inline-block'
	    },
	    width100: {
	        width: '100%',
	        maxWidth: 'none'
	    }
	};
	var SESSION_MODE_LIST = [{ name: 'LOCKSCREEN', value: 1 /* DEFAULT */ }, { name: 'BINGE', value: 2 /* BINGE */ }];
	var CATEGORY_SOURCE_CONFIG = { text: 'displayName', value: 'category' };
	var SESSION_MODE_CONFIG = { text: 'name', value: 'value' };
	var SEGMENT_SOURCE_CONFIG = { text: 'text', value: 'id' };
	var rendersessionPropertiesMapping = function (params) {
	    var data = Utils_1["default"].getRenderSessionData(params);
	    return SESSION_MODE_LIST.filter(function (item) { return data.includes(item.value); });
	};
	var GlanceChangeData = /** @class */ (function (_super) {
	    __extends(GlanceChangeData, _super);
	    function GlanceChangeData(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleGlanceUserAgeFilterChange = function (value, type) { return __awaiter(_this, void 0, void 0, function () {
	            var selectedDay;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        selectedDay = value;
	                        return [4 /*yield*/, this.props.onEdit(type, selectedDay)];
	                    case 1:
	                        _a.sent();
	                        if (type === 'startDay') {
	                            this.props.onEdit('endDay', null);
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        }); };
	        _this.handleRenderSessionModeChange = _this.handleRenderSessionModeChange.bind(_this);
	        _this.handleSkipSummaryChange = _this.handleSkipSummaryChange.bind(_this);
	        _this.handleShouldUnlock = _this.handleShouldUnlock.bind(_this);
	        _this.handleSdkSubscribedCategoriesFilterChange = _this.handleSdkSubscribedCategoriesFilterChange.bind(_this);
	        _this.handleTargetForCategoryChange = _this.handleTargetForCategoryChange.bind(_this);
	        _this.handleCategoryChange = _this.handleCategoryChange.bind(_this);
	        var categorySource = [];
	        var categoryMap = new Map();
	        _this.state = {
	            categorySource: categorySource,
	            categoryMap: categoryMap,
	            segmentSource: []
	        };
	        return _this;
	    }
	    GlanceChangeData.prototype.componentDidMount = function () {
	        var categorySource = [];
	        var categoryMap = new Map();
	        var studioAppConfig = this.props.studioAppConfig;
	        studioAppConfig.categories.forEach(function (category) {
	            categorySource.push({
	                displayName: category.displayName,
	                category: category
	            });
	            categoryMap.set(category.id, category);
	        });
	        this.setState(function (state, props) { return ({
	            categorySource: categorySource,
	            categoryMap: categoryMap,
	            segmentSource: []
	        }); });
	    };
	    GlanceChangeData.prototype.handleRenderSessionModeChange = function (chip, remove) {
	        if (!chip)
	            return;
	        var renderProperties = rendersessionPropertiesMapping(this.props.bulkChangeData);
	        if (remove) {
	            renderProperties = renderProperties.filter(function (item) {
	                return item.value !== chip;
	            });
	        }
	        else {
	            renderProperties.push(chip);
	        }
	        var renderSessionList = [];
	        renderProperties.forEach(function (ele) {
	            renderSessionList.push(ele.value);
	        });
	        this.props.onEdit('renderSessionProperties', renderSessionList);
	    };
	    GlanceChangeData.prototype.handleSkipSummaryChange = function (field, context, value) {
	        this.props.onEdit('canSkipSummary', value);
	    };
	    GlanceChangeData.prototype.handleShouldUnlock = function (field, context, value) {
	        this.props.onEdit('shouldUnlock', value);
	    };
	    GlanceChangeData.prototype.handleSdkSubscribedCategoriesFilterChange = function (field, context, value) {
	        this.props.onEdit('categorySubscriptionStatus', value);
	    };
	    GlanceChangeData.prototype.handleTargetForCategoryChange = function (chip, remove) {
	        console.log('handleTargetForCategoryChange', chip, remove);
	        var newCategories = this.props.bulkChangeData ? this.props.bulkChangeData.targetForCategories : null;
	        if (remove) {
	            if (!newCategories) {
	                return;
	            }
	            newCategories = newCategories.filter(function (category) {
	                return category != chip.id;
	            });
	            this.props.onEdit('targetForCategories', newCategories);
	        }
	        else {
	            if (!newCategories) {
	                newCategories = [];
	            }
	            if (newCategories.indexOf(chip.category.id) == -1 && this.state.categoryMap.has(chip.category.id)) {
	                newCategories = newCategories.concat([chip.category.id]);
	                this.props.onEdit('targetForCategories', newCategories);
	            }
	        }
	    };
	    GlanceChangeData.prototype.handleCategoryChange = function (chip, remove) {
	        console.log('handleCategoryChange', chip, remove);
	        var newCategories = this.props.bulkChangeData ? this.props.bulkChangeData.categoryIds : null;
	        if (remove) {
	            if (!newCategories) {
	                return;
	            }
	            newCategories = newCategories.filter(function (category) {
	                return category != chip.id;
	            });
	            if (newCategories.length == 0) {
	                newCategories = null;
	            }
	            this.props.onEdit('categoryIds', newCategories);
	        }
	        else {
	            if (!newCategories) {
	                newCategories = [];
	            }
	            if (newCategories.length >= 2) {
	                console.error('More than two not allowed');
	                return;
	            }
	            if (newCategories.indexOf(chip.category.id) == -1 && this.state.categoryMap.has(chip.category.id)) {
	                newCategories = newCategories.concat([chip.category.id]);
	                this.props.onEdit('categoryIds', newCategories);
	            }
	        }
	    };
	    GlanceChangeData.prototype.handleSegmentChange = function (chip, remove) {
	        var newSegments = this.props.bulkChangeData ? this.props.bulkChangeData.segments : null;
	        if (remove) {
	            if (!newSegments) {
	                return;
	            }
	            newSegments = newSegments.filter(function (segment) {
	                return segment.id != chip;
	            });
	            if (newSegments.length == 0) {
	                newSegments = null;
	            }
	            this.props.onEdit('segmentIds', newSegments);
	        }
	        else {
	            if (!newSegments) {
	                newSegments = [];
	            }
	            if (!newSegments.find(function (segment) { return segment.id == chip.id; })) {
	                var chipSegment = this.props.studioAppConfig.sqlSegments.find(function (s) { return s.id == chip.id; });
	                newSegments = newSegments.concat([chipSegment]);
	                this.props.onEdit('segmentIds', newSegments);
	            }
	        }
	    };
	    GlanceChangeData.prototype.convertSegmentsToSegmentSources = function (segments) {
	        var segmentSource = [];
	        if (!segments) {
	            return segmentSource;
	        }
	        segments.forEach(function (segment) {
	            segmentSource.push({
	                text: segment.name + ' / ' + segment.displayName,
	                id: segment.id
	            });
	        });
	        return segmentSource;
	    };
	    GlanceChangeData.prototype.onSegmentSearch = function (chip) {
	        var segments = this.props.studioAppConfig.sqlSegments;
	        var segmentSourceTemp = this.convertSegmentsToSegmentSources(segments.filter(function (segment) {
	            return segment.name.toLowerCase().indexOf(chip.toLowerCase()) != -1 || segment.displayName.toLowerCase().indexOf(chip.toLowerCase()) != -1;
	        }));
	        segmentSourceTemp = segmentSourceTemp.slice(0, 10);
	        this.setState(__assign({}, this.state, { segmentSource: segmentSourceTemp }));
	    };
	    GlanceChangeData.prototype.render = function () {
	        var _this = this;
	        var elements = [];
	        var bulkChangeData = this.props.bulkChangeData;
	        var userLifeTimeFilter = bulkChangeData && bulkChangeData.userLifeTimeFilter || { startDay: null, endDay: null };
	        var startDay = (userLifeTimeFilter && userLifeTimeFilter.startDay) || 1;
	        var startDays = Array.from(Array(8).keys()).map(function (stDay) { return stDay + 1; });
	        var endDays = startDays.filter(function (age) { return age >= startDay && age < 8; });
	        var categoryMap = [];
	        this.props.studioAppConfig.categories.forEach(function (category) {
	            categoryMap.push(React.createElement(material_ui_1.MenuItem, { key: category.id, value: category.id, primaryText: 'Not Subscribed To ' + category.displayName }));
	        });
	        var segments = (React.createElement(material_ui_chip_input_1["default"], { key: 'segments', hintText: 'Segments', style: __assign({}, styles.width100, { marginTop: '-8px' }), value: this.convertSegmentsToSegmentSources(this.props.bulkChangeData && this.props.bulkChangeData.segments != null
	                ? this.props.bulkChangeData.segments : null), dataSource: this.state.segmentSource, dataSourceConfig: SEGMENT_SOURCE_CONFIG, onUpdateInput: function (chip) { return _this.onSegmentSearch(chip); }, onRequestAdd: function (chip) { return _this.handleSegmentChange(chip, false); }, onRequestDelete: function (chip, index) { return _this.handleSegmentChange(chip, true); } }));
	        var userAgeFilterTpl = (React.createElement(material_ui_1.GridList, { cellHeight: 'auto' },
	            React.createElement(material_ui_1.GridTile, null,
	                React.createElement(material_ui_1.SelectField, { value: userLifeTimeFilter && userLifeTimeFilter.startDay ?
	                        userLifeTimeFilter.startDay : null, onChange: function (field, context, value) { return _this.handleGlanceUserAgeFilterChange(value, 'startDay'); } },
	                    React.createElement(material_ui_1.MenuItem, { key: 'data-startDay--1', value: null, primaryText: 'All Users' }),
	                    startDays.map(function (startDay) {
	                        return (React.createElement(material_ui_1.MenuItem, { key: "data-startDay-" + startDay, value: startDay, primaryText: "" + (startDay <= 7 ? startDay : startDay - 1 + "+") }));
	                    }))),
	            React.createElement(material_ui_1.GridTile, null,
	                React.createElement(material_ui_1.SelectField, { value: userLifeTimeFilter && userLifeTimeFilter.endDay ?
	                        userLifeTimeFilter.endDay : null, disabled: !userLifeTimeFilter.startDay || userLifeTimeFilter.startDay === 8, onChange: function (feild, context, value) { return _this.handleGlanceUserAgeFilterChange(value, 'endDay'); } },
	                    React.createElement(material_ui_1.MenuItem, { key: 'data-endDay--1', value: null, primaryText: 'End Day' }),
	                    endDays.map(function (endDay) {
	                        return (React.createElement(material_ui_1.MenuItem, { key: "data-endDay-" + endDay, value: endDay, primaryText: endDay }));
	                    })))));
	        var sessionMode = (React.createElement("div", null,
	            "Session Mode:",
	            React.createElement(material_ui_chip_input_1["default"], { key: 'renderSessionProperties', style: __assign({}, styles.width100), value: rendersessionPropertiesMapping(this.props.bulkChangeData), dataSource: SESSION_MODE_LIST, dataSourceConfig: SESSION_MODE_CONFIG, onRequestAdd: function (chip) { return _this.handleRenderSessionModeChange(chip, false); }, onRequestDelete: function (chip) { return _this.handleRenderSessionModeChange(chip, true); } })));
	        var canSkipSummary = (React.createElement(material_ui_1.DropDownMenu, { value: this.props.bulkChangeData && this.props.bulkChangeData.canSkipSummary != null
	                ? this.props.bulkChangeData.canSkipSummary
	                : null, key: 'skip_summary_changer', onChange: this.handleSkipSummaryChange },
	            React.createElement(material_ui_1.MenuItem, { key: 'Turn Off', value: null, primaryText: 'Skip Summary Turned Off' }),
	            React.createElement(material_ui_1.MenuItem, { key: 'Any', value: true, primaryText: 'Can Skip Summary' }),
	            React.createElement(material_ui_1.MenuItem, { key: 'Binge', value: false, primaryText: 'Cannot Skip Summary' })));
	        var shouldUnlock = (React.createElement(material_ui_1.DropDownMenu, { value: this.props.bulkChangeData && this.props.bulkChangeData.shouldUnlock != null
	                ? this.props.bulkChangeData.shouldUnlock
	                : null, key: 'peek_cta', onChange: this.handleShouldUnlock },
	            React.createElement(material_ui_1.MenuItem, { key: 'Turn Off', value: null, primaryText: 'CTA Position Turned Off' }),
	            React.createElement(material_ui_1.MenuItem, { key: 'Any', value: true, primaryText: 'CTA After Unlock' }),
	            React.createElement(material_ui_1.MenuItem, { key: 'Binge', value: false, primaryText: 'CTA On Lockscreen' })));
	        var sdkSubscribedCategoriesFilter = (React.createElement(material_ui_1.DropDownMenu, { value: this.props.bulkChangeData && this.props.bulkChangeData.categorySubscriptionStatus != null
	                ? this.props.bulkChangeData.categorySubscriptionStatus
	                : null, onChange: this.handleSdkSubscribedCategoriesFilterChange },
	            React.createElement(material_ui_1.MenuItem, { key: 'null', value: null, primaryText: 'Subscribed Status Turned Off' }),
	            React.createElement(material_ui_1.MenuItem, { key: 1 /* ANY */, value: 1 /* ANY */, primaryText: 'SDK Subscribed Categories At Least 1' }),
	            React.createElement(material_ui_1.MenuItem, { key: 0 /* NONE */, value: 0 /* NONE */, primaryText: 'SDK Subscribed Categories None' })));
	        var targetForCategoriesValue = [];
	        if (this.props.bulkChangeData && this.props.bulkChangeData.targetForCategories) {
	            this.state.categorySource.forEach(function (categorySource) {
	                if (_this.props.bulkChangeData.targetForCategories.indexOf(categorySource.category.id) != -1) {
	                    targetForCategoriesValue.push(categorySource);
	                }
	            });
	        }
	        var targetForCategory = (React.createElement(material_ui_chip_input_1["default"], { key: 'targetForCategories', hintText: 'Not Subscribed to Categories', style: __assign({}, styles.width100, { marginTop: '-8px' }), value: targetForCategoriesValue, dataSource: this.state.categorySource, dataSourceConfig: CATEGORY_SOURCE_CONFIG, onRequestAdd: function (chip) { return _this.handleTargetForCategoryChange(chip, false); }, onRequestDelete: function (chip, index) { return _this.handleTargetForCategoryChange(chip, true); } }));
	        var categoriesValue = [];
	        if (this.props.bulkChangeData && this.props.bulkChangeData.categoryIds) {
	            this.state.categorySource.forEach(function (categorySource) {
	                if (_this.props.bulkChangeData.categoryIds.indexOf(categorySource.category.id) != -1) {
	                    categoriesValue.push(categorySource);
	                }
	            });
	        }
	        var categories = (React.createElement(material_ui_chip_input_1["default"], { key: 'categoryIds', hintText: 'Category', style: __assign({}, styles.width100, { marginTop: '-8px' }), value: categoriesValue, dataSource: this.state.categorySource, dataSourceConfig: CATEGORY_SOURCE_CONFIG, onRequestAdd: function (chip) { return _this.handleCategoryChange(chip, false); }, onRequestDelete: function (chip, index) { return _this.handleCategoryChange(chip, true); } }));
	        var advancedCta = (React.createElement(material_ui_1.Chip, { style: { marginTop: '4px' }, key: 'load_android_js', backgroundColor: this.props != null
	                && this.props.bulkChangeData != null
	                && this.props.bulkChangeData.advancedCta
	                ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.props.onEdit('advancedCta', !(_this.props != null
	                    && _this.props.bulkChangeData != null
	                    && _this.props.bulkChangeData.advancedCta));
	            } }, this.props != null
	            && this.props.bulkChangeData != null
	            && this.props.bulkChangeData.advancedCta
	            ? 'Advanced CTA webview'
	            : 'Not advanced CTA webview'));
	        elements.push(userAgeFilterTpl);
	        elements.push(sessionMode);
	        elements.push(canSkipSummary);
	        elements.push(shouldUnlock);
	        elements.push(sdkSubscribedCategoriesFilter);
	        elements.push(targetForCategory);
	        elements.push(categories);
	        elements.push(segments);
	        elements.push(advancedCta);
	        return (React.createElement("div", null,
	            React.createElement("form", { className: 'form' }, elements)));
	    };
	    return GlanceChangeData;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(GlanceChangeData);


/***/ },

/***/ 980:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var material_ui_1 = __webpack_require__(38);
	var GlanceTime_1 = __webpack_require__(982);
	var Utils_1 = __webpack_require__(17);
	var GIONEE_PARTNER_ID = '59458435b8034886b62dbe672e010e064ab5aecf';
	var styles = {
	    width50: {
	        width: '50%',
	        maxWidth: 'none'
	    },
	    width35: {
	        width: '35%',
	        maxWidth: 'none'
	    },
	    width30: {
	        width: '30%',
	        maxWidth: 'none'
	    },
	    width100: {
	        width: '100%',
	        maxWidth: 'none'
	    },
	    inputStyle: {
	        color: '#505050',
	        fontSize: '0.9em'
	    },
	    textareaStyle: {
	        color: '#505050',
	        fontSize: '0.9em'
	    },
	    dataTimeStyle: {
	        display: 'inline-block',
	        width: '50%'
	    },
	    title: {
	        color: 'rgba(0, 0, 0, 0.3)',
	        fontSize: '12px'
	    },
	    subtitle: {
	        fontSize: '12px',
	        borderBottom: '1px solid #eee',
	        minHeight: '18px'
	    }
	};
	exports.durationMapping = {
	    0: 'Hours',
	    1: 'Days',
	    2: 'Minutes',
	    3: 'Seconds'
	};
	exports.sessionModeMapping = {
	    0: 'ANY',
	    1: 'LOCKSCREEN',
	    2: 'BINGE',
	    3: 'HIGHLIGHTS',
	    4: 'IN-GAME REWARDED VIDEOS',
	    5: 'GAME SPLASH',
	    6: 'SCREENSAVER',
	    7: 'PATCHWALL_STORIES'
	};
	var USER_NETWORK_TYPE_SELECTED = {
	    0: 'OFFLINE',
	    1: 'WIFI',
	    2: 'MOBILE DATA',
	    'OFFLINE': 'OFFLINE',
	    'WIFI': 'WIFI',
	    'MOBILE_DATA': 'MOBILE DATA'
	};
	function getImageAttribution(image) {
	    if (image && image.attribution) {
	        var attribution = image.attribution;
	        var result = '';
	        if (attribution.author) {
	            result = attribution.author + '/';
	        }
	        return '© ' + result + attribution.source;
	    }
	    return null;
	}
	var getUserLevelExpiry = function (meta) {
	    if (meta && meta.glanceTime) {
	        var userLevelDuration = meta.glanceTime.userLevelDuration;
	        if (userLevelDuration) {
	            return Utils_1["default"].getUserLevelExpiry(userLevelDuration);
	        }
	    }
	    return 'NA';
	};
	var getStartedAt = function (date) {
	    if (date) {
	        var minutes = date.getMinutes();
	        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
	        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
	        var year = date.getFullYear();
	        var dateString = day + "-" + month + "-" + year;
	        return dateString + " " + date.getHours() + ":" + (minutes > 9 ? minutes : "0" + minutes);
	    }
	};
	var GlanceDetailsCard = /** @class */ (function (_super) {
	    __extends(GlanceDetailsCard, _super);
	    function GlanceDetailsCard(props) {
	        var _this = _super.call(this, props) || this;
	        _this.getSegmentNames = function (ids) {
	            if (ids) {
	                var studioAppConfig = _this.props.studioAppConfig;
	                if (studioAppConfig && studioAppConfig.sqlSegments) {
	                    var sqlSegments = studioAppConfig.sqlSegments;
	                    return sqlSegments.filter(function (sqlsegment) { return ids.includes(sqlsegment.id); }).map(function (sqlsegment) { return sqlsegment.name + "/" + sqlsegment.displayName; }).join(', ');
	                }
	            }
	            return 'NA';
	        };
	        _this.getPartnerExperiments = function (partnerExperiments) {
	            var partnerExpInfo = '';
	            if (partnerExperiments) {
	                partnerExperiments.forEach(function (partnerExperiment) {
	                    var partnerId = partnerExperiment.partnerId, experiments = partnerExperiment.experiments;
	                    var partnerName = _this.getPartnerName(partnerId);
	                    partnerExpInfo = (partnerExpInfo && partnerExpInfo + ",") + " " + _this.getExperimentDetails(experiments) + "(" + partnerName + ") ";
	                });
	                return partnerExpInfo;
	            }
	            return 'NA';
	        };
	        _this.getPartnerName = function (partnerId) {
	            var partners = _this.props.studioAppConfig.partners;
	            if (partners) {
	                var partnerObj = partners.find(function (partner) { return partner.partnerId === partnerId; });
	                if (partnerObj) {
	                    return partnerObj.name;
	                }
	            }
	        };
	        _this.getExperimentDetails = function (experimentArray) {
	            if (experimentArray) {
	                var studioAppConfig = _this.props.studioAppConfig;
	                if (studioAppConfig && studioAppConfig.experiments) {
	                    var experimentNames_1 = [];
	                    var experiments_1 = studioAppConfig.experiments;
	                    experimentArray.forEach(function (expArray) {
	                        var expObj = experiments_1.find(function (exp) { return exp.id === expArray.id; });
	                        if (expObj) {
	                            var variantObj = expObj.variants.find(function (variant) { return variant.id === expArray.variantId; });
	                            if (variantObj) {
	                                experimentNames_1.push(variantObj.name + "/" + expObj.name);
	                            }
	                            else if (expObj.control.id === expArray.variantId) {
	                                experimentNames_1.push(expObj.control.name + "/" + expObj.name);
	                            }
	                        }
	                    });
	                    return experimentNames_1.join(', ');
	                }
	            }
	            return 'NA';
	        };
	        return _this;
	    }
	    GlanceDetailsCard.prototype.render = function () {
	        var _this = this;
	        var partners = [];
	        var isMetaArray = false;
	        if ('partnerIds' in this.props.glance.meta) {
	            isMetaArray = true;
	            var partnerIdNames = this.props.studioAppConfig.partners.filter(function (partner) {
	                return _this.props.glance.meta.partnerIds.indexOf(partner.partnerId) > -1;
	            });
	            partnerIdNames.forEach(function (partner) {
	                partners.push(partner.name);
	            });
	        }
	        var partnerNames = partners.join(', ');
	        var data = this.props.glance.data;
	        var meta = this.props.glance.meta;
	        var editable = this.props.editable;
	        var partnerName = (this.props.partner && this.props.partner.name) || '';
	        var getCtaDetail = function (data, key) {
	            if (data && data.peek && data.peek.article) {
	                var cta = data.peek.article.cta;
	                if (partnerName === 'Transsion') {
	                    var modifiedCtaUrl = Utils_1["default"].updateUrlParams(cta ? cta[key] : 'NA', { utm_medium: 'trans' });
	                    return modifiedCtaUrl;
	                }
	                return cta && cta[key] ? cta[key] : 'NA';
	            }
	            else if (data && data.peek && data.peek.video) {
	                var cta = data.peek.video.cta;
	                if (_this.props.partner.name === 'Transsion') {
	                    var modifiedCtaUrl = Utils_1["default"].updateUrlParams(cta ? cta[key] : 'NA', { utm_medium: 'trans' });
	                    return modifiedCtaUrl;
	                }
	                return cta && cta[key] ? cta[key] : 'NA';
	            }
	            return 'NA';
	        };
	        var elements = [];
	        elements.push(React.createElement(material_ui_1.GridTile, { cols: data.glanceLanguageId != null ? (isMetaArray ? 0.33 : 0.5)
	                : (isMetaArray ? 0.5 : 1), rows: 1 },
	            React.createElement("div", { style: styles.title }, "Glance Id"),
	            React.createElement("div", { style: styles.subtitle }, data.glanceId)));
	        if (data.glanceLanguageId != null) {
	            elements.push(React.createElement(material_ui_1.GridTile, { cols: isMetaArray ? 0.33 : 0.5, rows: 1 },
	                React.createElement("div", { style: styles.title }, "Language"),
	                React.createElement("div", { style: styles.subtitle }, data.glanceLanguageId)));
	        }
	        var priorityVal = "";
	        switch (data.priority) {
	            case 0:
	                priorityVal = "Normal Priority";
	                break;
	            case 1:
	                priorityVal = "High Priority 1";
	                break;
	            case 2:
	                priorityVal = "High Priority 2";
	                break;
	            default:
	                break;
	        }
	        if (isMetaArray) {
	            elements.push(React.createElement(material_ui_1.GridTile, { cols: data.glanceLanguageId ? 0.33 : 0.5, rows: 1 },
	                React.createElement("div", { style: styles.title }, "Priority"),
	                React.createElement("div", { style: styles.subtitle }, priorityVal)));
	        }
	        var categories = data.categoryIds ? data.categoryIds.join(', ') : '';
	        elements.push(React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	            React.createElement("div", { style: styles.title }, "Categories"),
	            React.createElement("div", { style: styles.subtitle }, categories)));
	        elements.push(React.createElement(material_ui_1.GridTile, { cols: data.bingeGlanceId != null ? 0.5 : 1, rows: 1 },
	            React.createElement("div", { style: styles.title }, "Mode View"),
	            data && Utils_1["default"].getRenderSessionData(data).map(function (renderSession, index, arr) {
	                if (arr === void 0) { arr = []; }
	                return (React.createElement("span", { style: styles.subtitle }, "" + exports.sessionModeMapping[renderSession] + ((index === (arr.length - 1)) ? '' : ',') + "  "));
	            })));
	        if (data.bingeGlanceId != null) {
	            elements.push(React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                React.createElement("div", { style: styles.title }, "Binge Glance Id"),
	                React.createElement("div", { style: styles.subtitle }, data.bingeGlanceId)));
	        }
	        if (data.peekData) {
	            elements.push(React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                React.createElement("div", { style: styles.title }, "Glance Title"),
	                React.createElement("div", { style: styles.subtitle }, this.props.partner && this.props.partner.partnerId == GIONEE_PARTNER_ID && data.peekData.shortTitle ? data.peekData.shortTitle : data.peekData.title)));
	            elements.push(React.createElement(material_ui_1.GridTile, { cols: data.overlayGlanceId != null ? 0.5 : 1, rows: 1 },
	                React.createElement("div", { style: styles.title }, "Peek Source Name"),
	                React.createElement("div", { style: styles.subtitle }, data.peekData.sourceName)));
	            if (data.bubbleId != null) {
	                elements.push(React.createElement(material_ui_1.GridTile, { cols: isMetaArray ? 0.5 : 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "BubbleId"),
	                    React.createElement("div", { style: styles.subtitle }, data.bubbleId)));
	            }
	            if (data.overlayGlanceId != null) {
	                elements.push(React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Overlay Glance Id"),
	                    React.createElement("div", { style: styles.subtitle }, data.overlayGlanceId)));
	            }
	            if (isMetaArray) {
	                elements.push(React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Partners"),
	                    React.createElement("div", { style: styles.subtitle }, partnerNames)));
	                if (meta.internalRejectionReason) {
	                    elements.push(React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                        React.createElement("div", { style: styles.title }, "RejectionReason"),
	                        React.createElement("div", { style: styles.subtitle }, meta.internalRejectionReason)));
	                }
	            }
	            if (this.props.detailedView) {
	                var summary = void 0;
	                var offlinePeek = 'NA';
	                if (data.peek) {
	                    if (data.peek.article && data.peek.article.summary) {
	                        summary = this.props.partner &&
	                            this.props.partner.partnerId == GIONEE_PARTNER_ID &&
	                            data.peek.article.cheesySummary ? data.peek.article.cheesySummary : data.peek.article.summary;
	                    }
	                    else if (data.peek.video && data.peek.video.summary) {
	                        summary = this.props.partner &&
	                            this.props.partner.partnerId == GIONEE_PARTNER_ID &&
	                            data.peek.video.cheesySummary ? data.peek.video.cheesySummary : data.peek.video.summary;
	                    }
	                }
	                if (data.offlinePeek) {
	                    if (data.offlinePeek.article) {
	                        offlinePeek = data.offlinePeek.article.cta.originalUrl;
	                    }
	                    else {
	                        offlinePeek = data.offlinePeek.video.cta.originalUrl;
	                    }
	                }
	                elements.push(React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Summary"),
	                    React.createElement("div", { style: styles.subtitle }, summary)), React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Attribution"),
	                    React.createElement("div", { style: styles.subtitle }, getImageAttribution(data.image))), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Priority"),
	                    React.createElement("div", { style: styles.subtitle }, priorityVal)), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Publisher"),
	                    React.createElement("div", { style: styles.subtitle }, data.publisherData ? data.publisherData.displayName : 'NA')), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Daily Cap"),
	                    React.createElement("div", { style: styles.subtitle }, data.frequencyCaps ? data.frequencyCaps.daily : 0)), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Weekly Cap"),
	                    React.createElement("div", { style: styles.subtitle }, data.frequencyCaps ? data.frequencyCaps.weekly : 0)), React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Offline Peek"),
	                    React.createElement("div", { style: styles.subtitle }, offlinePeek)), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Session Mode"),
	                    React.createElement("div", { style: styles.subtitle }, data && Utils_1["default"].getRenderSessionData(data).map(function (renderSession, index, arr) {
	                        if (arr === void 0) { arr = []; }
	                        return (React.createElement("span", { style: styles.subtitle }, "" + exports.sessionModeMapping[renderSession] + ((index === (arr.length - 1)) ? '' : ',') + "  "));
	                    }))), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "StickiNess"),
	                    React.createElement("div", { style: styles.subtitle }, data.stickinessCount ? data.stickinessCount : '0')), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Cta Text"),
	                    React.createElement("div", { style: styles.subtitle }, getCtaDetail(data, 'text'))), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "User Level Expiry"),
	                    React.createElement("div", { style: styles.subtitle }, getUserLevelExpiry(meta))), React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Cta Url"),
	                    React.createElement("div", { style: styles.subtitle }, getCtaDetail(data, 'url'))), React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Positive Targeted Segments Users"),
	                    React.createElement("div", { style: styles.subtitle }, this.getSegmentNames(data.segmentIds))), React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Negative Targeted Segments Users"),
	                    React.createElement("div", { style: styles.subtitle }, this.getSegmentNames(data.antiSegmentIds))), React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Experiments"),
	                    React.createElement("div", { style: styles.subtitle }, meta.partnerExperiments ? this.getPartnerExperiments(meta.partnerExperiments) :
	                        this.getExperimentDetails(meta.experiments))));
	            }
	        }
	        var selectedNetworkTypes = [];
	        if (data.userNetworkTypes) {
	            data.userNetworkTypes.forEach(function (element, key) {
	                key === data.userNetworkTypes.length - 1
	                    ? selectedNetworkTypes.push(USER_NETWORK_TYPE_SELECTED[element])
	                    : selectedNetworkTypes.push(USER_NETWORK_TYPE_SELECTED[element] + ", ");
	            });
	            elements.push(React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                React.createElement("div", { style: styles.title }, "Network Targeting"),
	                React.createElement("div", { style: styles.subtitle }, selectedNetworkTypes)));
	        }
	        var rules = meta.ruleIdsList;
	        if (rules && rules.length) {
	            var segmentTargetingRuleMapping_1 = Object.assign.apply(Object, [{}].concat(this.props.studioAppConfig.segmentTargetingRule.map(function (item) {
	                var _a;
	                return (_a = {}, _a[item.ruleId] = item.name, _a);
	            })));
	            var targetingRulesDetailList_1 = [];
	            rules.map(function (rule) {
	                var targetingRulesDetail = rule.ruleIdlist.map(function (ruleId) { return segmentTargetingRuleMapping_1[ruleId]; }).filter(function (item) { return !!item; }).join(', ');
	                targetingRulesDetailList_1.push(targetingRulesDetail);
	            });
	            if (targetingRulesDetailList_1.length) {
	                elements.push(React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	                    React.createElement("div", { style: styles.title }, "Targeting Rules"),
	                    targetingRulesDetailList_1.map(function (targetingRule) {
	                        return React.createElement("div", { style: styles.subtitle }, targetingRule);
	                    })));
	            }
	        }
	        var glanceTime = meta.glanceTime;
	        var startDate = Utils_1["default"].getStartDate(this.props.region, glanceTime);
	        var startEpochFinalInSecs = Utils_1["default"].getEpochFinalInSecs(glanceTime);
	        elements.push(React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	            React.createElement("div", { style: styles.title }, "Started at"),
	            React.createElement("div", { style: styles.subtitle }, getStartedAt(startDate))), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 },
	            React.createElement("div", { style: styles.title }, meta.glanceTime.duration.unit == 1 /* DAYS */ ? 'Duration in Days' : "Duration in " + exports.durationMapping[meta.glanceTime.duration.unit]),
	            React.createElement("div", { style: styles.subtitle }, meta.glanceTime.duration.length)), React.createElement(material_ui_1.GridTile, { cols: 0.5, rows: 1 }, meta.state === 10 /* STUDIO_PAUSED */ ?
	            React.createElement("div", null,
	                React.createElement("div", { style: styles.title }, "Paused at"),
	                React.createElement("div", { style: styles.subtitle }, Utils_1["default"].getReadableAbsoluteTime(meta.pausedAtInSecs)))
	            : null), React.createElement(material_ui_1.GridTile, { cols: 1, rows: 1 },
	            React.createElement("div", { key: 'glance_time', style: __assign({}, styles.width100, { display: 'inline-block' }) },
	                React.createElement(GlanceTime_1["default"], { startEpochInSecs: startEpochFinalInSecs, endEpochInSecs: startEpochFinalInSecs + (Utils_1["default"].getMillis(glanceTime.duration) / 1000) }))));
	        return (React.createElement("div", null,
	            React.createElement(material_ui_1.GridList, { cols: 1, cellHeight: 'auto' }, elements)));
	    };
	    return GlanceDetailsCard;
	}(React.Component));
	exports["default"] = GlanceDetailsCard;


/***/ },

/***/ 981:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var injectTapEventPlugin = __webpack_require__(244);
	var react_redux_1 = __webpack_require__(24);
	var draftsAction_1 = __webpack_require__(427);
	var MuiThemeProvider_1 = __webpack_require__(120);
	var RestService_1 = __webpack_require__(32);
	var Welcome_1 = __webpack_require__(998);
	var getMuiTheme_1 = __webpack_require__(215);
	var Utils_1 = __webpack_require__(17);
	// Needed for onTouchTap
	// http://stackoverflow.com/a/34015469/988941
	injectTapEventPlugin();
	var spacing = {
	    iconSize: 24,
	    desktopGutter: 24,
	    desktopGutterMore: 32,
	    desktopGutterLess: 8,
	    desktopGutterMini: 8,
	    desktopKeylineIncrement: 60,
	    desktopDropDownMenuItemHeight: 32,
	    desktopDropDownMenuFontSize: 15,
	    desktopLeftNavMenuItemHeight: 30,
	    desktopSubheaderHeight: 48,
	    desktopToolbarHeight: 56
	};
	var muiTheme = getMuiTheme_1["default"]({
	    spacing: spacing
	});
	var GlanceStudioApp = /** @class */ (function (_super) {
	    __extends(GlanceStudioApp, _super);
	    function GlanceStudioApp(props) {
	        var _this = _super.call(this, props) || this;
	        _this.setUserRole = function (config, showLogin) {
	            if (showLogin || _this.props.location.pathname.length == 1) {
	                switch (config.currentToken.role) {
	                    case 4 /* PARTNER */:
	                        _this.props.history.push('/partner');
	                        break;
	                    case 0 /* ADMIN */:
	                    case 2 /* MODERATOR */:
	                        _this.props.history.push('/moderator');
	                        break;
	                    case 3 /* DESIGNER */:
	                        _this.props.history.push('/designer');
	                        break;
	                    case 1 /* CURATOR */:
	                        _this.props.history.push('/curator');
	                        break;
	                    default:
	                        break;
	                }
	            }
	            _this.setState(__assign({}, _this.state, { checkingForLogin: false, studioAppConf: config }));
	        };
	        _this.state = {
	            checkingForLogin: true
	        };
	        return _this;
	    }
	    GlanceStudioApp.prototype.componentDidMount = function () {
	        var _this = this;
	        var isLoggedIn = Utils_1["default"].getCookieValueByName('glance-studio-session');
	        var showLogin = this.shouldShowLogin();
	        var that = this;
	        var isConfigFetch = Object.keys(this.props.studioAppConfig.currentToken).length > 0;
	        if (isLoggedIn) {
	            if (!isConfigFetch) {
	                RestService_1["default"].getStudioAppConfig(function (config) {
	                    _this.props.itemsFetchDataSuccess(config);
	                    if (!config) {
	                        if (!showLogin) {
	                            that.props.history.push('/login?redirect=' + _this.props.location.pathname);
	                            window.location.reload();
	                        }
	                        that.setState(__assign({}, that.state, { checkingForLogin: false }));
	                    }
	                    else {
	                        _this.setUserRole(config, showLogin);
	                    }
	                });
	            }
	            else {
	                var config = this.props.studioAppConfig;
	                this.setUserRole(config, showLogin);
	            }
	        }
	        else {
	            this.setState(__assign({}, this.state, { checkingForLogin: false }));
	            that.props.history.push('/login?redirect=' + this.props.location.pathname);
	        }
	    };
	    GlanceStudioApp.prototype.shouldShowLogin = function () {
	        var path = this.props.location.pathname;
	        var showLogin = false;
	        var pathEnd = path.indexOf('/', 1);
	        if (path.substr(1, pathEnd == -1 ? path.length - 1 : pathEnd) === 'login')
	            (showLogin = true);
	        return showLogin;
	    };
	    GlanceStudioApp.prototype.render = function () {
	        var content;
	        if (this.state.checkingForLogin) {
	            content = (React.createElement(Welcome_1["default"], null));
	        }
	        else {
	            content = this.props.children;
	        }
	        return (React.createElement(MuiThemeProvider_1["default"], { muiTheme: muiTheme }, content));
	    };
	    return GlanceStudioApp;
	}(React.Component));
	var mapStateToProps = function (state) { return ({
	    studioAppConfig: state.studioAppConfig
	}); };
	var mapDispatchToProps = function (dispatch) {
	    return {
	        itemsFetchDataSuccess: function (config) { return dispatch(draftsAction_1.itemsFetchDataSuccess(config)); }
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GlanceStudioApp);


/***/ },

/***/ 982:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var GlanceTimeComponent = /** @class */ (function (_super) {
	    __extends(GlanceTimeComponent, _super);
	    function GlanceTimeComponent(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {};
	        return _this;
	    }
	    GlanceTimeComponent.prototype.componentWillMount = function () {
	        this.updateStatus();
	    };
	    GlanceTimeComponent.prototype.componentDidMount = function () {
	        var _this = this;
	        var timerID = setInterval(function () { return _this.updateStatus(); }, 1000 * 60);
	        this.setState(__assign({}, this.state, { timerId: timerID }));
	    };
	    GlanceTimeComponent.prototype.componentWillUnmount = function () {
	        clearInterval(this.state.timerId);
	    };
	    GlanceTimeComponent.prototype.readableTime = function (duration) {
	        var minHourDayMonthConst = 30 * 24 * 60 * 60;
	        var result = '';
	        result += (duration / minHourDayMonthConst >= 1 ? (Math.floor(duration / minHourDayMonthConst) + ' month(s) ') : '');
	        duration = duration % minHourDayMonthConst;
	        minHourDayMonthConst /= 30;
	        result += (duration / minHourDayMonthConst >= 1 ? (Math.floor(duration / minHourDayMonthConst) + ' days(s) ') : '');
	        duration = duration % minHourDayMonthConst;
	        minHourDayMonthConst /= 24;
	        result += (duration / minHourDayMonthConst >= 1 ? (Math.floor(duration / minHourDayMonthConst) + ' hour(s) ') : '');
	        duration = duration % minHourDayMonthConst;
	        minHourDayMonthConst /= 60;
	        result += (duration / minHourDayMonthConst >= 1 ? (Math.floor(duration / minHourDayMonthConst) + ' minute(s) ') : '');
	        duration = duration % minHourDayMonthConst;
	        minHourDayMonthConst /= 60;
	        return result;
	    };
	    GlanceTimeComponent.prototype.updateStatus = function () {
	        var currentdate = new Date();
	        var currentdateEpochInSecs = Math.floor(currentdate.getTime() / 1000); // - currentdate.getTimezoneOffset() * 60        
	        if (currentdateEpochInSecs < this.props.startEpochInSecs) {
	            var diff = this.props.startEpochInSecs - currentdateEpochInSecs;
	            this.setState({
	                status: 'Active in ' + this.readableTime(diff),
	                className: 'future'
	            });
	        }
	        else if (currentdateEpochInSecs >= this.props.startEpochInSecs && currentdateEpochInSecs < this.props.endEpochInSecs) {
	            var diff = this.props.endEpochInSecs - currentdateEpochInSecs;
	            this.setState({
	                status: 'Expires in ' + this.readableTime(diff),
	                className: 'present'
	            });
	        }
	        else if (currentdateEpochInSecs > this.props.endEpochInSecs) {
	            var diff = currentdateEpochInSecs - this.props.endEpochInSecs;
	            this.setState({
	                status: 'Expired since ' + this.readableTime(diff),
	                className: 'past'
	            });
	        }
	    };
	    GlanceTimeComponent.prototype.render = function () {
	        return (React.createElement("span", { className: this.state.className }, this.state.status));
	    };
	    return GlanceTimeComponent;
	}(React.Component));
	exports["default"] = GlanceTimeComponent;


/***/ },

/***/ 983:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	__webpack_require__(424);
	var React = __webpack_require__(1);
	var react_responsive_carousel_1 = __webpack_require__(401);
	var Utils_1 = __webpack_require__(17);
	var Constants_1 = __webpack_require__(111);
	var XIAOMI_PARTNER_NAME = 'Xiaomi';
	var GlanceWallpaperCard = /** @class */ (function (_super) {
	    __extends(GlanceWallpaperCard, _super);
	    function GlanceWallpaperCard(props) {
	        return _super.call(this, props) || this;
	    }
	    GlanceWallpaperCard.prototype.render = function () {
	        var partner = this.props.partner;
	        var image = this.props.image;
	        var spaceData = this.props.spaceData;
	        var destinationIdentifier = this.props.destinationIdentifier;
	        var isTranssion = !!partner && partner.partnerId === Constants_1.Partners.TRANSSION_PARTNER_ID;
	        var className = partner
	            ? !this.props.renderSessionProperties.includes(2 /* BINGE */)
	                ? this.props.type == 2 /* STORY */
	                    ? partner.name == XIAOMI_PARTNER_NAME
	                        ? 'glance-overlay xiaomi'
	                        : 'glance-overlay'
	                    : partner.name == XIAOMI_PARTNER_NAME
	                        ? 'glance-overlay xiaomi wallpaper'
	                        : 'glance-overlay wallpaper'
	                : null
	            : null;
	        var cdnPrefix = this.props.studioAppConfig.cdnPrefix;
	        var glanceImage = (React.createElement("div", { key: 'glance-image-0' },
	            React.createElement("div", { style: { position: 'absolute', width: '100%', height: '100%' } },
	                React.createElement("div", { className: className, style: { float: 'left' } })),
	            React.createElement("img", { width: '100%', style: { position: 'relative' }, src: destinationIdentifier === 0 /* SPACE */
	                    ? Utils_1["default"].getImageUrlForSpaces(cdnPrefix, spaceData)
	                    : Utils_1["default"].getImageUrl(cdnPrefix, image, isTranssion ? 4 /* STUDIO_ORIGINAL */ : 3 /* ORIGINAL */) })));
	        var glanceImageWithOverlay = this.props.overlayImage ? (React.createElement("div", null,
	            React.createElement("span", null,
	                React.createElement("img", { width: '100%', style: { position: 'relative', top: 0, left: 0 }, src: Utils_1["default"].getImageUrl(cdnPrefix, this.props.image, isTranssion ? 4 /* STUDIO_ORIGINAL */ : 3 /* ORIGINAL */) }),
	                React.createElement("img", { width: '100%', style: { position: 'absolute', top: 0, left: 0 }, src: Utils_1["default"].getImageUrl(cdnPrefix, this.props.overlayImage, 3 /* ORIGINAL */) })))) : null;
	        var images = [];
	        images.push(glanceImage);
	        if (glanceImageWithOverlay) {
	            images.push(glanceImageWithOverlay);
	        }
	        return (React.createElement("div", { className: '', style: __assign({ position: 'relative' }, this.props.customStyle) },
	            React.createElement(react_responsive_carousel_1.Carousel, { showThumbs: false, showStatus: false, autoPlay: true, infiniteLoop: true, showIndicators: false }, images)));
	    };
	    return GlanceWallpaperCard;
	}(React.Component));
	exports["default"] = GlanceWallpaperCard;


/***/ },

/***/ 984:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	__webpack_require__(110);
	var React = __webpack_require__(1);
	var GridList_1 = __webpack_require__(118);
	var Toolbar_1 = __webpack_require__(100);
	var colors_1 = __webpack_require__(18);
	var Utils_1 = __webpack_require__(17);
	var Dialog_1 = __webpack_require__(55);
	var DropDownMenu_1 = __webpack_require__(69);
	var EmptyMessage_1 = __webpack_require__(153);
	var FlatButton_1 = __webpack_require__(49);
	var FontIcon_1 = __webpack_require__(50);
	var Glance_1 = __webpack_require__(246);
	var JerseyRestApiService_1 = __webpack_require__(83);
	var Loader_1 = __webpack_require__(154);
	var MenuItem_1 = __webpack_require__(51);
	var RaisedButton_1 = __webpack_require__(77);
	var Snackbar_1 = __webpack_require__(42);
	var TextField_1 = __webpack_require__(56);
	var Utils_2 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var approveIcon = React.createElement(FontIcon_1["default"], { className: 'material-icons' }, "check");
	var rejectIcon = React.createElement(FontIcon_1["default"], { className: 'material-icons' }, "remove_circle_outline");
	var timer;
	var styles = {
	    footer: {
	        position: 'fixed',
	        bottom: '0px',
	        paddingBottom: '10px',
	        paddingTop: '10px',
	        zIndex: 10,
	        backgroundColor: colors_1.grey800,
	        width: '90%',
	        maxWidth: '1400px',
	        display: 'inline-flex',
	        justifyContent: 'center',
	        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, visibility 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
	    },
	    footerButton: {
	        maxWidth: '232px',
	        flex: '1 1 0%',
	        marginLeft: '10px',
	        marginRight: '10px'
	    },
	    deleteButton: {
	        color: colors_1.red500,
	        background: colors_1.red300
	    },
	    disabledButton: {
	        backgroundColor: colors_1.grey500
	    },
	    loaderStyle: {
	        textAlign: 'center'
	    },
	    approveButton: {
	        color: colors_1.green500,
	        background: colors_1.green300
	    },
	    rejectButton: {
	        color: colors_1.orange500,
	        background: colors_1.orange300
	    }
	};
	var TypeFilter;
	(function (TypeFilter) {
	    TypeFilter[TypeFilter["ALL"] = 0] = "ALL";
	    TypeFilter[TypeFilter["WALLPAPER"] = 1] = "WALLPAPER";
	    TypeFilter[TypeFilter["STORY"] = 2] = "STORY";
	    TypeFilter[TypeFilter["SPONSORED"] = 3] = "SPONSORED";
	})(TypeFilter || (TypeFilter = {}));
	var StateFilter;
	(function (StateFilter) {
	    StateFilter[StateFilter["PENDING"] = 0] = "PENDING";
	    StateFilter[StateFilter["APPROVED"] = 1] = "APPROVED";
	    StateFilter[StateFilter["REJECTED"] = 2] = "REJECTED";
	})(StateFilter || (StateFilter = {}));
	var Action;
	(function (Action) {
	    Action[Action["APPROVE"] = 0] = "APPROVE";
	    Action[Action["REJECT"] = 1] = "REJECT";
	})(Action || (Action = {}));
	var InternalApprovalGlances = /** @class */ (function (_super) {
	    __extends(InternalApprovalGlances, _super);
	    function InternalApprovalGlances(props) {
	        var _this = _super.call(this, props) || this;
	        _this.pushFilterUrl = function (regionFilter) {
	            _this.props.history.push('/' + _this.props.params.role + '/internalApproval'
	                + (regionFilter ? ('/' + regionFilter + '/' + Utils_2["default"].getReadableRegionName(regionFilter)) : ''));
	        };
	        _this.setRegion = function (region) {
	            _this.setState(__assign({}, _this.state, { regionFilter: region, loadMessage: 'Loading live glances in ' + Utils_2["default"].getReadableRegionName(region) + ' ..', showLoader: true }), function () {
	                _this.fetchGlances(true);
	            });
	        };
	        _this.fetchGlances = function (resetPage) {
	            if (_this.state.regionFilter !== null) {
	                var _a = _this.state, perPage = _a.perPage, regionFilter = _a.regionFilter, selectedPage = _a.selectedPage, expiryFilter = _a.expiryFilter, stateFilter = _a.stateFilter, searchTerm = _a.searchTerm, storyType = _a.storyType, categoryIds = _a.categoryIds, isWebpeek = _a.isWebpeek;
	                var state = Utils_1.stateFiltersInternal[stateFilter];
	                var region = Utils_1.regionFilters[regionFilter];
	                // const offset = resetPage ? 0 : (selectedPage - 1) * perPage;
	                var payload = {
	                    limit: perPage,
	                    // offset,
	                    isExpiry: expiryFilter,
	                    state: state,
	                    region: region,
	                    search: searchTerm,
	                    storyType: storyType,
	                    categoryIds: categoryIds,
	                    isWebpeek: isWebpeek
	                };
	                _this.setState(__assign({}, _this.state, { showLoader: true, selectedPage: resetPage ? 1 : selectedPage }));
	                JerseyRestApiService_1["default"].getInternalGlances(payload, function (response) {
	                    var data = response;
	                    Utils_2["default"].parseGlancePairs(data);
	                    var newStateMap = new Map();
	                    _this.setState(__assign({}, _this.state, { glancePairs: data, showLoader: false, snackbarMessage: 'Glances loaded', openSnackbar: true, loadMessage: null }));
	                }, function (error) {
	                    console.log(error);
	                    _this.setState(__assign({}, _this.state, { snackbarMessage: 'Loading failed. Try refresh or Contact Glance Support.', openSnackbar: true, loadMessage: 'Loading failed. Try refresh or Contact Glance Support.', showLoader: false }));
	                });
	            }
	            else {
	                _this.setState(__assign({}, _this.state, { snackbarMessage: 'Please Select a Region', openSnackbar: true, loadMessage: 'Select a region', showLoader: false }));
	            }
	        };
	        _this.handleRegionFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(value);
	            _this.setRegion(value);
	        };
	        _this.handleTypeFilterChange = function (event, index, value) {
	            var categoryIds, storyType, isWebpeek = false;
	            switch (index) {
	                case 0:
	                    categoryIds = ['#games'];
	                    break;
	                case 1:
	                    categoryIds = ['#live_game_shows'];
	                    break;
	                case 2:
	                    categoryIds = ['#live_game_streams'];
	                    break;
	                case 3:
	                    storyType = ['GLANCETV'];
	                    break;
	                case 4:
	                    isWebpeek = true;
	                    break;
	            }
	            _this.setState(__assign({}, _this.state, { filter: value, categoryIds: categoryIds,
	                storyType: storyType,
	                isWebpeek: isWebpeek }), function () { return _this.fetchGlances(true); });
	        };
	        _this.handleExpiryFilterChange = function (event, index, value) {
	            _this.setState(__assign({}, _this.state, { expiryFilter: value }), function () { return _this.fetchGlances(true); });
	        };
	        _this.handleStateFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(_this.state.regionFilter);
	            var possibleActions = _this.getPossibleActions(value);
	            _this.setState(__assign({}, _this.state, { stateFilter: value, possibleActions: possibleActions }), function () { _this.fetchGlances(true); });
	        };
	        _this.getPossibleActions = function (stateFilter) {
	            if (stateFilter === void 0) { stateFilter = _this.state.stateFilter; }
	            var possibleActions;
	            switch (stateFilter) {
	                case StateFilter.APPROVED:
	                    break;
	                case StateFilter.PENDING:
	                    possibleActions = [Action.APPROVE, Action.REJECT];
	                    break;
	                case StateFilter.REJECTED:
	                default:
	                    possibleActions = null;
	            }
	            _this.setState(__assign({}, _this.state, { possibleActions: possibleActions }));
	            return possibleActions;
	        };
	        _this.onSelectGlance = function (element, selected) {
	            var newMap = new Map(_this.state.selectedGlances);
	            if (selected) {
	                newMap.set(element.data.glanceId, true);
	            }
	            else {
	                newMap["delete"](element.data.glanceId);
	            }
	            _this.setState(__assign({}, _this.state, { selectedGlances: newMap }));
	        };
	        _this.handleAction = function (action) {
	            _this.setState(__assign({}, _this.state, { actionClicked: action, openConfirmDialog: true }));
	        };
	        _this.handleActionConfirm = function (action) {
	            var selectedIds = [];
	            _this.state.selectedGlances.forEach(function (value, glanceId) {
	                selectedIds.push(glanceId);
	            });
	            _this.setState(__assign({}, _this.state, { snackbarMessage: 'Starting to ' + Action[action] + ' Glances ...', openSnackbar: true }));
	            switch (action) {
	                case Action.APPROVE:
	                    JerseyRestApiService_1["default"].approveInternalGlances(Utils_1.regionFilters[_this.state.regionFilter], selectedIds, function (success) {
	                        _this.handleActionComplete(action, success);
	                    });
	                    break;
	                default:
	                    break;
	            }
	        };
	        _this.handleActionRejectConfirm = function (action, rejectReason) {
	            var selectedIds = [];
	            _this.state.selectedGlances.forEach(function (value, glanceId) {
	                selectedIds.push(glanceId);
	            });
	            _this.setState(__assign({}, _this.state, { snackbarMessage: 'Starting to ' + Action[action] + ' Glances ...', openSnackbar: true }));
	            JerseyRestApiService_1["default"].rejectInternalGlances(Utils_1.regionFilters[_this.state.regionFilter], rejectReason, selectedIds, function (success) {
	                _this.handleActionComplete(action, success);
	            });
	        };
	        _this.handleActionComplete = function (action, success) {
	            if (success) {
	                _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: 'Glance ' + Action[action] + ' done. Updating view...', openConfirmDialog: false, selectedGlances: new Map() }));
	                _this.fetchGlances(true);
	            }
	            else {
	                _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: 'Unable to ' + Action[action] + ' glances. Contact Glance Support.', openConfirmDialog: false }));
	            }
	        };
	        _this.closeConfirmDialog = function () {
	            _this.setState(__assign({}, _this.state, { openConfirmDialog: false }));
	        };
	        _this.closeSnackbar = function () {
	            _this.setState(__assign({}, _this.state, { openSnackbar: false }));
	        };
	        _this.searchHandler = function (event) {
	            if (timer) {
	                clearTimeout(timer);
	            }
	            _this.setState(__assign({}, _this.state, { searchTerm: event.target.value }));
	            timer = setTimeout(function () {
	                _this.fetchGlances(true);
	            }, 800);
	        };
	        _this.searchButton = function () {
	            _this.fetchGlances(true);
	        };
	        _this.onPageChange = function (page) {
	            _this.setState(__assign({}, _this.state, { selectedPage: page, selectedGlances: new Map() }), function () {
	                _this.fetchGlances(false);
	            });
	        };
	        _this.rejectReasonHandler = function (event) {
	            _this.setState(__assign({}, _this.state, { rejectReason: event.target.value }));
	        };
	        _this.state = {
	            partnerFilter: null,
	            regionFilters: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 27, 29],
	            regionFilter: null,
	            filter: 'games',
	            stateFilter: StateFilter.PENDING,
	            expiryFilter: false,
	            openConfirmDialog: false,
	            openSnackbar: false,
	            snackbarMessage: '',
	            loadMessage: 'Select a region',
	            perPage: 200,
	            glancePairs: [],
	            selectedPage: 1,
	            searchTerm: '',
	            selectedGlances: new Map(),
	            possibleActions: [],
	            rejectReason: '',
	            categoryIds: ['#games'],
	            isWebpeek: false,
	            storyType: undefined
	        };
	        return _this;
	    }
	    InternalApprovalGlances.prototype.componentWillMount = function () {
	        // TODO: now studioAppConfig will always have a default value. this check needs to be changed
	        if (!this.props.studioAppConfig) {
	            this.props.history.push('/login');
	            window.location.reload();
	        }
	        if (this.props.params) {
	            var region = this.props.params.region;
	            if (region) {
	                this.setRegion(parseInt(region));
	            }
	        }
	    };
	    InternalApprovalGlances.prototype.componentDidMount = function () {
	        var possibleActions = this.getPossibleActions();
	        this.setState(__assign({}, this.state, { possibleActions: possibleActions }));
	    };
	    InternalApprovalGlances.prototype.render = function () {
	        var _this = this;
	        var actions = [];
	        var _a = this.state, perPage = _a.perPage, glancePairs = _a.glancePairs, showLoader = _a.showLoader;
	        var paginationElement = [];
	        // if (glancePairs.length > 0) {
	        //     paginationElement.push(
	        //         <Pagination
	        //             pageSize={perPage}
	        //             onPageChange={this.onPageChange}
	        //             disabled={showLoader}
	        //             disableNextBtn= {glancePairs.length < perPage}
	        //         />
	        //     );
	        // }
	        actions.push(React.createElement(FlatButton_1["default"], { label: 'Cancel', primary: true, style: { width: '100%' }, onClick: this.closeConfirmDialog }));
	        actions.push(React.createElement(FlatButton_1["default"], { label: ((this.state.actionClicked == Action.REJECT) ? ''
	                : 'Yes, ') + Action[this.state.actionClicked], primary: true, style: { width: '100%' }, onClick: function () { return (_this.state.actionClicked == Action.REJECT)
	                ? _this.handleActionRejectConfirm(_this.state.actionClicked, _this.state.rejectReason)
	                : _this.handleActionConfirm(_this.state.actionClicked); } }));
	        return (React.createElement("div", null,
	            React.createElement(Toolbar_1.Toolbar, { style: { marginTop: '2%' } },
	                React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true },
	                    React.createElement(Toolbar_1.ToolbarTitle, { text: 'Filters', style: { marginLeft: '24px' } }),
	                    React.createElement(Toolbar_1.ToolbarSeparator, null),
	                    React.createElement(DropDownMenu_1["default"], { value: this.state.regionFilter, onChange: this.handleRegionFilterChange },
	                        React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Select Region', key: 'empty' }),
	                        this.state.regionFilters.map(function (item, index) {
	                            return (React.createElement(MenuItem_1["default"], { value: item, primaryText: Utils_2["default"].getReadableRegionName(item), key: index }));
	                        })),
	                    React.createElement(DropDownMenu_1["default"], { value: this.state.stateFilter, onChange: this.handleStateFilterChange },
	                        React.createElement(MenuItem_1["default"], { value: StateFilter.PENDING, primaryText: 'Pending Approval' }),
	                        React.createElement(MenuItem_1["default"], { value: StateFilter.APPROVED, primaryText: 'Approved Glances' }),
	                        React.createElement(MenuItem_1["default"], { value: StateFilter.REJECTED, primaryText: 'Rejected Glances' })),
	                    React.createElement(DropDownMenu_1["default"], { value: this.state.filter, onChange: this.handleTypeFilterChange },
	                        React.createElement(MenuItem_1["default"], { value: 'games', primaryText: 'Games' }),
	                        React.createElement(MenuItem_1["default"], { value: 'live_game_shows', primaryText: 'Live Game Shows' }),
	                        React.createElement(MenuItem_1["default"], { value: 'live_game_streams', primaryText: 'Live Game Streams' }),
	                        React.createElement(MenuItem_1["default"], { value: 'glance_tv', primaryText: 'Glance Tv' }),
	                        React.createElement(MenuItem_1["default"], { value: 'isWebpeek', primaryText: 'WebPeek' })),
	                    React.createElement(DropDownMenu_1["default"], { value: this.state.expiryFilter, onChange: this.handleExpiryFilterChange },
	                        React.createElement(MenuItem_1["default"], { value: false, primaryText: 'Active Glances' }),
	                        React.createElement(MenuItem_1["default"], { value: true, primaryText: 'Expired Glances' })),
	                    React.createElement("div", { className: 'wrapInternal' },
	                        React.createElement("div", { className: 'searchInternal' },
	                            React.createElement("input", { type: 'text', value: this.state.searchTerm, onChange: this.searchHandler, placeholder: 'Search...', className: 'searchTerm' }),
	                            React.createElement("button", { type: 'submit', className: 'searchButton', onClick: this.searchButton },
	                                React.createElement("i", null,
	                                    React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20' },
	                                        React.createElement("path", { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })))))))),
	            this.state.regionFilter ? (React.createElement(Loader_1["default"], { show: showLoader, message: this.state.loadMessage }, this.state.glancePairs && this.state.glancePairs.length > 0 ?
	                React.createElement("div", null,
	                    React.createElement(GridList_1.GridList, { cols: 4, padding: 15, style: { width: '100%', margin: '0 auto', marginTop: '2%' }, cellHeight: 'auto' }, this.state.glancePairs.map(function (pair, glanceIndex) {
	                        return (React.createElement(GridList_1.GridTile, { key: glanceIndex, containerElement: React.createElement(Glance_1["default"], { glance: pair, selected: _this.state.selectedGlances.get(pair.data.glanceId), region: _this.state.regionFilter, partner: _this.state.partnerFilter, onSelect: function (selected) { return _this.onSelectGlance(pair, selected); } }) }));
	                    })))
	                : React.createElement(EmptyMessage_1["default"], { message: 'No glances for selected filters' }))) : React.createElement(EmptyMessage_1["default"], { message: this.state.loadMessage }),
	            paginationElement,
	            this.state.possibleActions && this.state.selectedGlances && this.state.selectedGlances.size > 0 ?
	                React.createElement("div", { style: styles.footer },
	                    this.state.partnerAutoApprove ? '' :
	                        React.createElement(RaisedButton_1["default"], { label: 'Approve Selected (' + this.state.selectedGlances.size + ')', icon: approveIcon, primary: true, buttonStyle: this.state.possibleActions.indexOf(Action.APPROVE) < 0 ? styles.disabledButton : styles.approveButton, style: styles.footerButton, onClick: function () { return _this.handleAction(Action.APPROVE); }, disabled: this.state.possibleActions.indexOf(Action.APPROVE) < 0 }),
	                    this.state.partnerAutoApprove ? '' :
	                        React.createElement(RaisedButton_1["default"], { label: 'Reject Selected (' + this.state.selectedGlances.size + ')', icon: rejectIcon, primary: true, buttonStyle: this.state.possibleActions.indexOf(Action.REJECT) < 0 ? styles.disabledButton : styles.rejectButton, style: styles.footerButton, onClick: function () { return _this.handleAction(Action.REJECT); }, disabled: this.state.possibleActions.indexOf(Action.APPROVE) < 0 })) : '',
	            this.state.actionClicked == Action.REJECT
	                ?
	                    React.createElement(Dialog_1["default"], { modal: false, open: this.state.openConfirmDialog, onRequestClose: this.closeConfirmDialog, actions: actions },
	                        "Please enter reason for rejecting Glances",
	                        React.createElement("span", { className: '' }, " : "),
	                        React.createElement(TextField_1["default"], { type: 'text', className: '', onChange: this.rejectReasonHandler }))
	                :
	                    React.createElement(Dialog_1["default"], { modal: false, open: this.state.openConfirmDialog, onRequestClose: this.closeConfirmDialog, actions: actions },
	                        "Please confirm that you want to ",
	                        Action[this.state.actionClicked],
	                        " these glances."),
	            React.createElement(Snackbar_1["default"], { open: this.state.openSnackbar, message: this.state.snackbarMessage, onRequestClose: this.closeSnackbar, autoHideDuration: 2000 })));
	    };
	    return InternalApprovalGlances;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(InternalApprovalGlances);


/***/ },

/***/ 985:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var MediaQuery = __webpack_require__(123);
	var React = __webpack_require__(1);
	var firebase = __webpack_require__(543);
	var colors_1 = __webpack_require__(18);
	var Divider_1 = __webpack_require__(117);
	var FontIcon_1 = __webpack_require__(50);
	var Paper_1 = __webpack_require__(30);
	var RaisedButton_1 = __webpack_require__(77);
	var RestService_1 = __webpack_require__(32);
	var TextField_1 = __webpack_require__(56);
	var Utils_1 = __webpack_require__(17);
	var firebaseConfig = {
	    apiKey: 'AIzaSyCYzP216jLWeSjFIxQcQ2c3RXgmTBvG7bU',
	    authDomain: 'vault-24754.firebaseapp.com',
	    databaseURL: 'https://vault-24754.firebaseio.com',
	    storageBucket: 'vault-24754.appspot.com',
	    messagingSenderId: '355957702177'
	};
	firebase.initializeApp(firebaseConfig);
	var styles = {
	    section: {
	        width: '100%',
	        height: '100%',
	        position: 'fixed',
	        backgroundColor: colors_1.cyan500,
	        display: 'flex',
	        maxWidth: 'none'
	    },
	    div: {
	        display: 'flex',
	        flexDirection: 'column',
	        justifyContent: 'initial',
	        resize: 'verticle',
	        width: '30%',
	        height: '70%',
	        margin: 'auto'
	    },
	    header: {
	        margin: '5% auto',
	        color: 'white',
	        background: 'url(../../../assets/images/logo_white.png) no-repeat',
	        backgroundSize: '40px',
	        paddingLeft: '50px',
	        backgroundPositionX: '0px',
	        fontSize: '34px',
	        lineHeight: '40px',
	        textAlign: 'center'
	    },
	    headerMobile: {
	        color: 'white',
	        background: 'url(../../../assets/images/logo_white.png) no-repeat',
	        backgroundSize: '40px',
	        paddingTop: '50px',
	        backgroundPositionX: 'center',
	        backgroundPositionY: '0px',
	        fontSize: '34px',
	        lineHeight: '40px',
	        textAlign: 'center'
	    },
	    paper: {
	        padding: '3%',
	        textAlign: 'center',
	        display: 'block',
	        resize: 'verticle'
	    },
	    textField: {
	        width: '100%',
	        maxWidth: '300px',
	        display: 'block',
	        margin: 'auto'
	    },
	    raisedButton: {
	        margin: '2%',
	        marginTop: '2%',
	        marginBottom: '5%',
	        width: '50%'
	    },
	    raiseGoogleButton: {
	        color: colors_1.red500,
	        marginTop: '5%',
	        marginBottom: '5%',
	        width: '50%'
	    },
	    raiseMicrosoftButton: {
	        color: colors_1.purple500,
	        marginTop: '5%',
	        marginBottom: '5%',
	        width: '50%'
	    },
	    errorStyle: {
	        color: colors_1.red500,
	        margin: '5px auto',
	        textAlign: 'center'
	    }
	};
	function findGetParameter(parameterName) {
	    var result = null, tmp = [];
	    console.log(location);
	    location.href
	        .substr(location.href.indexOf('?') + 1)
	        .split('&')
	        .forEach(function (item) {
	        tmp = item.split('=');
	        if (tmp[0] === parameterName)
	            result = decodeURIComponent(tmp[1]);
	    });
	    if (result && result.indexOf('id_token') > -1) {
	        return '/';
	    }
	    console.log(result);
	    return result;
	}
	function createMicrosoftLoginUrl() {
	    var options = {
	        loginURl: 'https://login.microsoftonline.com',
	        path: 'oauth2/v2.0/authorize',
	        tenantId: '89359cf4-9e60-4099-80c4-775a0cfe27a7',
	        clientId: '9e371d68-883c-4e25-8a43-7fe4e0c02e6a',
	        responseType: 'id_token',
	        redirect_uri: '/',
	        scope: 'openid+offline_access+profile+email',
	        responseMode: 'fragment',
	        nonce: '678910',
	        state: '12345'
	    };
	    return options.loginURl + "/" + options.tenantId + "/" + options.path + "?client_id=" + options.clientId + "&response_type=" + options.responseType + "&redirect_uri=" + (window.location
	        .origin + options.redirect_uri) + "&scope=" + options.scope + "&response_mode=" + options.responseMode + "&state=" + options.state + "&nonce=" + options.nonce;
	}
	var LoginComponent = /** @class */ (function (_super) {
	    __extends(LoginComponent, _super);
	    function LoginComponent(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleChange = function (event) {
	            var _a;
	            var target = event.target;
	            var value = target.type === 'checkbox' ? target.checked : target.value;
	            var name = target.name;
	            _this.setState(__assign({}, _this.state, (_a = {}, _a[name] = value, _a.logginFailed = false, _a)));
	        };
	        _this.handleGoogleAuthSuccess = function (response) {
	            var token = response['accessToken'];
	            _this.loginGoogleUserToDashboard(token);
	        };
	        _this.handleGoogleAuthFailure = function (response) {
	            console.error(response);
	        };
	        _this.setUserRoles = function (data) {
	            if (data == null) {
	                console.log('login failed');
	            }
	            else {
	                var redirect = findGetParameter('redirect');
	                if (redirect) {
	                    console.log('redirecting to', redirect);
	                    _this.props.history.push(redirect);
	                    window.location.reload();
	                }
	                else {
	                    switch (data.role) {
	                        case 0 /* ADMIN */:
	                            _this.props.history.push('/moderator');
	                            break;
	                        case 1 /* CURATOR */:
	                            _this.props.history.push('/curator');
	                            break;
	                        case 3 /* DESIGNER */:
	                            _this.props.history.push('/designer');
	                            break;
	                        case 2 /* MODERATOR */:
	                            _this.props.history.push('/moderator');
	                            break;
	                        default:
	                            console.error('Undefined role', data.role);
	                        // that.props.history.push("/logout")
	                        // window.location.reload()
	                    }
	                }
	                // this.props.history.push('/')
	            }
	        };
	        _this.state = {
	            logginFailed: false,
	            appConf: _this.props.appConf
	        };
	        _this.onSubmit = _this.onSubmit.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.loginUsingGoogle = _this.loginUsingGoogle.bind(_this);
	        _this.loginGoogleUserToDashboard = _this.loginGoogleUserToDashboard.bind(_this);
	        _this.loginUsingMicrosoftPortal = _this.loginUsingMicrosoftPortal.bind(_this);
	        _this.loginUsingMicrosoftAuth = _this.loginUsingMicrosoftAuth.bind(_this);
	        return _this;
	    }
	    LoginComponent.prototype.componentDidMount = function () {
	        // var that = this
	        // setTimeout(function(){
	        //     that.setState({
	        //         ...that.state,
	        //         checkingForLogin: false
	        //     })
	        // }, 3000)
	        if (window.location.href.indexOf('id_token=') > -1) {
	            var obj = window.location.href.split('id_token=');
	            obj = obj[1].split('&');
	            this.loginUsingMicrosoftAuth(obj[0]);
	        }
	    };
	    LoginComponent.prototype.loginUsingMicrosoftPortal = function () {
	        window.location.replace(createMicrosoftLoginUrl());
	    };
	    LoginComponent.prototype.shouldShowLogin = function () {
	        var path = this.props.location.pathname;
	        var showLogin = false;
	        var pathEnd = path.indexOf('/', 1);
	        if (path.substr(1, pathEnd == -1 ? path.length - 1 : pathEnd) === 'login')
	            showLogin = true;
	        return showLogin;
	    };
	    LoginComponent.prototype.loginUsingGoogle = function () {
	        var provider = new firebase.auth.GoogleAuthProvider();
	        var that = this;
	        firebase
	            .auth()
	            .signInWithPopup(provider)
	            .then(function (result) {
	            var token = result.credential.accessToken;
	            that.loginGoogleUserToDashboard(token);
	        })["catch"](function (error) {
	            console.error(error);
	        });
	    };
	    LoginComponent.prototype.loginUsingMicrosoftAuth = function (token) {
	        this.setState(__assign({}, this.state, { logginSucces: true }));
	        RestService_1["default"].loginUsingMicrosoftAuth(token, this.setUserRoles);
	    };
	    LoginComponent.prototype.loginGoogleUserToDashboard = function (token) {
	        this.setState(__assign({}, this.state, { logginSucces: true }));
	        RestService_1["default"].loginUsingGoogleAuth(token, this.setUserRoles);
	    };
	    LoginComponent.prototype.onSubmit = function () {
	        console.log('onSubmit');
	        var that = this;
	        RestService_1["default"].loginUsingEmailAndPassword(this.state.email, this.state.password, function (data) {
	            if (data == null) {
	                that.setState(__assign({}, that.state, { logginFailed: true }));
	            }
	            else {
	                console.log(data);
	                var redirect = findGetParameter('redirect');
	                if (redirect) {
	                    console.log('redirecting to', redirect);
	                    that.props.history.push(redirect);
	                    window.location.reload();
	                }
	                else {
	                    switch (data.role) {
	                        case 4 /* PARTNER */:
	                            that.props.history.push('/partner');
	                            window.location.reload();
	                            break;
	                        case 0 /* ADMIN */:
	                            that.props.history.push('/admin');
	                            window.location.reload();
	                            break;
	                        default:
	                        // that.props.history.push("/logout")
	                        // window.location.reload()
	                    }
	                    // this.props.history.push('/')
	                }
	            }
	        });
	    };
	    LoginComponent.prototype.render = function () {
	        var _this = this;
	        // console.log('New login component')
	        var loginCard = this.state.logginSucces || this.state.appConf ? (React.createElement(Paper_1["default"], { style: styles.paper, zDepth: 3 },
	            React.createElement("h3", null, " Login Successful. Opening the gate ... "))) : (React.createElement(Paper_1["default"], { style: styles.paper, zDepth: 3 },
	            this.state.logginFailed ? (React.createElement("span", { style: styles.errorStyle }, "Login failed. Incorrect email or password")) : (''),
	            React.createElement("form", { onSubmit: function (e) {
	                    e.preventDefault();
	                    _this.onSubmit();
	                } },
	                React.createElement(TextField_1["default"], { key: "email", style: styles.textField, floatingLabelText: "Email", type: "text", name: "email", onChange: this.handleChange }),
	                React.createElement(TextField_1["default"], { key: "password", style: styles.textField, floatingLabelText: "Password", type: "password", name: "password", onChange: this.handleChange }),
	                React.createElement(RaisedButton_1["default"], { label: "Email Login", type: "submit", primary: true, style: styles.raisedButton, icon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "account_circle") })),
	            React.createElement(Divider_1["default"], null),
	            React.createElement(RaisedButton_1["default"], { label: "Gmail Login", primary: true, onClick: this.loginUsingGoogle, style: styles.raiseGoogleButton, buttonStyle: { backgroundColor: colors_1.red500 }, icon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "account_circle") }),
	            React.createElement(Divider_1["default"], null),
	            React.createElement(RaisedButton_1["default"], { label: "Microsoft", primary: true, onClick: this.loginUsingMicrosoftPortal, style: styles.raiseMicrosoftButton, buttonStyle: { backgroundColor: colors_1.purple500 }, icon: React.createElement(FontIcon_1["default"], { className: "material-icons" }, "account_circle") })));
	        return (React.createElement("section", { style: styles.section },
	            React.createElement(MediaQuery, { query: "(min-device-width: 1224px)" },
	                React.createElement("div", { style: {
	                        display: 'flex',
	                        flexDirection: 'column',
	                        justifyContent: 'flex-start',
	                        resize: 'verticle',
	                        width: '30%',
	                        height: '70%',
	                        margin: 'auto'
	                    } },
	                    React.createElement("h1", { style: styles.header },
	                        ' ',
	                        "Glance For ",
	                        Utils_1["default"].getDomainPrefix(),
	                        ' '),
	                    loginCard)),
	            React.createElement(MediaQuery, { query: "(max-device-width: 1224px)" }, function (matches) {
	                if (matches) {
	                    console.log('mobile device');
	                    return (React.createElement("div", { style: {
	                            display: 'flex',
	                            flexDirection: 'column',
	                            justifyContent: 'flex-start',
	                            resize: 'verticle',
	                            width: '90%',
	                            height: '90%',
	                            margin: 'auto',
	                            overflow: 'auto'
	                        } },
	                        React.createElement("h1", { style: styles.headerMobile },
	                            ' ',
	                            "Glance For ",
	                            Utils_1["default"].getDomainPrefix()),
	                        loginCard));
	                }
	                else {
	                    return null;
	                }
	            })));
	    };
	    return LoginComponent;
	}(React.Component));
	exports["default"] = LoginComponent;


/***/ },

/***/ 986:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	var RestService_1 = __webpack_require__(32);
	var React = __webpack_require__(1);
	var LogoutComponent = /** @class */ (function (_super) {
	    __extends(LogoutComponent, _super);
	    function LogoutComponent(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {};
	        return _this;
	    }
	    LogoutComponent.prototype.componentDidMount = function () {
	        console.log('componentDidMount');
	        var loggedOut = RestService_1["default"].logout();
	        this.setState({
	            loggedOut: loggedOut
	        });
	        if (loggedOut) {
	            this.props.history.push('/login');
	        }
	    };
	    LogoutComponent.prototype.render = function () {
	        return (this.state.loggedOut ?
	            React.createElement("h1", null, "Logged out successfully")
	            : React.createElement("h1", null, "Error occurred while logging you out..."));
	    };
	    return LogoutComponent;
	}(React.Component));
	exports["default"] = LogoutComponent;


/***/ },

/***/ 987:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	__webpack_require__(110);
	var React = __webpack_require__(1);
	var GridList_1 = __webpack_require__(118);
	var Toolbar_1 = __webpack_require__(100);
	var colors_1 = __webpack_require__(18);
	var Utils_1 = __webpack_require__(17);
	var Dialog_1 = __webpack_require__(55);
	var DropDownMenu_1 = __webpack_require__(69);
	var EmptyMessage_1 = __webpack_require__(153);
	var FlatButton_1 = __webpack_require__(49);
	var FontIcon_1 = __webpack_require__(50);
	var Glance_1 = __webpack_require__(246);
	var Loader_1 = __webpack_require__(154);
	var MenuItem_1 = __webpack_require__(51);
	var RaisedButton_1 = __webpack_require__(77);
	var react_paginate_1 = __webpack_require__(393);
	var RestService_1 = __webpack_require__(32);
	var Snackbar_1 = __webpack_require__(42);
	var Utils_2 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var removeIcon = React.createElement(FontIcon_1["default"], { className: 'material-icons' }, "delete");
	var timer;
	var styles = {
	    footer: {
	        position: 'fixed',
	        bottom: '0px',
	        paddingBottom: '10px',
	        paddingTop: '10px',
	        zIndex: 10,
	        backgroundColor: colors_1.grey800,
	        width: '90%',
	        maxWidth: '1400px',
	        display: 'inline-flex',
	        justifyContent: 'center',
	        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, visibility 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
	    },
	    footerButton: {
	        maxWidth: '232px',
	        flex: '1 1 0%',
	        marginLeft: '10px',
	        marginRight: '10px'
	    },
	    deleteButton: {
	        color: colors_1.red500,
	        background: colors_1.red300
	    },
	    disabledButton: {
	        backgroundColor: colors_1.grey500
	    },
	    loaderStyle: {
	        textAlign: 'center'
	    }
	};
	var TypeFilter;
	(function (TypeFilter) {
	    TypeFilter[TypeFilter["ALL"] = 0] = "ALL";
	    TypeFilter[TypeFilter["WALLPAPER"] = 1] = "WALLPAPER";
	    TypeFilter[TypeFilter["STORY"] = 2] = "STORY";
	    TypeFilter[TypeFilter["SPONSORED"] = 3] = "SPONSORED";
	})(TypeFilter || (TypeFilter = {}));
	var StateFilter;
	(function (StateFilter) {
	    StateFilter[StateFilter["PENDING"] = 0] = "PENDING";
	    StateFilter[StateFilter["APPROVED"] = 1] = "APPROVED";
	    StateFilter[StateFilter["REJECTED"] = 2] = "REJECTED";
	    StateFilter[StateFilter["REMOVED"] = 3] = "REMOVED";
	})(StateFilter || (StateFilter = {}));
	var Action;
	(function (Action) {
	    Action[Action["REMOVE"] = 0] = "REMOVE";
	})(Action || (Action = {}));
	var ModeratorGlances = /** @class */ (function (_super) {
	    __extends(ModeratorGlances, _super);
	    function ModeratorGlances(props) {
	        var _this = _super.call(this, props) || this;
	        _this.pushFilterUrl = function (partnerFilter, regionFilter) {
	            _this.props.history.push('/' + _this.props.params.role + '/published'
	                + (partnerFilter ? ('/' + partnerFilter.partnerId + '/' + encodeURIComponent(partnerFilter.name)
	                    + (regionFilter ? ('/' + regionFilter + '/' + Utils_2["default"].getReadableRegionName(regionFilter)) : ''))
	                    : ''));
	        };
	        _this.setPartner = function (partner) {
	            var _a = _this.getPartnerDetails(partner), partnerAutoApprove = _a.partnerAutoApprove, isSponsoredEnabled = _a.isSponsoredEnabled, regionFilters = _a.regionFilters;
	            var regionFilter = regionFilters.length === 1 ? regionFilters[0] : null;
	            var partnerFilter = partner;
	            var loadMessage = regionFilter === null ? 'Select a Region' : '';
	            _this.setState(__assign({}, _this.state, { partnerFilter: partnerFilter,
	                regionFilters: regionFilters,
	                regionFilter: regionFilter,
	                partnerAutoApprove: partnerAutoApprove,
	                isSponsoredEnabled: isSponsoredEnabled,
	                loadMessage: loadMessage }), function () {
	                if (regionFilters.length === 1) {
	                    _this.pushFilterUrl(partner, regionFilter);
	                    _this.fetchGlances(true);
	                }
	            });
	        };
	        _this.setPartnerAndRegion = function (partner, region) {
	            var _a = _this.getPartnerDetails(partner), regionFilters = _a.regionFilters, partnerAutoApprove = _a.partnerAutoApprove, isSponsoredEnabled = _a.isSponsoredEnabled;
	            _this.setState(__assign({}, _this.state, { partnerFilter: partner, regionFilter: region, regionFilters: regionFilters,
	                partnerAutoApprove: partnerAutoApprove,
	                isSponsoredEnabled: isSponsoredEnabled, loadMessage: 'Loading live glances for ' + partner.name + ' in ' + Utils_2["default"].getReadableRegionName(region) + ' ...', showLoader: true }), function () {
	                _this.fetchGlances(true);
	            });
	        };
	        _this.fetchGlances = function (resetPage) {
	            var _a = _this.state, regionFilter = _a.regionFilter, partnerFilter = _a.partnerFilter, perPage = _a.perPage, selectedPage = _a.selectedPage, expiryFilter = _a.expiryFilter, stateFilter = _a.stateFilter, typeFilter = _a.typeFilter, searchTerm = _a.searchTerm, totalGlances = _a.totalGlances;
	            var type = Utils_1.typeFilters[typeFilter];
	            var state = Utils_1.stateFilters[stateFilter];
	            var offset = resetPage ? 0 : (selectedPage - 1) * perPage;
	            var payload = {
	                limit: perPage,
	                offset: offset,
	                expired: expiryFilter,
	                state: state,
	                type: type,
	                region: regionFilter,
	                partner: partnerFilter,
	                search: searchTerm
	            };
	            _this.setState(__assign({}, _this.state, { showLoader: true, selectedPage: resetPage ? 1 : selectedPage, totalGlances: resetPage ? 0 : totalGlances }), function () {
	                RestService_1["default"].getGlances(payload).then(function (response) {
	                    _this.setState(__assign({}, _this.state, { glancePairs: response.pairs, showLoader: false, snackbarMessage: 'Glances loaded', openSnackbar: true, loadMessage: null, totalGlances: response.count }));
	                })["catch"](function (error) {
	                    _this.setState(__assign({}, _this.state, { snackbarMessage: 'Loading failed. Try refresh or Contant Glance Support.', openSnackbar: true, loadMessage: 'Loading failed. Try refresh or Contant Glance Support.', showLoader: false }));
	                });
	            });
	        };
	        _this.getPartnerDetails = function (partner) {
	            var isSponsoredEnabled = false;
	            var partnerAutoApprove = false;
	            var regionFilters = [];
	            if (partner) {
	                var partnerObj = _this.props.studioAppConfig.partnerMetas.find(function (partnerMeta) { return partnerMeta.partnerId === partner.partnerId; });
	                if (partnerObj) {
	                    partnerAutoApprove = partnerObj.autoApprove;
	                    isSponsoredEnabled = partnerObj.isSponsoredEnabled ? partnerObj.isSponsoredEnabled : false;
	                    regionFilters = partnerObj.supportedRegions;
	                }
	            }
	            return { partnerAutoApprove: partnerAutoApprove, isSponsoredEnabled: isSponsoredEnabled, regionFilters: regionFilters };
	        };
	        _this.handlePartnerFilterChange = function (event, index, value) {
	            _this.setPartner(value);
	        };
	        _this.handleRegionFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(_this.state.partnerFilter, value);
	            _this.setPartnerAndRegion(_this.state.partnerFilter, value);
	        };
	        _this.handleTypeFilterChange = function (event, index, value) {
	            _this.setState(__assign({}, _this.state, { typeFilter: value }), function () { return _this.fetchGlances(true); });
	        };
	        _this.handleExpiryFilterChange = function (event, index, value) {
	            _this.setState(__assign({}, _this.state, { expiryFilter: value }), function () { return _this.fetchGlances(true); });
	        };
	        _this.handleStateFilterChange = function (event, index, value) {
	            _this.updateActions(value);
	            _this.setState(__assign({}, _this.state, { stateFilter: value }), function () { return _this.fetchGlances(true); });
	        };
	        _this.updateActions = function (stateFilter) {
	            var possibleActions;
	            switch (stateFilter) {
	                case StateFilter.PENDING:
	                case StateFilter.APPROVED:
	                    possibleActions = [Action.REMOVE];
	                    break;
	                case StateFilter.REJECTED:
	                case StateFilter.REMOVED:
	                default:
	                    possibleActions = null;
	            }
	            _this.setState(__assign({}, _this.state, { possibleActions: possibleActions }));
	        };
	        _this.onSelectGlance = function (element, selected) {
	            var newMap = new Map(_this.state.selectedGlances);
	            if (selected) {
	                newMap.set(element.data.glanceId, true);
	            }
	            else {
	                newMap["delete"](element.data.glanceId);
	            }
	            _this.setState(__assign({}, _this.state, { selectedGlances: newMap }));
	        };
	        _this.handleAction = function (action) {
	            _this.setState(__assign({}, _this.state, { actionClicked: action, openConfirmDialog: true }));
	        };
	        _this.handleActionConfirm = function (action) {
	            var selectedIds = [];
	            _this.state.selectedGlances.forEach(function (value, glanceId) {
	                selectedIds.push(glanceId);
	            });
	            _this.setState(__assign({}, _this.state, { snackbarMessage: 'Starting to ' + Action[action] + ' Glances ...', openSnackbar: true }));
	            switch (action) {
	                case Action.REMOVE:
	                    RestService_1["default"].removePartnerPublishedGlances(_this.state.partnerFilter, _this.state.regionFilter, selectedIds, function (success) {
	                        _this.handleActionComplete(action, success);
	                    });
	                    break;
	                default:
	                    break;
	            }
	        };
	        _this.handleActionComplete = function (action, success) {
	            if (success) {
	                _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: 'Glance ' + Action[action] + ' done. Updating view...', openConfirmDialog: false, selectedGlances: new Map() }));
	                _this.fetchGlances(true);
	            }
	            else {
	                _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: 'Unable to ' + Action[action] + ' glances. Contact Glance Support.', openConfirmDialog: false }));
	            }
	        };
	        _this.closeConfirmDialog = function () {
	            _this.setState(__assign({}, _this.state, { openConfirmDialog: false }));
	        };
	        _this.closeSnackbar = function () {
	            _this.setState(__assign({}, _this.state, { openSnackbar: false }));
	        };
	        _this.searchHandler = function (event) {
	            if (timer) {
	                clearTimeout(timer);
	            }
	            _this.setState(__assign({}, _this.state, { searchTerm: event.target.value }));
	            timer = setTimeout(function () {
	                _this.fetchGlances(true);
	            }, 800);
	        };
	        _this.searchButton = function () {
	            _this.fetchGlances(true);
	        };
	        _this.onPageChange = function (page) {
	            _this.setState(__assign({}, _this.state, { selectedPage: page.selected + 1, selectedGlances: new Map() }), function () {
	                _this.fetchGlances(false);
	            });
	        };
	        _this.getGridItems = function (glancePairs) {
	            // checking if the glance is created after march 1st 2023 if it's from spaces, non-space glances are not checked.
	            var gridItems = glancePairs.map(function (pair) {
	                if (pair.data.destinationIdentifier !== 0 /* SPACE */ || (pair.data.destinationIdentifier === 0 /* SPACE */ && pair.data.updatedAtInSecs >= 1677628800))
	                    return (React.createElement(GridList_1.GridTile, { key: pair.data.glanceId, style: { flex: 1 }, containerElement: React.createElement(Glance_1["default"], { glance: pair, selected: _this.state.selectedGlances.get(pair.data.glanceId), partner: _this.state.partnerFilter, region: _this.state.regionFilter, onSelect: function (selected) { return _this.onSelectGlance(pair, selected); } }) }));
	            });
	            return gridItems.filter(function (el) { return el !== undefined; });
	        };
	        _this.state = {
	            partnerFilter: null,
	            regionFilters: null,
	            regionFilter: null,
	            typeFilter: TypeFilter.STORY,
	            stateFilter: StateFilter.APPROVED,
	            expiryFilter: false,
	            openConfirmDialog: false,
	            openSnackbar: false,
	            snackbarMessage: '',
	            loadMessage: 'Select a partner and region to load',
	            isSponsoredEnabled: false,
	            perPage: 12,
	            glancePairs: [],
	            totalGlances: 0,
	            selectedPage: 1,
	            searchTerm: '',
	            selectedGlances: new Map(),
	            possibleActions: [],
	            showActive: false
	        };
	        return _this;
	    }
	    ModeratorGlances.prototype.componentWillMount = function () {
	        // TODO: now studioAppConfig will always have a default value. this check needs to be changed
	        var _this = this;
	        if (!this.props.studioAppConfig) {
	            this.props.history.push('/login');
	            window.location.reload();
	        }
	        if (this.props.params && this.props.params.partnerName) {
	            var partnerName_1 = this.props.params.partnerName;
	            var region_1 = this.props.params.region;
	            this.props.studioAppConfig.partners.forEach(function (partner) {
	                if (partner.name == partnerName_1) {
	                    if (region_1) {
	                        _this.setPartnerAndRegion(partner, parseInt(region_1));
	                    }
	                    else {
	                        _this.setPartner(partner);
	                    }
	                }
	            });
	        }
	    };
	    ModeratorGlances.prototype.componentDidMount = function () {
	        this.updateActions(this.state.stateFilter);
	    };
	    ModeratorGlances.prototype.render = function () {
	        var _this = this;
	        var actions = [];
	        var _a = this.state, selectedPage = _a.selectedPage, perPage = _a.perPage, glancePairs = _a.glancePairs, showLoader = _a.showLoader, totalGlances = _a.totalGlances;
	        actions.push(React.createElement(FlatButton_1["default"], { label: 'Cancel', primary: true, style: { width: '100%' }, onClick: this.closeConfirmDialog }));
	        actions.push(React.createElement(FlatButton_1["default"], { label: 'Yes, ' + Action[this.state.actionClicked], primary: true, style: { width: '100%' }, onClick: function () { return _this.handleActionConfirm(_this.state.actionClicked); } }));
	        return (React.createElement("div", null,
	            !this.state.partnerFilter ?
	                React.createElement(Toolbar_1.Toolbar, { style: { marginTop: '2%' } },
	                    React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true },
	                        React.createElement(DropDownMenu_1["default"], { value: this.state.partnerFilter, onChange: this.handlePartnerFilterChange },
	                            React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Click here select to Partner', key: 'empty' }),
	                            this.props.studioAppConfig.partners.map(function (item, index) {
	                                return (React.createElement(MenuItem_1["default"], { value: item, primaryText: item.name, key: item.partnerId }));
	                            }))))
	                :
	                    React.createElement(Toolbar_1.Toolbar, { style: { marginTop: '2%' } },
	                        React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true },
	                            React.createElement(Toolbar_1.ToolbarTitle, { text: 'Filters', style: { marginLeft: '24px' } }),
	                            React.createElement(Toolbar_1.ToolbarSeparator, null),
	                            React.createElement(DropDownMenu_1["default"], { value: this.state.partnerFilter, onChange: this.handlePartnerFilterChange },
	                                React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Select Partner', key: 'empty' }),
	                                this.props.studioAppConfig.partners.map(function (item, index) {
	                                    return (React.createElement(MenuItem_1["default"], { value: item, primaryText: item.name, key: item.partnerId }));
	                                })),
	                            React.createElement(DropDownMenu_1["default"], { value: this.state.regionFilter, onChange: this.handleRegionFilterChange },
	                                React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Select Region', key: 'empty' }),
	                                this.state.regionFilters.map(function (item, index) {
	                                    return (React.createElement(MenuItem_1["default"], { value: item, primaryText: Utils_2["default"].getReadableRegionName(item), key: index }));
	                                })),
	                            this.state.partnerAutoApprove ?
	                                React.createElement(DropDownMenu_1["default"], { value: this.state.stateFilter, onChange: this.handleStateFilterChange },
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.APPROVED, primaryText: 'Approved Glances' }),
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.REMOVED, primaryText: 'Removed Glances' })) :
	                                React.createElement(DropDownMenu_1["default"], { value: this.state.stateFilter, onChange: this.handleStateFilterChange },
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.PENDING, primaryText: 'Pending Approval' }),
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.APPROVED, primaryText: 'Approved Glances' }),
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.REJECTED, primaryText: 'Rejected Glances' }),
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.REMOVED, primaryText: 'Removed Glances' })),
	                            React.createElement(DropDownMenu_1["default"], { value: this.state.typeFilter, onChange: this.handleTypeFilterChange },
	                                React.createElement(MenuItem_1["default"], { value: TypeFilter.ALL, primaryText: 'Everything' }),
	                                React.createElement(MenuItem_1["default"], { value: TypeFilter.STORY, primaryText: 'Stories' }),
	                                React.createElement(MenuItem_1["default"], { value: TypeFilter.WALLPAPER, primaryText: 'Wallpapers' }),
	                                this.state.isSponsoredEnabled ?
	                                    React.createElement(MenuItem_1["default"], { value: TypeFilter.SPONSORED, primaryText: 'Sponsored' }) : ''),
	                            React.createElement(DropDownMenu_1["default"], { value: this.state.expiryFilter, onChange: this.handleExpiryFilterChange },
	                                React.createElement(MenuItem_1["default"], { value: false, primaryText: 'Active Glances' }),
	                                React.createElement(MenuItem_1["default"], { value: true, primaryText: 'Expired Glances' })),
	                            React.createElement("div", { className: 'wrap' },
	                                React.createElement("div", { className: 'search' },
	                                    React.createElement("input", { type: 'text', value: this.state.searchTerm, onChange: this.searchHandler, placeholder: 'Search...', className: 'searchTerm' }),
	                                    React.createElement("div", null, totalGlances),
	                                    React.createElement("button", { type: 'submit', className: 'searchButton', onClick: this.searchButton },
	                                        React.createElement("i", null,
	                                            React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20' },
	                                                React.createElement("path", { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })))))))),
	            this.state.regionFilter ? (React.createElement(Loader_1["default"], { show: showLoader, message: this.state.loadMessage }, glancePairs && glancePairs.length > 0 ?
	                React.createElement("div", null,
	                    React.createElement(GridList_1.GridList, { style: { width: '100%', margin: '0 auto', marginTop: '2%' }, cols: 4, padding: 15, cellHeight: 'auto' }, 
	                    //calling a method to get filtered grid titles, as filtering here directly is causing blank gridList
	                    this.getGridItems(glancePairs)))
	                : React.createElement(EmptyMessage_1["default"], { message: 'No glances for selected filters' }))) : React.createElement(EmptyMessage_1["default"], { message: this.state.loadMessage }),
	            totalGlances > perPage && React.createElement("div", { id: 'react-paginate' },
	                React.createElement(react_paginate_1["default"], { previousLabel: 'Previous', nextLabel: 'Next', pageRangeDisplayed: 3, marginPagesDisplayed: 3, breakLabel: React.createElement("span", { className: 'gap' }, "..."), pageCount: Math.ceil(totalGlances / perPage), onPageChange: this.onPageChange, forcePage: selectedPage - 1, activeClassName: 'active' })),
	            this.state.possibleActions && this.state.selectedGlances && this.state.selectedGlances.size > 0 ?
	                React.createElement("div", { style: styles.footer },
	                    React.createElement(RaisedButton_1["default"], { icon: removeIcon, label: 'Remove Selected (' + this.state.selectedGlances.size + ')', primary: true, buttonStyle: this.state.possibleActions.indexOf(Action.REMOVE) < 0 ? styles.disabledButton : styles.deleteButton, style: styles.footerButton, onClick: function () { return _this.handleAction(Action.REMOVE); }, disabled: this.state.possibleActions.indexOf(Action.REMOVE) < 0 })) : '',
	            React.createElement(Dialog_1["default"], { modal: false, open: this.state.openConfirmDialog, onRequestClose: this.closeConfirmDialog, actions: actions },
	                "Please confirm that you want to ",
	                Action[this.state.actionClicked],
	                " these glances."),
	            React.createElement(Snackbar_1["default"], { open: this.state.openSnackbar, message: this.state.snackbarMessage, onRequestClose: this.closeSnackbar, autoHideDuration: 2000 })));
	    };
	    return ModeratorGlances;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(ModeratorGlances);


/***/ },

/***/ 988:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var material_ui_1 = __webpack_require__(38);
	var colors_1 = __webpack_require__(18);
	var List_1 = __webpack_require__(320);
	var RadioButton_1 = __webpack_require__(99);
	var Utils_1 = __webpack_require__(17);
	var JerseyRestApiService_1 = __webpack_require__(83);
	var react_redux_1 = __webpack_require__(24);
	var FILE_UPLOAD_SIZE_LIMIT = 70485760;
	var styles = {
	    container: {
	        width: '80%',
	        margin: 'auto',
	        marginTop: '50px',
	        padding: '20px'
	    },
	    alertStyle: {
	        marginTop: '20px'
	    },
	    saveButtonStyle: {
	        marginTop: '15px'
	    },
	    dialogContentStyle: {
	        width: '400px'
	    },
	    toggleViewContainer: {
	        display: 'flex',
	        height: '40px',
	        textAlign: 'center'
	    },
	    activeView: {
	        flex: '1',
	        background: '#00BCD4',
	        padding: '8px'
	    },
	    inactiveview: {
	        flex: '1',
	        padding: '8px'
	    },
	    fileUploaderView: {
	        display: 'flex',
	        flexDirection: 'row',
	        paddingTop: '25px'
	    },
	    uploadButton: {
	        float: 'right',
	        flex: 1,
	        minWidth: '120px'
	    },
	    fileUpload: {
	        minWidth: '100px'
	    },
	    uploadedFilepath: {
	        display: 'flex',
	        paddingTop: '20px'
	    },
	    filePathLink: {
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	        flex: 3
	    },
	    errorTag: {
	        color: 'red'
	    },
	    targetViewText: {
	        paddingTop: '10px'
	    },
	    radioButtonGroup: {
	        paddingTop: '45px'
	    },
	    radioButton: {
	        float: 'left',
	        width: '50%',
	        margim: '10px 0 '
	    },
	    ctalinkInput: {
	        float: 'left',
	        width: '80%'
	    },
	    ctaIconButton: {
	        float: 'left',
	        width: '20%',
	        marginTop: '25px'
	    }
	};
	var regex = {
	    title: {
	        checker: /^.{3,}$/,
	        errMsg: 'Title should be min 3 characters'
	    },
	    body: {
	        checker: /^.{3,}$/,
	        errMsg: 'Body should be min 3 characters'
	    },
	    image: {
	        checker: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
	        errMsg: 'Please Enter Valid Image Url'
	    },
	    urlLink: {
	        checker: '^(?!s*$).+',
	        errMsg: 'Please Enter a Link Url'
	    },
	    deeplink: {
	        checker: '',
	        errMsg: 'Please Enter a GlanceId to Open'
	    },
	    text: {
	        checker: /^.{3,}$/,
	        errMsg: 'Text should be min 3 characters'
	    },
	    link: {
	        checker: /^.{1,}$/,
	        errMsg: 'Please Enter a Link Url'
	    }
	};
	var activePartners = [
	    '16b66d7123dd588670e011bbb88bec9c0a27359c',
	    '6c0df13798382e1044a104a8f984edb130b20ce6',
	    'ad5b47f7258c6ff30313557f32235fe64f7873a8',
	    'bac8164d2982a5afbac64c57b64f9688',
	    '0ca8383599b6a1b99fecd5d07ea6d355',
	    '439125bff2c51a774d87c95a7d4e460c',
	    '6ed915c905737998e3a505688863fede',
	    '8294b57a5a4a6227a45e10ab9d71ffb4',
	    'a07a917cae67e8a206bf9bdde2da9aed',
	    'eee86d7cb6b40eeabd6858f4a88e4374',
	    '8aa5e6d1bea2ee2ae3f3f148c70e4cc3',
	    '6f7caac7bf84937001342b8f9641d757',
	    'd41d8cd98f00b204e9800998ecf8427e',
	    'dde1b816a19d16a8b866ff74319d7995',
	    '2bea64040f41b17332d7a67fadeae336',
	    'fa647c9e01a2defa9fdc483a9a3352d003cb003d'
	];
	var deepLinkMap = {
	    '6c0df13798382e1044a104a8f984edb130b20ce6': [
	        {
	            name: 'To Open WC',
	            value: 'fashiongallery://home'
	        },
	        {
	            name: 'To Open Setting page',
	            value: 'fashiongallery://setting'
	        },
	        {
	            name: 'To Open Specific Glance Id',
	            value: 'fashiongallery://home?id={glance_id}'
	        },
	        {
	            name: 'To Open Categories',
	            value: 'glance://categories'
	        },
	    ],
	    '16b66d7123dd588670e011bbb88bec9c0a27359c': [
	        {
	            name: 'Settings',
	            value: 'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.SettingsLssActivity'
	        },
	        {
	            name: 'About(for update)',
	            value: 'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.about.AboutDynamicLockActivity'
	        },
	        {
	            name: 'Categories',
	            value: 'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.FollowCategoriesActivity'
	        },
	        {
	            name: 'Reactivation API',
	            value: 'dynamiclockscreen://flashpage?from=coaching'
	        },
	    ],
	    '-1': [],
	    bac8164d2982a5afbac64c57b64f9688: [
	        {
	            name: 'Settings',
	            value: 'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.SettingsLssActivity'
	        },
	        {
	            name: 'About(for update)',
	            value: 'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.about.AboutDynamicLockActivity'
	        },
	        {
	            name: 'Categories',
	            value: 'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.FollowCategoriesActivity'
	        },
	        {
	            name: 'Reactivation API',
	            value: 'dynamiclockscreen://flashpage?from=coaching'
	        },
	        {
	            name: 'About page',
	            value: 'dynamiclockscreen://flashpage?from=about&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.about.AboutDynamicLockActivity'
	        },
	        {
	            name: 'Setting page',
	            value: 'dynamiclockscreen://flashpage?from=setting&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.SettingLssActivity'
	        },
	    ],
	    '0ca8383599b6a1b99fecd5d07ea6d355': [
	        {
	            name: 'To Open WC',
	            value: 'fashiongallery://home'
	        },
	        {
	            name: 'To Open Setting page',
	            value: 'fashiongallery://setting'
	        },
	        {
	            name: 'To Open Specific Glance Id',
	            value: 'fashiongallery://home?id={glance_id}'
	        },
	        {
	            name: 'To Open Categories',
	            value: 'glance://categories'
	        },
	    ],
	    '439125bff2c51a774d87c95a7d4e460c': [
	        {
	            name: 'Settings',
	            value: 'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.SettingsLssActivity'
	        },
	        {
	            name: 'About(for update)',
	            value: 'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.about.AboutDynamicLockActivity'
	        },
	        {
	            name: 'Categories',
	            value: 'dynamiclockscreen://flashpage?from=coaching&package=com.samsung.android.dynamiclock&activity=com.samsung.android.dynamiclock.presentation.settings.lss.FollowCategoriesActivity'
	        },
	    ],
	    '6ed915c905737998e3a505688863fede': [
	        {
	            name: 'Settings',
	            value: 'mygalaxystories://flashpage?from=coaching&package=com.samsung.android.keyguardmgsupdator&activity=com.samsung.android.keyguardmgsupdator.ui.KeyguardMGSSettingsActivity'
	        },
	        {
	            name: 'About(for update)',
	            value: 'mygalaxystories://flashpage?from=coaching&package=com.samsung.android.keyguardmgsupdator&activity=com.samsung.android.keyguardmgsupdator.ui.KeyguardMGSAboutActivity'
	        },
	        {
	            name: 'Categories',
	            value: 'mygalaxystories://flashpage?from=coaching&package=com.samsung.android.keyguardmgsupdator&activity=com.samsung.android.keyguardmgsupdator.ui.glance.GlancePreferenceActivity'
	        },
	    ],
	    '8294b57a5a4a6227a45e10ab9d71ffb4': [
	        {
	            name: 'Settings',
	            value: 'glance://settings?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation screen',
	            value: 'glance://reactivation?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation API',
	            value: 'glance://reactivation/enable?referrer={referrer}'
	        },
	    ],
	    a07a917cae67e8a206bf9bdde2da9aed: [
	        {
	            name: 'Settings',
	            value: 'glance://settings?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation screen',
	            value: 'glance://reactivation?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation API',
	            value: 'glance://reactivation/enable?referrer={referrer}'
	        },
	        {
	            name: 'Shopping',
	            value: 'glance://shop'
	        },
	        {
	            name: 'Live',
	            value: 'glance://live'
	        },
	        {
	            name: 'Game',
	            value: 'glance://game'
	        },
	        {
	            name: 'Sports',
	            value: 'glance://sports'
	        },
	        {
	            name: 'Home',
	            value: 'glance://home'
	        },
	    ],
	    eee86d7cb6b40eeabd6858f4a88e4374: [
	        {
	            name: 'Settings',
	            value: 'glance://settings?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation screen',
	            value: 'glance://reactivation?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation API',
	            value: 'glance://reactivation/enable?referrer={referrer}'
	        },
	    ],
	    '8aa5e6d1bea2ee2ae3f3f148c70e4cc3': [
	        {
	            name: 'Settings',
	            value: 'glance://settings?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation screen',
	            value: 'glance://reactivation?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation API',
	            value: 'glance://reactivation/enable?referrer={referrer}'
	        },
	        {
	            name: 'Activation',
	            value: 'glance://activation/enable?referrer=notification'
	        },
	    ],
	    '6f7caac7bf84937001342b8f9641d757': [
	        {
	            name: 'Settings',
	            value: 'glance://settings?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation screen',
	            value: 'glance://reactivation?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation API',
	            value: 'glance://reactivation/enable?referrer={referrer}'
	        },
	        {
	            name: 'Activation',
	            value: 'glance://activation/enable?referrer=notification'
	        },
	    ],
	    'd41d8cd98f00b204e9800998ecf8427e': [
	        {
	            name: 'Settings',
	            value: 'glance://settings?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation screen',
	            value: 'glance://reactivation?referrer={referrer}'
	        },
	        {
	            name: 'Reactivation API',
	            value: 'glance://reactivation/enable?referrer={referrer}'
	        },
	        {
	            name: 'Activation',
	            value: 'glance://activation/enable?referrer=notification'
	        },
	    ]
	};
	var partnerRegionMap = __assign({}, activePartners.reduce(function (a, v) {
	    var _a;
	    return (__assign({}, a, (_a = {}, _a[v] = [], _a)));
	}, {}), { '-1': [] });
	var emptyCta = {
	    text: '',
	    link: '',
	    id: ''
	};
	var targetUnitDefaultRegions = [
	    { id: 'IN', name: 'India' },
	    { id: 'ID', name: 'Indonesia' },
	];
	var targetUnitJioNextNiuRegions = [{ id: 'IN', name: 'India' }];
	var targetUnitSoftbankRegions = [{ id: 'JP', name: 'Japan' },
	    { id: 'US', name: 'USA' }];
	var targetUnitJapanRegion = [{ id: 'JP', name: 'Japan' }];
	var latamTargetUnitRegions = targetUnitDefaultRegions.concat([
	    { id: 'BR', name: 'Brazil' },
	    { id: 'MX', name: 'Mexico' },
	    { id: 'CO', name: 'Columbia' },
	    { id: 'US', name: 'USA' }
	]);
	var usTargetUnitRegions = [{ id: 'US', name: 'USA' }];
	var targetUnitRegions = __assign({}, activePartners.reduce(function (a, v) {
	    var _a;
	    return (__assign({}, a, (_a = {}, _a[v] = targetUnitDefaultRegions, _a)));
	}, {}), { a07a917cae67e8a206bf9bdde2da9aed: latamTargetUnitRegions, '8aa5e6d1bea2ee2ae3f3f148c70e4cc3': targetUnitJioNextNiuRegions, '6f7caac7bf84937001342b8f9641d757': targetUnitSoftbankRegions, 'd41d8cd98f00b204e9800998ecf8427e': usTargetUnitRegions, 'eee86d7cb6b40eeabd6858f4a88e4374': latamTargetUnitRegions, 'dde1b816a19d16a8b866ff74319d7995': latamTargetUnitRegions, 'fa647c9e01a2defa9fdc483a9a3352d003cb003d': targetUnitJapanRegion, '-1': [] });
	var Notification = /** @class */ (function (_super) {
	    __extends(Notification, _super);
	    function Notification(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onSettingChange = function (key, value) {
	            var _a;
	            var errors = _this.state.errors;
	            if (key === 'title' || key === 'body' || key === 'image') {
	                if (value.match(regex[key].checker)) {
	                    errors[key] = '';
	                }
	                else {
	                    errors[key] = regex[key].errMsg;
	                }
	            }
	            if (key === 'deeplink' && value.includes('glance_id')) {
	                errors[key] = regex[key].errMsg;
	            }
	            _this.setState(__assign({}, _this.state, { settings: __assign({}, _this.state.settings, (_a = {}, _a[key] = value, _a)), errors: errors }));
	        };
	        _this.onCtaChange = function (key, value, ctaIndex) {
	            var _a;
	            var _b = _this.state, cta = _b.settings.cta, errors = _b.errors;
	            if (key === 'text') {
	                if (value.match(regex[key].checker)) {
	                    errors[key + ctaIndex] = '';
	                }
	                else {
	                    errors[key + ctaIndex] = regex[key].errMsg;
	                }
	            }
	            if (key === 'link') {
	                if (value.match(regex[key].checker)) {
	                    errors[key + ctaIndex] = '';
	                }
	                else {
	                    errors[key + ctaIndex] = regex[key].errMsg;
	                }
	            }
	            cta[ctaIndex] = __assign({}, cta[ctaIndex], (_a = {}, _a[key] = value, _a));
	            _this.setState(__assign({}, _this.state, { settings: __assign({}, _this.state.settings, { cta: cta }), errors: errors }));
	        };
	        _this.onMultipleCtas = function () {
	            _this.setState(__assign({}, _this.state, { multipleCtas: !_this.state.multipleCtas }));
	        };
	        _this.handleClose = function () {
	            _this.setState(__assign({}, _this.state, { dialogOpen: false }));
	        };
	        _this.publishNotification = function () {
	            var _a = _this.state, actionType = _a.actionType, settings = _a.settings, urlLink = _a.urlLink, glanceId = _a.glanceId, referrer = _a.referrer, isOptionalCta = _a.isOptionalCta;
	            var cta = settings.cta;
	            var deeplink = actionType === 'deepLink' ? settings.deeplink : urlLink;
	            if (deeplink && deeplink.includes('glance_id')) {
	                deeplink = deeplink.replace('{glance_id}', glanceId);
	            }
	            if (deeplink && deeplink.includes('referrer')) {
	                deeplink = deeplink.replace('{referrer}', referrer);
	            }
	            var payload = {};
	            if (!_this.state.topicView) {
	                if (!_this.state.multipleCtas) {
	                    // Omit the "cta" fields
	                    var cta_1 = settings.cta, otherSettings = __rest(settings, ["cta"]);
	                    payload = __assign({}, settings, { testPush: true, deeplink: deeplink, view: 'TARGETEDUSER' });
	                }
	                else {
	                    // Omit the "deeplink", "action" fields
	                    var deeplink_1 = settings.deeplink, action = settings.action, otherSettings = __rest(settings, ["deeplink", "action"]);
	                    payload = __assign({}, otherSettings, { testPush: true, view: 'TARGETEDUSER', cta: isOptionalCta ? cta : [cta[0]] });
	                }
	            }
	            else {
	                // Omit the "glanceEnabled", "targetFilePath", "cta" fields
	                var glanceEnabled = settings.glanceEnabled, targetFilePath = settings.targetFilePath, cta_2 = settings.cta, otherSettings = __rest(settings, ["glanceEnabled", "targetFilePath", "cta"]);
	                payload = __assign({}, otherSettings, { testPush: false, deeplink: deeplink, view: 'TOPIC' });
	            }
	            _this.setState(__assign({}, _this.state, { isProcessing: true, notificationId: '' }));
	            JerseyRestApiService_1["default"].sendNotification(payload, function (response) {
	                _this.setState(__assign({}, _this.state, { snackBarMsg: 'Successfully Saved', showSnackBar: true, dialogOpen: false, isProcessing: false, notificationId: response.notificationId }));
	            });
	        };
	        _this.openDialog = function () {
	            _this.setState(__assign({}, _this.state, { dialogOpen: true, showSnackBar: false }));
	        };
	        _this.getPartner = function (partnerId) {
	            var partnerObj = _this.props.studioAppConfig.partners.find(function (partner) { return partner.partnerId === partnerId; });
	            return partnerObj ? partnerObj.name : '';
	        };
	        _this.testNotification = function () {
	            var _a = _this.state, actionType = _a.actionType, settings = _a.settings, urlLink = _a.urlLink, glanceId = _a.glanceId, referrer = _a.referrer, isOptionalCta = _a.isOptionalCta;
	            var cta = settings.cta;
	            var deeplink = actionType === 'deepLink' ? settings.deeplink : urlLink;
	            if (deeplink && deeplink.includes('glance_id')) {
	                deeplink = deeplink.replace('{glance_id}', glanceId);
	            }
	            if (deeplink && deeplink.includes('referrer')) {
	                deeplink = deeplink.replace('{referrer}', referrer);
	            }
	            var payload = {};
	            if (!_this.state.topicView) {
	                if (!_this.state.multipleCtas) {
	                    // Omit the "cta" fields
	                    var cta_3 = settings.cta, otherSettings = __rest(settings, ["cta"]);
	                    payload = __assign({}, otherSettings, { testPush: true, deeplink: deeplink, view: 'TARGETEDUSER' });
	                }
	                else {
	                    // Omit the "deeplink", "action" fields
	                    var deeplink_2 = settings.deeplink, action = settings.action, otherSettings = __rest(settings, ["deeplink", "action"]);
	                    payload = __assign({}, otherSettings, { testPush: true, view: 'TARGETEDUSER', cta: isOptionalCta ? cta : [cta[0]] });
	                }
	            }
	            else {
	                // Omit the "glanceEnabled", "targetFilePath", "cta" fields
	                var glanceEnabled = settings.glanceEnabled, targetFilePath = settings.targetFilePath, cta_4 = settings.cta, otherSettings = __rest(settings, ["glanceEnabled", "targetFilePath", "cta"]);
	                payload = __assign({}, otherSettings, { testPush: true, deeplink: deeplink, view: 'TOPIC' });
	            }
	            _this.setState(__assign({}, _this.state, { isProcessing: true, showSnackBar: false }));
	            JerseyRestApiService_1["default"].sendNotification(payload, function (response) {
	                _this.setState(__assign({}, _this.state, { snackBarMsg: 'Test is Successful', showSnackBar: true, isProcessing: false, notificationId: response.notificationId }));
	            });
	        };
	        _this.handleActionTypeChange = function (event, value) {
	            _this.setState(__assign({}, _this.state, { actionType: value }));
	        };
	        _this.handleOptionalCtaClick = function () {
	            var _a = _this.state, settings = _a.settings, errors = _a.errors;
	            var cta = settings.cta;
	            if (_this.state.isOptionalCta) {
	                cta[1] = __assign({}, emptyCta);
	                errors['text1'] = '';
	                errors['link1'] = '';
	            }
	            _this.setState(__assign({}, _this.state, { isOptionalCta: !_this.state.isOptionalCta, settings: __assign({}, _this.state.settings, { cta: cta }), errors: errors }));
	        };
	        _this.onUrlLinkChange = function (urlLink) {
	            var errors = _this.state.errors;
	            if (urlLink.match(regex['urlLink'].checker)) {
	                errors['urlLink'] = '';
	            }
	            else {
	                errors['urlLink'] = regex['urlLink'].errMsg;
	            }
	            _this.setState(__assign({}, _this.state, { urlLink: urlLink }));
	        };
	        _this.handleSuccessClose = function () {
	            _this.setState(__assign({}, _this.state, { showSnackBar: false }));
	        };
	        _this.onGlanceIdChange = function (glanceId) {
	            _this.setState(__assign({}, _this.state, { glanceId: glanceId }));
	        };
	        _this.onReferrerChange = function (referrer) {
	            _this.setState(__assign({}, _this.state, { referrer: referrer }));
	        };
	        _this.handleViewClick = function (e) {
	            if (e === 'topicView') {
	                _this.setState(__assign({}, _this.state, { topicView: true }));
	            }
	            else {
	                _this.setState(__assign({}, _this.state, { topicView: false, settings: __assign({}, _this.state.settings, { partnerId: '6c0df13798382e1044a104a8f984edb130b20ce6', regionId: 'IN' }) }));
	            }
	        };
	        _this.fileSelectHandler = function (event) {
	            _this.setState(__assign({}, _this.state, { selectedFile: event.target.files }));
	        };
	        _this.fileUploadHandler = function () {
	            var selectedFile = _this.state.selectedFile;
	            var formData = new FormData();
	            if (selectedFile && selectedFile[0].name.match(/(.csv)$/)) {
	                formData.append('file', selectedFile[0]);
	            }
	            else {
	                _this.setState(__assign({}, _this.state, { uploadStatus: 'error', failureText: 'Only csv file type supported' }));
	                return;
	            }
	            if (selectedFile[0].size > FILE_UPLOAD_SIZE_LIMIT) {
	                _this.setState(__assign({}, _this.state, { uploadStatus: 'error', failureText: " " + selectedFile[0].name + " size is more than 70MB" }));
	                return;
	            }
	            var payload = {
	                formData: formData
	            };
	            var uploadFile = JerseyRestApiService_1["default"].targetUserNotification(payload);
	            _this.setState(__assign({}, _this.state, { uploadStatus: 'uploading' }));
	            uploadFile
	                .then(function (response) {
	                var s3Response = response;
	                _this.setState(__assign({}, _this.state, { uploadedFileName: s3Response.name, failureText: '', settings: __assign({}, _this.state.settings, { targetFilePath: s3Response.path }), uploadStatus: 'success' }));
	            })["catch"](function (err) {
	                _this.setState(__assign({}, _this.state, { uploadStatus: 'error', failureText: err }));
	            });
	        };
	        _this.removeUploadedFile = function () {
	            _this.setState(__assign({}, _this.state, { uploadStatus: '', uploadedFileName: '', failureText: '', settings: __assign({}, _this.state.settings, { targetFilePath: '' }) }));
	        };
	        _this.state = {
	            partners: [],
	            topicView: true,
	            selectedFile: null,
	            uploadStatus: '',
	            uploadedFileName: '',
	            folderPath: '',
	            failureText: '',
	            settings: {
	                title: '',
	                body: '',
	                image: '',
	                deeplink: '-1',
	                action: '',
	                alert: false,
	                partnerId: '-1',
	                regionId: '-1',
	                testPush: false,
	                sticky: false,
	                targetFilePath: '',
	                glanceEnabled: false,
	                id: '-1',
	                cta: [__assign({}, emptyCta), __assign({}, emptyCta)]
	            },
	            actionType: 'deepLink',
	            urlLink: '',
	            errors: {
	                title: '',
	                body: '',
	                image: '',
	                urlLink: ''
	            },
	            dialogOpen: false,
	            showSnackBar: false,
	            isProcessing: false,
	            snackBarMsg: '',
	            glanceId: '',
	            referrer: '',
	            notificationId: '',
	            multipleCtas: false,
	            isOptionalCta: false
	        };
	        return _this;
	    }
	    Notification.prototype.componentDidMount = function () {
	        // TODO: now studioAppConfig will always have a default value. this check needs to be changed
	        if (!this.props.studioAppConfig) {
	            this.props.history.push('/login');
	            window.location.reload();
	        }
	        else {
	            var partners = this.props.studioAppConfig.partners.filter(function (partner) {
	                return activePartners.indexOf(partner.partnerId) > -1;
	            });
	            this.props.studioAppConfig.partnerMetas.map(function (partnerMeta) {
	                if (activePartners.includes(partnerMeta.partnerId)) {
	                    partnerRegionMap[partnerMeta.partnerId] = partnerMeta.supportedRegions.map(function (supportedRegion) {
	                        return {
	                            id: Utils_1.regionFilters[supportedRegion],
	                            name: Utils_1.regionNames[supportedRegion]
	                        };
	                    });
	                }
	            });
	            this.setState(__assign({}, this.state, { partners: partners }));
	        }
	    };
	    Notification.prototype.render = function () {
	        var _this = this;
	        var _a = this.state, _b = _a.settings, title = _b.title, body = _b.body, image = _b.image, action = _b.action, sticky = _b.sticky, deeplink = _b.deeplink, alert = _b.alert, partnerId = _b.partnerId, regionId = _b.regionId, glanceEnabled = _b.glanceEnabled, targetFilePath = _b.targetFilePath, cta = _b.cta, dialogOpen = _a.dialogOpen, partners = _a.partners, errors = _a.errors, showSnackBar = _a.showSnackBar, snackBarMsg = _a.snackBarMsg, isProcessing = _a.isProcessing, actionType = _a.actionType, urlLink = _a.urlLink, glanceId = _a.glanceId, topicView = _a.topicView, uploadStatus = _a.uploadStatus, uploadedFileName = _a.uploadedFileName, failureText = _a.failureText, notificationId = _a.notificationId, referrer = _a.referrer, multipleCtas = _a.multipleCtas, isOptionalCta = _a.isOptionalCta;
	        var isValidForm = title.match(regex.title.checker) &&
	            body.match(regex.body.checker) &&
	            ((!topicView && targetFilePath) || topicView) &&
	            partnerId !== '-1' &&
	            regionId !== '-1' &&
	            (topicView ||
	                !multipleCtas ||
	                (cta[0].text.match(regex.text.checker) &&
	                    cta[0].link.match(regex.link.checker) &&
	                    (topicView ||
	                        !multipleCtas ||
	                        !isOptionalCta ||
	                        (isOptionalCta &&
	                            cta[1].text.match(regex.text.checker) &&
	                            cta[1].link.match(regex.link.checker))))) &&
	            ((!topicView && multipleCtas) ||
	                (actionType === 'deepLink' &&
	                    deeplink.includes('glance_id') &&
	                    glanceId !== '') ||
	                (actionType === 'deepLink' && !deeplink.includes('glance_id')) ||
	                actionType !== 'deepLink');
	        var actions = [
	            React.createElement(material_ui_1.FlatButton, { label: "Cancel", primary: true, onTouchTap: this.handleClose }),
	            React.createElement(material_ui_1.FlatButton, { label: isProcessing ? 'Publishing...' : 'Publish', primary: true, onTouchTap: this.publishNotification, disabled: isProcessing }),
	        ];
	        var successActions = [
	            React.createElement(material_ui_1.FlatButton, { label: "Close", primary: true, onTouchTap: this.handleSuccessClose }),
	        ];
	        return (React.createElement("div", null,
	            React.createElement(material_ui_1.Paper, { style: styles.container, zDepth: 2 },
	                React.createElement("h4", null, "Notification Settings"),
	                React.createElement("div", { style: styles.toggleViewContainer },
	                    React.createElement("span", { style: topicView ? styles.activeView : styles.inactiveview, onClick: function () { return _this.handleViewClick('topicView'); } }, "Topic"),
	                    React.createElement("span", { style: topicView ? styles.inactiveview : styles.activeView, onClick: this.handleViewClick }, "Target Unit")),
	                React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                    React.createElement("div", null,
	                        !topicView && uploadStatus !== 'success' && !targetFilePath && (React.createElement("div", { style: styles.fileUploaderView },
	                            React.createElement("input", { id: "fileupload", style: styles.fileUpload, type: "file", onChange: this.fileSelectHandler }),
	                            React.createElement(material_ui_1.FlatButton, { style: styles.uploadButton, label: uploadStatus === 'uploading' ? 'Uploading...' : 'Upload', primary: true, onTouchTap: this.fileUploadHandler }))),
	                        !topicView && uploadStatus === 'success' && targetFilePath && (React.createElement("div", { style: styles.uploadedFilepath },
	                            React.createElement("a", { style: styles.filePathLink, target: "_blank" }, uploadedFileName),
	                            React.createElement(material_ui_1.FlatButton, { label: "Remove", primary: true, onTouchTap: this.removeUploadedFile }))),
	                        !topicView && uploadStatus === 'error' && (React.createElement("div", { style: styles.errorTag }, failureText
	                            ? failureText
	                            : 'Something went wrong. Try again'))),
	                    React.createElement("div", null)),
	                React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                    React.createElement(material_ui_1.SelectField, { fullWidth: true, floatingLabelText: "Partners", value: partnerId, onChange: function (event, index, value) {
	                            return _this.onSettingChange('partnerId', value);
	                        } },
	                        React.createElement(material_ui_1.MenuItem, { value: '-1', primaryText: 'Select Partner', key: 'empty' }),
	                        topicView
	                            ? partners.map(function (item) {
	                                return (React.createElement(material_ui_1.MenuItem, { value: item.partnerId, primaryText: item.name, key: item.partnerId }));
	                            })
	                            : partners
	                                .filter(function (partner) {
	                                return (partner.partnerId !==
	                                    '16b66d7123dd588670e011bbb88bec9c0a27359c' && //Samsung Android
	                                    partner.partnerId !== '6ed915c905737998e3a505688863fede'); // Samsung LSS Test
	                            })
	                                .map(function (item) {
	                                return (React.createElement(material_ui_1.MenuItem, { value: item.partnerId, primaryText: item.name, key: item.partnerId }));
	                            })),
	                    React.createElement(material_ui_1.SelectField, { fullWidth: true, floatingLabelText: "Regions", value: regionId, onChange: function (event, index, value) {
	                            return _this.onSettingChange('regionId', value);
	                        } },
	                        React.createElement(material_ui_1.MenuItem, { value: '-1', primaryText: 'Select Region', key: 'empty', disabled: partnerId === '-1' }),
	                        topicView
	                            ? partnerRegionMap[partnerId].map(function (item) {
	                                return (React.createElement(material_ui_1.MenuItem, { value: item.id, primaryText: item.name, key: item.id }));
	                            })
	                            : targetUnitRegions[partnerId].map(function (item) {
	                                return (React.createElement(material_ui_1.MenuItem, { value: item.id, primaryText: item.name, key: item.id }));
	                            }))),
	                React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                    React.createElement(material_ui_1.TextField, { value: title, floatingLabelText: "Title", onChange: function (e, value) { return _this.onSettingChange('title', value); }, errorText: errors.title, fullWidth: true }),
	                    React.createElement(material_ui_1.TextField, { value: body, floatingLabelText: "Body", multiLine: true, rows: 1, fullWidth: true, rowsMax: 4, errorText: errors.body, onChange: function (e, value) { return _this.onSettingChange('body', value); } })),
	                React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                    React.createElement(material_ui_1.TextField, { value: image, floatingLabelText: "Image Url", fullWidth: true, errorText: errors.image, onChange: function (e, value) { return _this.onSettingChange('image', value); } }),
	                    React.createElement("div", null)),
	                (!multipleCtas || topicView) && (React.createElement("div", null,
	                    React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                        React.createElement(RadioButton_1.RadioButtonGroup, { style: styles.radioButtonGroup, name: "actionType", defaultSelected: actionType, onChange: this.handleActionTypeChange },
	                            React.createElement(RadioButton_1.RadioButton, { value: "urlLink", label: "Url Link", style: styles.radioButton }),
	                            React.createElement(RadioButton_1.RadioButton, { value: "deepLink", label: "Deep Link", style: styles.radioButton })),
	                        React.createElement("div", null)),
	                    React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                        React.createElement("div", null,
	                            actionType === 'deepLink' && (React.createElement(material_ui_1.SelectField, { floatingLabelText: "Deep Link", fullWidth: true, value: deeplink, onChange: function (event, index, value) {
	                                    return _this.onSettingChange('deeplink', value);
	                                }, disabled: partnerId === '-1' },
	                                React.createElement(material_ui_1.MenuItem, { value: '-1', primaryText: 'Select DeepLink', key: 'emptydeeplink' }),
	                                deepLinkMap[partnerId].map(function (item) {
	                                    return (React.createElement(material_ui_1.MenuItem, { value: item.value, primaryText: item.name, key: item.value }));
	                                }))),
	                            actionType === 'urlLink' && (React.createElement(material_ui_1.TextField, { fullWidth: true, hintText: "Url Link", value: urlLink, errorText: errors.urlLink, floatingLabelText: "Url Link", onChange: function (e, value) { return _this.onUrlLinkChange(value); } }))),
	                        React.createElement("div", null,
	                            deeplink.includes('glance_id') &&
	                                actionType === 'deepLink' && (React.createElement(material_ui_1.TextField, { fullWidth: true, hintText: "Glance Id", value: glanceId, floatingLabelText: "Glance Id", onChange: function (e, value) { return _this.onGlanceIdChange(value); } })),
	                            deeplink.includes('referrer') &&
	                                actionType === 'deepLink' && (React.createElement(material_ui_1.TextField, { fullWidth: true, hintText: "Referrer", value: referrer, floatingLabelText: "Referrer", onChange: function (e, value) { return _this.onReferrerChange(value); } })))),
	                    React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                        React.createElement(material_ui_1.TextField, { fullWidth: true, hintText: "Action", value: action, floatingLabelText: "Action", onChange: function (e, value) { return _this.onSettingChange('action', value); } }),
	                        React.createElement("div", null)))),
	                !topicView && multipleCtas && (React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                    React.createElement(material_ui_1.TextField, { fullWidth: true, hintText: "CTA 1 Text", value: cta[0].text, errorText: errors.text0, floatingLabelText: "CTA 1 Text", onChange: function (e, value) { return _this.onCtaChange('text', value, 0); } }),
	                    React.createElement("div", null,
	                        React.createElement(material_ui_1.TextField, { fullWidth: true, hintText: "CTA 1 Link", value: cta[0].link, errorText: errors.link0, floatingLabelText: "CTA 1 Link", onChange: function (e, value) { return _this.onCtaChange('link', value, 0); }, style: styles.ctalinkInput }),
	                        !isOptionalCta && (React.createElement(material_ui_1.IconButton, { onClick: this.handleOptionalCtaClick, style: styles.ctaIconButton },
	                            React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.blue500, style: { fontSize: '2em' } }, "add")))))),
	                !topicView && multipleCtas && isOptionalCta && (React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                    React.createElement(material_ui_1.TextField, { fullWidth: true, hintText: "CTA 2 Text", value: cta[1].text, errorText: errors.text1, floatingLabelText: "CTA 2 Text", onChange: function (e, value) { return _this.onCtaChange('text', value, 1); } }),
	                    React.createElement("div", null,
	                        React.createElement(material_ui_1.TextField, { fullWidth: true, hintText: "CTA 2 Link", value: cta[1].link, errorText: errors.link1, floatingLabelText: "CTA 2 Link", onChange: function (e, value) { return _this.onCtaChange('link', value, 1); }, style: styles.ctalinkInput }),
	                        React.createElement(material_ui_1.IconButton, { onClick: this.handleOptionalCtaClick, style: styles.ctaIconButton },
	                            React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.blue500, style: { fontSize: '2em' } }, "remove"))))),
	                React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                    React.createElement(material_ui_1.Toggle, { label: "Alert", style: styles.alertStyle, toggled: alert, onToggle: function (e, value) { return _this.onSettingChange('alert', value); } }),
	                    React.createElement(material_ui_1.Toggle, { label: "Sticky", style: styles.alertStyle, toggled: sticky, onToggle: function (e, value) { return _this.onSettingChange('sticky', value); } })),
	                !topicView && (React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                    React.createElement(material_ui_1.Toggle, { label: "GlanceEnabled", style: styles.alertStyle, toggled: glanceEnabled, onToggle: function (e, value) {
	                            return _this.onSettingChange('glanceEnabled', value);
	                        } }),
	                    React.createElement(material_ui_1.Toggle, { label: "MultipleCTA's", style: styles.alertStyle, toggled: multipleCtas, onToggle: function (e, value) { return _this.onMultipleCtas(); } }))),
	                React.createElement(material_ui_1.GridList, { cols: 2, padding: 10, cellHeight: "auto" },
	                    React.createElement(material_ui_1.RaisedButton, { label: isProcessing ? 'Testing...' : 'Test', fullWidth: true, style: styles.saveButtonStyle, onTouchTap: this.testNotification, disabled: !isValidForm || isProcessing }),
	                    React.createElement(material_ui_1.RaisedButton, { label: "Publish", fullWidth: true, primary: true, style: styles.saveButtonStyle, onTouchTap: this.openDialog, disabled: !isValidForm || isProcessing }))),
	            React.createElement(material_ui_1.Dialog, { actions: actions, modal: false, open: dialogOpen, contentStyle: styles.dialogContentStyle, onRequestClose: this.handleClose, autoScrollBodyContent: true },
	                React.createElement(List_1.List, null,
	                    React.createElement("h4", null, "Please Validate Below Details "),
	                    React.createElement(List_1.ListItem, { primaryText: "Partner", secondaryText: this.getPartner(partnerId) }),
	                    React.createElement(List_1.ListItem, { primaryText: "Region", secondaryText: regionId }),
	                    React.createElement(List_1.ListItem, { primaryText: "Title", secondaryText: title }),
	                    React.createElement(List_1.ListItem, { primaryText: "Body", secondaryText: body }),
	                    React.createElement(List_1.ListItem, { primaryText: 'Image Url', secondaryText: image }),
	                    (topicView || !multipleCtas) && (React.createElement(List_1.ListItem, { primaryText: actionType === 'deepLink' ? 'Deep Link' : 'Url Link', secondaryText: actionType === 'deepLink' ? deeplink : urlLink })),
	                    (topicView || !multipleCtas) && (React.createElement(List_1.ListItem, { primaryText: "Action", secondaryText: action })),
	                    !topicView && multipleCtas && (React.createElement(List_1.ListItem, { primaryText: "CTA Text 1", secondaryText: cta[0].text })),
	                    !topicView && multipleCtas && (React.createElement(List_1.ListItem, { primaryText: "CTA Link 1", secondaryText: cta[0].link })),
	                    !topicView && multipleCtas && isOptionalCta && (React.createElement(List_1.ListItem, { primaryText: "CTA Text 2", secondaryText: cta[1].text })),
	                    !topicView && multipleCtas && isOptionalCta && (React.createElement(List_1.ListItem, { primaryText: "CTA Link 2", secondaryText: cta[1].link })),
	                    React.createElement(List_1.ListItem, { primaryText: "Alert", secondaryText: alert ? 'On' : 'Off' }),
	                    React.createElement(List_1.ListItem, { primaryText: "Sticky", secondaryText: sticky ? 'On' : 'Off' }))),
	            React.createElement(material_ui_1.Dialog, { actions: successActions, modal: false, open: showSnackBar, onRequestClose: this.handleSuccessClose },
	                "Notification ",
	                notificationId,
	                " Sent Successfully")));
	    };
	    return Notification;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(Notification);


/***/ },

/***/ 989:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	__webpack_require__(110);
	var MediaQuery = __webpack_require__(123);
	var React = __webpack_require__(1);
	var GridList_1 = __webpack_require__(118);
	var Toolbar_1 = __webpack_require__(100);
	var colors_1 = __webpack_require__(18);
	var colors_2 = __webpack_require__(18);
	var Utils_1 = __webpack_require__(17);
	var Dialog_1 = __webpack_require__(55);
	var DropDownMenu_1 = __webpack_require__(69);
	var EmptyMessage_1 = __webpack_require__(153);
	var FlatButton_1 = __webpack_require__(49);
	var FontIcon_1 = __webpack_require__(50);
	var Glance_1 = __webpack_require__(246);
	var Loader_1 = __webpack_require__(154);
	var MenuItem_1 = __webpack_require__(51);
	var RaisedButton_1 = __webpack_require__(77);
	var react_paginate_1 = __webpack_require__(393);
	var RestService_1 = __webpack_require__(32);
	var Snackbar_1 = __webpack_require__(42);
	var Utils_2 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var removeIcon = React.createElement(FontIcon_1["default"], { className: 'material-icons' }, "delete");
	var approveIcon = React.createElement(FontIcon_1["default"], { className: 'material-icons' }, "check");
	var rejectIcon = React.createElement(FontIcon_1["default"], { className: 'material-icons' }, "remove_circle_outline");
	var styles = {
	    footer: {
	        position: 'fixed',
	        bottom: '0px',
	        paddingBottom: '10px',
	        paddingTop: '10px',
	        zIndex: 10,
	        backgroundColor: colors_2.grey800,
	        width: '90%',
	        maxWidth: '1400px',
	        display: 'inline-flex',
	        justifyContent: 'center',
	        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, visibility 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
	    },
	    footerButton: {
	        maxWidth: '232px',
	        flex: '1 1 0%',
	        marginLeft: '10px',
	        marginRight: '10px'
	    },
	    deleteButton: {
	        color: colors_2.red500,
	        background: colors_2.red300
	    },
	    disabledButton: {
	        backgroundColor: colors_2.grey500
	    },
	    loaderStyle: {
	        textAlign: 'center'
	    },
	    approveButton: {
	        color: colors_1.green500,
	        background: colors_1.green300
	    },
	    rejectButton: {
	        color: colors_1.orange500,
	        background: colors_1.orange300
	    }
	};
	var TypeFilter;
	(function (TypeFilter) {
	    TypeFilter[TypeFilter["ALL"] = 0] = "ALL";
	    TypeFilter[TypeFilter["WALLPAPER"] = 1] = "WALLPAPER";
	    TypeFilter[TypeFilter["STORY"] = 2] = "STORY";
	    TypeFilter[TypeFilter["SPONSORED"] = 3] = "SPONSORED";
	})(TypeFilter || (TypeFilter = {}));
	var StateFilter;
	(function (StateFilter) {
	    StateFilter[StateFilter["PENDING"] = 0] = "PENDING";
	    StateFilter[StateFilter["APPROVED"] = 1] = "APPROVED";
	    StateFilter[StateFilter["REJECTED"] = 2] = "REJECTED";
	    StateFilter[StateFilter["REMOVED"] = 3] = "REMOVED";
	})(StateFilter || (StateFilter = {}));
	var Action;
	(function (Action) {
	    Action[Action["APPROVE"] = 0] = "APPROVE";
	    Action[Action["REJECT"] = 1] = "REJECT";
	    Action[Action["REMOVE"] = 2] = "REMOVE";
	})(Action || (Action = {}));
	function getTypeFilterString(type) {
	    switch (type) {
	        case TypeFilter.ALL:
	            return 'Glances';
	        case TypeFilter.STORY:
	            return 'Stories';
	        case TypeFilter.WALLPAPER:
	            return 'Wallpapers';
	        case TypeFilter.SPONSORED:
	            return 'Sponsored';
	        default:
	            throw new TypeError('Unknown value ' + type);
	    }
	}
	var timer;
	var PartnerGlances = /** @class */ (function (_super) {
	    __extends(PartnerGlances, _super);
	    function PartnerGlances(props) {
	        var _this = _super.call(this, props) || this;
	        _this.searchHandler = function (event) {
	            if (timer) {
	                clearTimeout(timer);
	            }
	            ;
	            _this.setState(__assign({}, _this.state, { searchTerm: event.target.value }));
	            timer = setTimeout(function () {
	                _this.fetchGlances(true);
	            }, 800);
	        };
	        _this.searchButton = function () {
	            _this.fetchGlances(true);
	        };
	        _this.fetchGlances = function (resetPage) {
	            var _a = _this.state, regionFilter = _a.regionFilter, partner = _a.partner, perPage = _a.perPage, selectedPage = _a.selectedPage, expiryFilter = _a.expiryFilter, stateFilter = _a.stateFilter, typeFilter = _a.typeFilter, searchTerm = _a.searchTerm, languages = _a.languages;
	            var type = Utils_1.typeFilters[typeFilter];
	            var state = Utils_1.stateFilters[stateFilter];
	            var offset = resetPage ? 0 : (selectedPage - 1) * perPage;
	            var payload = {
	                limit: perPage,
	                offset: offset,
	                expired: expiryFilter,
	                state: state,
	                type: type,
	                region: regionFilter,
	                partner: partner,
	                search: searchTerm,
	                languages: languages
	            };
	            _this.setState(__assign({}, _this.state, { showLoader: true, selectedPage: resetPage ? 1 : selectedPage, selectedGlances: new Map() }));
	            RestService_1["default"].getPartnerPublishedGlances(payload).then(function (response) {
	                _this.setState(__assign({}, _this.state, { glancePairs: response.pairs, showLoader: false, totalGlances: response.count, snackbarMessage: 'Glances loaded', openSnackbar: true }));
	            })["catch"](function (error) {
	                _this.setState(__assign({}, _this.state, { snackbarMessage: 'Loading failed. Try refresh or Contant Glance Support.', openSnackbar: true, showLoader: false }));
	            });
	        };
	        _this.handleRegionFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(value, StateFilter.APPROVED, _this.state.typeFilter);
	            window.location.reload();
	        };
	        _this.handleTypeFilterChange = function (event, index, value) {
	            _this.setState(__assign({}, _this.state, { typeFilter: value }), function () { return _this.fetchGlances(true); });
	        };
	        _this.handleExpiryFilterChange = function (event, index, value) {
	            _this.setState(__assign({}, _this.state, { expiryFilter: value }), function () { return _this.fetchGlances(true); });
	        };
	        _this.handleLanguageFilterChange = function (event, index, value) {
	            if (value) {
	                _this.setState(__assign({}, _this.state, { languages: [value] }), function () { return _this.fetchGlances(true); });
	            }
	            else {
	                _this.setState(__assign({}, _this.state, { languages: [] }));
	            }
	        };
	        _this.handleStateFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(_this.state.regionFilter, value, _this.state.typeFilter);
	            var possibleActions = _this.getPossibleActions(value);
	            _this.setState(__assign({}, _this.state, { stateFilter: value, possibleActions: possibleActions }), function () { _this.fetchGlances(true); });
	        };
	        _this.getPossibleActions = function (stateFilter) {
	            if (stateFilter === void 0) { stateFilter = _this.state.stateFilter; }
	            var possibleActions;
	            switch (stateFilter) {
	                case StateFilter.APPROVED:
	                    possibleActions = [Action.REMOVE];
	                    break;
	                case StateFilter.PENDING:
	                    possibleActions = [Action.APPROVE, Action.REJECT];
	                    break;
	                case StateFilter.REJECTED:
	                case StateFilter.REMOVED:
	                default:
	                    possibleActions = [];
	            }
	            return possibleActions;
	        };
	        _this.onSelectGlance = function (element, selected) {
	            var newMap = new Map(_this.state.selectedGlances);
	            if (selected) {
	                newMap.set(element.data.glanceId, true);
	            }
	            else {
	                newMap["delete"](element.data.glanceId);
	            }
	            _this.setState(__assign({}, _this.state, { selectedGlances: newMap }));
	        };
	        _this.handleAction = function (action) {
	            _this.setState(__assign({}, _this.state, { actionClicked: action, openConfirmDialog: true }));
	        };
	        _this.handleActionConfirm = function (action) {
	            var selectedIds = [];
	            _this.state.selectedGlances.forEach(function (value, glanceId) {
	                selectedIds.push(glanceId);
	            });
	            _this.setState(__assign({}, _this.state, { snackbarMessage: 'Starting to ' + Action[action] + ' Glances ...', openSnackbar: true }));
	            switch (action) {
	                case Action.REMOVE:
	                    RestService_1["default"].removeGlances(_this.state.regionFilter, selectedIds, _this.state.partner, function (success) {
	                        _this.handleActionComplete(action, success);
	                    });
	                    break;
	                case Action.APPROVE:
	                    RestService_1["default"].approveGlances(_this.state.regionFilter, selectedIds, _this.state.partner, function (success) {
	                        _this.handleActionComplete(action, success);
	                    });
	                    break;
	                case Action.REJECT:
	                    RestService_1["default"].rejectGlances(_this.state.regionFilter, selectedIds, _this.state.partner, function (success) {
	                        _this.handleActionComplete(action, success);
	                    });
	                    break;
	                default:
	                    break;
	            }
	        };
	        _this.handleActionComplete = function (action, success) {
	            if (success) {
	                _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: 'Glance ' + Action[action] + ' done. Updating view...', openConfirmDialog: false, selectedGlances: new Map() }), function () {
	                    _this.fetchGlances(true);
	                });
	            }
	            else {
	                _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: 'Unable to ' + Action[action] + ' glances. Contact Glance Support.', openConfirmDialog: false }));
	            }
	        };
	        _this.closeConfirmDialog = function () {
	            _this.setState(__assign({}, _this.state, { openConfirmDialog: false }));
	        };
	        _this.closeSnackbar = function () {
	            _this.setState(__assign({}, _this.state, { openSnackbar: false }));
	        };
	        _this.onPageChange = function (page) {
	            _this.setState(__assign({}, _this.state, { selectedPage: page.selected + 1, selectedGlances: new Map() }), function () {
	                _this.fetchGlances(false);
	            });
	        };
	        _this.handleSelectAllClick = function () {
	            var newMap = new Map();
	            for (var _i = 0, _a = _this.state.glancePairs; _i < _a.length; _i++) {
	                var pair = _a[_i];
	                newMap.set(pair.data.glanceId, true);
	            }
	            _this.setState(__assign({}, _this.state, { selectedGlances: newMap }));
	        };
	        _this.isTranssionPartner = function () {
	            return _this.state.partner && _this.state.partner.name === 'Transsion';
	        };
	        var regionFilters = [];
	        var partner;
	        var _a = _this.props, params = _a.params, partnerMap = _a.partnerMap, studioAppConfig = _a.studioAppConfig, history = _a.history;
	        if (params && params.partnerId) {
	            partner = partnerMap.get(params.partnerId);
	        }
	        else if (partnerMap.size > 0) {
	            var partnerId = partnerMap.keys().next().value;
	            partner = partnerMap.get(partnerId);
	            history.push('/partner/' + partnerId);
	        }
	        else {
	            partner = studioAppConfig.currentToken.partner;
	        }
	        var partnerMeta;
	        studioAppConfig.partnerMetas.forEach(function (item) {
	            if (partner) {
	                if (item.partnerId == partner.partnerId) {
	                    partnerMeta = item;
	                    item.supportedRegions.forEach(function (item) {
	                        regionFilters.push(item);
	                    });
	                }
	            }
	        });
	        _this.state = {
	            partner: partner,
	            partnerMeta: partnerMeta,
	            regionFilter: null,
	            stateFilter: StateFilter.APPROVED,
	            possibleActions: [],
	            partnerFilter: null,
	            typeFilterString: 'Stories',
	            typeFilter: TypeFilter.STORY,
	            expiryFilter: false,
	            openConfirmDialog: false,
	            isSponsoredEnabled: false,
	            glancePairs: [],
	            totalGlances: 0,
	            selectedPage: 1,
	            showLoader: true,
	            selectedGlances: new Map(),
	            regionFilters: regionFilters,
	            openSnackbar: true,
	            snackbarMessage: 'Please select a region first',
	            showActive: false,
	            perPage: 28,
	            searchTerm: '',
	            languages: []
	        };
	        return _this;
	    }
	    PartnerGlances.prototype.componentWillMount = function () {
	        var _this = this;
	        if (!this.props.studioAppConfig) {
	            this.props.history.push('/login');
	        }
	        var _a = this.props, params = _a.params, partnerMap = _a.partnerMap, studioAppConfig = _a.studioAppConfig, history = _a.history;
	        if (params && params.region) {
	            var region = parseInt(this.props.params.region);
	            var filter = params.filter ? parseInt(params.filter) : StateFilter.APPROVED;
	            var typeFilter = params.type ? parseInt(params.type) : TypeFilter.STORY;
	            this.setState(__assign({}, this.state, { glancePairs: [], regionFilter: region, openSnackbar: true, snackbarMessage: 'Loading glances for region ' + Utils_2["default"].getReadableRegionName(region) + ' ...', stateFilter: filter, typeFilter: typeFilter, typeFilterString: getTypeFilterString(typeFilter) }), function () {
	                _this.fetchGlances(true);
	            });
	        }
	        else if (this.state.regionFilters.length == 1) {
	            var region = this.state.regionFilters[0];
	            this.props.history.push('/partner/' + this.state.partner.partnerId + '/published/' + region + '/' + Utils_2["default"].getReadableRegionName(region) + '/'
	                + StateFilter.APPROVED + '/' + StateFilter[StateFilter.APPROVED]);
	            window.location.reload();
	        }
	    };
	    PartnerGlances.prototype.componentDidMount = function () {
	        var possibleActions = this.getPossibleActions();
	        this.setState(__assign({}, this.state, { possibleActions: possibleActions }));
	    };
	    PartnerGlances.prototype.pushFilterUrl = function (region, state, type) {
	        var url = '/partner/' + this.state.partner.partnerId + '/published/' + region + '/' + Utils_2["default"].getReadableRegionName(region) + '/'
	            + state + '/' + StateFilter[state] + '/' + type + '/' + TypeFilter[type];
	        this.props.history.push(url);
	    };
	    PartnerGlances.prototype.render = function () {
	        var _this = this;
	        var actions = [];
	        var _a = this.state, selectedPage = _a.selectedPage, glancePairs = _a.glancePairs, regionFilters = _a.regionFilters, showLoader = _a.showLoader, totalGlances = _a.totalGlances, perPage = _a.perPage;
	        var paginationElement = [];
	        if (totalGlances > perPage) {
	            paginationElement.push(React.createElement(react_paginate_1["default"], { previousLabel: 'Previous', nextLabel: 'Next', breakLabel: React.createElement("span", { className: 'gap' }, "..."), pageCount: Math.ceil(totalGlances / perPage), onPageChange: this.onPageChange, forcePage: selectedPage, containerClassName: 'pagination', previousLinkClassName: 'previous_page', nextLinkClassName: 'next_page', disabledClassName: 'disabled', activeClassName: 'active' }));
	        }
	        actions.push(React.createElement(FlatButton_1["default"], { label: 'Cancel', primary: true, onClick: this.closeConfirmDialog }));
	        actions.push(React.createElement(FlatButton_1["default"], { label: 'Yes, ' + Action[this.state.actionClicked], primary: true, onClick: function () { return _this.handleActionConfirm(_this.state.actionClicked); } }));
	        return (React.createElement("div", null,
	            !this.state.regionFilter ?
	                React.createElement(Toolbar_1.Toolbar, { style: { marginTop: '2%' } },
	                    React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true },
	                        React.createElement(DropDownMenu_1["default"], { value: this.state.regionFilter, onChange: this.handleRegionFilterChange },
	                            regionFilters.length > 1 ?
	                                React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Click here to select your region' })
	                                : '',
	                            regionFilters.map(function (item) {
	                                return React.createElement(MenuItem_1["default"], { value: item, primaryText: Utils_2["default"].getReadableRegionName(item), key: item });
	                            })))) :
	                React.createElement("div", null,
	                    React.createElement(Toolbar_1.Toolbar, { style: { marginTop: '2%' } },
	                        React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true },
	                            React.createElement(Toolbar_1.ToolbarTitle, { text: 'Filters', style: { marginLeft: '10px' } }),
	                            React.createElement(Toolbar_1.ToolbarSeparator, null),
	                            React.createElement(DropDownMenu_1["default"], { value: this.state.regionFilter, onChange: this.handleRegionFilterChange },
	                                regionFilters.length > 1 && !this.state.regionFilter ?
	                                    React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Select your region' })
	                                    : '',
	                                regionFilters.map(function (item) {
	                                    return React.createElement(MenuItem_1["default"], { value: item, primaryText: Utils_2["default"].getReadableRegionName(item), key: item });
	                                })),
	                            this.state.partnerMeta.autoApprove ?
	                                React.createElement(DropDownMenu_1["default"], { value: this.state.stateFilter, onChange: this.handleStateFilterChange },
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.APPROVED, primaryText: 'Active Glances' }),
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.REMOVED, primaryText: 'Removed Glances' })) :
	                                React.createElement(DropDownMenu_1["default"], { value: this.state.stateFilter, onChange: this.handleStateFilterChange },
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.PENDING, primaryText: 'Pending Approval' }),
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.APPROVED, primaryText: 'Approved Glances' }),
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.REJECTED, primaryText: 'Rejected Glances' }),
	                                    React.createElement(MenuItem_1["default"], { value: StateFilter.REMOVED, primaryText: 'Removed Glances' })),
	                            React.createElement(MediaQuery, { query: '(min-device-width: 1224px)', style: { marginTop: '2%' } },
	                                React.createElement(DropDownMenu_1["default"], { value: this.state.typeFilter, onChange: this.handleTypeFilterChange },
	                                    React.createElement(MenuItem_1["default"], { value: TypeFilter.ALL, primaryText: 'Everything' }),
	                                    React.createElement(MenuItem_1["default"], { value: TypeFilter.STORY, primaryText: 'Stories' }),
	                                    React.createElement(MenuItem_1["default"], { value: TypeFilter.WALLPAPER, primaryText: 'Wallpapers' }),
	                                    this.state.partnerMeta && this.state.partnerMeta.isSponsoredEnabled ?
	                                        React.createElement(MenuItem_1["default"], { value: TypeFilter.SPONSORED, primaryText: 'Sponsored' }) : ''),
	                                React.createElement(DropDownMenu_1["default"], { value: this.state.expiryFilter, onChange: this.handleExpiryFilterChange },
	                                    React.createElement(MenuItem_1["default"], { value: false, primaryText: 'Active Glances' }),
	                                    React.createElement(MenuItem_1["default"], { value: true, primaryText: 'Expired Glances' })),
	                                this.isTranssionPartner() ? (React.createElement(DropDownMenu_1["default"], { value: this.state.languages.length > 0 ? this.state.languages[0] : null, onChange: this.handleLanguageFilterChange },
	                                    React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Language' }),
	                                    this.props.studioAppConfig.glanceLanguages.map(function (language) { return (React.createElement(MenuItem_1["default"], { key: language.id, value: language.id, primaryText: language.displayName })); }))) : null,
	                                this.isTranssionPartner() ? (React.createElement("div", { className: "wrap partner transsion" },
	                                    React.createElement("div", { className: 'search' },
	                                        React.createElement("input", { type: 'text', value: this.state.searchTerm, onChange: this.searchHandler, placeholder: 'Search...', className: 'searchTerm' }),
	                                        React.createElement("div", null, totalGlances),
	                                        React.createElement("button", { type: 'submit', className: 'searchButton', onClick: this.searchButton },
	                                            React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20' },
	                                                React.createElement("path", { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })))))) : null)),
	                        React.createElement(MediaQuery, { query: '(min-device-width: 1224px)' }, this.state.stateFilter == StateFilter.PENDING
	                            || this.state.stateFilter == StateFilter.APPROVED ?
	                            React.createElement(Toolbar_1.ToolbarGroup, null,
	                                React.createElement(RaisedButton_1["default"], { label: 'Select All ' + this.state.typeFilterString, primary: true, onClick: this.handleSelectAllClick, disabled: glancePairs.length === 0 || showLoader })) : '')),
	                    React.createElement(MediaQuery, { query: '(max-device-width: 1224px)' },
	                        React.createElement(Toolbar_1.Toolbar, { style: { marginTop: '2%' } },
	                            React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true, style: { margin: 0 } },
	                                React.createElement(DropDownMenu_1["default"], { value: this.state.typeFilter, onChange: this.handleTypeFilterChange, style: { marginRight: 0 } },
	                                    React.createElement(MenuItem_1["default"], { value: TypeFilter.ALL, primaryText: 'Everything' }),
	                                    React.createElement(MenuItem_1["default"], { value: TypeFilter.STORY, primaryText: 'Stories' }),
	                                    React.createElement(MenuItem_1["default"], { value: TypeFilter.WALLPAPER, primaryText: 'Wallpapers' }),
	                                    this.state.partnerMeta && this.state.partnerMeta.isSponsoredEnabled ?
	                                        React.createElement(MenuItem_1["default"], { value: TypeFilter.SPONSORED, primaryText: 'Sponsored' }) : ''),
	                                React.createElement(DropDownMenu_1["default"], { value: this.state.expiryFilter, onChange: this.handleExpiryFilterChange, style: { marginRight: 0 } },
	                                    React.createElement(MenuItem_1["default"], { value: false, primaryText: 'Active Glances' }),
	                                    React.createElement(MenuItem_1["default"], { value: true, primaryText: 'Expired Glances' })),
	                                this.isTranssionPartner() ? (React.createElement(DropDownMenu_1["default"], { value: this.state.languages.length > 0 ? this.state.languages[0] : null, onChange: this.handleLanguageFilterChange },
	                                    React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Language' }),
	                                    this.props.studioAppConfig.glanceLanguages.map(function (language) { return (React.createElement(MenuItem_1["default"], { key: language.id, value: language.id, primaryText: language.displayName })); }))) : null,
	                                this.isTranssionPartner() ? (React.createElement("div", { className: "wrap partner transsion" },
	                                    React.createElement("div", { className: 'search' },
	                                        React.createElement("input", { type: 'text', value: this.state.searchTerm, onChange: this.searchHandler, placeholder: 'Search...', className: 'searchTerm' }),
	                                        React.createElement("div", null, totalGlances),
	                                        React.createElement("button", { type: 'submit', className: 'searchButton', onClick: this.searchButton },
	                                            React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20' },
	                                                React.createElement("path", { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })))))) : null,
	                                this.state.stateFilter == StateFilter.PENDING
	                                    || this.state.stateFilter == StateFilter.APPROVED
	                                    ? React.createElement(RaisedButton_1["default"], { label: 'Select All ' + this.state.typeFilterString, primary: true, onClick: this.handleSelectAllClick, disabled: glancePairs.length === 0 || showLoader })
	                                    : '')))),
	            this.state.regionFilter && (React.createElement(Loader_1["default"], { show: showLoader, message: 'Loading Glances' }, this.state.glancePairs && this.state.glancePairs.length > 0 ?
	                React.createElement("div", null,
	                    React.createElement(MediaQuery, { query: '(min-device-width: 1224px)' },
	                        React.createElement(GridList_1.GridList, { style: { width: '100%', margin: '0 auto', marginTop: '2%' }, cols: 4, padding: 15, cellHeight: 'auto' }, this.state.glancePairs.map(function (element) {
	                            return (React.createElement(GridList_1.GridTile, { key: element.data.glanceId, containerElement: React.createElement(Glance_1["default"], { glance: element, selected: _this.state.selectedGlances.get(element.data.glanceId), partner: _this.state.partner, region: _this.state.regionFilter, onSelect: function (selected) { return _this.onSelectGlance(element, selected); } }) }));
	                        }))),
	                    React.createElement(MediaQuery, { query: '(max-device-width: 1224px)' },
	                        React.createElement(GridList_1.GridList, { style: { width: '100%', margin: '0 auto', marginTop: '2%' }, cols: 2, cellHeight: 'auto' }, this.state.glancePairs.map(function (element) {
	                            return (React.createElement(GridList_1.GridTile, { key: element.data.glanceId, containerElement: React.createElement(Glance_1["default"], { glance: element, selected: _this.state.selectedGlances.get(element.data.glanceId), partner: _this.state.partner, region: _this.state.regionFilter, onSelect: function (selected) { return _this.onSelectGlance(element, selected); } }) }));
	                        })))) : React.createElement(EmptyMessage_1["default"], { message: 'No glances for selected filters' }))),
	            !this.state.regionFilter ?
	                React.createElement(EmptyMessage_1["default"], { message: this.state.snackbarMessage })
	                : '',
	            totalGlances > perPage && React.createElement("div", { id: 'react-paginate' },
	                React.createElement(react_paginate_1["default"], { previousLabel: 'Previous', nextLabel: 'Next', pageRangeDisplayed: 3, marginPagesDisplayed: 3, breakLabel: React.createElement("span", { className: 'gap' }, "..."), pageCount: Math.ceil(totalGlances / perPage), onPageChange: this.onPageChange, forcePage: selectedPage - 1, activeClassName: 'active' })),
	            this.state.possibleActions && this.state.selectedGlances && this.state.selectedGlances.size > 0 ?
	                React.createElement("div", { style: styles.footer },
	                    React.createElement(RaisedButton_1["default"], { icon: removeIcon, label: 'Remove Selected (' + this.state.selectedGlances.size + ')', primary: true, buttonStyle: this.state.possibleActions.indexOf(Action.REMOVE) < 0 ? styles.disabledButton : styles.deleteButton, style: styles.footerButton, onClick: function () { return _this.handleAction(Action.REMOVE); }, disabled: this.state.possibleActions.indexOf(Action.REMOVE) < 0 }),
	                    this.state.partnerMeta.autoApprove ? '' :
	                        React.createElement(RaisedButton_1["default"], { label: 'Approve Selected (' + this.state.selectedGlances.size + ')', icon: approveIcon, primary: true, buttonStyle: this.state.possibleActions.indexOf(Action.APPROVE) < 0 ? styles.disabledButton : styles.approveButton, style: styles.footerButton, onClick: function () { return _this.handleAction(Action.APPROVE); }, disabled: this.state.possibleActions.indexOf(Action.APPROVE) < 0 }),
	                    this.state.partnerMeta.autoApprove ? '' :
	                        React.createElement(RaisedButton_1["default"], { label: 'Reject Selected (' + this.state.selectedGlances.size + ')', icon: rejectIcon, primary: true, buttonStyle: this.state.possibleActions.indexOf(Action.REJECT) < 0 ? styles.disabledButton : styles.rejectButton, style: styles.footerButton, onClick: function () { return _this.handleAction(Action.REJECT); }, disabled: this.state.possibleActions.indexOf(Action.APPROVE) < 0 })) : '',
	            React.createElement(Dialog_1["default"], { modal: false, open: this.state.openConfirmDialog, onRequestClose: this.closeConfirmDialog, actions: actions },
	                "Please confirm that you want to ",
	                Action[this.state.actionClicked],
	                " these glances."),
	            React.createElement(Snackbar_1["default"], { open: this.state.openSnackbar, message: this.state.snackbarMessage, onRequestClose: this.closeSnackbar, autoHideDuration: 2000 })));
	    };
	    return PartnerGlances;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(PartnerGlances);


/***/ },

/***/ 990:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var Utils_1 = __webpack_require__(17);
	var styles = {
	    videoWrapper: {
	        position: 'relative',
	        paddingBottom: '56.25%',
	        paddingTop: '25px',
	        height: 0
	    },
	    instaWrppaer: {
	        position: 'relative',
	        paddingBottom: '140%',
	        paddingTop: '25px',
	        height: 0
	    },
	    iframe: {
	        position: 'absolute',
	        top: '5%',
	        left: 0,
	        width: '100%',
	        height: '80%'
	    }
	};
	var PeekView = /** @class */ (function (_super) {
	    __extends(PeekView, _super);
	    function PeekView() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PeekView.prototype.render = function () {
	        var params = this.props.params;
	        var content;
	        if (params) {
	            switch (params.type) {
	                case 'facebook':
	                    content = (React.createElement("div", { style: styles.videoWrapper },
	                        React.createElement("iframe", { src: 'https://www.facebook.com/video/embed?video_id=' + params.id, width: '500', height: '280', style: styles.iframe, scrolling: 'no', frameBorder: '0', allowTransparency: true })));
	                    break;
	                case 'youtube':
	                    content = (React.createElement("div", { style: styles.videoWrapper },
	                        React.createElement("iframe", { style: styles.iframe, width: '560', height: '349', src: 'https://www.youtube.com/embed/' + params.id + '?autoplay=1', frameBorder: '0', allowFullScreen: true, autoPlay: true })));
	                    break;
	                case 'instagram':
	                    content = (React.createElement("div", { style: styles.instaWrppaer },
	                        React.createElement("iframe", { style: styles.iframe, width: '560', height: '349', src: '//instagram.com/p/' + params.id + '/embed/?autoplay=1', frameBorder: '0', allowFullScreen: true, autoPlay: true })));
	                    break;
	                case 'youku':
	                    content = (React.createElement("div", { style: styles.videoWrapper },
	                        React.createElement("iframe", { style: styles.iframe, width: '560', height: '349', src: 'http://player.youku.com/embed/' + params.id, frameBorder: '0', allowFullScreen: true, autoPlay: true })));
	                    break;
	                case 'native':
	                    content = (React.createElement("div", { style: styles.videoWrapper },
	                        React.createElement("iframe", { style: styles.iframe, width: '560', height: '349', src: Utils_1["default"].getParameterByName('url'), frameBorder: '0', allowFullScreen: true, autoPlay: true })));
	                    break;
	            }
	        }
	        return (React.createElement("div", { style: { width: '50%', margin: 'auto' } }, content));
	    };
	    return PeekView;
	}(React.Component));
	exports["default"] = PeekView;


/***/ },

/***/ 991:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var styles = {
	    inputBox: {
	        width: '90%',
	        padding: '8px 17px',
	        border: '2px solid grey',
	        borderTopLeftRadius: '4px',
	        borderBottomLeftRadius: '4px',
	        borderTopRightRadius: '4px',
	        borderBottomRightRadius: '4px'
	    }
	};
	var PublisherInsertForm = /** @class */ (function (_super) {
	    __extends(PublisherInsertForm, _super);
	    function PublisherInsertForm(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            row: {},
	            publisherPropositionType: 'APP_INSTALL',
	            fields: {},
	            errors: {}
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        _this.handleSaveBtnClick = _this.handleSaveBtnClick.bind(_this);
	        _this.updateInputValue = _this.updateInputValue.bind(_this);
	        _this.handleValidation = _this.handleValidation.bind(_this);
	        return _this;
	    }
	    PublisherInsertForm.prototype.handleChange = function (event) {
	        this.state.publisherPropositionType = event.target.value;
	        this.state.row['propositionType'] = this.state.publisherPropositionType;
	        this.setState(__assign({}, this.state));
	    };
	    PublisherInsertForm.prototype.updateInputValue = function (event) {
	        this.state.row[event.target.name] = event.target.value;
	        this.setState(__assign({}, this.state));
	    };
	    PublisherInsertForm.prototype.handleSaveBtnClick = function () {
	        this.state.row['propositionType'] = this.state.publisherPropositionType;
	        this.props.onSave(this.state.row);
	    };
	    PublisherInsertForm.prototype.handleValidation = function () {
	        var fields = this.state.row;
	        var errors = {};
	        var formIsValid = true;
	        var nameRegExp = new RegExp('^[a-z0-9A-Z_\\s]+$');
	        if (!fields['displayName'] || !nameRegExp.test(fields['displayName'])) {
	            formIsValid = false;
	            errors['displayName'] = 'INVALID USER NAME';
	        }
	        if (!fields['name'] || !nameRegExp.test(fields['name'])) {
	            formIsValid = false;
	            errors['name'] = 'INVALID NAME';
	        }
	        var propositionsTypes = ['CTA_URL', 'APP_INSTALL', 'NO_PROPOSITION'];
	        var packageNameRegExp = new RegExp('^((\\w+)(\\.))+(\\w+)$');
	        var urlRegExp = new RegExp('^http(s)?://([\\w-]+\\.)+[\\w-]+(/[\\w- ./?%&amp;=]*)?$');
	        if (fields['propositionType'] == 'APP_INSTALL') {
	            if (!fields['url'] || !urlRegExp.test(fields['url'])) {
	                formIsValid = false;
	                errors['url'] = 'INVALID URL';
	            }
	            if (!fields['packageName'] || !packageNameRegExp.test(fields['packageName'])) {
	                formIsValid = false;
	                errors['packageName'] = 'INVALID PACKAGE NAME';
	            }
	        }
	        if (fields['propositionType'] == 'CTA_URL') {
	            if (!fields['url'] || !urlRegExp.test(fields['url'])) {
	                formIsValid = false;
	                errors['url'] = 'INVALID URL';
	            }
	        }
	        this.setState(__assign({}, this.state, { errors: errors }));
	        return formIsValid;
	    };
	    PublisherInsertForm.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, onModalClose = _a.onModalClose, onSave = _a.onSave, columns = _a.columns, validateState = _a.validateState, ignoreEditable = _a.ignoreEditable;
	        return (React.createElement("div", { className: 'modal-content' },
	            React.createElement("h2", { style: {
	                    marginLeft: '26%',
	                    marginTop: '40px',
	                    color: '#0dc1e5'
	                } }, "Insert New Row"),
	            React.createElement("div", { style: { marginLeft: '20px', marginTop: '30px' } }, columns.map(function (column, i) {
	                var editable = column.editable, format = column.format, field = column.field, name = column.name, hiddenOnInsert = column.hiddenOnInsert;
	                if (field == 'displayName' || field == 'name')
	                    return (React.createElement("div", { className: 'form-group', key: field },
	                        React.createElement("label", null,
	                            name,
	                            " : "),
	                        React.createElement("br", null),
	                        React.createElement("input", { style: styles.inputBox, value: _this.state.row[field], ref: field, type: 'text', defaultValue: '', name: field, onChange: _this.updateInputValue.bind(_this) }),
	                        React.createElement("br", null),
	                        React.createElement("span", { style: { color: 'red' } }, _this.state.errors[field])));
	                if (field == 'propositionType')
	                    return (React.createElement("div", { className: 'form-group', key: field },
	                        React.createElement("label", null,
	                            name,
	                            " : "),
	                        React.createElement("select", { style: {
	                                marginLeft: '20px',
	                                marginTop: '20px'
	                            }, value: _this.state.row[field], ref: field, name: field, onChange: _this.handleChange },
	                            React.createElement("option", { value: 'CTA_URL' }, "CTA_URL"),
	                            React.createElement("option", { selected: true, value: 'APP_INSTALL' }, "APP_INSTALL"),
	                            React.createElement("option", { value: 'NoProposition' }, "No Proposition"))));
	                if (_this.state.publisherPropositionType == 'APP_INSTALL' &&
	                    field == 'packageName')
	                    return (React.createElement("div", { className: 'form-group', key: field },
	                        React.createElement("label", null,
	                            name,
	                            " : "),
	                        React.createElement("input", { style: styles.inputBox, value: _this.state.row[field], ref: field, type: 'text', name: field, defaultValue: '', onChange: _this.updateInputValue }),
	                        React.createElement("br", null),
	                        React.createElement("span", { style: { color: 'red' } }, _this.state.errors[field])));
	                if ((_this.state.publisherPropositionType == 'APP_INSTALL' ||
	                    _this.state.publisherPropositionType == 'CTA_URL') &&
	                    field == 'url')
	                    return (React.createElement("div", { className: 'form-group', key: field },
	                        React.createElement("label", null,
	                            name,
	                            " : "),
	                        React.createElement("br", null),
	                        React.createElement("input", { style: styles.inputBox, value: _this.state.row[field], ref: field, type: 'text', name: field, defaultValue: '', onChange: _this.updateInputValue }),
	                        React.createElement("br", null),
	                        React.createElement("span", { style: { color: 'red' } }, _this.state.errors[field])));
	                if (field == 'logoUrl')
	                    return (React.createElement("div", { className: "form-group", key: field },
	                        React.createElement("label", null,
	                            name,
	                            " : "),
	                        React.createElement("br", null),
	                        React.createElement("input", { style: styles.inputBox, value: _this.state.row[field], ref: field, type: "text", name: field, defaultValue: '', onChange: _this.updateInputValue }),
	                        React.createElement("br", null),
	                        React.createElement("span", { style: { color: 'red' } }, _this.state.errors[field])));
	            })),
	            React.createElement("div", null,
	                React.createElement("button", { style: {
	                        marginTop: '30px',
	                        marginBottom: '50px',
	                        marginLeft: '30%'
	                    }, className: 'btn btn-danger', onClick: onModalClose }, "Cancel"),
	                React.createElement("button", { style: {
	                        marginTop: '30px',
	                        marginBottom: '50px',
	                        marginLeft: '5%'
	                    }, className: 'btn btn-success', onClick: function () { return _this.handleSaveBtnClick(); } }, "Confirm"))));
	    };
	    return PublisherInsertForm;
	}(React.Component));
	exports["default"] = PublisherInsertForm;


/***/ },

/***/ 992:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	__webpack_require__(423);
	var CryptoJs = __webpack_require__(268);
	var React = __webpack_require__(1);
	var react_bootstrap_table_1 = __webpack_require__(217);
	var JerseyRestApiService_1 = __webpack_require__(83);
	var PublisherInsertForm_1 = __webpack_require__(991);
	var Snackbar_1 = __webpack_require__(42);
	var Publishers = /** @class */ (function (_super) {
	    __extends(Publishers, _super);
	    function Publishers() {
	        var _this = _super.call(this) || this;
	        _this.getPublishers = function () {
	            JerseyRestApiService_1["default"].getAllActivePublishers(function (publisherTable) {
	                _this.parseData(publisherTable);
	            });
	        };
	        _this.parseData = function (tableData) {
	            var pubList = [];
	            for (var pub in tableData) {
	                pubList[pub] = JSON.parse(JSON.stringify(tableData[pub]));
	                if (pubList[pub]['propositions'] && pubList[pub]['propositions'][0] && pubList[pub]['propositions'][0]['ctaUrl']) {
	                    pubList[pub]['url'] = pubList[pub]['propositions'][0]['ctaUrl'];
	                    pubList[pub]['packageName'] = '';
	                    pubList[pub]['propositionType'] = 'CTA_URL';
	                }
	                else if (pubList[pub]['propositions'] && pubList[pub]['propositions'][0] && pubList[pub]['propositions'][0]['appInstallMeta']) {
	                    pubList[pub]['packageName'] = pubList[pub]['propositions'][0]['appInstallMeta']['packageName'];
	                    pubList[pub]['url'] = pubList[pub]['propositions'][0]['appInstallMeta']['appBundleUrl'];
	                    pubList[pub]['propositionType'] = 'APP_INSTALL';
	                }
	                else {
	                    pubList[pub]['displayProposition'] = '';
	                    pubList[pub]['propositionType'] = 'NO_PROPOSITIONS';
	                    pubList[pub]['url'] = '';
	                    pubList[pub]['packageName'] = '';
	                }
	                pubList[pub]['updated'] = false;
	            }
	            _this.setState(__assign({}, _this.state, { processedTable: pubList }));
	        };
	        _this.onDeleteRow = function (row, fullrow) {
	            row.forEach(function (value, index, array) {
	                JerseyRestApiService_1["default"].removePublisher(value);
	            });
	        };
	        _this.toJsonObject = function (row) {
	            row['id'] = CryptoJs.MD5(JSON.stringify(row)).toString().slice(0, 10);
	            row['active'] = true;
	            switch (row['propositionType']) {
	                case 'CTA_URL':
	                    row['propositions'] = [
	                        {
	                            appInstallMeta: null,
	                            ctaUrl: row['url'],
	                            type: 'CTA_URL'
	                        },
	                    ];
	                    break;
	                case 'APP_INSTALL':
	                    row['propositions'] = [
	                        {
	                            appInstallMeta: {
	                                packageName: row['packageName'],
	                                appBundleUrl: row['url']
	                            },
	                            ctaUrl: null,
	                            type: 'APP_INSTALL'
	                        },
	                    ];
	                    break;
	                default:
	                    row['propositions'] = [];
	                    break;
	            }
	            return row;
	        };
	        _this.handleInsertedRow = function (row) {
	            JerseyRestApiService_1["default"].addPublisher(JSON.stringify(_this.toJsonObject(row)), function (response) {
	                _this.getPublishers();
	            });
	        };
	        _this.onBeforeSaveCell = function (row, cellName, cellValue) {
	            var updatedObject = _this.state.processedTable.find(function (object) {
	                return object['id'] == row['id'];
	            });
	            updatedObject[cellName] = cellValue;
	            updatedObject['updated'] = true;
	            _this.setState(__assign({}, _this.state));
	            return false;
	        };
	        _this.handleClose = function () {
	            _this.setState(__assign({}, _this.state, { openSnackBar: false }));
	        };
	        _this.validation = function (cellName, cellValue) {
	            if (cellName == 'displayName') {
	                var regexp = new RegExp('^[a-z0-9A-Z_\\s]+$');
	                if (!regexp.test(cellValue)) {
	                    _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: 'Please Provide correct DisplayName' }));
	                }
	                return regexp.test(cellValue);
	            }
	            else if (cellName == 'propositionType') {
	                var propositionsTypes = ['CTA_URL', 'APP_INSTALL', 'NO_PROPOSITION'];
	                if (!propositionsTypes.includes(cellValue)) {
	                    _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: 'Please Provide correct Proposition Type' }));
	                }
	                return propositionsTypes.includes(cellValue);
	            }
	            else if (cellName == 'packageName') {
	                var regexp = new RegExp('^((\\w+)(\\.))+(\\w+)$');
	                if (!regexp.test(cellValue)) {
	                    _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: 'Please Provide correct Package Name' }));
	                }
	                return regexp.test(cellValue);
	            }
	            else if (cellName == 'url') {
	                var regexp = new RegExp('^http(s)?://([\\w-]+\\.)+[\\w-]+(/[\\w- ./?%&amp;=]*)?$');
	                if (!regexp.test(cellValue)) {
	                    _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: 'Please Provide correct URL' }));
	                }
	                return regexp.test(cellValue);
	            }
	        };
	        _this.cellButton = function (cell, row, enumObject, rowIndex) {
	            if (row['updated']) {
	                return (React.createElement("button", { style: { backgroundColor: 'orangered', color: 'white' }, type: 'button', onClick: function () { return _this.updateRow(row); } }, "update"));
	            }
	            else {
	            }
	        };
	        _this.createCustomModal = function (onModalClose, onSave, columns, validateState, ignoreEditable) {
	            return (React.createElement(PublisherInsertForm_1["default"], { onModalClose: onModalClose, onSave: onSave, columns: columns, validateState: validateState, ignoreEditable: ignoreEditable }));
	        };
	        var cellEditProp = {
	            mode: 'dbclick',
	            blurToSave: true,
	            beforeSaveCell: _this.onBeforeSaveCell.bind(_this)
	        };
	        var option = {
	            onDeleteRow: _this.onDeleteRow,
	            onAddRow: _this.handleInsertedRow,
	            insertModal: _this.createCustomModal
	        };
	        var selectRow = {
	            mode: 'checkbox',
	            bgColor: 'pink',
	            className: 'my-selection-custom',
	            columnWidth: '50px'
	        };
	        _this.state = {
	            page: 1,
	            processedTable: [],
	            cellEditProp: cellEditProp,
	            option: option,
	            selectRow: selectRow,
	            openSnackBar: false,
	            snackBarMessage: ''
	        };
	        return _this;
	    }
	    Publishers.prototype.componentWillMount = function () {
	        this.getPublishers();
	    };
	    Publishers.prototype.toJsonObjectForUpdate = function (row) {
	        switch (row['propositionType']) {
	            case 'CTA_URL':
	                if (row['url'] == '') {
	                    return null;
	                }
	                row['propositions'] = [
	                    {
	                        appInstallMeta: null,
	                        ctaUrl: row['url'],
	                        type: 'CTA_URL'
	                    },
	                ];
	                break;
	            case 'APP_INSTALL':
	                if (row['url'] == '' || row['packageName'] == '') {
	                    return null;
	                }
	                row['propositions'] = [
	                    {
	                        appInstallMeta: {
	                            packageName: row['packageName'],
	                            appBundleUrl: row['url']
	                        },
	                        ctaUrl: null,
	                        type: 'APP_INSTALL'
	                    },
	                ];
	                break;
	            default:
	                row['propositions'] = [];
	                break;
	        }
	        return row;
	    };
	    Publishers.prototype.updateRow = function (row) {
	        var _this = this;
	        if (this.toJsonObjectForUpdate(row)) {
	            JerseyRestApiService_1["default"].updatePublisher(JSON.stringify(this.toJsonObjectForUpdate(row)), function (response) {
	                var updatedObject = _this.state.processedTable.find(function (object) {
	                    return object['id'] == row['id'];
	                });
	                updatedObject['updated'] = false;
	                _this.getPublishers();
	            });
	        }
	        else {
	            this.getPublishers();
	        }
	    };
	    Publishers.prototype.render = function () {
	        return (React.createElement("div", { style: { marginTop: '80px', width: '100%' } },
	            React.createElement(react_bootstrap_table_1.BootstrapTable, { ref: 'table', data: this.state.processedTable, cellEdit: this.state.cellEditProp, selectRow: this.state.selectRow, insertRow: true, options: this.state.option, deleteRow: true, hover: true, search: true },
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { isKey: true, dataField: 'id', width: '8%', hidden: true }, "ID"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'name', width: '8%', hidden: true }, "Name"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'displayName', width: '8%' }, "DisplayName"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'active', width: '5%', hidden: true, editable: { type: 'select', options: { values: [{ value: true, text: 'true' }, { value: false, text: 'false' }] } } }, "Active"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'propositionType', width: '10%', editable: { type: 'select', options: { values: [{ value: 'CTA_URL', 'text': 'CTA_URL' }, { value: 'APP_INSTALL', text: 'APP_INSTALL' }, { value: 'NO_PROPOSITION', text: 'No Proposition' }] } } }, "PropositionType"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'url', width: '25%' }, "URL(APP BUNDLE/CTA) "),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "logoUrl", width: "25%" }, "Publisher Logo URL "),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'packageName', width: '10%' }, "PackageName"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { required: true, dataField: 'primaryReserveCount', hidden: true, width: '10%' }, "primaryReserveCount"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'primaryReserveExpiryInDays', hidden: true, width: '10%' }, "PrimaryReserveExpiryInDays"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'secondaryReserveCount', hidden: true, width: '10%' }, "SecondaryReserveCount"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'secondaryReserveExpiryInDays', hidden: true, width: '10%' }, "SecondaryReserveExpiryInDays"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'button', width: '6%', autoValue: true, editable: false, dataFormat: this.cellButton }, "Update")),
	            React.createElement(Snackbar_1["default"], { open: this.state.openSnackBar, message: this.state.snackBarMessage, onRequestClose: this.handleClose, autoHideDuration: 2000 })));
	    };
	    return Publishers;
	}(React.Component));
	exports["default"] = Publishers;


/***/ },

/***/ 993:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var RestService_1 = __webpack_require__(32);
	var TextField_1 = __webpack_require__(56);
	var RaisedButton_1 = __webpack_require__(77);
	var FontIcon_1 = __webpack_require__(50);
	var Paper_1 = __webpack_require__(30);
	var colors_1 = __webpack_require__(18);
	var React = __webpack_require__(1);
	var getMuiTheme_1 = __webpack_require__(215);
	var MuiThemeProvider_1 = __webpack_require__(120);
	var spacing = {
	    iconSize: 24,
	    desktopGutter: 24,
	    desktopGutterMore: 32,
	    desktopGutterLess: 8,
	    desktopGutterMini: 8,
	    desktopKeylineIncrement: 60,
	    desktopDropDownMenuItemHeight: 32,
	    desktopDropDownMenuFontSize: 15,
	    desktopLeftNavMenuItemHeight: 30,
	    desktopSubheaderHeight: 48,
	    desktopToolbarHeight: 56
	};
	var muiTheme = getMuiTheme_1["default"]({
	    spacing: spacing
	});
	var styles = {
	    section: {
	        width: '100%',
	        height: '100%',
	        position: 'fixed',
	        backgroundColor: colors_1.cyan500,
	        display: 'flex',
	        maxWidth: 'none'
	    },
	    div: {
	        display: 'flex',
	        flexDirection: 'column',
	        justifyContent: 'flex-start',
	        resize: 'verticle',
	        width: '50%',
	        height: '70%',
	        margin: 'auto'
	    },
	    paper: {
	        padding: '3%',
	        textAlign: 'center',
	        display: 'block',
	        resize: 'verticle'
	    },
	    textField: {
	        width: '100%',
	        maxWidth: '300px',
	        display: 'block',
	        margin: 'auto'
	    },
	    raisedButton: {
	        margin: '2%',
	        marginTop: '4%',
	        marginBottom: '5%',
	        width: '50%'
	    }
	};
	var ResetPassword = /** @class */ (function (_super) {
	    __extends(ResetPassword, _super);
	    function ResetPassword(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleChange = function (event) {
	            var target = event.target;
	            var value = target.type === 'checkbox' ? target.checked : target.value;
	            var name = target.name;
	            var password, confirmPassword;
	            if (name == 'password') {
	                password = value;
	                confirmPassword = _this.state.confirmPassword;
	            }
	            else if (name == 'password_retype') {
	                password = _this.state.password;
	                confirmPassword = value;
	            }
	            var passmatch = password ? confirmPassword == password : false;
	            _this.setState(__assign({}, _this.state, { password: password, confirmPassword: confirmPassword, passwordMatch: passmatch }));
	        };
	        _this.state = {
	            passwordMatch: false
	        };
	        _this.onSubmit = _this.onSubmit.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        return _this;
	    }
	    ResetPassword.prototype.onSubmit = function () {
	        var that = this;
	        RestService_1["default"].generateHash(this.state.password, function (hash, error) {
	            if (hash) {
	                that.setState(__assign({}, that.state, { generatedHash: hash }));
	            }
	            else {
	                that.setState(__assign({}, that.state, { generatedHash: 'Error generating hash' }));
	            }
	        });
	    };
	    ResetPassword.prototype.render = function () {
	        var _this = this;
	        console.log(this.state);
	        return (React.createElement(MuiThemeProvider_1["default"], { muiTheme: muiTheme },
	            React.createElement("section", { style: styles.section },
	                React.createElement("div", { style: styles.div },
	                    React.createElement(Paper_1["default"], { style: styles.paper, zDepth: 3 },
	                        React.createElement("h3", null, "Reset Password"),
	                        React.createElement("form", { onSubmit: function (e) { e.preventDefault(); _this.onSubmit(); } },
	                            React.createElement(TextField_1["default"], { key: 'password', style: styles.textField, floatingLabelText: 'New Password', type: 'password', name: 'password', onChange: this.handleChange }),
	                            React.createElement(TextField_1["default"], { key: 'password_retype', style: styles.textField, floatingLabelText: 'Retype Password', type: 'password', name: 'password_retype', onChange: this.handleChange, errorText: !this.state.passwordMatch && (this.state.password ? true : false) ? 'Passwords do not match' : '' }),
	                            React.createElement(RaisedButton_1["default"], { label: 'Create Hash', type: 'submit', primary: true, style: styles.raisedButton, disabled: !this.state.passwordMatch, icon: React.createElement(FontIcon_1["default"], { className: 'material-icons' }, "vpn_key") })),
	                        this.state.generatedHash ?
	                            React.createElement("div", null,
	                                React.createElement("div", { style: { margin: '5px' } }, 'Hash: ' + this.state.generatedHash),
	                                React.createElement("span", { style: { margin: '5px' } }, "Mail the generated hash to glance-eng@glance.app"))
	                            : '')))));
	    };
	    return ResetPassword;
	}(React.Component));
	exports["default"] = ResetPassword;


/***/ },

/***/ 994:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var styles = {
	    inputBox: {
	        width: '90%',
	        padding: '8px 17px',
	        border: '2px solid grey',
	        borderTopLeftRadius: '4px',
	        borderBottomLeftRadius: '4px',
	        borderTopRightRadius: '4px',
	        borderBottomRightRadius: '4px'
	    }
	};
	var SegmentInsertForm = /** @class */ (function (_super) {
	    __extends(SegmentInsertForm, _super);
	    function SegmentInsertForm(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            row: {},
	            fields: {},
	            errors: {}
	        };
	        _this.handleSaveBtnClick = _this.handleSaveBtnClick.bind(_this);
	        _this.handleValidation = _this.handleValidation.bind(_this);
	        _this.handleChange = _this.handleChange.bind(_this);
	        return _this;
	    }
	    SegmentInsertForm.prototype.handleSaveBtnClick = function () {
	        this.props.onSave(this.state.row);
	    };
	    SegmentInsertForm.prototype.handleValidation = function () {
	        var fields = this.state.row;
	        var errors = {};
	        var formIsValid = true;
	        var nameRegExp = new RegExp('^[a-z0-9A-Z_\\s]+$');
	        if (!fields['displayName']) {
	            formIsValid = false;
	            errors['displayName'] = 'Cannot be empty';
	        }
	        else if (!fields['displayName'] || !nameRegExp.test(fields['displayName'])) {
	            formIsValid = false;
	            errors['displayName'] = 'Please enter alphanumeric characters only';
	        }
	        if (!fields['name']) {
	            formIsValid = false;
	            errors['name'] = 'Cannot be empty';
	        }
	        else if (!fields['name'] || !nameRegExp.test(fields['name'])) {
	            formIsValid = false;
	            errors['name'] = 'Please enter alphanumeric characters only';
	        }
	        this.setState(__assign({}, this.state, { errors: errors }));
	        if (formIsValid)
	            this.handleSaveBtnClick();
	    };
	    SegmentInsertForm.prototype.handleChange = function (event) {
	        var fields = this.state.row;
	        fields[event.target.name] = event.target.value;
	        this.setState(__assign({}, this.state, { row: fields }));
	    };
	    SegmentInsertForm.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, onModalClose = _a.onModalClose, columns = _a.columns;
	        return (React.createElement("div", { className: 'modal-content' },
	            React.createElement("h2", { style: {
	                    textAlign: 'center',
	                    marginTop: '40px',
	                    color: '#0dc1e5'
	                } }, "Insert New Segment"),
	            React.createElement("div", { style: {
	                    textAlign: 'center',
	                    margin: '3% 10% 0',
	                    color: '#e12b31',
	                    fontSize: '14px'
	                } }, "Note : Please enter alphanumeric characters only. Both fields are required."),
	            React.createElement("br", null),
	            React.createElement("div", { style: { marginLeft: '20px' } }, columns.map(function (column, i) {
	                var field = column.field, name = column.name;
	                if (field == 'displayName' || field == 'name') {
	                    return (React.createElement("div", { className: 'form-group', key: field },
	                        React.createElement("label", null,
	                            name,
	                            " : "),
	                        React.createElement("br", null),
	                        React.createElement("input", { style: styles.inputBox, value: _this.state.row[field], ref: field, type: 'text', defaultValue: '', name: field, required: true, onChange: _this.handleChange.bind(_this) }),
	                        React.createElement("br", null),
	                        React.createElement("span", { style: { color: 'red' } }, _this.state.errors[field])));
	                }
	            })),
	            React.createElement("div", null,
	                React.createElement("button", { style: {
	                        marginTop: '30px',
	                        marginBottom: '50px',
	                        marginLeft: '30%'
	                    }, className: 'btn btn-danger', onClick: onModalClose }, "Cancel"),
	                React.createElement("button", { style: {
	                        marginTop: '30px',
	                        marginBottom: '50px',
	                        marginLeft: '5%'
	                    }, className: 'btn btn-success', onClick: function () { return _this.handleValidation(); } }, "Confirm"))));
	    };
	    return SegmentInsertForm;
	}(React.Component));
	exports["default"] = SegmentInsertForm;


/***/ },

/***/ 995:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	__webpack_require__(423);
	var React = __webpack_require__(1);
	var react_bootstrap_table_1 = __webpack_require__(217);
	var RestService_1 = __webpack_require__(32);
	var SegmentInsertForm_1 = __webpack_require__(994);
	var Snackbar_1 = __webpack_require__(42);
	var Segments = /** @class */ (function (_super) {
	    __extends(Segments, _super);
	    function Segments() {
	        var _this = _super.call(this) || this;
	        _this.getSegments = function () {
	            RestService_1["default"].getSegments(function (SegmentTable) {
	                _this.parseData(SegmentTable);
	            });
	        };
	        _this.parseData = function (tableData) {
	            var segList = [];
	            for (var seg in tableData) {
	                segList[seg] = JSON.parse(JSON.stringify(tableData[seg]));
	            }
	            _this.setState(__assign({}, _this.state, { processedTable: segList }));
	        };
	        _this.getRandomCsid = function () {
	            var min = Math.ceil(10);
	            var max = Math.floor(10000000);
	            return Math.floor(Math.random() * (max - min)) + min;
	        };
	        _this.toJsonObject = function (row) {
	            var startDate = Math.round(new Date().getTime() / 1000);
	            var randomCsid = _this.getRandomCsid();
	            var segmentSet = new Set(_this.state.processedTable);
	            while (segmentSet.has(randomCsid)) {
	                randomCsid = _this.getRandomCsid();
	            }
	            row['id'] = randomCsid;
	            row['source'] = 'custom';
	            row['createdAtInSecs'] = startDate;
	            row['updatedAtInSecs'] = startDate;
	            return row;
	        };
	        _this.handleInsertedRow = function (row) {
	            RestService_1["default"].addSegment(_this.toJsonObject(row), function (response) {
	                _this.getSegments();
	            });
	        };
	        _this.handleClose = function () {
	            _this.setState(__assign({}, _this.state, { openSnackBar: false }));
	        };
	        _this.createCustomModal = function (onModalClose, onSave, columns, validateState, ignoreEditable) {
	            return (React.createElement(SegmentInsertForm_1["default"], { onModalClose: onModalClose, onSave: onSave, columns: columns, validateState: validateState, ignoreEditable: ignoreEditable }));
	        };
	        _this.state = {
	            page: 1,
	            processedTable: [],
	            option: {
	                onAddRow: _this.handleInsertedRow,
	                insertModal: _this.createCustomModal
	            },
	            openSnackBar: false,
	            snackBarMessage: ''
	        };
	        return _this;
	    }
	    Segments.prototype.componentWillMount = function () {
	        this.getSegments();
	    };
	    Segments.prototype.render = function () {
	        return (React.createElement("div", { style: { marginTop: '80px', width: '100%' } },
	            React.createElement(react_bootstrap_table_1.BootstrapTable, { ref: 'table', data: this.state.processedTable, insertRow: true, options: this.state.option, hover: true, search: { type: 'TextSearch' }, pagination: true },
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { isKey: true, dataField: 'id', width: '8%' }, "ID"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'name', width: '8%' }, "Name"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'displayName', width: '8%' }, "Display Name"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'source', width: '8%' }, "Source"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'createdAtInSecs', width: '8%' }, "createdAtInSecs"),
	                React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: 'updatedAtInSecs', width: '8%' }, "updatedAtInSecs")),
	            React.createElement(Snackbar_1["default"], { open: this.state.openSnackBar, message: this.state.snackBarMessage, onRequestClose: this.handleClose, autoHideDuration: 2000 })));
	    };
	    return Segments;
	}(React.Component));
	exports["default"] = Segments;


/***/ },

/***/ 996:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var RestService_1 = __webpack_require__(32);
	var React = __webpack_require__(1);
	var Snackbar_1 = __webpack_require__(42);
	__webpack_require__(110);
	var UploadCsvComponent = /** @class */ (function (_super) {
	    __extends(UploadCsvComponent, _super);
	    function UploadCsvComponent(props) {
	        var _this = _super.call(this, props) || this;
	        _this.fileSelectedHandler = function (event) {
	            _this.setState(__assign({}, _this.state, { selectedFile: event.target.files[0], selectedFileSize: event.target.files[0].size, openSnackbar: false }));
	        };
	        _this.fileUploadHandler = function () {
	            if (_this.state.selectedFile == null) {
	                _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: 'Please Choose a csv file to upload.' }));
	            }
	            else {
	                if (_this.state.selectedFileSize > 0 && _this.state.selectedFileSize <= 94371840) {
	                    console.log('File Size', _this.state.selectedFileSize);
	                    RestService_1["default"].uploadCsv(_this.state.selectedFile);
	                    _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: 'CSV uploaded.' }));
	                }
	                else {
	                    _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: 'CSV upload failed. File Size Greater than 90 MB' }));
	                }
	            }
	        };
	        _this.state = {
	            selectedFile: null,
	            selectedFileSize: 0,
	            snackbarMessage: 'Progress Updates will come here',
	            openSnackbar: true
	        };
	        return _this;
	    }
	    UploadCsvComponent.prototype.render = function () {
	        return (React.createElement("div", { className: 'center' },
	            React.createElement("h1", null, "Upload CSV"),
	            React.createElement("div", { className: 'upload' },
	                React.createElement("input", { type: 'file', accept: '.csv', onChange: this.fileSelectedHandler })),
	            React.createElement("div", null,
	                React.createElement("button", { onClick: this.fileUploadHandler }, " Click to Upload ")),
	            React.createElement("div", { className: 'info' }, "Maximum file size 5 MB. Valid Only For 365 Days."),
	            React.createElement(Snackbar_1["default"], { open: this.state.openSnackbar, message: this.state.snackbarMessage, autoHideDuration: 2000 })));
	    };
	    return UploadCsvComponent;
	}(React.Component));
	exports["default"] = UploadCsvComponent;


/***/ },

/***/ 997:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var material_ui_1 = __webpack_require__(38);
	var RadioButton_1 = __webpack_require__(99);
	var JerseyRestApiService_1 = __webpack_require__(83);
	var react_copy_to_clipboard_1 = __webpack_require__(822);
	var FILE_UPLOAD_SIZE_LIMIT = 104857600;
	var FILE_UPLOAD_SAMSUNG_SIZE_LIMIT = FILE_UPLOAD_SIZE_LIMIT * 10; // Samsung Assets upload maximum size limit 1GB
	var folderTypes = [{
	        key: 'content/amp',
	        name: 'Amp'
	    }, {
	        key: 'content/games',
	        name: 'Games'
	    }, {
	        key: 'content/shopthelook',
	        name: 'Shopthelook'
	    }, {
	        key: 'content/tweet',
	        name: 'Tweet'
	    }, {
	        key: 'content/polls',
	        name: 'Polls'
	    }, {
	        key: 'content/assets',
	        name: 'Assets'
	    }];
	var partnerTypes = [{
	        key: 'samsung',
	        name: 'Samsung'
	    }, {
	        key: 'xiaomi',
	        name: 'Xiaomi'
	    }, {
	        key: 'gionee',
	        name: 'Gionee'
	    }, {
	        key: 'other',
	        name: 'Other'
	    }];
	var styles = {
	    container: {
	        width: '400px',
	        margin: 'auto',
	        marginTop: '50px',
	        padding: '20px'
	    },
	    alertStyle: {
	        marginTop: '20px'
	    },
	    saveButtonStyle: {
	        marginTop: '15px'
	    },
	    dialogContentStyle: {
	        width: '400px'
	    },
	    copy: {
	        height: 'fit-content',
	        backgroundColor: '#e2e2e2',
	        color: 'black',
	        width: 'fit-content'
	    }
	};
	var UploadFile = /** @class */ (function (_super) {
	    __extends(UploadFile, _super);
	    function UploadFile(props) {
	        var _this = _super.call(this, props) || this;
	        _this.fileSelectHandler = function (event) {
	            _this.setState(__assign({}, _this.state, { selectedFile: event.target.files }));
	        };
	        _this.folderSelectHandler = function (event) {
	            _this.setState(__assign({}, _this.state, { selectedFile: event.target.files }));
	        };
	        _this.fileUploadHandler = function () {
	            var _a = _this.state, selectedFile = _a.selectedFile, folderPath = _a.folderPath, subFolderPath = _a.subFolderPath, fileType = _a.fileType;
	            var formData = new FormData();
	            var fileSize = 0;
	            for (var fileIndex = 0; fileIndex < selectedFile.length; fileIndex++) {
	                var fileName = selectedFile[fileIndex].webkitRelativePath ? selectedFile[fileIndex].webkitRelativePath : selectedFile[fileIndex].name;
	                formData.append('file', selectedFile[fileIndex], fileName);
	                fileSize += selectedFile[fileIndex].size;
	            }
	            var samsungFileUploadFlag = false;
	            if (folderPath === 'content/assets' && subFolderPath === 'samsung') {
	                samsungFileUploadFlag = true;
	                if (fileSize > FILE_UPLOAD_SAMSUNG_SIZE_LIMIT) {
	                    alert(" " + fileType + " size is more than 1GB");
	                    return;
	                }
	            }
	            if (fileSize > FILE_UPLOAD_SIZE_LIMIT && !samsungFileUploadFlag) {
	                alert(" " + fileType + " size is more than 100MB");
	                return;
	            }
	            var payload = {
	                folderPath: folderPath,
	                subFolderPath: subFolderPath,
	                formData: formData
	            };
	            var uploadFileToBlobPromise = JerseyRestApiService_1["default"].uploadFileToBlob(payload);
	            _this.setState(__assign({}, _this.state, { uploadStatus: 'uploading' }));
	            uploadFileToBlobPromise.then(function (response) {
	                var s3Response = response;
	                var encoded = encodeURI(s3Response.message);
	                _this.setState(__assign({}, _this.state, { responseText: encoded, statusCode: s3Response.statusCode, uploadStatus: 'success' }));
	            })["catch"](function (err) {
	                _this.setState(__assign({}, _this.state, { uploadStatus: 'error', failureText: err }));
	            });
	        };
	        _this.onFolderPathChange = function (value) {
	            _this.setState(__assign({}, _this.state, { folderPath: value }));
	        };
	        _this.onSubFolderPathChange = function (value) {
	            _this.setState(__assign({}, _this.state, { subFolderPath: value }));
	        };
	        _this.handleFileTypeChange = function (event, value) {
	            _this.setState(__assign({}, _this.state, { fileType: value }));
	        };
	        _this.state = {
	            selectedFile: null,
	            selectedFileSize: 0,
	            folderPath: '-1',
	            subFolderPath: '-1',
	            uploadStatus: '',
	            statusCode: 0,
	            responseText: '',
	            failureText: '',
	            fileType: 'file'
	        };
	        return _this;
	    }
	    UploadFile.prototype._addDirectory = function (node) {
	        if (node) {
	            node.directory = true;
	            node.webkitdirectory = true;
	        }
	    };
	    UploadFile.prototype.render = function () {
	        var _this = this;
	        var _a = this.state, folderPath = _a.folderPath, subFolderPath = _a.subFolderPath, responseText = _a.responseText, statusCode = _a.statusCode, uploadStatus = _a.uploadStatus, selectedFile = _a.selectedFile, fileType = _a.fileType, failureText = _a.failureText;
	        var fileUploadText = React.createElement("span", null, "File Uploaded Successfully");
	        if (statusCode == 200 && subFolderPath == 'samsung') {
	            fileUploadText = (React.createElement("span", null,
	                "File Uploaded Successfully -",
	                ' ',
	                React.createElement("span", { style: { color: '#169916' } }, "APK is Approved")));
	        }
	        var response = React.createElement("a", { href: responseText, target: '_blank' }, responseText);
	        if (statusCode == 202) {
	            if (responseText.includes('Rejected')) {
	                response = React.createElement("h4", { style: { color: '#f25959' } }, "\"apk rejected\"");
	            }
	            else {
	                response = React.createElement("h4", null, "\"apk review in-progress\"");
	            }
	        }
	        return (React.createElement("div", null,
	            React.createElement(material_ui_1.Paper, { style: styles.container, zDepth: 2 },
	                React.createElement("h4", null, "File Upload"),
	                React.createElement(material_ui_1.SelectField, { fullWidth: true, floatingLabelText: 'Type', value: folderPath, onChange: function (event, index, value) { return _this.onFolderPathChange(value); } },
	                    React.createElement(material_ui_1.MenuItem, { value: '-1', primaryText: 'Select Type', key: 'empty' }),
	                    folderTypes.map(function (item) {
	                        return (React.createElement(material_ui_1.MenuItem, { value: item.key, primaryText: item.name, key: item.name }));
	                    })),
	                React.createElement(material_ui_1.SelectField, { fullWidth: true, floatingLabelText: 'Select Partner', value: subFolderPath, onChange: function (event, index, value) { return _this.onSubFolderPathChange(value); } },
	                    React.createElement(material_ui_1.MenuItem, { value: '-1', primaryText: 'Select Partner', key: 'empty' }),
	                    partnerTypes.map(function (item) {
	                        return (React.createElement(material_ui_1.MenuItem, { value: item.key, primaryText: item.name, key: item.name }));
	                    })),
	                React.createElement(RadioButton_1.RadioButtonGroup, { name: 'actionType', defaultSelected: fileType, onChange: this.handleFileTypeChange },
	                    React.createElement(RadioButton_1.RadioButton, { value: 'file', label: 'File' }),
	                    React.createElement(RadioButton_1.RadioButton, { value: 'folder', label: 'Folder' })),
	                fileType === 'folder' && React.createElement("input", { ref: function (node) { return _this._addDirectory(node); }, type: 'file', onChange: this.folderSelectHandler }),
	                fileType === 'file' && React.createElement("input", { type: 'file', onChange: this.fileSelectHandler }),
	                React.createElement(material_ui_1.GridList, { cols: 1, padding: 10, cellHeight: 'auto' },
	                    React.createElement(material_ui_1.RaisedButton, { label: uploadStatus === 'uploading' ? 'Uploading' : 'Upload', fullWidth: true, primary: true, style: styles.saveButtonStyle, onTouchTap: this.fileUploadHandler, disabled: selectedFile === null || folderPath === '-1' || uploadStatus === 'uploading' }))),
	            uploadStatus === 'success' && React.createElement("div", { className: 'center' },
	                React.createElement("pre", null,
	                    React.createElement("code", null,
	                        !responseText.includes('Rejected') && fileUploadText,
	                        React.createElement("br", null),
	                        response,
	                        React.createElement("br", null),
	                        statusCode != 202 && React.createElement(react_copy_to_clipboard_1.CopyToClipboard, { text: responseText },
	                            React.createElement("button", { style: styles.copy }, "Copy link to clipboard"))))),
	            uploadStatus === 'error' && React.createElement("div", { className: 'center' },
	                React.createElement("pre", null,
	                    React.createElement("code", null,
	                        React.createElement("a", { target: '_blank' }, failureText ? failureText : 'Something went wrong. Try again'))))));
	    };
	    return UploadFile;
	}(React.Component));
	exports["default"] = UploadFile;


/***/ },

/***/ 998:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	var Utils_1 = __webpack_require__(17);
	var Paper_1 = __webpack_require__(30);
	var colors_1 = __webpack_require__(18);
	var MediaQuery = __webpack_require__(123);
	var React = __webpack_require__(1);
	var styles = {
	    section: {
	        width: '100%',
	        height: '100%',
	        position: 'fixed',
	        backgroundColor: colors_1.cyan500,
	        display: 'flex',
	        maxWidth: 'none'
	    },
	    header: {
	        margin: '5% auto',
	        color: 'white',
	        background: 'url(../../../assets/images/logo_white.png) no-repeat',
	        backgroundSize: '40px',
	        paddingLeft: '50px',
	        backgroundPositionX: '0px',
	        fontSize: '34px',
	        lineHeight: '40px',
	        textAlign: 'center'
	    },
	    headerMobile: {
	        color: 'white',
	        background: 'url(../../../assets/images/logo_white.png) no-repeat',
	        backgroundSize: '40px',
	        paddingTop: '50px',
	        backgroundPositionX: 'center',
	        backgroundPositionY: '0px',
	        fontSize: '34px',
	        lineHeight: '40px',
	        textAlign: 'center'
	    },
	    paper: {
	        padding: '3%',
	        textAlign: 'center',
	        display: 'block',
	        resize: 'verticle'
	    }
	};
	var Welcome = /** @class */ (function (_super) {
	    __extends(Welcome, _super);
	    function Welcome(props) {
	        return _super.call(this, props) || this;
	    }
	    Welcome.prototype.render = function () {
	        // console.log('New login component')
	        var loginCard = (React.createElement(Paper_1["default"], { style: styles.paper, zDepth: 3 },
	            React.createElement("h3", null, " Checking your login state ...")));
	        return (React.createElement("section", { style: styles.section },
	            React.createElement(MediaQuery, { query: '(min-device-width: 1224px)' },
	                React.createElement("div", { style: {
	                        display: 'flex',
	                        flexDirection: 'column',
	                        justifyContent: 'flex-start',
	                        resize: 'verticle',
	                        width: '30%',
	                        height: '70%',
	                        margin: 'auto'
	                    } },
	                    React.createElement("h1", { style: styles.header },
	                        " Glance For ",
	                        Utils_1["default"].getDomainPrefix()),
	                    loginCard)),
	            React.createElement(MediaQuery, { query: '(max-device-width: 1224px)' }, function (matches) {
	                if (matches) {
	                    console.log('mobile device');
	                    return (React.createElement("div", { style: {
	                            display: 'flex',
	                            flexDirection: 'column',
	                            justifyContent: 'flex-start',
	                            resize: 'verticle',
	                            width: '90%',
	                            height: '90%',
	                            margin: 'auto',
	                            overflow: 'auto'
	                        } },
	                        React.createElement("h1", { style: styles.headerMobile },
	                            " Glance For ",
	                            Utils_1["default"].getDomainPrefix()),
	                        loginCard));
	                }
	                else {
	                    return null;
	                }
	            })));
	    };
	    return Welcome;
	}(React.Component));
	exports["default"] = Welcome;


/***/ },

/***/ 999:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	__webpack_require__(967);
	var React = __webpack_require__(1);
	var MultiSelectDropdown = /** @class */ (function (_super) {
	    __extends(MultiSelectDropdown, _super);
	    function MultiSelectDropdown(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onClick = function () {
	            _this.setState(function (prevState) { return ({
	                isOpen: !prevState.isOpen
	            }); });
	        };
	        _this.onMouseLeave = function () {
	            _this.setState(function () { return ({
	                isOpen: false
	            }); });
	        };
	        _this.onDeleteOption = function (e) {
	            var value = e.currentTarget.dataset.value;
	            _this.setState(function (prevState) {
	                var values = prevState.values.slice(0);
	                var index = values.indexOf(value);
	                values.splice(index, 1);
	                _this.props.onChange(values);
	                return { values: values };
	            });
	        };
	        _this.onHoverOption = function (e) {
	            var options = _this.props.options;
	            var value = e.currentTarget.dataset.value;
	            var index = options.findIndex(function (option) { return option.value === value; });
	            _this.setState({
	                focusedValue: index
	            });
	        };
	        _this.onClickOption = function (e) {
	            var value = e.currentTarget.dataset.value;
	            _this.setState(function (prevState) {
	                var values = prevState.values.slice(0);
	                var index = values.indexOf(value);
	                if (index === -1) {
	                    values.push(value);
	                }
	                else {
	                    values.splice(index, 1);
	                }
	                _this.props.onChange(values);
	                return { values: values };
	            });
	        };
	        _this.stopPropagation = function (e) {
	            e.stopPropagation();
	        };
	        _this.renderValues = function () {
	            var placeholder = _this.props.placeholder;
	            var values = _this.state.values;
	            if (values.length === 0) {
	                return React.createElement("div", { className: "placeholder" }, placeholder);
	            }
	            return values.map(function (value) {
	                return (React.createElement("span", { key: value, onClick: _this.stopPropagation, className: "multiple value" },
	                    value,
	                    React.createElement("span", { "data-value": value, onClick: _this.onDeleteOption, className: "delete" },
	                        React.createElement(X, null))));
	            });
	        };
	        _this.renderOptions = function () {
	            var options = _this.props.options;
	            var isOpen = _this.state.isOpen;
	            if (!isOpen) {
	                return null;
	            }
	            return React.createElement("div", { className: "options" }, options.map(_this.renderOption));
	        };
	        _this.checkDisableStatus = function (value) {
	            return _this.props.rankInBubble > 1 && value === 'LOCKSCREEN';
	        };
	        _this.renderOption = function (option, index) {
	            var _a = _this.state, values = _a.values, focusedValue = _a.focusedValue;
	            var value = option.value;
	            var selected = values.includes(value);
	            var className = 'option';
	            if (selected)
	                className += ' selected';
	            if (index === focusedValue)
	                className += ' focused';
	            return (React.createElement("div", { key: value, "data-value": value, className: className + " " + (_this.checkDisableStatus(value) &&
	                    'disabled-item'), onMouseOver: _this.onHoverOption, onClick: !_this.checkDisableStatus(value) && _this.onClickOption },
	                React.createElement("span", { className: "checkbox " + (selected ? 'selected' : '') }, selected ? React.createElement(Check, null) : null),
	                value));
	        };
	        _this.state = {
	            values: [],
	            focusedValue: -1,
	            isOpen: false
	        };
	        return _this;
	    }
	    MultiSelectDropdown.prototype.componentDidMount = function () {
	        var _this = this;
	        var selectedValue = this.props.selectedValue;
	        selectedValue
	            ? selectedValue.forEach(function (element) {
	                var value = element.value;
	                _this.setState(function (prevState) {
	                    var values = prevState.values.slice(0);
	                    var index = values.indexOf(value);
	                    if (index === -1) {
	                        values.push(value);
	                    }
	                    else {
	                        values.splice(index, 1);
	                    }
	                    _this.props.onChange(values);
	                    return { values: values };
	                });
	            })
	            : null;
	    };
	    MultiSelectDropdown.prototype.render = function () {
	        var label = this.props.label;
	        var isOpen = this.state.isOpen;
	        return (React.createElement("div", { className: "select", onMouseLeave: this.onMouseLeave },
	            React.createElement("label", { className: "label" }, label),
	            React.createElement("div", { className: "selection", onClick: this.onClick },
	                this.renderValues(),
	                React.createElement("span", { className: "arrow" }, isOpen ? React.createElement(ChevronUp, null) : React.createElement(ChevronDown, null))),
	            this.renderOptions()));
	    };
	    return MultiSelectDropdown;
	}(React.Component));
	var ChevronDown = function () { return (React.createElement("svg", { viewBox: "0 0 10 7" },
	    React.createElement("path", { d: "M2.08578644,6.5 C1.69526215,6.89052429 1.69526215,7.52368927 2.08578644,7.91421356 C2.47631073,8.30473785 3.10947571,8.30473785 3.5,7.91421356 L8.20710678,3.20710678 L3.5,-1.5 C3.10947571,-1.89052429 2.47631073,-1.89052429 2.08578644,-1.5 C1.69526215,-1.10947571 1.69526215,-0.476310729 2.08578644,-0.0857864376 L5.37867966,3.20710678 L2.08578644,6.5 Z", transform: "translate(5.000000, 3.207107) rotate(90.000000) translate(-5.000000, -3.207107) " }))); };
	var ChevronUp = function () { return (React.createElement("svg", { viewBox: "0 0 10 8" },
	    React.createElement("path", { d: "M2.08578644,7.29289322 C1.69526215,7.68341751 1.69526215,8.31658249 2.08578644,8.70710678 C2.47631073,9.09763107 3.10947571,9.09763107 3.5,8.70710678 L8.20710678,4 L3.5,-0.707106781 C3.10947571,-1.09763107 2.47631073,-1.09763107 2.08578644,-0.707106781 C1.69526215,-0.316582489 1.69526215,0.316582489 2.08578644,0.707106781 L5.37867966,4 L2.08578644,7.29289322 Z", transform: "translate(5.000000, 4.000000) rotate(-90.000000) translate(-5.000000, -4.000000) " }))); };
	var X = function () { return (React.createElement("svg", { viewBox: "0 0 16 16" },
	    React.createElement("path", { d: "M2 .594l-1.406 1.406.688.719 5.281 5.281-5.281 5.281-.688.719 1.406 1.406.719-.688 5.281-5.281 5.281 5.281.719.688 1.406-1.406-.688-.719-5.281-5.281 5.281-5.281.688-.719-1.406-1.406-.719.688-5.281 5.281-5.281-5.281-.719-.688z" }))); };
	var Check = function () { return (React.createElement("svg", { viewBox: "0 0 16 16" },
	    React.createElement("path", { d: "M13 .156l-1.406 1.438-5.594 5.594-1.594-1.594-1.406-1.438-2.844 2.844 1.438 1.406 3 3 1.406 1.438 1.406-1.438 7-7 1.438-1.406-2.844-2.844z", transform: "translate(0 1)" }))); };
	exports["default"] = MultiSelectDropdown;
	//how to use
	//import MultiSelectDropdown
	{
	    /* <MultiSelectDropdown
	                  label="React Multiple Select"
	                  placeholder="Multi Select..."
	                  options={[
	                    { value: 'Item1' },
	                    { value: 'Item2' },
	                    { value: 'Item3' }
	                  ]}
	                  onChange={this.onhandleChange}
	                /> */
	}


/***/ },

/***/ 1001:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var Ban = function () {
	    return (React.createElement("svg", { style: {
	            width: "32px",
	            height: "32px"
	        }, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        React.createElement("path", { d: "M16.0003 2.66602C13.3632 2.66602 10.7854 3.448 8.59273 4.91309C6.40007 6.37817 4.69111 8.46055 3.68194 10.8969C2.67277 13.3333 2.40872 16.0141 2.92319 18.6006C3.43766 21.187 4.70754 23.5627 6.57224 25.4274C8.43694 27.2921 10.8127 28.562 13.3991 29.0765C15.9855 29.591 18.6664 29.3269 21.1028 28.3177C23.5391 27.3086 25.6215 25.5996 27.0866 23.407C28.5517 21.2143 29.3337 18.6364 29.3337 15.9993C29.3337 14.2484 28.9888 12.5146 28.3187 10.8969C27.6487 9.27923 26.6665 7.80937 25.4284 6.57126C24.1903 5.33314 22.7205 4.35102 21.1028 3.68096C19.4851 3.01089 17.7513 2.66602 16.0003 2.66602ZM16.0003 26.666C13.1714 26.666 10.4582 25.5422 8.45786 23.5418C6.45747 21.5414 5.33366 18.8283 5.33366 15.9993C5.33072 13.6305 6.12435 11.3294 7.587 9.46602L22.5337 24.4127C20.6703 25.8753 18.3692 26.669 16.0003 26.666ZM24.4137 22.5327L9.467 7.58602C11.3304 6.12337 13.6315 5.32974 16.0003 5.33268C18.8293 5.33268 21.5424 6.45649 23.5428 8.45688C25.5432 10.4573 26.667 13.1704 26.667 15.9993C26.6699 18.3682 25.8763 20.6693 24.4137 22.5327Z", fill: "#EB5757" })));
	};
	exports.Ban = Ban;


/***/ },

/***/ 1002:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var FileUpload = function () {
	    return (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        React.createElement("path", { d: "M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z", fill: "#616161" })));
	};
	exports.FileUpload = FileUpload;


/***/ },

/***/ 1003:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var Pencil = function () {
	    return (React.createElement("svg", { width: "19", height: "19", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        React.createElement("path", { d: "M17.709 5.04006C18.099 4.65006 18.099 4.00006 17.709 3.63006L15.369 1.29006C14.999 0.900059 14.349 0.900059 13.959 1.29006L12.119 3.12006L15.869 6.87006L17.709 5.04006ZM-0.000976562 15.2501V19.0001H3.74902L14.809 7.93006L11.059 4.18006L-0.000976562 15.2501Z", fill: "white" })));
	};
	exports.Pencil = Pencil;


/***/ },

/***/ 1004:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var Selected = function () {
	    return (React.createElement("svg", { width: "17", height: "17", viewBox: "0 0 17 17", style: { fill: 'none' }, xmlns: "http://www.w3.org/2000/svg" },
	        React.createElement("rect", { x: "0.667969", y: "0.667969", width: "15.3333", height: "15.3333", rx: "2", fill: "#72BF40" }),
	        React.createElement("path", { d: "M12.4259 5.52148L6.80094 11.1464L4.24414 8.58964", stroke: "white", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" })));
	};
	exports.Selected = Selected;


/***/ },

/***/ 1005:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var Utils_1 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var GlanceDraftRedirect = /** @class */ (function (_super) {
	    __extends(GlanceDraftRedirect, _super);
	    function GlanceDraftRedirect(props) {
	        return _super.call(this, props) || this;
	    }
	    GlanceDraftRedirect.prototype.componentDidMount = function () {
	        var appConf = this.props.studioAppConfig;
	        if (appConf && appConf.currentToken) {
	            this.props.history.push('/' + Utils_1["default"].getReadableRoleName(appConf.currentToken.role) + '/drafts/draftIds/' + this.props.params.draftIds);
	        }
	        else {
	            this.props.history.push('/');
	        }
	    };
	    GlanceDraftRedirect.prototype.render = function () {
	        return (React.createElement("div", null));
	    };
	    return GlanceDraftRedirect;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(GlanceDraftRedirect);


/***/ },

/***/ 1006:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	exports.__esModule = true;
	var CryptoJS = __webpack_require__(268);
	var React = __webpack_require__(1);
	var base64url = __webpack_require__(441);
	var GlanceRegionPublish_1 = __webpack_require__(428);
	var glance_datatypes_1 = __webpack_require__(67);
	var types_1 = __webpack_require__(125);
	var material_ui_1 = __webpack_require__(38);
	var GridList_1 = __webpack_require__(118);
	var Tabs_1 = __webpack_require__(210);
	var Toolbar_1 = __webpack_require__(100);
	var Utils_1 = __webpack_require__(17);
	var EmptyMessage_1 = __webpack_require__(153);
	var GlanceChangeData_1 = __webpack_require__(979);
	var GlanceDraft_1 = __webpack_require__(1008);
	var ImageDropzone_1 = __webpack_require__(152);
	var JerseyRestApiService_1 = __webpack_require__(83);
	var Loader_1 = __webpack_require__(154);
	var Constants_1 = __webpack_require__(111);
	var RestService_1 = __webpack_require__(32);
	var react_redux_1 = __webpack_require__(24);
	var glanceDraftsStyle_1 = __webpack_require__(1015);
	var categoryList = [];
	var publisherList = [];
	/*
	 * GlanceDrafts renders a list of Glance Drafts
	 */
	var GlanceDrafts = /** @class */ (function (_super) {
	    __extends(GlanceDrafts, _super);
	    function GlanceDrafts(props) {
	        var _this = _super.call(this, props) || this;
	        _this.defaultValues = {
	            durationUnit: 1 /* DAYS */,
	            duration: 2,
	            startTimeType: GlanceRegionPublish_1.StartTimeType.NOW,
	            startDate: new Date(),
	            startTime: new Date()
	        };
	        _this.userLevelDefaultValues = {
	            enabled: true,
	            duration: 1,
	            durationUnit: 1 /* DAYS */
	        };
	        _this.getInitialStateFromProp = function (props) {
	            var partnerIdToPartner = new Map();
	            var partnerIdToPartnerMeta = new Map();
	            var studioAppConfig = props.studioAppConfig, params = props.params;
	            var partners = studioAppConfig.partners, partnerMetas = studioAppConfig.partnerMetas, categories = studioAppConfig.categories, segmentRules = studioAppConfig.segmentTargetingRule, publishers = studioAppConfig.publishers;
	            partners.forEach(function (partner) {
	                partnerIdToPartner.set(partner.partnerId, partner);
	            });
	            partnerMetas.forEach(function (partner) {
	                partnerIdToPartnerMeta.set(partner.partnerId, partner);
	            });
	            categoryList.push(React.createElement(material_ui_1.MenuItem, { value: null, key: 'null', primaryText: 'All Categories' }));
	            categories.forEach(function (category) {
	                categoryList.push(React.createElement(material_ui_1.MenuItem, { value: category.id, key: category.id, primaryText: category.displayName }));
	            });
	            publisherList.push(React.createElement(material_ui_1.MenuItem, { value: null, key: 'null', primaryText: 'All Publishers' }));
	            publishers.forEach(function (publisher) {
	                publisherList.push(React.createElement(material_ui_1.MenuItem, { value: publisher.id, key: publisher.id, primaryText: publisher.displayName }));
	            });
	            var experiments = new Map();
	            studioAppConfig.experiments.forEach(function (experiment) {
	                experiments.set(experiment.id, experiment);
	            });
	            var regionPublishMeta = new Map();
	            var partnerSources = new Map();
	            var abPartitions = new Map();
	            var partnerMap = new Map();
	            var errorMsgMap = new Map();
	            var draftToRegionPartnerMap = new Map();
	            var draftMetas = new Map();
	            studioAppConfig.partners.forEach(function (partner) {
	                partnerMap.set(partner.partnerId, partner);
	            });
	            Utils_1.allRegions.forEach(function (region) {
	                partnerSources.set(region, []);
	                abPartitions.set(region, []);
	            });
	            studioAppConfig.partnerMetas.forEach(function (item) {
	                var partner = partnerMap.get(item.partnerId);
	                item.supportedRegions.forEach(function (region) {
	                    partnerSources.set(region, partnerSources.get(region).concat([
	                        {
	                            text: partner.name,
	                            value: partner
	                        },
	                    ]));
	                });
	                item.abConfigs
	                    ? item.abConfigs.forEach(function (abConfig) {
	                        abPartitions.set(abConfig.region, abPartitions.get(abConfig.region).concat([
	                            {
	                                partnerId: partner.partnerId,
	                                abTag: abConfig.id
	                            },
	                        ]));
	                    })
	                    : '';
	            });
	            Utils_1.allRegions.forEach(function (region) {
	                regionPublishMeta.set(region, {
	                    partnerSources: partnerSources.get(region),
	                    abMappings: abPartitions.get(region)
	                });
	            });
	            var glanceType = params.type ? parseInt(params.type) : 2 /* STORY */;
	            var category = params.category
	                ? decodeURIComponent(params.category) == 'null'
	                    ? null
	                    : decodeURIComponent(params.category)
	                : null;
	            var publisher = params.publisher
	                ? decodeURIComponent(params.publisher) === 'null'
	                    ? null
	                    : decodeURIComponent(params.publisher)
	                : null;
	            var region = params.region ? parseInt(params.region) : null;
	            var publishFilter = params.publishState
	                ? parseInt(params.publishState)
	                : types_1.PublishFilter.ALL;
	            var timeFilter = params.time ? parseFloat(params.time) : 1;
	            var partner = params.partner
	                ? _this.state.partnerMap.get(params.partner)
	                : null;
	            var partnerRegion = params.partnerRegion
	                ? parseInt(params.partnerRegion)
	                : null;
	            var draftIds = params.draftIds ? params.draftIds.split(',') : [];
	            return {
	                snackbarOpen: false,
	                snackbarMessage: 'Elves have been sent to fetch some drafts.',
	                typeFilter: glanceType,
	                categoryFilter: category,
	                publisherFilter: publisher,
	                publishFilter: publishFilter,
	                regionFilter: types_1.RegionFilter.ANY,
	                partner: partner,
	                region: region,
	                partnerRegion: partnerRegion,
	                sortItem: types_1.SortItem.DEFAULT,
	                partnerMap: partnerIdToPartner,
	                partnerMetaMap: partnerIdToPartnerMeta,
	                timeFilter: timeFilter,
	                experiments: experiments,
	                segmentRules: segmentRules,
	                selectedPartners: [],
	                isPublishSettingChangeClicked: false,
	                isChangeDataClicked: false,
	                regionPublishMeta: regionPublishMeta,
	                activeRegion: 2 /* IN */,
	                errorMsgMap: errorMsgMap,
	                draftToRegionPartnerMap: draftToRegionPartnerMap,
	                draftIds: draftIds,
	                bulkChangeData: null,
	                limit: 25,
	                currentPage: 1,
	                showLoader: true,
	                totalDrafts: 0,
	                draftMeta: draftMetas,
	                bubbleData: {},
	                cardType: 1,
	                testMode: false,
	                disableCopy: false
	            };
	        };
	        _this.onEditBulkData = function (key, value) {
	            var _a, _b;
	            switch (key) {
	                case 'startDay':
	                case 'endDay':
	                    var bulkChangeData = _this.state.bulkChangeData || {
	                        userLifeTimeFilter: null
	                    };
	                    var userLifeTimeFilter = bulkChangeData.userLifeTimeFilter || {};
	                    _this.setState(__assign({}, _this.state, { bulkChangeData: __assign({}, _this.state.bulkChangeData, { userLifeTimeFilter: __assign({}, userLifeTimeFilter, (_a = {}, _a[key] = value, _a)) }) }));
	                    break;
	                case 'renderSessionProperties':
	                case 'renderSessionMode':
	                case 'categoryIds':
	                case 'publisherId':
	                case 'canSkipSummary':
	                case 'shouldUnlock':
	                case 'categorySubscriptionStatus':
	                case 'targetForCategories':
	                case 'advancedCta':
	                    _this.setState(__assign({}, _this.state, { bulkChangeData: __assign({}, _this.state.bulkChangeData, (_b = {}, _b[key] = value, _b)) }));
	                    break;
	                case 'segmentIds':
	                    _this.setState(__assign({}, _this.state, { bulkChangeData: __assign({}, _this.state.bulkChangeData, { segments: value }) }));
	                    break;
	            }
	        };
	        _this.loadDraftMetas = function (drafts) {
	            var ids = [];
	            drafts.map(function (draft) {
	                ids.push(draft.draftId);
	            });
	            RestService_1["default"].getDraftToPublishMeta(ids, function (draftToMetaMap) {
	                var draftToRegionPartnerMap = _this.state.draftToRegionPartnerMap;
	                var draftMeta = _this.state.draftMeta;
	                if (draftToMetaMap != null) {
	                    var _loop_1 = function (k) {
	                        var tuples = [];
	                        var metas = draftToMetaMap[k];
	                        metas.map(function (meta) {
	                            tuples.push({
	                                region: meta.region,
	                                partner: _this.state.partnerMap.get(meta.partnerId)
	                            });
	                        });
	                        draftToRegionPartnerMap.set(k, tuples);
	                        draftMeta.set(k, metas);
	                    };
	                    for (var k in draftToMetaMap) {
	                        _loop_1(k);
	                    }
	                }
	                _this.setState(__assign({}, _this.state, { draftToRegionPartnerMap: draftToRegionPartnerMap,
	                    draftMeta: draftMeta }));
	            });
	        };
	        _this.durationUpdate = function (unit, value) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { duration: value, durationUnit: unit });
	            regionPublishMeta.set(_this.state.activeRegion, newCurrentRegionPublishMeta);
	            _this.defaultValues = __assign({}, _this.defaultValues, { duration: value, durationUnit: unit });
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.startTimeUpdate = function (type, startDate, startTime) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { startTimeType: type, startDate: startDate, startTime: startTime });
	            regionPublishMeta.set(_this.state.activeRegion, newCurrentRegionPublishMeta);
	            _this.defaultValues = __assign({}, _this.defaultValues, { startTimeType: type, startDate: startDate, startTime: startTime });
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.handlerPartnerAdd = function (chip) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var partnerSources = _this.state.selectedPartners;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            var publishToPartners = currentRegionPublishMeta.publishTo;
	            if (!publishToPartners) {
	                publishToPartners = [];
	            }
	            if (partnerSources.indexOf(chip) == -1) {
	                partnerSources.push(chip);
	                _this.setState(__assign({}, _this.state, { selectedPartners: partnerSources }));
	            }
	            if (publishToPartners.indexOf(chip) == -1 &&
	                currentRegionPublishMeta.partnerSources.indexOf(chip) != -1) {
	                publishToPartners = publishToPartners.concat([chip]);
	                var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { publishTo: publishToPartners, publishToSelected: chip.value.partnerId });
	                if (publishToPartners.length != 1 ||
	                    !(publishToPartners[0].value.partnerId ==
	                        Constants_1.Partners.SAMSUNG_ANDROID_PARTNER_ID ||
	                        publishToPartners[0].value.partnerId == Constants_1.Partners.TEST_PARTNER_ID)) {
	                    newCurrentRegionPublishMeta = __assign({}, newCurrentRegionPublishMeta, { userLevelDurationEnabled: false, userLevelDuration: undefined, userLevelDurationUnit: undefined });
	                }
	                regionPublishMeta.set(_this.state.activeRegion, newCurrentRegionPublishMeta);
	                _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	            }
	        };
	        _this.handleCategoryFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(_this.state.typeFilter, value, _this.state.publisherFilter, _this.state.regionFilter, _this.state.timeFilter, _this.state.publishFilter, _this.state.partner, _this.state.region);
	            _this.setState(__assign({}, _this.state, { categoryFilter: value }), function () {
	                var _a = _this.state, region = _a.region, partner = _a.partner;
	                if (region && partner) {
	                    _this.getPartnerRegionFilteredDrafts(true);
	                }
	                else {
	                    _this.loadDrafts(true);
	                }
	            });
	        };
	        _this.handlePublisherFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(_this.state.typeFilter, value, _this.state.categoryFilter, _this.state.regionFilter, _this.state.timeFilter, _this.state.publishFilter, _this.state.partner, _this.state.region);
	            _this.setState(__assign({}, _this.state, { publisherFilter: value }), function () {
	                var _a = _this.state, region = _a.region, partner = _a.partner;
	                if (region && partner) {
	                    _this.getPartnerRegionFilteredDrafts(true);
	                }
	                else {
	                    _this.loadDrafts(true);
	                }
	            });
	        };
	        _this.handleTypeFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(value, _this.state.categoryFilter, _this.state.publisherFilter, _this.state.regionFilter, _this.state.timeFilter, _this.state.publishFilter, _this.state.partner, _this.state.region);
	            _this.setState(__assign({}, _this.state, { typeFilter: value }), function () {
	                var _a = _this.state, region = _a.region, partner = _a.partner;
	                if (region && partner) {
	                    _this.getPartnerRegionFilteredDrafts(true);
	                }
	                else {
	                    _this.loadDrafts(true);
	                }
	            });
	        };
	        _this.handleTestModeChange = function (event, value) {
	            _this.setState(__assign({}, _this.state, { testMode: value }));
	        };
	        _this.handleRegionFilterChange = function (event, value) {
	            var regionFilter = value ? types_1.RegionFilter.SPECIFIC : types_1.RegionFilter.ANY;
	            _this.pushFilterUrl(_this.state.typeFilter, _this.state.categoryFilter, _this.state.publisherFilter, regionFilter, _this.state.timeFilter, _this.state.publishFilter, _this.state.partner, _this.state.region);
	            _this.setState(__assign({}, _this.state, { regionFilter: regionFilter }));
	        };
	        _this.handlePublishFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(_this.state.typeFilter, _this.state.categoryFilter, _this.state.publisherFilter, null, _this.state.timeFilter, value, null, null);
	            _this.setState(__assign({}, _this.state, { publishFilter: value, snackbarMessage: '', partner: null, region: null, data: null }), function () {
	                var publishFilter = _this.state.publishFilter;
	                if (publishFilter === types_1.PublishFilter.ALL) {
	                    _this.loadDrafts(true);
	                }
	            });
	        };
	        _this.handleSortItemChange = function (event, index, value) {
	            var data = _this.state.data;
	            if (data) {
	                if (value === types_1.SortItem.PRIORITY_ASC) {
	                    data.sort(function (a, b) { return a.priority - b.priority; });
	                }
	                else if (value === types_1.SortItem.PRIORITY_DESC) {
	                    data.sort(function (a, b) { return b.priority - a.priority; });
	                }
	            }
	            _this.setState(__assign({}, _this.state, { sortItem: value, data: data }));
	        };
	        _this.handleTimeFilterChange = function (event, index, value) {
	            _this.pushFilterUrl(_this.state.typeFilter, _this.state.categoryFilter, _this.state.publisherFilter, _this.state.regionFilter, value, _this.state.publishFilter, _this.state.partner, _this.state.region);
	            _this.setState(__assign({}, _this.state, { snackbarOpen: true, snackbarMessage: 'Elves have been sent to fetch some drafts.', timeFilter: value, partner: null, region: null, publishFilter: types_1.PublishFilter.ALL }), function () {
	                var _a = _this.state, region = _a.region, partner = _a.partner;
	                if (region && partner) {
	                    _this.getPartnerRegionFilteredDrafts(true);
	                }
	                else {
	                    _this.loadDrafts(true);
	                }
	            });
	        };
	        _this.handlePartnerFilterChange = function (event, index, value) {
	            var partner = _this.state.partnerMap.get(value);
	            _this.pushFilterUrl(_this.state.typeFilter, _this.state.categoryFilter, _this.state.publisherFilter, _this.state.regionFilter, _this.state.timeFilter, _this.state.publishFilter, partner, _this.state.region);
	            _this.setState(__assign({}, _this.state, { partner: partner, region: null }));
	        };
	        _this.filterDraftsByPartnerRegion = function (value) {
	            _this.pushFilterUrl(_this.state.typeFilter, _this.state.categoryFilter, _this.state.publisherFilter, _this.state.regionFilter, _this.state.timeFilter, _this.state.publishFilter, _this.state.partner, value);
	            _this.setState(__assign({}, _this.state, { snackbarOpen: true, snackbarMessage: 'Loading ...', region: value, currentPage: 1 }), function () {
	                _this.getPartnerRegionFilteredDrafts();
	            });
	        };
	        _this.handlePartnerRegionFilterChange = function (event, index, value) {
	            _this.filterDraftsByPartnerRegion(value);
	        };
	        _this.onDraftLinkChange = function (e, newValue) {
	            var warning = '';
	            var draftLink = newValue.trim();
	            if (draftLink.includes('.zip') &&
	                !draftLink.startsWith('https://glancecdn.azureedge.net/one-world/')) {
	                warning =
	                    'This webpeek does not belong to Project One World, please migrate to Project One World. Webpeeks built with any other pipeline apart from Project One World will be blocked soon.';
	            }
	            _this.setState(__assign({}, _this.state, { link: draftLink, linkWarning: warning }));
	        };
	        _this.fetchBubbleDataByIds = function () {
	            var bubbleIds = _this.state.data.map(function (item) { return item.bubbleId; });
	            var filteredIds = bubbleIds
	                .filter(function (item, index) {
	                if (item) {
	                    return bubbleIds.indexOf(item) === index;
	                }
	            })
	                .join(',');
	            JerseyRestApiService_1["default"].getBubbleById(filteredIds).then(function (response) {
	                _this.setState(__assign({}, _this.state, { bubbleData: response }));
	            });
	        };
	        _this.fetchCityStates = function () { return __awaiter(_this, void 0, void 0, function () {
	            var response;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, JerseyRestApiService_1["default"].getCityStates()];
	                    case 1:
	                        response = _a.sent();
	                        this.setState(__assign({}, this.state, { cityStates: response.cities }));
	                        return [2 /*return*/];
	                }
	            });
	        }); };
	        _this.loadDrafts = function (resetPage) {
	            var _a = _this.state, categoryFilter = _a.categoryFilter, publisherFilter = _a.publisherFilter, timeFilter = _a.timeFilter, typeFilter = _a.typeFilter, limit = _a.limit, currentPage = _a.currentPage, draftIds = _a.draftIds;
	            var categoryIds = categoryFilter === null ? [] : [categoryFilter];
	            var publisherId = publisherFilter === null ? '' : publisherFilter;
	            var createdAfterSeconds = Math.round(new Date().getTime() / 1000) - timeFilter * 3600;
	            var offset = resetPage ? 0 : (currentPage - 1) * limit;
	            var type = typeFilter, storyType;
	            if (typeFilter === types_1.TypeFilter.NEWS || typeFilter === types_1.TypeFilter.FEATURE) {
	                storyType = Utils_1.typeFilters[typeFilter];
	                type = types_1.TypeFilter.STORY;
	            }
	            else if (typeFilter === types_1.TypeFilter.GLANCETV) {
	                storyType = Utils_1.typeFilters[typeFilter];
	                type = types_1.TypeFilter.ALL;
	            }
	            var payload = {
	                categoryIds: categoryIds,
	                publisherId: publisherId,
	                type: Utils_1.typeFilters[type],
	                createdAfterSeconds: createdAfterSeconds,
	                limit: limit,
	                offset: offset,
	                storyType: storyType
	            };
	            _this.setState(__assign({}, _this.state, { showLoader: true, data: resetPage ? null : _this.state.data, currentPage: resetPage ? 1 : currentPage }));
	            if (!draftIds || draftIds.length == 0) {
	                // TODO: Move this api call to actions.
	                RestService_1["default"].getAllDrafts(payload)
	                    .then(function (response) {
	                    var drafts = response.drafts, count = response.count;
	                    _this.setState(__assign({}, _this.state, { data: resetPage ? drafts : _this.state.data.concat(drafts), showLoader: false, originalData: drafts, totalDrafts: count }));
	                    _this.loadDraftMetas(drafts);
	                    if (drafts.length) {
	                        _this.fetchBubbleDataByIds();
	                    }
	                })["catch"](function (error) {
	                    return _this.setState(__assign({}, _this.state, { snackbarOpen: true, showLoader: false, snackbarMessage: 'Something went wrong. Santa denied your request for drafts.' }));
	                });
	            }
	            else {
	                // TODO: Move this api call to actions.
	                RestService_1["default"].getDraftsByIds(draftIds, function (drafts) {
	                    if (drafts != null) {
	                        _this.setState(__assign({}, _this.state, { data: drafts, originalData: drafts, showLoader: false }));
	                        _this.loadDraftMetas(drafts);
	                        if (drafts.length) {
	                            _this.fetchBubbleDataByIds();
	                        }
	                    }
	                    else {
	                        _this.setState(__assign({}, _this.state, { snackbarOpen: true, showLoader: false, snackbarMessage: 'Something went wrong. Santa denied your request for drafts.' }));
	                    }
	                });
	            }
	        };
	        _this.isDraftPresentInList = function (drafts, draft) {
	            var result = false;
	            drafts.forEach(function (item) {
	                if (item.draftId == draft.draftId) {
	                    result = true;
	                }
	            });
	            return result;
	        };
	        _this.getPartnerRegionFilteredDrafts = function (resetPage) {
	            if (resetPage === void 0) { resetPage = true; }
	            var _a = _this.state, partner = _a.partner, publishFilter = _a.publishFilter, region = _a.region, typeFilter = _a.typeFilter, categoryFilter = _a.categoryFilter, publisherFilter = _a.publisherFilter, timeFilter = _a.timeFilter, limit = _a.limit, currentPage = _a.currentPage;
	            var categoryIds = categoryFilter === null ? [] : [categoryFilter];
	            var publisherId = publisherFilter === null ? '' : publisherFilter;
	            var createdAfterSeconds = Math.round(new Date().getTime() / 1000) - timeFilter * 3600;
	            var offset = resetPage ? 0 : currentPage * limit;
	            var isPublished = publishFilter === types_1.PublishFilter.PUBLISHED;
	            var type = typeFilter, storyType;
	            if (typeFilter === types_1.TypeFilter.NEWS || typeFilter === types_1.TypeFilter.FEATURE) {
	                storyType = Utils_1.typeFilters[typeFilter];
	                type = types_1.TypeFilter.STORY;
	            }
	            var payload = {
	                categoryIds: categoryIds,
	                publisherId: publisherId,
	                type: Utils_1.typeFilters[type],
	                createdAfterSeconds: createdAfterSeconds,
	                limit: limit,
	                offset: offset,
	                partner: partner,
	                region: region,
	                isPublished: isPublished,
	                storyType: storyType
	            };
	            _this.setState(__assign({}, _this.state, { showLoader: true, currentPage: resetPage ? 1 : currentPage, data: resetPage ? null : _this.state.data }), function () {
	                RestService_1["default"].getDraftsByPartnerAndRegion(payload)
	                    .then(function (response) {
	                    var drafts = response.drafts, count = response.count;
	                    _this.setState(__assign({}, _this.state, { data: resetPage ? drafts : _this.state.data.concat(drafts), snackbarOpen: false, showLoader: false, totalDrafts: count }));
	                })["catch"](function (error) {
	                    _this.setState(__assign({}, _this.state, { snackbarOpen: false, showLoader: false }));
	                });
	            });
	        };
	        _this.copyDraft = function (draft) {
	            var copyDraft = __assign({}, draft);
	            if (copyDraft.peek.offlinePeekUrl === '') {
	                copyDraft.peek.offlinePeekUrl = null;
	            }
	            copyDraft.createdAtInSecs = Math.round(new Date().getTime() / 1000);
	            var getCopyId = function () { return __awaiter(_this, void 0, void 0, function () {
	                var encrypted, copyDraftId, checkId;
	                return __generator(this, function (_a) {
	                    switch (_a.label) {
	                        case 0:
	                            console.log('inside getCopyId');
	                            encrypted = CryptoJS.SHA1(Math.random().toString() + new Date().getTime.toString());
	                            copyDraftId = base64url
	                                .encode(String(encrypted), 'utf8')
	                                .substring(0, 8);
	                            if (copyDraftId.charAt(0) === 'Y' || copyDraftId.charAt(0) === 'Z') {
	                                copyDraftId = 'X' + copyDraftId.substring(1, copyDraftId.length);
	                            }
	                            return [4 /*yield*/, RestService_1["default"].checkDraftById(copyDraftId)];
	                        case 1:
	                            checkId = _a.sent();
	                            if (checkId)
	                                return [2 /*return*/, copyDraftId];
	                            getCopyId();
	                            return [2 /*return*/];
	                    }
	                });
	            }); };
	            getCopyId()
	                .then(function (res) { return (copyDraft.draftId = res); })
	                .then(function () {
	                _this.setState(__assign({}, _this.state, { showLoader: false, disableCopy: false, snackbarOpen: false }));
	            })["catch"](function (err) {
	                _this.setState(__assign({}, _this.state, { showLoader: false, disableCopy: false, snackbarOpen: true, snackbarMessage: 'copying draft failed. try again later' }));
	            });
	            copyDraft.version = 0;
	            copyDraft.editMeta.state = 0 /* NEW */;
	            var copyAppMeta = copyDraft.peek &&
	                copyDraft.peek.appCta &&
	                copyDraft.peek.appCta.appInstallMeta;
	            if (copyAppMeta) {
	                var appMatch = _this.props.studioAppConfig.apps.filter(function (app) {
	                    return app.packageId == copyAppMeta.packageName;
	                });
	                if (appMatch && appMatch.length) {
	                    var appItem = appMatch[0];
	                    copyDraft.peek.appCta.appInstallMeta = {
	                        secondaryBrandColor: appItem.secondaryBrandColor,
	                        logoUrl: appItem.logoUrl,
	                        appName: appItem.name,
	                        category: appItem.category,
	                        size: appItem.size,
	                        rating: appItem.rating,
	                        downloadCount: appItem.downloadCount,
	                        title: appItem.title,
	                        description: appItem.description,
	                        screenshotUrls: appItem.screenshotUrls,
	                        packageName: appItem.packageId,
	                        appBundleUrl: '',
	                        notifTemplateId: '',
	                        d1NotifTemplateId: '',
	                        ltvNotifTemplateId: '',
	                        appId: '',
	                        brandColor: appItem.brandColor,
	                        brandBgImage: appItem.brandBgImage,
	                        appOptionalDetails: appItem.appOptionalDetails,
	                        preloadEnable: appItem.preloadEnable ? appItem.preloadEnable : false,
	                        contentProviderUrl: appItem.contentProviderUrl
	                            ? appItem.contentProviderUrl
	                            : '',
	                        prldAttr: appItem.prldAttr,
	                        templateId: appItem.templateId,
	                        tag: appItem.tag,
	                        reviewCount: appItem.reviewCount,
	                        sizeInMb: appItem.sizeInMb,
	                        categoryInfo: appItem.categoryInfo,
	                        bgColor: appItem.bgColor,
	                        textColor: appItem.textColor,
	                        carouselImages: appItem.carouselImages,
	                        installNowCta: appItem.installNowCta,
	                        installLaterCta: appItem.installLaterCta,
	                        fbu: appItem.fbu,
	                        sourceName: appItem.sourceName,
	                        dspAdvertiserGuid: appItem.dspAdvertiserGuid
	                    };
	                }
	            }
	            var newData = _this.state.data.slice();
	            newData.splice(newData.indexOf(draft) + 1, 0, copyDraft);
	            _this.setState(__assign({}, _this.state, { data: newData, originalData: newData, snackbarOpen: true, snackbarMessage: 'Copying..', showLoader: true, disableCopy: true }));
	        };
	        _this.createDraft = function () {
	            if (!_this.state.link || _this.state.link.length == 0) {
	                return;
	            }
	            var that = _this;
	            _this.setState(__assign({}, _this.state, { snackbarOpen: true, snackbarMessage: 'Hold your horses. Creating new draft...' }));
	            RestService_1["default"].createDraftFromLink(_this.state.link, _this.state.cardType, _this.state.testMode, function (draft) {
	                if (draft != null) {
	                    var newData = [draft].concat(that.state.data);
	                    that.setState(__assign({}, that.state, { link: null, data: newData, originalData: newData, snackbarOpen: true, snackbarMessage: 'Behold. New draft has been created!', typeFilter: types_1.TypeFilter.STORY }));
	                }
	            });
	        };
	        _this.createDraftFromImage = function (files) {
	            var that = _this;
	            that.setState(__assign({}, that.state, { snackbarOpen: true, snackbarMessage: 'Uploading image. Might take a few seconds, go grab a coffee.' }));
	            RestService_1["default"].uploadImage(files[0], function (image) {
	                if (image == null) {
	                    that.setState(__assign({}, that.state, { snackbarOpen: true, snackbarMessage: 'Image upload failed.' }));
	                }
	                else {
	                    that.setState(__assign({}, that.state, { snackbarOpen: true, snackbarMessage: 'Image uploaded. Creating new draft...' }));
	                    RestService_1["default"].createDraftFromImage(image.id, _this.state.cardType, function (draft) {
	                        if (draft != null) {
	                            var newData = [draft].concat(that.state.data);
	                            that.setState(__assign({}, that.state, { link: null, data: newData, originalData: newData, snackbarOpen: true, snackbarMessage: 'Behold. New draft has been created!', typeFilter: types_1.TypeFilter.WALLPAPER }));
	                        }
	                    });
	                }
	            });
	        };
	        _this.closeSnackbar = function () {
	            _this.setState(__assign({}, _this.state, { snackbarOpen: false }));
	        };
	        _this.pushFilterUrl = function (typeFilter, categoryFilter, publisherFilter, regionFilter, timeFilter, publishFilter, partner, region) {
	            var url = '/' +
	                _this.props.params.role +
	                '/drafts/type/' +
	                types_1.TypeFilter[typeFilter] +
	                '/' +
	                typeFilter +
	                '/category/' +
	                encodeURIComponent(categoryFilter) +
	                '/publisher/' +
	                encodeURIComponent(publisherFilter) +
	                '/time/' +
	                timeFilter +
	                '/publishState/' +
	                types_1.PublishFilter[publishFilter] +
	                '/' +
	                publishFilter +
	                (partner ? '/partner/' + partner.partnerId : '') +
	                (region ? '/partnerRegion/' + region : '') +
	                (regionFilter
	                    ? '/regionFilter/' + regionFilter
	                    : partner && region
	                        ? '/regionFilter/' + types_1.RegionFilter.ANY
	                        : '');
	            _this.props.history.push(url);
	        };
	        _this.filterByTypeAndStoryType = function (glanceType, typeFilter, storyType) {
	            if (glanceType == 1 /* WALLPAPER */ &&
	                typeFilter == types_1.TypeFilter.WALLPAPER) {
	                return true;
	            }
	            if (glanceType == 4 /* SPONSORED */ &&
	                typeFilter == types_1.TypeFilter.SPONSORED) {
	                return true;
	            }
	            if (glanceType == 2 /* STORY */ && typeFilter == types_1.TypeFilter.STORY) {
	                return true;
	            }
	            if (glanceType == 2 /* STORY */ &&
	                typeFilter == types_1.TypeFilter.NEWS &&
	                storyType == 1 /* NEWS */) {
	                return true;
	            }
	            if (glanceType == 2 /* STORY */ &&
	                typeFilter == types_1.TypeFilter.FEATURE &&
	                storyType == 2 /* FEATURE */) {
	                return true;
	            }
	            return false;
	        };
	        _this.singleClickPublish = function (draft) {
	            var _a = _this.state, regionPublishMeta = _a.regionPublishMeta, activeRegion = _a.activeRegion;
	            var errorMsgMap = _this.state.errorMsgMap;
	            errorMsgMap.set(draft.draftId, '');
	            _this.setState(__assign({}, _this.state, { errorMsgMap: errorMsgMap }));
	            var partnerIds = _this.state.selectedPartners.map(function (partnerSource) { return partnerSource.value.partnerId; });
	            var hasProlongedExpiry = draft.type == 2 /* STORY */ &&
	                !Utils_1["default"].isExpiryRelaxed(partnerIds) &&
	                ((_this.defaultValues.durationUnit == 1 /* DAYS */ &&
	                    _this.defaultValues.duration > 30) ||
	                    (_this.defaultValues.durationUnit == 0 /* HOURS */ &&
	                        _this.defaultValues.duration > 720));
	            if (hasProlongedExpiry) {
	                if (draft.frequencyCaps == null ||
	                    draft.frequencyCaps.weekly == null ||
	                    draft.frequencyCaps.weekly > 5) {
	                    errorMsgMap.set(draft.draftId, 'Duration Cannot be more than 72 hours for glances without frequency cap');
	                    _this.setState(__assign({}, _this.state, { errorMsgMap: errorMsgMap }));
	                    return;
	                }
	            }
	            _this.state.selectedPartners.forEach(function (partner) {
	                if (regionPublishMeta &&
	                    regionPublishMeta.get(activeRegion).partnerSources.indexOf(partner) ==
	                        -1) {
	                    errorMsgMap.set(draft.draftId, 'Selected partners and selected region not valid');
	                    _this.setState(__assign({}, _this.state, { errorMsgMap: errorMsgMap }));
	                    return;
	                }
	            });
	            if (_this.state.errorMsgMap.get(draft.draftId)) {
	                return;
	            }
	            if (!_this.state.activeRegion) {
	                errorMsgMap.set(draft.draftId, 'No region selected in publish settings');
	                _this.setState(__assign({}, _this.state, { errorMsgMap: errorMsgMap }));
	                return;
	            }
	            if (!draft.preferedRegions ||
	                draft.preferedRegions.indexOf(_this.state.activeRegion) == -1) {
	                errorMsgMap.set(draft.draftId, 'Selected region not in preferred regions');
	                _this.setState(__assign({}, _this.state, { errorMsgMap: errorMsgMap }));
	                return;
	            }
	            if (!_this.state.selectedPartners ||
	                _this.state.selectedPartners.length == 0) {
	                errorMsgMap.set(draft.draftId, 'No partners selected');
	                _this.setState(__assign({}, _this.state, { errorMsgMap: errorMsgMap }));
	                return;
	            }
	            var partners = [];
	            _this.state.selectedPartners.map(function (partner) {
	                partners.push(partner.value);
	            });
	            var startTimeObj;
	            var startTimeType = _this.defaultValues.startTimeType;
	            if (startTimeType == GlanceRegionPublish_1.StartTimeType.NOW) {
	                startTimeObj = new glance_datatypes_1.StartTime({
	                    absoluteTime: new glance_datatypes_1.AbsoluteTime({
	                        timeInSecs: Math.round(new Date().getTime() / 1000)
	                    })
	                });
	            }
	            else {
	                var startDate = _this.defaultValues.startDate;
	                var startTime = _this.defaultValues.startTime;
	                startTimeObj = new glance_datatypes_1.StartTime({
	                    relativeTime: new glance_datatypes_1.RelativeTime({
	                        year: startDate.getFullYear(),
	                        month: startDate.getMonth() + 1,
	                        date: startDate.getDate(),
	                        hour: startTime.getHours(),
	                        minute: startTime.getMinutes()
	                    })
	                });
	            }
	            var publishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            if (publishMeta &&
	                publishMeta.selectedExperiments &&
	                publishMeta.selectedExperiments.length > 0 &&
	                publishMeta.selectedExperimentMetas.length == 0) {
	                errorMsgMap.set(draft.draftId, 'Select at least 1 variant for publishing');
	                _this.setState(__assign({}, _this.state, { errorMsgMap: errorMsgMap }));
	                return;
	            }
	            var userLevelDuration = _this.userLevelDefaultValues.enabled
	                ? new glance_datatypes_1.Duration({
	                    unit: _this.userLevelDefaultValues.durationUnit,
	                    length: _this.userLevelDefaultValues.duration
	                })
	                : null;
	            var glanceTime = new glance_datatypes_1.GlanceTime({
	                duration: new glance_datatypes_1.Duration({
	                    unit: _this.defaultValues.durationUnit,
	                    length: _this.defaultValues.duration
	                }),
	                startTime: startTimeObj,
	                userLevelDuration: userLevelDuration
	            });
	            var resMsg = '';
	            if (_this.state.bulkChangeData != null) {
	                if (_this.state.bulkChangeData.canSkipSummary != null) {
	                    if (draft.peek != null) {
	                        draft.peek.canSkipSummary = _this.state.bulkChangeData.canSkipSummary;
	                    }
	                }
	                if (_this.state.bulkChangeData.categorySubscriptionStatus != null) {
	                    draft.categorySubscriptionStatus = _this.state.bulkChangeData.categorySubscriptionStatus;
	                }
	                if (_this.state.bulkChangeData.renderSessionProperties &&
	                    _this.state.bulkChangeData.renderSessionProperties.length) {
	                    draft.renderSessionProperties = _this.state.bulkChangeData.renderSessionProperties;
	                }
	                if (_this.state.bulkChangeData.shouldUnlock != null) {
	                    if (draft.peek) {
	                        draft.peek.shouldUnlock = _this.state.bulkChangeData.shouldUnlock;
	                    }
	                }
	                if (_this.state.bulkChangeData.targetForCategories != null) {
	                    draft.targetForCategories = _this.state.bulkChangeData.targetForCategories;
	                }
	                if (_this.state.bulkChangeData.advancedCta != null) {
	                    draft.peek.loadAndroidJs = _this.state.bulkChangeData.advancedCta;
	                }
	                if (_this.state.bulkChangeData.userLifeTimeFilter) {
	                    draft.userLifeTimeFilter = _this.state.bulkChangeData.userLifeTimeFilter;
	                }
	                if (_this.state.bulkChangeData.categoryIds != null) {
	                    draft.categoryIds = _this.state.bulkChangeData.categoryIds;
	                }
	                if (_this.state.bulkChangeData.segments != null) {
	                    draft.segmentIds = _this.state.bulkChangeData.segments.map(function (seg) { return seg.id; });
	                }
	            }
	            var that = _this;
	            if (_this.state.bulkChangeData) {
	                RestService_1["default"].saveDraft(draft, function (newDraft) {
	                    if (newDraft) {
	                        RestService_1["default"].publishDraft(newDraft.draftId, that.state.activeRegion, partners, glanceTime, publishMeta.selectedExperimentMetas, publishMeta.selectedSegmentRulesList, publishMeta.isPartedGlance, publishMeta.partingSchedule, function (result, error) {
	                            if (result) {
	                                resMsg = 'Glance Published Successfully';
	                            }
	                            if (error) {
	                                resMsg = 'Glance Publishing Failed';
	                            }
	                            that.updateData(resMsg, draft);
	                        });
	                    }
	                    else {
	                        resMsg = 'Glance Publishing Failed';
	                        this.updateData(resMsg, draft);
	                    }
	                });
	            }
	            else {
	                RestService_1["default"].publishDraft(draft.draftId, that.state.activeRegion, partners, glanceTime, publishMeta.selectedExperimentMetas, publishMeta.selectedSegmentRulesList, publishMeta.isPartedGlance, publishMeta.partingSchedule, function (result, error) {
	                    if (result) {
	                        resMsg = 'Glance Published Successfully';
	                    }
	                    if (error) {
	                        resMsg = 'Glance Publishing Failed';
	                    }
	                    that.updateData(resMsg, draft);
	                });
	            }
	        };
	        _this.updateData = function (msg, draft) {
	            var that = _this;
	            var regionPartnerList = [];
	            var draftMeta = _this.state.draftMeta;
	            RestService_1["default"].getPublishMeta(draft.draftId, function (metas) {
	                if (metas && metas.length > 0) {
	                    metas.forEach(function (meta) {
	                        var tuple = {
	                            region: meta.region,
	                            partner: _this.state.partnerMap.get(meta.partnerId)
	                        };
	                        regionPartnerList.push(tuple);
	                    });
	                }
	                var draftToRegionPartnerMap = _this.state.draftToRegionPartnerMap;
	                var errorMsgMap = _this.state.errorMsgMap;
	                errorMsgMap.set(draft.draftId, msg);
	                draftToRegionPartnerMap.set(draft.draftId, regionPartnerList);
	                draftMeta.set(draft.draftId, metas);
	                that.setState(__assign({}, _this.state, { draftToRegionPartnerMap: draftToRegionPartnerMap, errorMsgMap: errorMsgMap, draftMeta: draftMeta }));
	            });
	        };
	        _this.handleActiveRegion = function (region) {
	            _this.setState(__assign({}, _this.state, { activeRegion: region }));
	        };
	        _this.handlerPartnerDelete = function (chip) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var partnerSources = [];
	            _this.state.selectedPartners.map(function (partner) {
	                if (chip.partnerId != partner.value.partnerId) {
	                    partnerSources.push(partner);
	                }
	            });
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            if (!currentRegionPublishMeta.publishTo) {
	                return;
	            }
	            var publishToPartners = currentRegionPublishMeta.publishTo.filter(function (item) {
	                return item.value.partnerId != chip.partnerId;
	            });
	            var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { publishTo: publishToPartners, publishToSelected: null });
	            regionPublishMeta.set(_this.state.activeRegion, newCurrentRegionPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta, selectedPartners: partnerSources }));
	        };
	        _this.closePublishDialog = function () {
	            _this.setState(__assign({}, _this.state, { isPublishSettingChangeClicked: false }));
	        };
	        _this.closeChangeDataDialog = function () {
	            _this.setState(__assign({}, _this.state, { bulkChangeData: null, isChangeDataClicked: false }));
	        };
	        _this.saveChangeDataDialog = function () {
	            _this.setState(__assign({}, _this.state, { isChangeDataClicked: false }));
	        };
	        _this.handleExperimentSelected = function (experimentId) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            var selectedExperimentMeta = null;
	            if (currentRegionPublishMeta.selectedExperiments) {
	                selectedExperimentMeta = currentRegionPublishMeta.selectedExperiments[0];
	            }
	            var experiments = [];
	            if (experimentId) {
	                var selectedExperiment = _this.state.experiments.get(experimentId);
	                experiments = [
	                    __assign({}, selectedExperimentMeta, { id: experimentId, variantId: selectedExperimentMeta
	                            ? selectedExperimentMeta.variantId
	                            : selectedExperiment.control.id }),
	                ];
	            }
	            currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedExperiments: experiments, selectedExperimentMetas: experiments.slice() });
	            regionPublishMeta.set(_this.state.activeRegion, currentRegionPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.handleExperimentVariantSelected = function (variantId, experimentId) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            var selectedExperiment = null;
	            var selectedExperimentMetas = currentRegionPublishMeta.selectedExperimentMetas;
	            selectedExperiment = {
	                id: experimentId,
	                variantId: variantId
	            };
	            var alreadyExists = currentRegionPublishMeta.selectedExperimentMetas.indexOf(selectedExperiment);
	            if (alreadyExists == -1) {
	                selectedExperimentMetas.push(selectedExperiment);
	            }
	            selectedExperiment = __assign({}, selectedExperiment, { variantId: variantId });
	            currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedExperimentMetas: selectedExperimentMetas });
	            regionPublishMeta.set(_this.state.activeRegion, currentRegionPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.handleExperimentVariantDelete = function (chip, experimentId) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            var selectedExperiments = currentRegionPublishMeta.selectedExperimentMetas.filter(function (item) {
	                return item.variantId != chip.id;
	            });
	            currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedExperimentMetas: selectedExperiments });
	            regionPublishMeta.set(_this.state.activeRegion, currentRegionPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.getBulkPublishDateAndTime = function () {
	            var date = _this.defaultValues.startDate;
	            var time = _this.defaultValues.startTime;
	            return (date.getDate().toString() +
	                '-' +
	                (date.getMonth() + 1).toString() +
	                '-' +
	                date.getFullYear().toString() +
	                '; ' +
	                time.getHours().toString() +
	                ':' +
	                time.getMinutes());
	        };
	        _this.onUserLevelDurationUpdate = function (enabled, unit, value) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            if (!enabled) {
	                unit = null;
	                value = null;
	            }
	            _this.userLevelDefaultValues = {
	                enabled: enabled,
	                duration: value,
	                durationUnit: unit
	            };
	            var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { userLevelDuration: value, userLevelDurationUnit: unit, userLevelDurationEnabled: enabled });
	            regionPublishMeta.set(_this.state.activeRegion, newCurrentRegionPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.onPartingTimeUpdate = function (enabled, schedule) {
	            var _a = _this.state, regionPublishMeta = _a.regionPublishMeta, activeRegion = _a.activeRegion;
	            var currentRegionPublishMeta = regionPublishMeta.get(activeRegion);
	            if (!enabled) {
	                schedule = null;
	            }
	            var newPublishMeta = __assign({}, currentRegionPublishMeta, { partingSchedule: schedule, isPartedGlance: enabled });
	            regionPublishMeta.set(activeRegion, newPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.getBulkUserLevelDuration = function () {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var publishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            if (publishMeta) {
	                return publishMeta.userLevelDurationEnabled
	                    ? 'user: ' +
	                        publishMeta.userLevelDuration +
	                        ' ' +
	                        (publishMeta.userLevelDurationUnit == 1 /* DAYS */
	                            ? 'days'
	                            : 'hours')
	                    : 'User level expiry disabled';
	            }
	            return '';
	        };
	        _this.onPageChange = function (page) {
	            _this.setState(__assign({}, _this.state, { currentPage: page }), function () {
	                var _a = _this.state, region = _a.region, partner = _a.partner;
	                if (region && partner) {
	                    _this.getPartnerRegionFilteredDrafts(false);
	                }
	                else {
	                    _this.loadDrafts(false);
	                }
	            });
	        };
	        _this.onTargetingRuleDeleted = function (index) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            var _a = currentRegionPublishMeta.selectedSegmentRulesList, selectedSegmentRulesNew = _a === void 0 ? [] : _a;
	            selectedSegmentRulesNew.splice(index, 1);
	            currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedSegmentRulesList: selectedSegmentRulesNew });
	            regionPublishMeta.set(_this.state.activeRegion, currentRegionPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.onSegmentRuleSelected = function (value, isAdd, index) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.state.activeRegion);
	            var _a = currentRegionPublishMeta.selectedSegmentRulesList, selectedSegmentRulesNew = _a === void 0 ? [] : _a;
	            if (isAdd) {
	                if (selectedSegmentRulesNew[index]) {
	                    selectedSegmentRulesNew[index].push(value);
	                }
	                else {
	                    selectedSegmentRulesNew[index] = [value];
	                }
	            }
	            else {
	                selectedSegmentRulesNew[index] = selectedSegmentRulesNew[index].filter(function (selSeg) { return selSeg.ruleId !== value; });
	            }
	            currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedSegmentRulesList: selectedSegmentRulesNew });
	            regionPublishMeta.set(_this.state.activeRegion, currentRegionPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        var initialStateFromProp = _this.getInitialStateFromProp(props);
	        _this.state = __assign({}, initialStateFromProp);
	        return _this;
	    }
	    GlanceDrafts.prototype.componentDidMount = function () {
	        var _a = this.state, partner = _a.partner, region = _a.region;
	        if (partner && region) {
	            this.filterDraftsByPartnerRegion(region);
	        }
	        else {
	            this.loadDrafts(true);
	        }
	        this.fetchCityStates();
	    };
	    GlanceDrafts.prototype.render = function () {
	        var _this = this;
	        var activeRegion = this.state.activeRegion;
	        var tabs = [];
	        var publishActions = [];
	        var changeDataActions = [];
	        var _a = this.state, limit = _a.limit, currentPage = _a.currentPage, data = _a.data, totalDrafts = _a.totalDrafts, regionPublishMeta = _a.regionPublishMeta;
	        changeDataActions.push(React.createElement(material_ui_1.FlatButton, { label: "Turn Off", primary: true, onClick: this.closeChangeDataDialog }));
	        changeDataActions.push(React.createElement(material_ui_1.FlatButton, { label: "Turn On", primary: true, onClick: this.saveChangeDataDialog }));
	        publishActions.push(React.createElement(material_ui_1.FlatButton, { label: "Ok", primary: true, onClick: this.closePublishDialog }));
	        Utils_1.allRegions.forEach(function (region) {
	            tabs.push(React.createElement(Tabs_1.Tab, { key: region, label: React.createElement("span", { key: region }, Utils_1.regionNames[region]), value: region, style: glanceDraftsStyle_1.styles.regionTab },
	                React.createElement(GlanceRegionPublish_1.GlanceRegionPublish, { key: region, region: region, regionPublishMeta: regionPublishMeta.get(region), defaultValues: _this.defaultValues, userLevelDefaultValues: _this.userLevelDefaultValues, partnerAdded: _this.handlerPartnerAdd, partnerRemoved: _this.handlerPartnerDelete, experimentAdded: _this.handleExperimentSelected, variantSelected: _this.handleExperimentVariantSelected, variantRemoved: _this.handleExperimentVariantDelete, onDurationUpdate: _this.durationUpdate, onStartTimeUpdate: _this.startTimeUpdate, onUserLevelDurationUpdate: _this.onUserLevelDurationUpdate, onPartingTimeUpdate: _this.onPartingTimeUpdate, shortTitleCheck: true, cheesySummaryCheck: true, partnerMetas: _this.props.studioAppConfig.partnerMetas, draft: null, experiments: _this.state.experiments, segmentRules: _this.state.segmentRules, onSegmentRuleSelected: _this.onSegmentRuleSelected, onTargetingRuleDeleted: _this.onTargetingRuleDeleted, isSettingsView: true, isDspCampaign: false })));
	        });
	        var selectedExperiments = [];
	        if (regionPublishMeta &&
	            regionPublishMeta.get(this.state.activeRegion) &&
	            regionPublishMeta.get(this.state.activeRegion).selectedExperimentMetas) {
	            regionPublishMeta
	                .get(this.state.activeRegion)
	                .selectedExperimentMetas.map(function (ex) {
	                var experiment = _this.state.experiments.get(ex.id);
	                var variant = experiment.control.id == ex.variantId ? experiment.control : null;
	                variant = variant
	                    ? variant
	                    : experiment.variants.find(function (v) { return v.id == ex.variantId; });
	                selectedExperiments.push({
	                    experiment: experiment.name,
	                    variant: variant ? variant.name : 'No Variant'
	                });
	            });
	        }
	        var handleCardTypeChange = function (_event, value) {
	            _this.setState(__assign({}, _this.state, { cardType: value }));
	        };
	        var _b = this.state, link = _b.link, linkWarning = _b.linkWarning;
	        return (React.createElement("div", { style: { display: 'inline-block', minWidth: '100%' } },
	            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
	                React.createElement(material_ui_1.RadioButtonGroup, { name: "cardType", style: {
	                        display: 'inline-flex',
	                        width: '25%',
	                        margin: '25px 0 15px 60px'
	                    }, defaultSelected: "1", onChange: handleCardTypeChange },
	                    React.createElement(material_ui_1.RadioButton, { style: {
	                            float: 'left',
	                            marginLeft: '5px',
	                            display: 'inline-block'
	                        }, value: "1", label: "Smart Phone" }),
	                    React.createElement(material_ui_1.RadioButton, { style: {
	                            float: 'left',
	                            marginLeft: '10px',
	                            display: 'inline-block'
	                        }, value: "2", label: "TV" })),
	                React.createElement(material_ui_1.Toggle, { label: 'Test Mode', style: { width: 125, marginTop: 27 }, onToggle: function (e, value) { return _this.handleTestModeChange(e, value); } })),
	            React.createElement("div", { style: { display: 'block' } },
	                this.props.studioAppConfig.currentToken.role == 0 /* ADMIN */ ||
	                    this.props.studioAppConfig.currentToken.role == 1 /* CURATOR */ ||
	                    this.props.studioAppConfig.currentToken.role == 2 /* MODERATOR */ ? (React.createElement("form", { onSubmit: function (e) {
	                        e.preventDefault();
	                        _this.createDraft();
	                    }, style: glanceDraftsStyle_1.styles.draftLinkForm },
	                    React.createElement(material_ui_1.TextField, { hintText: "Enter a link to create draft", style: glanceDraftsStyle_1.styles.draftLinkText, value: this.state.link == null ? '' : this.state.link, inputStyle: { width: '100%' }, onChange: this.onDraftLinkChange }),
	                    linkWarning && (React.createElement("div", { style: glanceDraftsStyle_1.styles.alertMessage },
	                        React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: glanceDraftsStyle_1.warningColor, hoverColor: glanceDraftsStyle_1.warningColor, style: { fontSize: '24px', marginRight: '8px' } }, "info"),
	                        this.state.linkWarning)),
	                    React.createElement("div", { style: glanceDraftsStyle_1.styles.draftCTA },
	                        React.createElement(material_ui_1.FloatingActionButton, { mini: true, type: "submit" },
	                            React.createElement(material_ui_1.FontIcon, { className: "material-icons" }, "add"))))) : (''),
	                this.props.studioAppConfig.currentToken.role == 0 /* ADMIN */ ||
	                    this.props.studioAppConfig.currentToken.role == 3 /* DESIGNER */ ||
	                    this.props.studioAppConfig.currentToken.role == 2 /* MODERATOR */ ? (React.createElement("div", { style: { width: '30%', margin: 'auto' } },
	                    React.createElement(ImageDropzone_1["default"], { draftImageHeight: true, onDrop: this.createDraftFromImage, style: { paddingBottom: null } }))) : ('')),
	            React.createElement(Toolbar_1.Toolbar, { style: { marginTop: '2%' } },
	                React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true },
	                    React.createElement(Toolbar_1.ToolbarTitle, { text: "Filters", style: { marginLeft: '24px' } }),
	                    React.createElement(Toolbar_1.ToolbarSeparator, null),
	                    React.createElement(material_ui_1.DropDownMenu, { value: this.state.typeFilter, onChange: this.handleTypeFilterChange },
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.TypeFilter.ALL, primaryText: "Everything" }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.TypeFilter.WALLPAPER, primaryText: "Wallpapers" }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.TypeFilter.STORY, primaryText: "Stories" }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.TypeFilter.SPONSORED, primaryText: "Sponsored" }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.TypeFilter.NEWS, primaryText: "News Stories" }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.TypeFilter.FEATURE, primaryText: "Feature Stories" }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.TypeFilter.GLANCETV, primaryText: "Glance TV" })),
	                    React.createElement(material_ui_1.DropDownMenu, { maxHeight: 400, value: this.state.categoryFilter, onChange: this.handleCategoryFilterChange }, categoryList),
	                    React.createElement(material_ui_1.DropDownMenu, { maxHeight: 400, value: this.state.publisherFilter, onChange: this.handlePublisherFilterChange }, publisherList),
	                    React.createElement(material_ui_1.DropDownMenu, { value: this.state.timeFilter, onChange: this.handleTimeFilterChange },
	                        React.createElement(material_ui_1.MenuItem, { value: 24, primaryText: "Created Today" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 1, primaryText: "1 Hour Ago" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 3, primaryText: "3 Hours Ago" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 6, primaryText: "6 Hours Ago" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 12, primaryText: "12 Hours Ago" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 48, primaryText: "Last 2 days" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 72, primaryText: "Last 3 days" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 120, primaryText: "Last 5 days" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 192, primaryText: "Last 8 days" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 360, primaryText: "Last 15 days" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 720, primaryText: "Last 30 days" }),
	                        React.createElement(material_ui_1.MenuItem, { value: 1440, primaryText: "Last 60 days" })),
	                    React.createElement(material_ui_1.DropDownMenu, { value: this.state.publishFilter, onChange: this.handlePublishFilterChange },
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.PublishFilter.ALL, primaryText: 'All Drafts' }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.PublishFilter.PUBLISHED, primaryText: 'Published Drafts' }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.PublishFilter.UNPUBLISHED, primaryText: 'Unpublished Drafts' })),
	                    React.createElement(material_ui_1.DropDownMenu, { value: this.state.sortItem, onChange: this.handleSortItemChange },
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.SortItem.PRIORITY_ASC, primaryText: 'Priority Ascending' }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.SortItem.PRIORITY_DESC, primaryText: 'Priority Descending' }),
	                        React.createElement(material_ui_1.MenuItem, { value: types_1.SortItem.DEFAULT, primaryText: 'Sort By' })),
	                    this.state.publishFilter != types_1.PublishFilter.ALL ? (React.createElement(material_ui_1.DropDownMenu, { value: this.state.partner ? this.state.partner.partnerId : null, onChange: this.handlePartnerFilterChange },
	                        React.createElement(material_ui_1.MenuItem, { value: null, primaryText: 'Select Partner' }),
	                        this.props.studioAppConfig.partners.map(function (item, index) {
	                            return (React.createElement(material_ui_1.MenuItem, { value: item.partnerId, primaryText: item.name }));
	                        }))) : (''),
	                    this.state.partner &&
	                        this.state.publishFilter != types_1.PublishFilter.ALL ? (React.createElement(material_ui_1.DropDownMenu, { value: this.state.region, onChange: this.handlePartnerRegionFilterChange },
	                        React.createElement(material_ui_1.MenuItem, { value: null, primaryText: 'Select Region' }),
	                        this.state.partnerMetaMap
	                            .get(this.state.partner.partnerId)
	                            .supportedRegions.map(function (item, index) {
	                            return (React.createElement(material_ui_1.MenuItem, { value: item, primaryText: Utils_1["default"].getReadableRegionName(item) }));
	                        }))) : (''),
	                    this.state.partner &&
	                        this.state.region &&
	                        this.state.publishFilter != types_1.PublishFilter.ALL ? (React.createElement("div", null,
	                        React.createElement(material_ui_1.Toggle, { label: 'Tagged for ' +
	                                Utils_1["default"].getReadableRegionName(this.state.region), style: { width: 200, marginTop: 10 }, onToggle: this.handleRegionFilterChange }),
	                        ' ')) : (''))),
	            React.createElement(Toolbar_1.Toolbar, { style: __assign({}, glanceDraftsStyle_1.styles.footer, { marginTop: '1%', zIndex: 10 }) },
	                React.createElement(Toolbar_1.ToolbarGroup, { firstChild: true },
	                    React.createElement(Toolbar_1.ToolbarTitle, { text: "Publish Settings", style: { marginLeft: '24px' } }),
	                    React.createElement(Toolbar_1.ToolbarSeparator, null),
	                    this.state.selectedPartners &&
	                        this.state.selectedPartners.length > 0 ? (this.state.selectedPartners.map(function (partner) {
	                        return (React.createElement(material_ui_1.Chip, { style: glanceDraftsStyle_1.styles.chip, key: 'ps_' + partner.value.partnerId, backgroundColor: glanceDraftsStyle_1.selectedColor }, partner.text));
	                    })) : (React.createElement("div", { style: { marginLeft: '14px' } }, 'No partner Selected')),
	                    React.createElement(Toolbar_1.ToolbarSeparator, null),
	                    React.createElement("div", { style: { marginLeft: '14px' } }, this.state.activeRegion
	                        ? Utils_1["default"].getReadableRegionName(this.state.activeRegion)
	                        : 'No region'),
	                    React.createElement(Toolbar_1.ToolbarSeparator, null),
	                    React.createElement("div", { style: { marginLeft: '14px' } }, this.defaultValues.startTimeType == GlanceRegionPublish_1.StartTimeType.NOW
	                        ? 'publish now'
	                        : this.getBulkPublishDateAndTime()),
	                    React.createElement(Toolbar_1.ToolbarSeparator, null),
	                    React.createElement("div", { style: { marginLeft: '14px' } }, this.defaultValues.duration +
	                        ' ' +
	                        (this.defaultValues.durationUnit == 1 /* DAYS */
	                            ? 'days'
	                            : 'hours')),
	                    React.createElement(Toolbar_1.ToolbarSeparator, null),
	                    React.createElement("div", { style: { marginLeft: '14px' } }, this.getBulkUserLevelDuration()),
	                    React.createElement(Toolbar_1.ToolbarSeparator, null),
	                    selectedExperiments.length > 0 ? (React.createElement("div", { style: { marginLeft: '14px' } }, selectedExperiments.length + ' experiment variants selected')) : (React.createElement("div", { style: { marginLeft: '14px' } }, 'No experiments Selected')),
	                    React.createElement(material_ui_1.FlatButton, { label: 'Change', primary: true, onClick: function () {
	                            _this.setState(__assign({}, _this.state, { isPublishSettingChangeClicked: true }));
	                        } }),
	                    React.createElement(material_ui_1.FlatButton, { label: 'Change-Data', key: "changeData", primary: true, onClick: function () {
	                            _this.setState(__assign({}, _this.state, { isChangeDataClicked: true }));
	                        } }))),
	            React.createElement("div", null,
	                React.createElement(material_ui_1.Dialog, { modal: false, open: this.state.isPublishSettingChangeClicked, onRequestClose: this.closePublishDialog, actions: publishActions, autoScrollBodyContent: true, contentStyle: { maxWidth: '1200px', width: '90%' } }, React.createElement(Tabs_1.Tabs, { value: activeRegion, onChange: this.handleActiveRegion }, tabs))),
	            React.createElement("div", null,
	                React.createElement(material_ui_1.Dialog, { modal: false, open: this.state.isChangeDataClicked, onRequestClose: this.closeChangeDataDialog, actions: changeDataActions, autoScrollBodyContent: true }, React.createElement(GlanceChangeData_1["default"], { onEdit: this.onEditBulkData, bulkChangeData: this.state.bulkChangeData }))),
	            data &&
	                (data.length > 0 ? (React.createElement(GridList_1.GridList, { style: { width: '100%', margin: '0 auto', marginTop: '2%' }, cellHeight: "auto" }, data.map(function (element, index) {
	                    return (React.createElement(GridList_1.GridTile, { key: element.draftId, containerElement: React.createElement(GlanceDraft_1["default"], { glanceDraftData: element, draftMeta: _this.state.draftMeta.get(element.draftId), experiments: _this.state.experiments, singleClickPublish: _this.singleClickPublish, errorMsg: _this.state.errorMsgMap.get(element.draftId), regionPartnerList: _this.state.draftToRegionPartnerMap.get(element.draftId), role: _this.props.params.role, copyDraft: _this.copyDraft, disableCopy: _this.state.disableCopy, bubbleData: _this.state.bubbleData[element.bubbleId], cardType: _this.state.cardType, cityStates: _this.state.cityStates }), cols: 2 }));
	                }))) : (React.createElement(EmptyMessage_1["default"], { message: "No drafts for this combination of filters" }))),
	            React.createElement(Loader_1["default"], { show: this.state.showLoader, message: this.state.snackbarMessage, noHeight: true }),
	            data && totalDrafts > limit * currentPage && (React.createElement("div", { style: glanceDraftsStyle_1.styles.loadMoreStyleContainer },
	                React.createElement(material_ui_1.RaisedButton, { label: "Load More", primary: true, onTouchTap: function () { return _this.onPageChange(_this.state.currentPage + 1); } }))),
	            React.createElement(material_ui_1.Snackbar, { open: this.state.snackbarOpen, message: this.state.snackbarMessage, autoHideDuration: 5000, onRequestClose: this.closeSnackbar })));
	    };
	    return GlanceDrafts;
	}(React.Component));
	var mapStateToProps = function (state, ownProps) {
	    return __assign({ studioAppConfig: state.studioAppConfig }, ownProps);
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(GlanceDrafts);


/***/ },

/***/ 1007:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var material_ui_1 = __webpack_require__(38);
	var types_1 = __webpack_require__(125);
	var Utils_1 = __webpack_require__(17);
	var draftDetailsStyle_1 = __webpack_require__(247);
	var colors_1 = __webpack_require__(18);
	var BeaconTableRow = /** @class */ (function (_super) {
	    __extends(BeaconTableRow, _super);
	    function BeaconTableRow(props) {
	        var _this = _super.call(this, props) || this;
	        _this.checkBeaconUrlValidity = function (beaconUrl, s2sFlag) {
	            return new Promise(function (resolve, reject) {
	                $.ajax({
	                    type: 'POST',
	                    url: "https://beacons.glance.inmobi.com/beacon/validateBeacon?ctx=cta&s2s=" + s2sFlag,
	                    data: JSON.stringify({ urls: [
	                            beaconUrl,
	                        ] }),
	                    contentType: 'application/json',
	                    success: function (dataResponse) {
	                        var isValid = dataResponse[0];
	                        resolve(isValid);
	                    },
	                    error: function (error) {
	                        reject(error);
	                    }
	                });
	            });
	        };
	        _this.state = {
	            isValid: 'check'
	        };
	        return _this;
	    }
	    BeaconTableRow.prototype.componentWillMount = function () {
	        var _this = this;
	        this.checkBeaconUrlValidity(this.props.beaconItem.url, this.props.s2sFlag)
	            .then(function (isValid) {
	            _this.setState({
	                isValid: isValid
	            });
	        })["catch"](function (err) {
	        });
	        ;
	    };
	    BeaconTableRow.prototype.componentWillReceiveProps = function (nextProps) {
	        var _this = this;
	        if (nextProps.beaconItem.url !== this.props.beaconItem.url || nextProps.s2sFlag !== this.props.s2sFlag) {
	            this.setState({
	                isValid: 'check'
	            });
	            this.checkBeaconUrlValidity(nextProps.beaconItem.url, nextProps.s2sFlag)
	                .then(function (isValid) {
	                _this.setState({
	                    isValid: isValid
	                });
	            })["catch"](function (err) {
	            });
	            ;
	        }
	    };
	    BeaconTableRow.prototype.render = function () {
	        var _a = this.props, beaconType = _a.beaconType, beaconList = _a.beaconList, index = _a.index, beaconItem = _a.beaconItem, removeBeacon = _a.removeBeacon;
	        var isValid = this.state.isValid;
	        var isBeaconURLError = Utils_1["default"].isValidBeaconURL(beaconItem.url, beaconType, beaconItem.beaconPartner);
	        return (React.createElement(material_ui_1.TableRow, { selectable: false, key: beaconType + '_' + index, style: __assign({}, draftDetailsStyle_1.styles.width100, { height: '48px' }) },
	            React.createElement(material_ui_1.TableRowColumn, { style: { maxWidth: '150px', wordWrap: 'break-word', whiteSpace: 'normal', padding: '0 10px 0 0' } },
	                types_1.BeaconType[beaconType],
	                React.createElement("h6", null, beaconItem.beaconPartner !== 'None' ? beaconItem.beaconPartner : '')),
	            React.createElement(material_ui_1.TableRowColumn, { style: { maxWidth: '300px', whiteSpace: 'normal', padding: '0 10px', width: '300px', wordWrap: 'break-word' } },
	                beaconItem.url,
	                isBeaconURLError ? (React.createElement("span", null,
	                    React.createElement("hr", { style: { margin: 0 } }),
	                    React.createElement("span", { style: { color: 'red' } }, 'Beacon URL may not be correct please check'))) : ('')),
	            React.createElement(material_ui_1.TableRowColumn, { style: { width: '26px', wordWrap: 'break-word', padding: 0 } }, isValid === true ? (React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.green500, style: { fontSize: '2em', display: 'block', width: '26px' } }, "check")) :
	                isValid === false ?
	                    (React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.red500, style: { fontSize: '2em', width: '26px' } }, "close")) :
	                    (React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.blueGrey500, style: { fontSize: '2em', width: '26px' } }, "pending"))),
	            React.createElement(material_ui_1.TableRowColumn, { style: {
	                    width: '100px',
	                    maxWidth: '100px',
	                    wordWrap: 'break-word',
	                    padding: '0 10px',
	                    textAlign: 'center'
	                } }, beaconItem.minDurationInSecs + "/" + beaconItem.delayDurationInMillis),
	            React.createElement(material_ui_1.TableRowColumn, { style: { maxWidth: '80px', wordWrap: 'break-word', paddingLeft: '0', paddingRight: '0' } }, React.createElement(material_ui_1.FlatButton, { onClick: function (e) { return removeBeacon(beaconType, beaconList, index); } }, "DELETE"))));
	    };
	    return BeaconTableRow;
	}(React.Component));
	exports["default"] = BeaconTableRow;


/***/ },

/***/ 1008:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var glance_datatypes_1 = __webpack_require__(67);
	var types_1 = __webpack_require__(125);
	var Dialog_1 = __webpack_require__(55);
	var FlatButton_1 = __webpack_require__(49);
	var GlanceDraftCard_1 = __webpack_require__(1009);
	var GlanceDraftPublish_1 = __webpack_require__(1011);
	var RestService_1 = __webpack_require__(32);
	var Snackbar_1 = __webpack_require__(42);
	var react_redux_1 = __webpack_require__(24);
	var GlanceDraftComponent = /** @class */ (function (_super) {
	    __extends(GlanceDraftComponent, _super);
	    function GlanceDraftComponent(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            pristine: true,
	            draft: _this.props.glanceDraftData,
	            removed: false,
	            openRemoveConfirmDialog: false,
	            openSyncConfirmDialog: false,
	            onPublishClicked: false,
	            openPublishDialog: false,
	            publishToPartners: [],
	            openSnackbar: false,
	            snackbarMessage: 'Progress Updates will come here',
	            bubbleData: _this.props.bubbleData,
	            editAdCoefficient: false,
	            editBucketPriority: false,
	            editEcpm: false,
	            editRank: false,
	            editFCap: false,
	            displayRank: false,
	            storyCount: 0,
	            peekSourceList: [],
	            dspPeekSourceList: []
	        };
	        _this.onSave = _this.onSave.bind(_this);
	        _this.saveDraft = _this.saveDraft.bind(_this);
	        _this.onEdit = _this.onEdit.bind(_this);
	        _this.onRemove = _this.onRemove.bind(_this);
	        _this.onOverride = _this.onOverride.bind(_this);
	        _this.onRemoveConfirm = _this.onRemoveConfirm.bind(_this);
	        _this.closeConfirmDialog = _this.closeConfirmDialog.bind(_this);
	        _this.onPublish = _this.onPublish.bind(_this);
	        _this.onImageDrop = _this.onImageDrop.bind(_this);
	        _this.onBingeImageDrop = _this.onBingeImageDrop.bind(_this);
	        _this.onOverlayImageDrop = _this.onOverlayImageDrop.bind(_this);
	        _this.removeImage = _this.removeImage.bind(_this);
	        _this.removeBingeImage = _this.removeBingeImage.bind(_this);
	        _this.removeOverlayImage = _this.removeOverlayImage.bind(_this);
	        _this.onPublishDone = _this.onPublishDone.bind(_this);
	        _this.closePublishDialog = _this.closePublishDialog.bind(_this);
	        _this.closeSnackbar = _this.closeSnackbar.bind(_this);
	        _this.onPause = _this.onPause.bind(_this);
	        _this.getDSPAdvertiserGuid = _this.getDSPAdvertiserGuid.bind(_this);
	        _this.getAppInstallMeta = _this.getAppInstallMeta.bind(_this);
	        return _this;
	    }
	    GlanceDraftComponent.prototype.componentWillReceiveProps = function (nextProps) {
	        if (JSON.stringify(nextProps.bubbleData) !==
	            JSON.stringify(this.props.bubbleData)) {
	            this.setState(__assign({}, this.state, { bubbleData: nextProps.bubbleData }));
	        }
	    };
	    GlanceDraftComponent.prototype.componentDidMount = function () {
	        var adCoefficientDisabled = this.state.draft.adCoefficient ? true : false;
	        var bucketPriorityDisabled = this.state.draft.bucketPriority ? true : false;
	        var eCpmDisabled = false;
	        if (this.state.draft.campaignMeta) {
	            eCpmDisabled = this.state.draft.campaignMeta.eCpm ? true : false;
	        }
	        var sourceNameList = [];
	        var dspSourceNameList = [];
	        this.props.studioAppConfig &&
	            this.props.studioAppConfig.apps &&
	            this.props.studioAppConfig.apps.forEach(function (app) {
	                if (app.sourceName && app.sourceName.length > 0) {
	                    sourceNameList = sourceNameList.length
	                        ? sourceNameList.concat(app.sourceName) : app.sourceName.slice();
	                    if (app.dspAdvertiserGuid) {
	                        dspSourceNameList = dspSourceNameList.length
	                            ? dspSourceNameList.concat(app.sourceName) : app.sourceName.slice();
	                    }
	                }
	            });
	        sourceNameList.sort(function (app1, app2) {
	            return app1.toLowerCase().localeCompare(app2.toLowerCase());
	        });
	        dspSourceNameList.sort(function (app1, app2) {
	            return app1.toLowerCase().localeCompare(app2.toLowerCase());
	        });
	        this.setState(__assign({}, this.state, { editAdCoefficient: adCoefficientDisabled, editBucketPriority: bucketPriorityDisabled, editEcpm: eCpmDisabled, peekSourceList: sourceNameList, dspPeekSourceList: dspSourceNameList }));
	    };
	    GlanceDraftComponent.prototype.getDSPAdvertiserGuid = function (sourceName) {
	        if (sourceName && this.props.studioAppConfig) {
	            var dspAdvertiserGuid_1 = '';
	            this.props.studioAppConfig.apps.forEach(function (app) {
	                if (app.sourceName && app.sourceName.length > 0) {
	                    if (app.sourceName.includes(sourceName) && app.dspAdvertiserGuid) {
	                        dspAdvertiserGuid_1 = app.dspAdvertiserGuid;
	                    }
	                }
	            });
	            return dspAdvertiserGuid_1;
	        }
	        else {
	            return '';
	        }
	    };
	    GlanceDraftComponent.prototype.getAppInstallMeta = function (sourceName) {
	        if (sourceName && this.props.studioAppConfig) {
	            var appInstallMeta_1;
	            this.props.studioAppConfig.apps.forEach(function (app) {
	                if (app.sourceName && app.sourceName.length > 0) {
	                    if (app.sourceName.includes(sourceName)) {
	                        appInstallMeta_1 = __assign({}, app, { appName: app.name, packageName: app.packageId, appBundleUrl: '', notifTemplateId: '', d1NotifTemplateId: '', ltvNotifTemplateId: '', preloadEnable: app.preloadEnable ? app.preloadEnable : false, contentProviderUrl: app.contentProviderUrl
	                                ? app.contentProviderUrl
	                                : '' });
	                    }
	                }
	            });
	            return appInstallMeta_1;
	        }
	    };
	    GlanceDraftComponent.prototype.onEdit = function (key, value) {
	        var _a, _b, _c;
	        var currentDraft = this.state.draft;
	        var draftChange = this.state.draft;
	        var adCoeffDisabled = this.state.editAdCoefficient;
	        var bucketPriorityDisabled = this.state.editBucketPriority;
	        var eCpmDisabled = this.state.editEcpm;
	        var displayRank = this.state.displayRank;
	        var storyCount = this.state.storyCount;
	        var draftTargeting = currentDraft.targeting || {
	            apps: {
	                absent: [],
	                present: [],
	                anyPresent: [],
	                anyAbsent: []
	            },
	            requiresGPayReadiness: false,
	            enableDSPRetargeting: false,
	            childLockFlag: null
	        };
	        var beacons;
	        value = value == null || value.length == 0 ? null : value;
	        var getUpdatedEus = function (value) {
	            var updatedEus = currentDraft.eus !== null
	                ? currentDraft.eus.filter(function (eu) { return eu.region !== value.region; })
	                : [];
	            var valueProps = currentDraft.valueProps !== null
	                ? currentDraft.valueProps.filter(function (valueProp) { return valueProp.region !== value.region; })
	                : [];
	            if (value.euId === null) {
	                return {
	                    updatedEus: updatedEus,
	                    valueProps: valueProps
	                };
	            }
	            updatedEus = updatedEus.concat([value]);
	            return {
	                updatedEus: updatedEus,
	                valueProps: valueProps
	            };
	        };
	        var getUpdatedValueProps = function (value) {
	            var updatedValueProps = currentDraft.valueProps !== null
	                ? currentDraft.valueProps.filter(function (vp) { return vp.region !== value.region; })
	                : [];
	            if (value.vpId !== null) {
	                updatedValueProps = updatedValueProps.concat([value]);
	            }
	            return {
	                updatedValueProps: updatedValueProps
	            };
	        };
	        switch (key) {
	            case 'rankInBubble':
	                draftChange = __assign({}, currentDraft, { rankInBubble: value }, (value > 1 && {
	                    frequencyCaps: __assign({}, currentDraft.frequencyCaps, { daily: null, weekly: null })
	                }));
	                break;
	            case 'bubbleId':
	                draftChange = __assign({}, currentDraft, { bubbleId: value.bubbleId });
	                break;
	            case 'priority':
	                draftChange = __assign({}, currentDraft, { priority: value });
	                break;
	            case 'type':
	                var cityIds = void 0;
	                cityIds = value == 4 /* SPONSORED */ ? currentDraft.cityIds : [];
	                draftChange = __assign({}, currentDraft, { type: value, cityIds: cityIds });
	                break;
	            case 'isDspCampaign':
	                draftChange = __assign({}, currentDraft, { dspCampaignData: {
	                        isDspCampaign: value,
	                        dspAdvertiserGuid: this.getDSPAdvertiserGuid(currentDraft.peek.sourceName)
	                    }, preferedRegions: value && currentDraft.preferedRegions
	                        ? currentDraft.preferedRegions.filter(function (e) { return e == 2 /* IN */ || e == 5 /* ID */; }).slice() : currentDraft.preferedRegions, categoryIds: value ? ['#daily_digest'] : currentDraft.categoryIds, peek: __assign({}, currentDraft.peek, { glanceContext: value
	                            ? 1 /* FEATURED */
	                            : currentDraft.peek.glanceContext }) });
	                break;
	            case 'title':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { title: value }) });
	                break;
	            case 'shortTitle':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { shortTitle: value }) });
	                break;
	            case 'source':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { sourceName: value }) }, (currentDraft.dspCampaignData &&
	                    currentDraft.dspCampaignData.isDspCampaign
	                    ? {
	                        dspCampaignData: __assign({}, currentDraft.dspCampaignData, { dspAdvertiserGuid: this.getDSPAdvertiserGuid(value) })
	                    }
	                    : {}));
	                break;
	            case 'hearts':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { heartCount: value ? parseInt(value) : undefined }) });
	                break;
	            case 'ctaUrl':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { ctaUrl: value == null ? null : value.trim() }) });
	                break;
	            case 'videoUrl':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { videoUrl: value == null ? null : value.trim() }) });
	                break;
	            case 'webPeekUrl':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { webPeekUrl: value == null ? null : value.trim() }) });
	                break;
	            case 'shouldUnlock':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { shouldUnlock: value }) });
	                break;
	            case 'openInBg':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { cta: __assign({}, currentDraft.peek.cta, { openUrlCta: __assign({}, currentDraft.peek.cta.openUrlCta, { openInBg: value }) }) }) });
	                break;
	            case 'shouldUnlockAppInstalled':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstalledCta: __assign({}, currentDraft.peek.appCta.appInstalledCta, { shouldUnlock: value }) }) }) });
	                break;
	            case 'ociAppSelection':
	                var appItem = value;
	                var appMeta = {
	                    secondaryBrandColor: appItem.secondaryBrandColor,
	                    logoUrl: appItem.logoUrl,
	                    appName: appItem.name,
	                    category: appItem.category,
	                    size: appItem.size,
	                    rating: appItem.rating,
	                    downloadCount: appItem.downloadCount,
	                    title: appItem.title,
	                    description: appItem.description,
	                    screenshotUrls: appItem.screenshotUrls,
	                    packageName: appItem.packageId,
	                    appBundleUrl: '',
	                    notifTemplateId: '',
	                    d1NotifTemplateId: '',
	                    ltvNotifTemplateId: '',
	                    appId: appItem.appId,
	                    brandColor: appItem.brandColor,
	                    brandBgImage: appItem.brandBgImage,
	                    appOptionalDetails: appItem.appOptionalDetails,
	                    preloadEnable: appItem.preloadEnable ? appItem.preloadEnable : false,
	                    contentProviderUrl: appItem.contentProviderUrl
	                        ? appItem.contentProviderUrl
	                        : '',
	                    prldAttr: appItem.prldAttr,
	                    templateId: appItem.templateId,
	                    tag: appItem.tag,
	                    reviewCount: appItem.reviewCount,
	                    sizeInMb: appItem.sizeInMb,
	                    categoryInfo: appItem.categoryInfo,
	                    bgColor: appItem.bgColor,
	                    textColor: appItem.textColor,
	                    carouselImages: appItem.carouselImages,
	                    installNowCta: appItem.installNowCta,
	                    installLaterCta: appItem.installLaterCta,
	                    fbu: appItem.fbu,
	                    sourceName: appItem.sourceName,
	                    dspAdvertiserGuid: appItem.dspAdvertiserGuid
	                };
	                var defaultBeacons = {};
	                if (appItem.clickBeaconUrl) {
	                    var beacon = {
	                        url: appItem.clickBeaconUrl,
	                        minDurationInSecs: 0,
	                        delayDurationInMillis: 0,
	                        beaconPartner: ''
	                    };
	                    var beaconList = [beacon];
	                    defaultBeacons = {
	                        appSubmitBeacons: beaconList,
	                        peekBeacons: beaconList,
	                        ctaBeacons: beaconList
	                    };
	                }
	                var peekUrl = '';
	                if (currentDraft.peek) {
	                    if (currentDraft.peek.videoUrl) {
	                        peekUrl = currentDraft.peek.videoCtaUrl || '';
	                    }
	                    else if (currentDraft.peek.ctaUrl) {
	                        peekUrl = currentDraft.peek.ctaUrl || '';
	                    }
	                }
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstallMeta: appMeta, appInstallCta: __assign({}, this.state.draft.peek.appCta.appInstallCta, { ctaDisplay: __assign({}, this.state.draft.peek.appCta.appInstallCta.ctaDisplay, { ctaDisplayText: __assign({}, this.state.draft.peek.appCta.appInstallCta.ctaDisplay
	                                        .ctaDisplayText, { text: currentDraft.peek.lockscreenCtaText || 'Install' }), ctaDisplayType: 1 /* TEXT */ }), shouldUnlock: true }), appInstallingCta: __assign({}, currentDraft.peek.appCta.appInstallingCta, { ctaDisplay: __assign({}, currentDraft.peek.appCta.appInstallingCta.ctaDisplay, { ctaDisplayText: __assign({}, currentDraft.peek.appCta.appInstallingCta.ctaDisplay
	                                        .ctaDisplayText, { text: 'Installing' }), ctaDisplayType: 1 /* TEXT */ }), shouldUnlock: true }), appInstalledCta: __assign({}, currentDraft.peek.appCta.appInstalledCta, { ctaDisplay: __assign({}, currentDraft.peek.appCta.appInstalledCta.ctaDisplay, { ctaDisplayText: __assign({}, currentDraft.peek.appCta.appInstalledCta.ctaDisplay
	                                        .ctaDisplayText, { text: 'Open' }), ctaDisplayType: 1 /* TEXT */ }), shouldUnlock: true }) }), ctaType: peekUrl.includes('.zip') && currentDraft.type == 4
	                            ? 1 /* CTA_URL */
	                            : 2 /* APP_INSTALL */ }), beacons: __assign({}, currentDraft.beacons, defaultBeacons) });
	                break;
	            case 'notifTemplateId':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstallMeta: __assign({}, currentDraft.peek.appCta.appInstallMeta, { notifTemplateId: value }) }) }) });
	                break;
	            case 'ltvNotifTemplateId':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstallMeta: __assign({}, currentDraft.peek.appCta.appInstallMeta, { ltvNotifTemplateId: value }) }) }) });
	                break;
	            case 'd1NotifTemplateId':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstallMeta: __assign({}, currentDraft.peek.appCta.appInstallMeta, { d1NotifTemplateId: value }) }) }) });
	                break;
	            case 'summary':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { summary: value }) });
	                break;
	            case 'cheesySummary':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { cheesySummary: value }) });
	                break;
	            case 'tags':
	                draftChange = __assign({}, currentDraft, { tags: [value] });
	                break;
	            case 'preferedRegions':
	                draftChange = __assign({}, currentDraft, { preferedRegions: value, priority: currentDraft.priority === 2 && !currentDraft.peek.webPeekUrl
	                        ? 0
	                        : currentDraft.priority });
	                break;
	            case 'attribution_caption':
	                if (currentDraft.image) {
	                    draftChange = __assign({}, currentDraft, { image: __assign({}, currentDraft.image, { attribution: __assign({}, currentDraft.image.attribution, { caption: value }) }) });
	                }
	                else {
	                    this.setState(__assign({}, this.state, { dropImage: __assign({}, this.state.dropImage, { attrCaption: value }), openSnackbar: false }));
	                    return;
	                }
	                break;
	            case 'attribution_source':
	                if (currentDraft.image) {
	                    draftChange = __assign({}, currentDraft, { image: __assign({}, currentDraft.image, { attribution: __assign({}, currentDraft.image.attribution, { source: value }) }) });
	                }
	                else {
	                    this.setState(__assign({}, this.state, { dropImage: __assign({}, this.state.dropImage, { attrSource: value }), openSnackbar: false }));
	                    return;
	                }
	                break;
	            case 'curationReason':
	                draftChange = __assign({}, currentDraft, { editMeta: __assign({}, currentDraft.editMeta, { curationReason: value }) });
	                break;
	            case 'publisherData':
	                draftChange = __assign({}, currentDraft, { publisherData: value });
	                break;
	            case 'categoryIds':
	                draftChange = __assign({}, currentDraft, { categoryIds: value });
	                break;
	            case 'sourceCreatorId':
	                draftChange = __assign({}, currentDraft, { sourceCreatorId: value });
	                break;
	            case 'cityIds':
	                draftChange = __assign({}, currentDraft, { cityIds: value });
	                break;
	            case 'ociConfigs':
	                draftChange = __assign({}, currentDraft, { ociConfigs: value });
	                break;
	            case 'carriers':
	                draftChange = __assign({}, currentDraft, { carriers: value });
	                break;
	            case 'targetingNegative':
	                draftChange = __assign({}, currentDraft, { targeting: __assign({}, draftTargeting, { apps: __assign({}, draftTargeting.apps, (_a = {}, _a[value[1]] = value[0], _a[value[2][0]] = [], _a)) }) });
	                break;
	            case 'targetingPositive':
	                draftChange = __assign({}, currentDraft, { targeting: __assign({}, draftTargeting, { apps: __assign({}, draftTargeting.apps, (_b = {}, _b[value[1]] = value[0], _b[value[2][0]] = [], _b)) }) });
	                break;
	            case 'gPayReadiness':
	                draftChange = __assign({}, currentDraft, { targeting: __assign({}, draftTargeting, { requiresGPayReadiness: value }) });
	                break;
	            case 'dspRetargeting':
	                draftChange = __assign({}, currentDraft, { targeting: __assign({}, draftTargeting, { enableDSPRetargeting: value }) });
	                break;
	            case 'childlockflag':
	                draftChange = __assign({}, currentDraft, { targeting: __assign({}, draftTargeting, { childLockFlag: value }) });
	                break;
	            case 'targetingNetwork':
	                draftChange = __assign({}, currentDraft, { userNetworkTypes: value });
	                break;
	            case 'useUnlockNudge':
	                draftChange = __assign({}, currentDraft, { useUnlockNudge: value });
	                break;
	            case 'segmentIds':
	                draftChange = __assign({}, currentDraft, { segmentIds: value });
	                break;
	            case 'antiSegmentIds':
	                draftChange = __assign({}, currentDraft, { antiSegmentIds: value });
	                break;
	            case 'cta_text':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { cta: __assign({}, currentDraft.peek.cta, { text: value }) }) });
	                break;
	            case 'storyType':
	                draftChange = __assign({}, currentDraft, { storyType: value });
	                break;
	            case 'languageLimit':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { summaryLimit: value }) });
	                break;
	            case 'targetForCategories':
	                draftChange = __assign({}, currentDraft, { targetForCategories: value });
	                break;
	            case 'categorySubscriptionStatus':
	                draftChange = __assign({}, currentDraft, { categorySubscriptionStatus: value });
	                break;
	            case 'canSkipSummary':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { canSkipSummary: value }) });
	                break;
	            case 'dailyCap':
	                draftChange = __assign({}, currentDraft, { frequencyCaps: __assign({}, currentDraft.frequencyCaps, { daily: value }) });
	                break;
	            case 'weeklyCap':
	                draftChange = __assign({}, currentDraft, { frequencyCaps: __assign({}, currentDraft.frequencyCaps, { weekly: value }) });
	                break;
	            case 'stickiness':
	                draftChange = __assign({}, currentDraft, { stickinessCount: value });
	                break;
	            case 'renderSessionProperties':
	                draftChange = __assign({}, currentDraft, { renderSessionProperties: value, renderSessionMode: value ? currentDraft.renderSessionMode : null });
	                break;
	            case 'startDay':
	            case 'endDay':
	                draftChange = __assign({}, currentDraft, { userLifeTimeFilter: __assign({}, currentDraft.userLifeTimeFilter, (_c = {}, _c[key] = value, _c)) });
	                break;
	            case 'OfflinePeekLink':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { offlinePeekUrl: value === null ? null : value.trim() !== '' ? value.trim() : null }) });
	                break;
	            case 'VideoCtaUrl':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { videoCtaUrl: value == null ? null : value.trim(), cta: __assign({}, currentDraft.peek.cta, { url: value == null ? null : value.trim(), originalUrl: value == null ? null : value.trim() }) }) });
	                break;
	            case 'ArticleCtaUrl':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { articleCtaUrl: value == null ? null : value.trim(), cta: __assign({}, currentDraft.peek.cta, { url: value == null ? null : value.trim(), originalUrl: value == null ? null : value.trim() }) }) });
	                break;
	            case 'subText':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { subText: value }) });
	                break;
	            case 'useBubbleImageAsRibbonIcon':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { useBubbleImageAsRibbonIcon: value }) });
	                break;
	            case 'ctaType':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { ctaType: value }) });
	                break;
	            case 'autoOpenCtaDurationInSecs':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { cta: __assign({ url: '' }, currentDraft.peek.cta, { autoOpenCtaDurationInSecs: value }) }) });
	                break;
	            case 'InstallLink':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { ctaUrl: value, appCta: __assign({}, currentDraft.peek.appCta, { appInstallCta: __assign({}, currentDraft.peek.appCta.appInstallCta, { url: value }) }) }) });
	                break;
	            case 'InstalledLink':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstalledCta: __assign({}, currentDraft.peek.appCta.appInstalledCta, { url: value }) }) }) });
	                break;
	            case 'InstallingLink':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstallingCta: __assign({}, currentDraft.peek.appCta.appInstallingCta, { url: value }) }) }) });
	                break;
	            // case 'InstallCtaText':
	            //     draftChange = {
	            //         ...currentDraft,
	            //         peek: {
	            //             ...currentDraft.peek,
	            //             appCta: {
	            //                 ...currentDraft.peek.appCta,
	            //                 appInstallCta: {
	            //                     ...currentDraft.peek.appCta.appInstallCta,
	            //                     ctaDisplay: {
	            //                         ...currentDraft.peek.appCta.appInstallCta.ctaDisplay,
	            //                         ctaDisplayText: {
	            //                             ...currentDraft.peek.appCta.appInstallCta.ctaDisplay
	            //                                 .ctaDisplayText,
	            //                             text: value,
	            //                         },
	            //                         ctaDisplayType: CtaDisplayType.TEXT,
	            //                     },
	            //                 },
	            //             },
	            //         },
	            //     };
	            //     break;
	            case 'InstalledCtaText':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstalledCta: __assign({}, currentDraft.peek.appCta.appInstalledCta, { ctaDisplay: __assign({}, currentDraft.peek.appCta.appInstalledCta.ctaDisplay, { ctaDisplayText: __assign({}, currentDraft.peek.appCta.appInstalledCta.ctaDisplay
	                                        .ctaDisplayText, { text: value }), ctaDisplayType: 1 /* TEXT */ }) }) }) }) });
	                break;
	            case 'InstallingCtaText':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstallingCta: __assign({}, currentDraft.peek.appCta.appInstallingCta, { ctaDisplay: __assign({}, currentDraft.peek.appCta.appInstallingCta.ctaDisplay, { ctaDisplayText: __assign({}, currentDraft.peek.appCta.appInstallingCta.ctaDisplay
	                                        .ctaDisplayText, { text: value }), ctaDisplayType: 1 /* TEXT */ }) }) }) }) });
	                break;
	            case 'AppPackageName':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstallMeta: __assign({}, currentDraft.peek.appCta.appInstallMeta, { packageName: value }) }) }) });
	                break;
	            case 'AppName':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { appCta: __assign({}, currentDraft.peek.appCta, { appInstallMeta: __assign({}, currentDraft.peek.appCta.appInstallMeta, { appName: value }) }) }) });
	                break;
	            case 'isShareable':
	                draftChange = __assign({}, currentDraft, { isShareable: value });
	                break;
	            case 'nativeVideoOverflow':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { nativeVideoOverflow: value }) });
	                break;
	            case 'shareUrl':
	                draftChange = __assign({}, currentDraft, { shareUrl: value });
	                break;
	            case 'hardwareAccelerated':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { hardwareAccelerated: value }) });
	                break;
	            case 'loadAndroidJs':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { loadAndroidJs: value }) });
	                break;
	            case 'hardwareAccelerated':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { hardwareAccelerated: value }) });
	                break;
	            case 'loadAndroidJs':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { loadAndroidJs: value }) });
	                break;
	            case 'lockscreen_cta_text':
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { lockscreenCtaText: value }, (currentDraft.peek.appCta.appInstallCta.ctaDisplay.ctaDisplayText
	                        ? {
	                            appCta: __assign({}, currentDraft.peek.appCta, { appInstallCta: __assign({}, this.state.draft.peek.appCta.appInstallCta, { ctaDisplay: __assign({}, this.state.draft.peek.appCta.appInstallCta
	                                        .ctaDisplay, { ctaDisplayText: __assign({}, this.state.draft.peek.appCta.appInstallCta
	                                            .ctaDisplay.ctaDisplayText, { text: value || 'Install' }), ctaDisplayType: 1 /* TEXT */ }), shouldUnlock: true }) })
	                        }
	                        : {})) });
	                break;
	            case 'offlineShoppingZipUrl':
	                draftChange = __assign({}, currentDraft, { shoppableData: __assign({}, currentDraft.shoppableData, { offlineShoppingZipUrl: value }) });
	                break;
	            case 'iconImageUrl':
	                draftChange = __assign({}, currentDraft, { shoppableData: __assign({}, currentDraft.shoppableData, { iconImageUrl: value }) });
	                break;
	            case 'shoppingUrl':
	                draftChange = __assign({}, currentDraft, { shoppableData: __assign({}, currentDraft.shoppableData, { shoppingUrl: value }) });
	                break;
	            case 'isShoppable':
	                draftChange = __assign({}, currentDraft, { isShoppable: value });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.CTA]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { ctaBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.VIDEO]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { videoBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.RENDER]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { renderBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.PEEK]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { peekBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.LIKE]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { likeBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.SHARE]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { shareBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.VIDEO_STARTED]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { videoStartedBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.HOLD]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { holdBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.APP_SUBMIT]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { appSubmitBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.INSTALL_NOW]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { installNowBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.INSTALL_LATER]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { installLaterBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.INSTALL_COMPLETE]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { installCompleteBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.APP_OPEN]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { appOpenBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.GLANCE_STARTED]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { glanceStartedBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.PRIVIEW_TAP]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { previewTapBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.VIDEO_VIEWED]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { videoViewedBeacons: value }) });
	                break;
	            case types_1.BeaconType[types_1.BeaconType.GLANCE_VIEWED]:
	                draftChange = __assign({}, currentDraft, { beacons: __assign({}, currentDraft.beacons, { glanceViewedBeacons: value }) });
	                break;
	            case 's2sIntegration':
	                draftChange = __assign({}, currentDraft, { beaconsInfo: __assign({}, currentDraft.beaconsInfo, { s2sIntegration: value }) });
	                break;
	            case 'advertiserId':
	                draftChange = __assign({}, currentDraft, { programmaticDetail: __assign({}, currentDraft.programmaticDetail, { advertiserId: value }) });
	                break;
	            case 'cappingPacingCheck':
	                draftChange = __assign({}, currentDraft, { programmaticDetail: __assign({}, currentDraft.programmaticDetail, { cappingPacingCheck: value }) });
	                break;
	            case 'creativeId':
	                draftChange = __assign({}, currentDraft, { programmaticDetail: __assign({}, currentDraft.programmaticDetail, { creativeId: value }) });
	                break;
	            case 'channelType':
	                draftChange = __assign({}, currentDraft, { programmaticDetail: __assign({}, currentDraft.programmaticDetail, { channelType: value }) });
	                break;
	            case 'language':
	                draftChange = __assign({}, currentDraft, { glanceLanguageId: value });
	                break;
	            case 'topicName':
	                draftChange = __assign({}, currentDraft, { topicName: value });
	                break;
	            case 'homescreenWorthy':
	                draftChange = __assign({}, currentDraft, { homescreenWorthy: value });
	                break;
	            case 'dynamicOverlay':
	                draftChange = __assign({}, currentDraft, { dynamicOverlay: value });
	                break;
	            case 'allowKeyboard':
	                draftChange = __assign({}, currentDraft, { allowKeyboard: value });
	                break;
	            case 'allowNativeKeyboard':
	                draftChange = __assign({}, currentDraft, { allowNativeKeyboard: value });
	                break;
	            case 'campaignObjective':
	                draftChange = __assign({}, currentDraft, { campaignMeta: __assign({}, currentDraft.campaignMeta, { objective: value }) });
	                break;
	            case 'campaignEcpm':
	                draftChange = __assign({}, currentDraft, { campaignMeta: __assign({}, currentDraft.campaignMeta, { eCpm: value }) });
	                break;
	            case 'glroId':
	                draftChange = __assign({}, currentDraft, { campaignMeta: __assign({}, currentDraft.campaignMeta, { glroId: value }) });
	                break;
	            case 'impressionCappingData':
	                draftChange = __assign({}, currentDraft, { impressionCappingData: value });
	                break;
	            case 'totalImpressionRequired':
	                draftChange = __assign({}, currentDraft, { impressionCappingData: __assign({}, currentDraft.impressionCappingData, { totalImpressionRequired: value }) });
	                break;
	            case 'triggerPercentage':
	                draftChange = __assign({}, currentDraft, { impressionCappingData: __assign({}, currentDraft.impressionCappingData, { triggerPercentage: value }) });
	                break;
	            case 'servingCappingEnabled':
	                draftChange = __assign({}, currentDraft, { impressionCappingData: __assign({}, currentDraft.impressionCappingData, { servingCappingEnabled: value }) });
	                break;
	            case 'glanceTimer':
	                draftChange = __assign({}, currentDraft, { glanceBubbleDetails: __assign({}, currentDraft.glanceBubbleDetails, { glanceTimer: value * 1000 }) });
	                break;
	            // OMSDK cases start here
	            case 'omSdkInfoType':
	                draftChange = __assign({}, currentDraft, { omSdkInfo: __assign({}, currentDraft.omSdkInfo, { type: value }) });
	                break;
	            case 'validationUrl':
	                draftChange = __assign({}, currentDraft, { omSdkInfo: __assign({}, currentDraft.omSdkInfo, { validationUrl: value }) });
	                break;
	            case 'verificationParam':
	                draftChange = __assign({}, currentDraft, { omSdkInfo: __assign({}, currentDraft.omSdkInfo, { verificationParam: value }) });
	                break;
	            case 'vendorKey':
	                draftChange = __assign({}, currentDraft, { omSdkInfo: __assign({}, currentDraft.omSdkInfo, { vendorKey: value }) });
	                break;
	            case 'ctaview_height':
	                draftChange = __assign({}, currentDraft, { ctaViewConfig: __assign({}, currentDraft.ctaViewConfig, { height: value }) });
	                break;
	            case 'ctaview_hide_toppadding':
	                draftChange = __assign({}, currentDraft, { ctaViewConfig: __assign({}, currentDraft.ctaViewConfig, { removeTopPadding: value }) });
	                break;
	            case 'ctaview_hide_crossicon':
	                draftChange = __assign({}, currentDraft, { ctaViewConfig: __assign({}, currentDraft.ctaViewConfig, { hideCrossIcon: value }) });
	                break;
	            //omsdk cases ends
	            case 'paused':
	                draftChange = __assign({}, currentDraft, { paused: value });
	                break;
	            case 'adCoefficient':
	                draftChange = __assign({}, currentDraft, { adCoefficient: value });
	                break;
	            case 'bucketPriority':
	                draftChange = __assign({}, currentDraft, { bucketPriority: value });
	                break;
	            case 'gamPgAdUnitId':
	                draftChange = __assign({}, currentDraft, { gamPgAdUnitId: value });
	                break;
	            case 'ecpm':
	                draftChange = __assign({}, currentDraft, { campaignMeta: __assign({}, currentDraft.campaignMeta, { eCpm: value }) });
	                break;
	            case 'sponsoredBubbleChange':
	                console.log('case sponsoredBubbleChange', value);
	                draftChange = __assign({}, currentDraft, { bubbleId: value.bubbleId, adCoefficient: value.adCoefficient, bucketPriority: value.bucketPriority, rankInBubble: value.rankInBubble, campaignMeta: __assign({}, currentDraft.campaignMeta, { eCpm: value.eCpm }) });
	                adCoeffDisabled = value.adCoefficientDisabled;
	                bucketPriorityDisabled = value.bucketPriorityDisabled;
	                eCpmDisabled = value.eCpmDisabled;
	                storyCount = value.storyCount;
	                displayRank = value.rankInBubbleDispay;
	                storyCount = value.storyCount;
	                // rankDisplay = value.rankInBubbleDispay
	                break;
	            case 'isBeautifulWallpaperEnabled':
	                draftChange = __assign({}, currentDraft, { isBeautifulWallpaperEnabled: value });
	                break;
	            case 'eu':
	                var _d = getUpdatedEus(value), updatedEus = _d.updatedEus, valueProps = _d.valueProps;
	                draftChange = __assign({}, currentDraft, { eus: updatedEus.length > 0 ? updatedEus : null, valueProps: valueProps.length > 0 ? valueProps : null });
	                break;
	            case 'valueProp':
	                var updatedValueProps = getUpdatedValueProps(value).updatedValueProps;
	                draftChange = __assign({}, currentDraft, { valueProp: value.vpId, valueProps: updatedValueProps.length > 0 ? updatedValueProps : null });
	                break;
	            default:
	                console.error('What the hell!', key, value);
	        }
	        // Send appInstallMeta for Google Playstore Campaign's
	        if ((key === 'source' || key === 'campaignObjective') &&
	            draftChange.campaignMeta &&
	            draftChange.campaignMeta.objective &&
	            draftChange.campaignMeta.objective === 'V1_Google Playstore') {
	            // Only for Sponsored
	            if (draftChange.type === 4) {
	                draftChange = __assign({}, draftChange, { peek: __assign({}, draftChange.peek, { appCta: __assign({}, draftChange.peek.appCta, { appInstallMeta: this.getAppInstallMeta(key === 'source' ? value : draftChange.peek.sourceName) || draftChange.peek.appCta.appInstallMeta }) }) });
	            }
	        }
	        if (key === 'bubbleId') {
	            this.setState(__assign({}, this.state, { pristine: false, draft: new glance_datatypes_1.GlanceDraft(draftChange), bubbleData: value }));
	        }
	        else if (key === 'glanceContextType') {
	            if (value === 0 /* LIVE */) {
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { useBubbleImageAsRibbonIcon: false, glanceContext: value }) });
	            }
	            else {
	                draftChange = __assign({}, currentDraft, { peek: __assign({}, currentDraft.peek, { useBubbleImageAsRibbonIcon: false, glanceContext: value }) });
	            }
	            this.setState(__assign({}, this.state, { pristine: false, draft: new glance_datatypes_1.GlanceDraft(draftChange), editAdCoefficient: adCoeffDisabled, editBucketPriority: bucketPriorityDisabled, editEcpm: eCpmDisabled, displayRank: displayRank, storyCount: storyCount }));
	        }
	        else {
	            this.setState(__assign({}, this.state, { pristine: false, draft: new glance_datatypes_1.GlanceDraft(draftChange), editAdCoefficient: adCoeffDisabled, editBucketPriority: bucketPriorityDisabled, editEcpm: eCpmDisabled, displayRank: displayRank, storyCount: storyCount }));
	        }
	    };
	    GlanceDraftComponent.prototype.onSave = function (isCTASecReq) {
	        return __awaiter(this, void 0, void 0, function () {
	            var draftChange, rankInBubble, selectValuePropsMessage_1, isValuePropSelected_1, mandatoryValuePropRegions_1, errorMessage;
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        draftChange = this.state.draft;
	                        if (this.state.draft.type === 4 /* SPONSORED */ &&
	                            this.state.bubbleData &&
	                            this.state.bubbleData.storyCount > 0) {
	                            rankInBubble = this.state.draft.rankInBubble;
	                            if (rankInBubble === null) {
	                                this.setState(__assign({}, this.state, { openSnackbar: true, snackbarMessage: 'Missing Rank' }));
	                                return [2 /*return*/];
	                            }
	                        }
	                        else {
	                            draftChange = __assign({}, draftChange, { rankInBubble: null });
	                        }
	                        if (this.state.draft.type === 4 /* SPONSORED */ &&
	                            (this.state.draft.campaignMeta === null ||
	                                this.state.draft.campaignMeta.objective === null)) {
	                            this.setState(__assign({}, this.state, { openSnackbar: true, snackbarMessage: 'Campaign Objective Missing' }));
	                            return [2 /*return*/];
	                        }
	                        if (this.state.draft.type !== 4 /* SPONSORED */ &&
	                            this.state.draft.preferedRegions.length) {
	                            selectValuePropsMessage_1 = 'Please select EU and Value Prop for India and/or Indonesia';
	                            isValuePropSelected_1 = true;
	                            mandatoryValuePropRegions_1 = [2 /* IN */, 5 /* ID */];
	                            this.state.draft.preferedRegions.forEach(function (region) {
	                                if (mandatoryValuePropRegions_1.includes(region)) {
	                                    if (_this.state.draft.valueProps === null) {
	                                        _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: selectValuePropsMessage_1 }));
	                                        isValuePropSelected_1 = false;
	                                    }
	                                    if (!_this.state.draft.valueProps
	                                        .map(function (valueProp) { return valueProp.region; })
	                                        .includes(region)) {
	                                        _this.setState(__assign({}, _this.state, { openSnackbar: true, snackbarMessage: selectValuePropsMessage_1 }));
	                                        isValuePropSelected_1 = false;
	                                    }
	                                }
	                            });
	                            if (!isValuePropSelected_1)
	                                return [2 /*return*/];
	                        }
	                        this.setState(__assign({}, this.state, { openSnackbar: true, snackbarMessage: 'Uploading Image...', draft: new glance_datatypes_1.GlanceDraft(draftChange) }));
	                        if (!(this.state.dropImage && this.state.dropImage.image)) return [3 /*break*/, 2];
	                        if (!this.state.dropImage.attrSource) {
	                            this.setState(__assign({}, this.state, { openSnackbar: true, snackbarMessage: 'Missing attribution details' }));
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, RestService_1["default"].uploadImage(this.state.dropImage.image, function (image) {
	                                if (image != null) {
	                                    _this.setState(__assign({}, _this.state, { draft: new glance_datatypes_1.GlanceDraft(__assign({}, _this.state.draft, { imageId: image.id })) }));
	                                }
	                            })];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2:
	                        if (isCTASecReq) {
	                            errorMessage = '';
	                            if (!this.state.draft.peek.cta.autoOpenCtaDurationInSecs &&
	                                this.state.draft.peek.cta.autoOpenCtaDurationInSecs !== 0) {
	                                errorMessage = 'Missing CTA duration';
	                            }
	                            else if (this.state.draft.peek.cta.autoOpenCtaDurationInSecs &&
	                                this.state.draft.peek.cta.autoOpenCtaDurationInSecs < 0) {
	                                errorMessage = 'CTA duration should not be negative value';
	                            }
	                            if (errorMessage) {
	                                this.setState(__assign({}, this.state, { openSnackbar: true, snackbarMessage: errorMessage }));
	                                return [2 /*return*/];
	                            }
	                        }
	                        if (!(this.state.overlayImage &&
	                            this.state.overlayImage.image &&
	                            this.state.overlayImage.image.name.endsWith('.png'))) return [3 /*break*/, 4];
	                        return [4 /*yield*/, RestService_1["default"].uploadImage(this.state.overlayImage.image, function (overlayImage) {
	                                if (overlayImage != null) {
	                                    _this.setState(__assign({}, _this.state, { draft: new glance_datatypes_1.GlanceDraft(__assign({}, _this.state.draft, { overlayImageId: overlayImage.id })) }));
	                                }
	                            })];
	                    case 3:
	                        _a.sent();
	                        _a.label = 4;
	                    case 4:
	                        if (!(this.state.bingeImage && this.state.bingeImage.image)) return [3 /*break*/, 6];
	                        return [4 /*yield*/, RestService_1["default"].uploadImage(this.state.bingeImage.image, function (bingeImage) {
	                                if (bingeImage != null) {
	                                    _this.setState(__assign({}, _this.state, { draft: new glance_datatypes_1.GlanceDraft(__assign({}, _this.state.draft, { bingeImageId: bingeImage.id })) }));
	                                }
	                            })];
	                    case 5:
	                        _a.sent();
	                        _a.label = 6;
	                    case 6:
	                        this.saveDraft();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    GlanceDraftComponent.prototype.saveDraft = function () {
	        var that = this;
	        console.log('draft', this.state.draft);
	        this.setState(__assign({}, this.state, { openSnackbar: true, snackbarMessage: 'Image Uploaded. Saving Draft...' }));
	        RestService_1["default"].saveDraft(this.state.draft, function (newDraft) {
	            if (newDraft) {
	                var updatedDraft = void 0;
	                var updateDraftFlag = false;
	                if (that.state.bingeImage && that.state.bingeImage.image) {
	                    updatedDraft = __assign({}, newDraft, { bingeImage: __assign({}, newDraft.bingeImage) });
	                    updateDraftFlag = true;
	                }
	                if (that.state.overlayImage &&
	                    that.state.overlayImage.image &&
	                    that.state.overlayImage.image.name.endsWith('.png')) {
	                    updatedDraft = __assign({}, newDraft, { overlayImage: __assign({}, newDraft.overlayImage) });
	                    updateDraftFlag = true;
	                }
	                if (that.state.dropImage && that.state.dropImage.image) {
	                    updatedDraft = __assign({}, newDraft, { image: __assign({}, newDraft.image, { attribution: __assign({}, newDraft.image.attribution, { source: that.state.dropImage.attrSource, author: that.state.dropImage.attrAuthor }) }) });
	                    updateDraftFlag = true;
	                }
	                if (updateDraftFlag) {
	                    RestService_1["default"].saveDraft(new glance_datatypes_1.GlanceDraft(updatedDraft), function (updatedNewDraft) {
	                        that.setState(__assign({}, that.state, { pristine: true, openSnackbar: true, dropImage: null, snackbarMessage: 'Draft Saved.', draft: updatedNewDraft }));
	                    });
	                }
	                else {
	                    that.setState(__assign({}, that.state, { pristine: true, openSnackbar: true, dropImage: null, snackbarMessage: 'Draft Saved.', draft: newDraft }));
	                }
	            }
	            else {
	                that.setState(__assign({}, that.state, { openSnackbar: true, snackbarMessage: 'Draft Save failed.' }));
	            }
	        });
	    };
	    GlanceDraftComponent.prototype.onOverride = function () {
	        console.log('onOverride');
	        this.setState(__assign({}, this.state, { openSyncConfirmDialog: true }));
	    };
	    GlanceDraftComponent.prototype.onOverrideConfirm = function () {
	        console.log('onOverrideConfirm');
	        var that = this;
	        that.setState(__assign({}, that.state, { openSnackbar: true, snackbarMessage: 'Syncing publish data ...', openSyncConfirmDialog: false }));
	        RestService_1["default"].overrideDraft(this.state.draft, function (error) {
	            if (error == null) {
	                that.setState(__assign({}, that.state, { openSnackbar: true, snackbarMessage: 'Publish data synced', openSyncConfirmDialog: false }));
	            }
	            else {
	                that.setState(__assign({}, that.state, { openSnackbar: true, snackbarMessage: "Publish data sync failed. Most common reason is that draft isn't published", openSyncConfirmDialog: false }));
	            }
	        });
	    };
	    GlanceDraftComponent.prototype.onRemove = function () {
	        console.log('onRemove');
	        this.setState(__assign({}, this.state, { openRemoveConfirmDialog: true }));
	    };
	    GlanceDraftComponent.prototype.onPause = function () {
	        var _a = this.state.draft, paused = _a.paused, draftId = _a.draftId;
	        RestService_1["default"].glancePauseRequest([draftId], !paused, function (success) { });
	        this.setState(__assign({}, this.state, { openSnackbar: true, snackbarMessage: 'Campaign Paused' }));
	    };
	    GlanceDraftComponent.prototype.removeImage = function () {
	        this.setState(__assign({}, this.state, { draft: new glance_datatypes_1.GlanceDraft(__assign({}, this.state.draft, { image: undefined, imageId: undefined })), dropImage: __assign({}, this.state.dropImage, { image: undefined }), pristine: false }));
	    };
	    GlanceDraftComponent.prototype.removeOverlayImage = function () {
	        this.setState(__assign({}, this.state, { overlayImage: __assign({}, this.state.overlayImage, { image: undefined }), draft: new glance_datatypes_1.GlanceDraft(__assign({}, this.state.draft, { overlayImage: undefined, overlayImageId: undefined })), pristine: false }));
	    };
	    GlanceDraftComponent.prototype.removeBingeImage = function () {
	        this.setState(__assign({}, this.state, { bingeImage: __assign({}, this.state.bingeImage, { image: undefined }), draft: new glance_datatypes_1.GlanceDraft(__assign({}, this.state.draft, { bingeImage: undefined, bingeImageId: undefined })), pristine: false }));
	    };
	    GlanceDraftComponent.prototype.onImageDrop = function (image) {
	        this.setState(__assign({}, this.state, { pristine: false, dropImage: __assign({}, this.state.dropImage, { image: image }) }));
	    };
	    GlanceDraftComponent.prototype.onOverlayImageDrop = function (image) {
	        this.setState(__assign({}, this.state, { pristine: false, overlayImage: __assign({}, this.state.overlayImage, { image: image }) }));
	    };
	    GlanceDraftComponent.prototype.onBingeImageDrop = function (image) {
	        this.setState(__assign({}, this.state, { pristine: false, bingeImage: __assign({}, this.state.bingeImage, { image: image }) }));
	    };
	    GlanceDraftComponent.prototype.onPublish = function () {
	        console.log('onPublish');
	        this.setState(__assign({}, this.state, { onPublishClicked: true, openPublishDialog: true }));
	    };
	    GlanceDraftComponent.prototype.onPublishDone = function (newDraft) {
	        console.log('onPublishConfirm');
	    };
	    GlanceDraftComponent.prototype.onRemoveConfirm = function () {
	        RestService_1["default"].removeDraft(this.state.draft.draftId);
	        this.setState(__assign({}, this.state, { removed: true, openRemoveConfirmDialog: false }));
	    };
	    GlanceDraftComponent.prototype.closeConfirmDialog = function () {
	        this.setState(__assign({}, this.state, { openRemoveConfirmDialog: false, openSyncConfirmDialog: false }));
	    };
	    GlanceDraftComponent.prototype.closePublishDialog = function () {
	        this.setState(__assign({}, this.state, { openPublishDialog: false }));
	    };
	    GlanceDraftComponent.prototype.closeSnackbar = function () {
	        this.setState(__assign({}, this.state, { openSnackbar: false }));
	    };
	    GlanceDraftComponent.prototype.render = function () {
	        var _this = this;
	        var draft = this.state.draft;
	        var userRole = this.props.studioAppConfig.currentToken.role;
	        var actions = [];
	        actions.push(React.createElement(FlatButton_1["default"], { label: "Cancel", primary: true, onClick: this.closeConfirmDialog }));
	        actions.push(React.createElement(FlatButton_1["default"], { label: "Confirm", primary: true, onClick: function () {
	                _this.state.openRemoveConfirmDialog
	                    ? _this.onRemoveConfirm()
	                    : _this.onOverrideConfirm();
	            } }));
	        return (React.createElement("div", { className: "" },
	            React.createElement(GlanceDraftCard_1["default"], { cardStyle: { paddingBottom: 'none' }, glanceDraftData: this.state.draft, draftMeta: this.props.draftMeta, pristine: this.state.pristine, removed: this.state.removed, dropImage: this.state.dropImage, onImageDrop: this.onImageDrop, removeImage: this.removeImage, onOverride: this.onOverride, onOverlayImageDrop: this.onOverlayImageDrop, onBingeImageDrop: this.onBingeImageDrop, removeBingeImage: this.removeBingeImage, removeOverlayImage: this.removeOverlayImage, overlayImage: this.state.overlayImage, bingeImage: this.state.bingeImage, onEdit: this.onEdit, onSave: this.onSave, onRemove: this.onRemove, onPublish: this.onPublish, onPause: this.onPause, studioAppConfig: this.props.studioAppConfig, singleClickPublish: this.props.singleClickPublish, errorMsg: this.props.errorMsg, regionPartnerList: this.props.regionPartnerList, role: this.props.role, copyDraft: this.props.copyDraft, disableCopy: this.props.disableCopy, bubbleData: this.state.bubbleData, cardType: this.props.cardType, adCoefficientDisabled: this.state.editAdCoefficient, bucketPriorityDisabled: this.state.editBucketPriority, ecpmDisabled: this.state.editEcpm, rankDisabled: this.state.editRank, fCapDisabled: this.state.editFCap, rankDisplay: this.state.displayRank, storyCount: this.state.storyCount, cityStates: this.props.cityStates, peekSourceList: this.state.peekSourceList, dspPeekSourceList: this.state.dspPeekSourceList }),
	            React.createElement(Dialog_1["default"], { modal: false, open: this.state.openRemoveConfirmDialog ||
	                    this.state.openSyncConfirmDialog, onRequestClose: this.closeConfirmDialog, actions: actions }, this.state.openRemoveConfirmDialog
	                ? 'Please confirm that you want to remove this draft'
	                : 'Please confirm that you want to sync this draft with published glances'),
	            this.state.onPublishClicked &&
	                (userRole == 2 /* MODERATOR */ || userRole == 0 /* ADMIN */) ? (React.createElement(GlanceDraftPublish_1["default"], { studioAppConf: this.props.studioAppConfig, draft: this.state.draft, open: this.state.openPublishDialog, experiments: this.props.experiments, onPublishDone: this.onPublishDone, closeDialog: this.closePublishDialog })) : (''),
	            React.createElement(Snackbar_1["default"], { open: this.state.openSnackbar, message: this.state.snackbarMessage, onRequestClose: this.closeSnackbar })));
	    };
	    return GlanceDraftComponent;
	}(React.Component));
	var mapStateToProps = function (state, ownProps) {
	    return __assign({ studioAppConfig: state.studioAppConfig }, ownProps);
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(GlanceDraftComponent);


/***/ },

/***/ 1009:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	__webpack_require__(110);
	var React = __webpack_require__(1);
	var Card_1 = __webpack_require__(201);
	var react_lightweight_tooltip_1 = __webpack_require__(392);
	var Chip_1 = __webpack_require__(137);
	var DropDownMenu_1 = __webpack_require__(69);
	var FontIcon_1 = __webpack_require__(50);
	var GlanceDraftDetails_1 = __webpack_require__(1010);
	var GlanceThumbnail_1 = __webpack_require__(1012);
	var IconButton_1 = __webpack_require__(76);
	var ImageDropzone_1 = __webpack_require__(152);
	var MenuItem_1 = __webpack_require__(51);
	var Utils_1 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var draftsHelper_1 = __webpack_require__(429);
	var colors_1 = __webpack_require__(18);
	var colors_2 = __webpack_require__(18);
	var wallpaperWidth = '65px';
	var detailsWidth = 'calc(100% - 65px)';
	var wallpaperWidthExpanded = '10%';
	var styles = {
	    tooltipStyle: {
	        wrapper: {
	            zIndex: 1,
	            cursor: 'arrow'
	        },
	        tooltip: {
	            backgroundColor: '#808080',
	            borderRadius: '10px',
	            minWidth: '180px',
	            textAlign: 'center',
	            padding: '2px'
	        },
	        content: {
	            backgroundColor: '#808080',
	            color: '#FFFFFF',
	            display: 'inline-block',
	            fontSize: '0.9em',
	            paddind: '0'
	        },
	        arrow: {
	            borderTop: 'solid #808080 5px'
	        },
	        gap: {}
	    },
	    readableChip: {
	        margin: 1,
	        backgroundColor: '#808080',
	        display: 'inline-block',
	        borderRadius: '1em',
	        fontSize: '0.9em'
	    },
	    readableChipLive: {
	        margin: 1,
	        backgroundColor: colors_2.blue500,
	        color: '#ccc',
	        display: 'inline-block',
	        borderRadius: '1em',
	        fontSize: '0.9em'
	    },
	    chip: {
	        margin: 3
	    },
	    wrapperDiv: {
	        margin: '0px auto',
	        display: 'flex',
	        position: 'relative',
	        justifyContent: 'center',
	        alignItems: 'center'
	    },
	    cardTextDiv: {
	        padding: '5px',
	        display: 'flex',
	        margin: '0px auto',
	        top: 0,
	        right: 0,
	        bottom: 0,
	        left: 0,
	        height: '100%'
	    },
	    cardTextDivExpanded: {
	        padding: '5px',
	        display: 'flex',
	        margin: '0px auto'
	    },
	    actionsDiv: {
	        padding: '5px',
	        display: 'flex',
	        margin: '0px auto',
	        position: 'absolute',
	        right: 0,
	        height: '100%',
	        marginLeft: detailsWidth
	    },
	    action: {
	        margin: '0 auto'
	    },
	    wallpaperDiv: {
	        padding: '5px',
	        display: 'flex',
	        minHeight: '100px',
	        maxWidth: '120px'
	    },
	    wallpaper: {
	        maxWidth: '270px',
	        display: 'block',
	        margin: '0px auto'
	    },
	    rightBottomCornerDiv: {
	        color: '#ccc',
	        padding: '5px',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'flex-end',
	        marginTop: '2%'
	    },
	    rightDiv: {
	        position: 'absolute',
	        bottom: '-1%',
	        right: 0,
	        color: '#ccc',
	        padding: '1%',
	        marginBottom: '2.5%'
	    },
	    marginTop: {
	        marginTop: '35px'
	    },
	    marginAuto: {
	        margin: '0 auto',
	        height: '100%'
	    }
	};
	var GlanceDraftCard = /** @class */ (function (_super) {
	    __extends(GlanceDraftCard, _super);
	    function GlanceDraftCard(props) {
	        var _this = _super.call(this, props) || this;
	        _this.getInitialStateFromProp = function (props) {
	            var studioAppConfig = props.studioAppConfig, glanceDraftData = props.glanceDraftData, pristine = props.pristine, removed = props.removed;
	            var editable = !removed;
	            var _a = draftsHelper_1.getPublishButtonAtributes({
	                editable: editable,
	                glanceDraftData: glanceDraftData,
	                studioAppConfig: studioAppConfig,
	                pristine: pristine
	            }), publishButtonDisability = _a.disable, _b = _a.tooltip, publishButtonTooltipText = _b === void 0 ? '' : _b;
	            return {
	                publishButtonDisability: publishButtonDisability,
	                publishButtonTooltipText: publishButtonTooltipText
	            };
	        };
	        _this.state = {
	            expanded: false,
	            language: 'ENG',
	            publishButtonDisability: false,
	            publishButtonTooltipText: ''
	        };
	        _this.removeImage = _this.removeImage.bind(_this);
	        _this.onImageDrop = _this.onImageDrop.bind(_this);
	        _this.onOverlayImageDrop = _this.onOverlayImageDrop.bind(_this);
	        _this.onBingeImageDrop = _this.onBingeImageDrop.bind(_this);
	        _this.removeOverlayImage = _this.removeOverlayImage.bind(_this);
	        _this.removeBingeImage = _this.removeBingeImage.bind(_this);
	        _this.onEdit = _this.onEdit.bind(_this);
	        _this.onSave = _this.onSave.bind(_this);
	        _this.onRemove = _this.onRemove.bind(_this);
	        _this.onPause = _this.onPause.bind(_this);
	        _this.onPublish = _this.onPublish.bind(_this);
	        _this.onOverride = _this.onOverride.bind(_this);
	        _this.onPublish = _this.onPublish.bind(_this);
	        _this.toggleExpansion = _this.toggleExpansion.bind(_this);
	        _this.handleLanguageChange = _this.handleLanguageChange.bind(_this);
	        _this.checkLanguageCategory = _this.checkLanguageCategory.bind(_this);
	        _this.readStartTime = _this.readStartTime.bind(_this);
	        return _this;
	    }
	    GlanceDraftCard.prototype.componentDidMount = function () {
	        var _this = this;
	        var initialStateFromProp = this.getInitialStateFromProp(this.props);
	        this.setState(function (state, props) { return (__assign({}, _this.state, initialStateFromProp)); });
	    };
	    GlanceDraftCard.prototype.componentWillReceiveProps = function (nextProps) {
	        var _this = this;
	        var initialStateFromProp = this.getInitialStateFromProp(nextProps);
	        this.setState(function (state, props) { return (__assign({}, _this.state, initialStateFromProp)); });
	    };
	    GlanceDraftCard.prototype.toggleExpansion = function () {
	        this.setState(__assign({}, this.state, { expanded: !this.state.expanded }));
	    };
	    GlanceDraftCard.prototype.onEdit = function (key, value) {
	        this.props.onEdit(key, value);
	    };
	    GlanceDraftCard.prototype.onSave = function (isCTASecReq) {
	        this.props.onSave(isCTASecReq);
	    };
	    GlanceDraftCard.prototype.onOverride = function () {
	        this.props.onOverride();
	    };
	    GlanceDraftCard.prototype.onRemove = function () {
	        this.props.onRemove();
	    };
	    GlanceDraftCard.prototype.onPause = function () {
	        this.props.onPause();
	    };
	    GlanceDraftCard.prototype.onPublish = function () {
	        this.props.onPublish();
	    };
	    GlanceDraftCard.prototype.onImageDrop = function (files) {
	        this.props.onImageDrop(files[0]);
	    };
	    GlanceDraftCard.prototype.onOverlayImageDrop = function (files) {
	        this.props.onOverlayImageDrop(files[0]);
	    };
	    GlanceDraftCard.prototype.onBingeImageDrop = function (files) {
	        this.props.onBingeImageDrop(files[0]);
	    };
	    GlanceDraftCard.prototype.removeImage = function () {
	        this.props.removeImage();
	    };
	    GlanceDraftCard.prototype.removeOverlayImage = function () {
	        this.props.removeOverlayImage();
	    };
	    GlanceDraftCard.prototype.removeBingeImage = function () {
	        this.props.removeBingeImage();
	    };
	    GlanceDraftCard.prototype.getUrl = function (image, imageType, dropImage) {
	        var cdnPrefix = this.props.studioAppConfig.cdnPrefix;
	        if (image) {
	            var meta_1;
	            image.imageMetas.forEach(function (elem) {
	                if (elem.type == imageType) {
	                    meta_1 = elem;
	                }
	            });
	            if (meta_1 === null || typeof meta_1 == 'undefined') {
	                return null;
	            }
	            return Utils_1["default"].getImagePath(cdnPrefix, image.id, meta_1);
	        }
	        if (dropImage) {
	            return dropImage.image.preview;
	        }
	        return null;
	    };
	    GlanceDraftCard.prototype.checkLanguageCategory = function (value) {
	        var glanceDraftData = this.props.glanceDraftData;
	        if (glanceDraftData.type === 1 /* WALLPAPER */) {
	            return false;
	        }
	        if (glanceDraftData.categoryIds == null || value == null) {
	            return true;
	        }
	        if (glanceDraftData.categoryIds.find(function (category) { return category === '#tamil_news'; }) != undefined &&
	            !(value == 'ta')) {
	            return false;
	        }
	        if (glanceDraftData.categoryIds.find(function (category) { return category === '#telugu_news'; }) != undefined &&
	            !(value == 'te')) {
	            return false;
	        }
	        if (glanceDraftData.categoryIds.find(function (category) { return category === '#bengali_news'; }) != undefined &&
	            !(value == 'bn')) {
	            return false;
	        }
	        if (glanceDraftData.categoryIds.find(function (category) { return category === '#marathi_news'; }) != undefined &&
	            !(value == 'mr')) {
	            return false;
	        }
	        if (glanceDraftData.categoryIds.find(function (category) { return category === '#kannada_news'; }) != undefined &&
	            !(value == 'kn')) {
	            return false;
	        }
	        return true;
	    };
	    GlanceDraftCard.prototype.handleLanguageChange = function (field, context, value) {
	        if (!this.checkLanguageCategory(value)) {
	            return;
	        }
	        this.state.language = value;
	        console.log(value);
	        this.setState(__assign({}, this.state, { language: value }));
	        this.onEdit('language', value);
	    };
	    GlanceDraftCard.prototype.readStartTime = function (glanceTime) {
	        if (glanceTime && glanceTime != null) {
	            if (glanceTime.startTime.absoluteTime) {
	                var absoluteTime = glanceTime.startTime.absoluteTime.timeInSecs;
	                return Utils_1["default"].getReadableAbsoluteTime(absoluteTime);
	            }
	            else if (glanceTime.startTime.relativeTime) {
	                return Utils_1["default"].getReadableRelativeTime(glanceTime.startTime.relativeTime);
	            }
	            else
	                return '';
	        }
	        else
	            return '';
	    };
	    GlanceDraftCard.prototype.checkExpiry = function (glanceTime) {
	        var currentdateEpochInSecs = Math.floor(new Date().getTime() / 1000);
	        var endDateEpochInSecs = Utils_1["default"].getEpochFinalInSecs(glanceTime) +
	            Utils_1["default"].getMillis(glanceTime.duration) / 1000;
	        return currentdateEpochInSecs > endDateEpochInSecs;
	    };
	    GlanceDraftCard.prototype.render = function () {
	        var _this = this;
	        var detailStyle = this.state.expanded
	            ? styles.cardTextDivExpanded
	            : styles.cardTextDiv;
	        var paddingBottom = this.state.expanded ? '0em' : '';
	        var wallpaperDivWidth = this.state.expanded
	            ? wallpaperWidthExpanded
	            : wallpaperWidth;
	        var _a = this.props, glanceDraftData = _a.glanceDraftData, dropImage = _a.dropImage, draftMeta = _a.draftMeta, regionPartnerList = _a.regionPartnerList, bubbleData = _a.bubbleData;
	        var image = glanceDraftData.image, overlayImage = glanceDraftData.overlayImage, bingeImage = glanceDraftData.bingeImage, glanceType = glanceDraftData.type, peek = glanceDraftData.peek, publisherData = glanceDraftData.publisherData, userLifeTimeFilter = glanceDraftData.userLifeTimeFilter, adCoefficient = glanceDraftData.adCoefficient, bucketPriority = glanceDraftData.bucketPriority, rankInBubble = glanceDraftData.rankInBubble, campaignMeta = glanceDraftData.campaignMeta, dspCampaignData = glanceDraftData.dspCampaignData;
	        var isDspCampaign = (dspCampaignData || { isDspCampaign: false }).isDspCampaign;
	        var eCpm = campaignMeta ? campaignMeta.eCpm : null;
	        var _b = (peek || {}).tvVideoPeek, tvVideoPeek = _b === void 0 ? null : _b;
	        var _c = this.state, publishButtonDisability = _c.publishButtonDisability, publishButtonTooltipText = _c.publishButtonTooltipText;
	        var backgroundStyle = {};
	        if (this.props.removed) {
	            backgroundStyle = {
	                backgroundColor: '#E8E8E8'
	            };
	        }
	        var errorText;
	        if ((dropImage && dropImage.image && !dropImage.attrSource) ||
	            (image && !image.attribution)) {
	            errorText = "Wallpaper can't be saved/published without Glance source";
	        }
	        else if (!image && !dropImage) {
	            errorText = "Draft doesn't have image yet";
	        }
	        else if (glanceType == 2 /* STORY */ && peek && !peek.sourceName) {
	            errorText = "Draft doesn't have peek source name or title";
	        }
	        else if (glanceType == 4 /* SPONSORED */ && !publisherData) {
	            errorText = 'Publisher must be specified for Sponsored Content';
	        }
	        else if (userLifeTimeFilter &&
	            userLifeTimeFilter.startDay !== null &&
	            userLifeTimeFilter.startDay !== 8 &&
	            !userLifeTimeFilter.endDay) {
	            errorText = 'End Day is missing';
	        }
	        else if (glanceType == 4 /* SPONSORED */) {
	            if (adCoefficient == null && !isDspCampaign) {
	                errorText = 'Ads Coefficient must be specified for Type: Sponsored';
	            }
	            if (bucketPriority == null) {
	                errorText = 'Bucket Priority must be specified for Type: Sponsored';
	            }
	            if (eCpm == null && !isDspCampaign) {
	                errorText = 'ECPM must be specified for Type: Sponsored';
	            }
	            if (this.props.storyCount > 0 && rankInBubble === null) {
	                errorText = 'Missing Rank';
	            }
	        }
	        var showBubbleImage = function () {
	            var commonChecks = _this.state.expanded && !tvVideoPeek &&
	                glanceDraftData.bubbleId &&
	                bubbleData && bubbleData.imagePath;
	            if (commonChecks && glanceType === 4 /* SPONSORED */) {
	                return true;
	            }
	            else if (commonChecks && glanceType != 1 /* WALLPAPER */ &&
	                glanceDraftData.peek.glanceContext === 0 /* LIVE */) {
	                return true;
	            }
	            return false;
	        };
	        return (React.createElement("div", null,
	            React.createElement(Card_1.Card, { style: __assign({}, this.props.cardStyle, backgroundStyle), containerStyle: this.props.cardStyle },
	                React.createElement(Card_1.CardText, { style: {
	                        padding: '0px',
	                        position: 'relative',
	                        paddingBottom: paddingBottom
	                    } },
	                    React.createElement("div", { className: "display-flex", style: __assign({}, styles.wrapperDiv, { alignItems: isDspCampaign ? 'end' : 'center' }) },
	                        React.createElement("div", { className: "", style: __assign({ width: wallpaperDivWidth }, styles.wallpaperDiv, { display: this.state.expanded ? 'block' : 'flex', maxHeight: this.state.expanded ? null : '110px' }) },
	                            React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
	                                React.createElement("div", { style: this.state.expanded ? styles.marginTop : styles.marginAuto },
	                                    image ||
	                                        (this.props.dropImage && this.props.dropImage.image) ? (React.createElement(GlanceThumbnail_1["default"], { width: "100%", imageUrl: this.getUrl(image, 0 /* LEGACY */, this.props.dropImage), overlayImageUrl: this.getUrl(overlayImage, 0 /* LEGACY */, this.props.dropImage), bingeImageUrl: this.getUrl(bingeImage, 0 /* LEGACY */, this.props.dropImage), shouldShowCarousal: !this.state.expanded, style: { margin: 'auto', display: 'inline-block' }, imageStyle: { margin: 'auto', display: 'block' } })) : (React.createElement(ImageDropzone_1["default"], { onDrop: this.onImageDrop, flex: true, disableClick: !this.state.expanded || this.props.removed })),
	                                    this.state.expanded ? (React.createElement("div", { className: "imageLabel" }, "Drop Image")) : null,
	                                    (image ||
	                                        (this.props.dropImage && this.props.dropImage.image)) &&
	                                        this.state.expanded &&
	                                        !this.props.removed ? (React.createElement(IconButton_1["default"], { onClick: this.removeImage, tooltip: 'Remove Image', style: { display: 'block', margin: '0 auto' } },
	                                        React.createElement(FontIcon_1["default"], { className: "material-icons", color: colors_1.red500, style: { fontSize: '2em' } }, "close"))) : null),
	                                React.createElement("div", { style: this.state.expanded ? styles.marginTop : styles.marginAuto },
	                                    this.state.expanded &&
	                                        !tvVideoPeek &&
	                                        glanceType != 1 /* WALLPAPER */ ? (overlayImage ||
	                                        (this.props.overlayImage &&
	                                            this.props.overlayImage.image) ? (React.createElement(GlanceThumbnail_1["default"], { width: "90%", imageUrl: this.getUrl(overlayImage, 0 /* LEGACY */, this.props.overlayImage), style: {
	                                            margin: 'auto',
	                                            display: 'inline-block',
	                                            backgroundColor: 'black'
	                                        }, imageStyle: { margin: 'auto', display: 'block' } })) : (React.createElement(ImageDropzone_1["default"], { onDrop: this.onOverlayImageDrop, flex: true, disableClick: !this.state.expanded || this.props.overlayRemoved }))) : (''),
	                                    this.state.expanded && !tvVideoPeek ? (React.createElement("div", { className: "imageLabel" }, "Overlay Image")) : null,
	                                    (overlayImage ||
	                                        (this.props.overlayImage &&
	                                            this.props.overlayImage.image)) &&
	                                        this.state.expanded &&
	                                        !tvVideoPeek &&
	                                        !this.props.overlayRemoved ? (React.createElement(IconButton_1["default"], { onClick: this.removeOverlayImage, tooltip: 'Remove Overlay Image', style: { display: 'block', margin: '0 auto' } },
	                                        React.createElement(FontIcon_1["default"], { className: "material-icons", color: colors_1.red500, style: { fontSize: '2em' } }, "close"))) : null),
	                                React.createElement("div", { style: this.state.expanded ? styles.marginTop : styles.marginAuto },
	                                    this.state.expanded &&
	                                        !tvVideoPeek &&
	                                        glanceType != 1 /* WALLPAPER */ ? (bingeImage ||
	                                        (this.props.bingeImage && this.props.bingeImage.image) ? (React.createElement(GlanceThumbnail_1["default"], { width: "90%", imageUrl: this.getUrl(bingeImage, 0 /* LEGACY */, this.props.bingeImage), style: { margin: 'auto', display: 'inline-block' }, imageStyle: { margin: 'auto', display: 'block' } })) : (React.createElement(ImageDropzone_1["default"], { onDrop: this.onBingeImageDrop, flex: true, disableClick: !this.state.expanded || this.props.bingeRemoved }))) : (''),
	                                    this.state.expanded && !tvVideoPeek ? (React.createElement("div", { className: "imageLabel" }, "Binge Image")) : null,
	                                    (bingeImage ||
	                                        (this.props.bingeImage && this.props.bingeImage.image)) &&
	                                        this.state.expanded &&
	                                        !tvVideoPeek &&
	                                        !this.props.bingeRemoved ? (React.createElement(IconButton_1["default"], { onClick: this.removeBingeImage, tooltip: 'Remove Binge Image', style: { display: 'block', margin: '0 auto' } },
	                                        React.createElement(FontIcon_1["default"], { className: "material-icons", color: colors_1.red500, style: { fontSize: '2em' } }, "close"))) : null),
	                                React.createElement("div", { style: this.state.expanded
	                                        ? __assign({}, styles.marginTop, { position: 'relative' }) : styles.marginAuto }, showBubbleImage() ? (React.createElement("div", null,
	                                    React.createElement(GlanceThumbnail_1["default"], { width: "90%", imageUrl: Utils_1["default"].getBubbleImagePath(bubbleData ? bubbleData.imagePath : ''), style: { margin: 'auto', display: 'inline-block' }, imageStyle: { margin: 'auto', display: 'block' } }),
	                                    React.createElement(Chip_1["default"], { style: { position: 'absolute', top: 0, left: 125 }, key: 'useBubbleImageAsRibbonIcon', backgroundColor: glanceDraftData.peek.useBubbleImageAsRibbonIcon
	                                            ? colors_1.blue300
	                                            : null, onTouchTap: function () {
	                                            _this.onEdit('useBubbleImageAsRibbonIcon', !glanceDraftData.peek.useBubbleImageAsRibbonIcon);
	                                        } }, glanceDraftData.peek.useBubbleImageAsRibbonIcon
	                                        ? 'Show icon on LS'
	                                        : 'Dont show icon on LS'))) : ''))),
	                        React.createElement("div", { className: "display-flex", style: __assign({ width: detailsWidth }, detailStyle) },
	                            React.createElement(GlanceDraftDetails_1["default"], { glanceDraftData: glanceDraftData, onEdit: this.onEdit, editable: !this.props.removed, detailed: this.state.expanded, onSave: this.onSave, pristine: this.props.pristine, onRemove: this.onRemove, onPause: this.onPause, onPublish: this.onPublish, onOverride: this.onOverride, disableAttribution: (!dropImage || !dropImage.image) && !glanceDraftData.image, role: this.props.role, bubbleData: this.props.bubbleData, cardType: this.props.cardType, adCoefficientDisabled: this.props.adCoefficientDisabled, bucketPriorityDisabled: this.props.bucketPriorityDisabled, ecpmDisabled: this.props.ecpmDisabled, rankDisabled: this.props.rankDisabled, fCapDisabled: this.props.fCapDisabled, displayRank: this.props.displayRank, storyCount: this.props.storyCount, cityStates: this.props.cityStates, peekSourceList: this.props.peekSourceList, dspPeekSourceList: this.props.dspPeekSourceList }))),
	                    React.createElement("div", { style: styles.rightDiv },
	                        React.createElement("div", { style: {
	                                display: 'inline-block',
	                                flexWrap: 'wrap',
	                                marginBottom: '20px',
	                                marginTop: '30px',
	                                maxWidth: '1000px'
	                            } }, // 0: {region: 2, partner: undefined}
	                        regionPartnerList && regionPartnerList.length > 0
	                            ? regionPartnerList.map(function (tuple, index) {
	                                if (tuple.partner && tuple.region) {
	                                    return (React.createElement(react_lightweight_tooltip_1.Tooltip, { content: draftMeta && draftMeta[index]
	                                            ? _this.readStartTime(draftMeta[index].glanceTime)
	                                            : null, styles: styles.tooltipStyle, key: 'published_to_' + tuple.partner.partnerId },
	                                        React.createElement(Chip_1["default"], { style: _this.checkExpiry(draftMeta[index].glanceTime) ||
	                                                draftMeta[index].removed
	                                                ? __assign({}, styles.readableChip) : __assign({}, styles.readableChipLive), labelColor: colors_1.white, labelStyle: { lineHeight: '1.5em' }, key: 'published_to_' +
	                                                tuple.partner.partnerId +
	                                                tuple.region }, tuple.partner.name +
	                                            ': ' +
	                                            Utils_1["default"].getReadableRegionName(tuple.region))));
	                                }
	                            })
	                            : '')),
	                    React.createElement("div", { style: this.state.expanded
	                            ? __assign({}, styles.rightBottomCornerDiv) : __assign({}, styles.rightBottomCornerDiv, { marginTop: '-50px' }) },
	                        this.props.errorMsg,
	                        this.state.expanded && errorText ? (React.createElement("span", { style: { color: colors_1.red500 } }, errorText)) : null,
	                        React.createElement(DropDownMenu_1["default"], { value: glanceDraftData.glanceLanguageId, onChange: this.handleLanguageChange },
	                            React.createElement(MenuItem_1["default"], { value: null, primaryText: 'Language', key: 'empty' }),
	                            this.props.studioAppConfig.glanceLanguages.map(function (item, index) {
	                                return (React.createElement(MenuItem_1["default"], { value: item.id, primaryText: item.id, key: item.id }));
	                            })),
	                        React.createElement(IconButton_1["default"], { key: "copy", disabled: this.props.disableCopy, onClick: function () { return _this.props.copyDraft(glanceDraftData); } },
	                            React.createElement(FontIcon_1["default"], { className: "material-icons", color: '#ccc', style: { fontSize: '2em' } }, "add_circle")),
	                        React.createElement(IconButton_1["default"], { key: "bulkpublishButton", onClick: function () {
	                                _this.props.singleClickPublish(glanceDraftData);
	                            }, disabled: publishButtonDisability, tooltip: publishButtonTooltipText },
	                            React.createElement(FontIcon_1["default"], { className: "material-icons", style: { fontSize: '2em' } }, "publish")),
	                        React.createElement(IconButton_1["default"], { onClick: this.toggleExpansion, tooltip: this.state.expanded ? 'Close' : 'Edit', key: "toggleExpansionButton" },
	                            React.createElement(FontIcon_1["default"], { className: "material-icons", color: '#ccc', style: { fontSize: '2em' } }, this.state.expanded ? 'keyboard_arrow_up' : 'edit')))))));
	    };
	    return GlanceDraftCard;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(GlanceDraftCard);


/***/ },

/***/ 1010:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var glance_datatypes_1 = __webpack_require__(67);
	var types_1 = __webpack_require__(125);
	var material_ui_1 = __webpack_require__(38);
	var RadioButton_1 = __webpack_require__(99);
	var Table_1 = __webpack_require__(330);
	var colors_1 = __webpack_require__(18);
	var draftsHelper_1 = __webpack_require__(429);
	var draftDetailsStyle_1 = __webpack_require__(247);
	var Constants_1 = __webpack_require__(111);
	var BeaconTableRow_1 = __webpack_require__(1007);
	var material_ui_chip_input_1 = __webpack_require__(191);
	var JerseyRestApiService_1 = __webpack_require__(83);
	var MultiSelectDropdown_1 = __webpack_require__(999);
	var react_lightweight_tooltip_1 = __webpack_require__(392);
	var Utils_1 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var lodash_1 = __webpack_require__(294);
	var RestService_1 = __webpack_require__(32);
	var Popover_1 = __webpack_require__(322);
	var LottieWrapper_1 = __webpack_require__(1013);
	var Selected_1 = __webpack_require__(1004);
	var FileUpload_1 = __webpack_require__(1002);
	var Ban_1 = __webpack_require__(1001);
	var Pencil_1 = __webpack_require__(1003);
	var TAG_SOURCE = [
	    'Politics',
	    'National',
	    'International',
	    'Entertainment',
	    'Business/Markets',
	    'Automotive',
	    'Fashion',
	    'Health and Fitness',
	    'Nature',
	    'Space',
	    'Travel',
	    'Sci/Tech',
	    'Sports',
	    'Culture/Lifestyle',
	    'DIY/Life Hacks',
	    'Photo Stories',
	    'Interesting',
	    'Sports',
	    'Animals',
	    'Humour',
	    'Social Media',
	    'Facts',
	    'Motivation',
	    'Puzzles',
	    "What's today",
	    'Food',
	    'Consumer Product',
	].sort();
	var SPONSORED_SESSION_MODE_LIST = [
	    { name: 'LOCKSCREEN', value: 1 /* DEFAULT */ },
	    { name: 'BINGE', value: 2 /* BINGE */ },
	    { name: 'IN-GAME REWARDED VIDEOS', value: 4 /* GAME_REWARDED */ },
	    { name: 'GAME SPLASH', value: 5 /* GAME_SPLASH */ },
	];
	var SESSION_MODE_LIST_OPTIONS = [
	    { value: 'LOCKSCREEN' },
	    { value: 'BINGE' },
	    { value: 'IN-GAME REWARDED VIDEOS' },
	    { value: 'GAME SPLASH' },
	];
	var GLANCE_TV_LIST_OPTIONS = [
	    { value: 6 /* SCREENSAVER */, name: 'SCREENSAVER' },
	    { value: 7 /* PATCHWALL_STORIES */, name: 'PATCHWALL_STORIES' },
	];
	var sessionModeMappingSelected = {
	    ANY: 0,
	    LOCKSCREEN: 1,
	    BINGE: 2,
	    HIGHLIGHTS: 3,
	    'IN-GAME REWARDED VIDEOS': 4,
	    'GAME SPLASH': 5,
	    SCREENSAVER: 6,
	    PATCHWALL_STORIES: 7
	};
	exports.sessionModeMapping = {
	    0: 'ANY',
	    1: 'LOCKSCREEN',
	    2: 'BINGE',
	    3: 'HIGHLIGHTS',
	    4: 'IN-GAME REWARDED VIDEOS',
	    5: 'GAME SPLASH',
	    6: 'SCREENSAVER',
	    7: 'PATCHWALL_STORIES'
	};
	var MAX_CATEGORY = {
	    DEFAULT: 2,
	    SPONSORED: 6
	};
	var networkTargetingOptions = [
	    { value: 'OFFLINE' },
	    { value: 'WIFI' },
	    { value: 'MOBILE_DATA' },
	];
	var USER_NETWORK_TYPE = {
	    OFFLINE: 0,
	    WIFI: 1,
	    MOBILE_DATA: 2
	};
	var USER_NETWORK_TYPE_SELECTED = {
	    0: 'OFFLINE',
	    1: 'WIFI',
	    2: 'MOBILE_DATA'
	};
	var glanceTypes = {
	    1: 'WALLPAPER',
	    2: 'STORY',
	    3: 'RESERVED_STORY',
	    4: 'SPONSORED'
	};
	var TITLE_LENGTH_LIMIT_NON_SPONSORED = 50;
	var TITLE_LENGTH_LIMIT_SPONSORED = 40;
	var SHORT_TITLE_LENGTH_LIMIT = 25;
	var DEFAULT_SUMMARY_LENGTH_LIMIT = 150;
	var LS_SUBTEXT_LIMIT = 10;
	var CTA_TEXT_LENGTH_LIMIT = 11;
	var NEGATIVE_TARGET_TYPE = ['absent', 'anyAbsent'];
	var POSITIVE_TARGET_TYPE = ['present', 'anyPresent'];
	var CATEGORY_SOURCE_CONFIG = { text: 'displayName', value: 'category' };
	var CITY_SOURCE_CONFIG = { text: 'groupName', value: 'groupName' };
	var CARRIER_SOURCE_CONFIG = { text: 'carrierName', value: 'carrierId' };
	var SEGMENT_SOURCE_CONFIG = { text: 'text', value: 'id' };
	var TARGET_SOURCE_CONFIG = { text: 'name', value: 'packageId' };
	var BUBBLE_SOURCE_CONFIG = { text: 'qualifier', value: 'bubbleId' };
	var EMOJI_FORMAT = {
	    LOTTIE: 'LOTTIE',
	    GIF: 'GIF',
	    SVG: 'SVG',
	    PNG: 'PNG',
	    UNKNOWN: 'UNKNOWN'
	};
	var rendersessionPropertiesMapping = function (params) {
	    var _a = (params.peek || {}).tvVideoPeek, tvVideoPeek = _a === void 0 ? null : _a;
	    var selectedRenderSession = [];
	    var sessionList;
	    var data = Utils_1["default"].getRenderSessionData(params);
	    if (tvVideoPeek) {
	        sessionList = GLANCE_TV_LIST_OPTIONS.filter(function (item) {
	            return data.includes(item.value);
	        });
	    }
	    else {
	        sessionList = SPONSORED_SESSION_MODE_LIST.filter(function (item) {
	            return data.includes(item.value);
	        });
	    }
	    sessionList.forEach(function (element) {
	        selectedRenderSession.push({
	            value: exports.sessionModeMapping[element.value]
	        });
	    });
	    return selectedRenderSession;
	};
	var GlanceDraftDetails = /** @class */ (function (_super) {
	    __extends(GlanceDraftDetails, _super);
	    function GlanceDraftDetails(props) {
	        var _this = _super.call(this, props) || this;
	        _this.setEuAndValuePropSource = function () {
	            RestService_1["default"].getEUs(function (response) {
	                _this.setState(__assign({}, _this.state, { allEus: response }));
	            });
	        };
	        _this.getInitialStateFromProp = function (props) {
	            var publisherDatas = new Map();
	            var studioAppConfig = props.studioAppConfig, glanceDraftData = props.glanceDraftData, editable = props.editable, pristine = props.pristine, removed = props.removed;
	            studioAppConfig.publishers.forEach(function (publisher) {
	                publisherDatas.set(publisher.id, new glance_datatypes_1.PublisherData({
	                    id: publisher.id,
	                    displayName: publisher.displayName,
	                    logoUrl: publisher.logoUrl,
	                    advertiserId: publisher.advertiserId
	                }));
	            });
	            var peek = glanceDraftData.peek, beacons = glanceDraftData.beacons, carriers = glanceDraftData.carriers, cityIds = glanceDraftData.cityIds, segmentIds = glanceDraftData.segmentIds, antiSegmentIds = glanceDraftData.antiSegmentIds, targeting = glanceDraftData.targeting, type = glanceDraftData.type, publisherData = glanceDraftData.publisherData, editMeta = glanceDraftData.editMeta, rankInBubble = glanceDraftData.rankInBubble, adCoefficient = glanceDraftData.adCoefficient, bucketPriority = glanceDraftData.bucketPriority, campaignMeta = glanceDraftData.campaignMeta, 
	            // comment/uncomment for network types
	            userNetworkTypes = glanceDraftData.userNetworkTypes;
	            var ecpm = campaignMeta ? campaignMeta.eCpm : null;
	            var categorySource = [];
	            var categoryMap = new Map();
	            studioAppConfig.categories.forEach(function (category) {
	                categorySource.push({
	                    displayName: category.displayName,
	                    category: category
	                });
	                categoryMap.set(category.id, category);
	            });
	            var linkType;
	            if (peek) {
	                if (peek.videoUrl) {
	                    linkType = 'videoUrl';
	                }
	                else if (peek.webPeekUrl) {
	                    linkType = 'webPeekUrl';
	                }
	                else if (peek.ctaUrl) {
	                    linkType = 'ctaUrl';
	                }
	                else {
	                    linkType = 'linkType_unknown';
	                }
	            }
	            var cities = [];
	            var cityGroups = [];
	            var carrierMetas = [];
	            var segments = [];
	            var antiSegments = [];
	            var positiveTargets = [];
	            var negativeTargets = [];
	            var negativeTargetingType = 'absent';
	            var positiveTargetingType = 'present';
	            var selectedNetworkTypes = [];
	            var storyCount = props.bubbleData ? props.bubbleData.storyCount : 0;
	            var publishedBubbleId = _this.state.publishValue === 8 /* PUBLISHED */ &&
	                _this.state.publishedBubbleId === ''
	                ? props.glanceDraftData.bubbleId
	                : _this.state.publishedBubbleId;
	            var publishedRank = _this.state.publishValue === 8 /* PUBLISHED */ &&
	                _this.state.publishedRank === null
	                ? props.glanceDraftData.rankInBubble
	                : _this.state.publishedRank;
	            if (cityIds) {
	                studioAppConfig.cityGroups.forEach(function (cityGroup) {
	                    for (var _i = 0, _a = cityGroup.cities; _i < _a.length; _i++) {
	                        var city = _a[_i];
	                        if (cityIds.includes(city)) {
	                            cityGroups.push(cityGroup);
	                            break;
	                        }
	                    }
	                });
	            }
	            if (cityIds) {
	                cityIds.forEach(function (city) {
	                    var cityObj = studioAppConfig.cities.find(function (c) { return c.id === city; });
	                    if (cityObj) {
	                        cities.push(cityObj);
	                    }
	                });
	            }
	            if (carriers) {
	                carriers.forEach(function (carrier) {
	                    var carrierObj = studioAppConfig.carrierMetas.find(function (c) { return c.carrierId === carrier; });
	                    if (carrierObj) {
	                        carrierMetas.push(carrierObj);
	                    }
	                });
	            }
	            if (segmentIds) {
	                segmentIds.forEach(function (segment) {
	                    segments.push(studioAppConfig.sqlSegments.find(function (s) { return s.id == segment; }));
	                });
	            }
	            if (antiSegmentIds) {
	                antiSegmentIds.forEach(function (segment) {
	                    antiSegments.push(studioAppConfig.sqlSegments.find(function (s) { return s.id == segment; }));
	                });
	            }
	            if (lodash_1.get(targeting, 'apps.absent[0]')) {
	                negativeTargetingType = 'absent';
	                targeting.apps.absent.forEach(function (target) {
	                    var searchItem = studioAppConfig.apps.find(function (t) { return t.packageId == target; });
	                    if (searchItem) {
	                        negativeTargets.push(searchItem);
	                    }
	                });
	            }
	            else if (lodash_1.get(targeting, 'apps.anyAbsent[0]')) {
	                negativeTargetingType = 'anyAbsent';
	                targeting.apps.anyAbsent.forEach(function (target) {
	                    var searchItem = studioAppConfig.apps.find(function (t) { return t.packageId == target; });
	                    if (searchItem) {
	                        negativeTargets.push(searchItem);
	                    }
	                });
	            }
	            if (lodash_1.get(targeting, 'apps.present[0]')) {
	                positiveTargetingType = 'present';
	                targeting.apps.present.forEach(function (target) {
	                    var searchItem = studioAppConfig.apps.find(function (t) { return t.packageId == target; });
	                    if (searchItem) {
	                        positiveTargets.push(searchItem);
	                    }
	                });
	            }
	            else if (lodash_1.get(targeting, 'apps.anyPresent[0]')) {
	                positiveTargetingType = 'anyPresent';
	                targeting.apps.anyPresent.forEach(function (target) {
	                    var searchItem = studioAppConfig.apps.find(function (t) { return t.packageId == target; });
	                    if (searchItem) {
	                        positiveTargets.push(searchItem);
	                    }
	                });
	            }
	            if (type == 4) {
	                JerseyRestApiService_1["default"].getCampaignObjectives()
	                    .then(function (response) {
	                    _this.setState(__assign({}, _this.state, { campaignObjectiveList: response }));
	                })["catch"](function (err) {
	                    console.log(err);
	                });
	            }
	            // Comment/Uncomment for network Targeting
	            if (userNetworkTypes) {
	                userNetworkTypes.forEach(function (element) {
	                    selectedNetworkTypes.push({
	                        value: USER_NETWORK_TYPE_SELECTED[element]
	                    });
	                });
	            }
	            else if (!(peek && peek.title)) {
	                for (var key in USER_NETWORK_TYPE_SELECTED) {
	                    selectedNetworkTypes.push({ value: USER_NETWORK_TYPE_SELECTED[key] });
	                }
	            }
	            var sortedBubbles = _this.sortBubbleData(type);
	            var _a = draftsHelper_1.getPublishButtonAtributes({
	                editable: editable,
	                glanceDraftData: glanceDraftData,
	                studioAppConfig: studioAppConfig,
	                pristine: pristine
	            }), publishButtonDisability = _a.disable, _b = _a.tooltip, publishButtonTooltipText = _b === void 0 ? '' : _b;
	            var beautifulWallpaperFlag = glanceDraftData.isBeautifulWallpaperEnabled;
	            var isBeautifulWallpaperEnabled = beautifulWallpaperFlag === null || beautifulWallpaperFlag === undefined
	                ? true
	                : beautifulWallpaperFlag;
	            return {
	                publisherDatas: publisherDatas,
	                categorySource: categorySource,
	                categoryMap: categoryMap,
	                linkType: linkType,
	                dailyWeeklyCapError: false,
	                beaconType: types_1.BeaconType.RENDER,
	                beaconPartner: _this.state.beaconPartner || '',
	                beaconUrl: _this.state.beaconUrl || null,
	                beaconError: '',
	                minDurationInSecs: 0,
	                delayDurationInMillis: null,
	                beacons: beacons,
	                publisherData: publisherData,
	                cities: cities,
	                cityGroups: cityGroups,
	                citySource: [],
	                carrierMetas: carrierMetas,
	                carrierSource: [],
	                negativeTargets: negativeTargets,
	                positiveTargets: positiveTargets,
	                negativeTargetingType: negativeTargetingType,
	                positiveTargetingType: positiveTargetingType,
	                negativeTargetSource: [],
	                positiveTargetSource: [],
	                segments: segments,
	                bubbles: _this.state.bubbles,
	                filteredBubbles: [],
	                antiSegments: antiSegments,
	                segmentSource: [],
	                publishValue: editMeta.state,
	                publishButtonDisability: publishButtonDisability,
	                publishButtonTooltipText: publishButtonTooltipText,
	                ctaType: peek && peek.ctaType ? peek.ctaType : 1 /* CTA_URL */,
	                sortedBubbles: sortedBubbles,
	                renderSessionProperties: rendersessionPropertiesMapping(glanceDraftData),
	                lsSubTextExceededSize: false,
	                lockscreenCtaTextExceededSize: false,
	                ctaTextExceededSize: false,
	                userNetworkTypes: selectedNetworkTypes,
	                campaignObjectiveList: _this.state.campaignObjectiveList,
	                showTriggerPercentage: false,
	                CtaViewExceededHeight: false,
	                rankInBubble: rankInBubble ? rankInBubble : 1,
	                storyCount: storyCount,
	                publishedBubbleId: publishedBubbleId,
	                publishedRank: publishedRank,
	                showPopover: false,
	                allEmojis: [],
	                selectedEmoji: {
	                    emoji: null,
	                    target: null,
	                    idx: null
	                },
	                chosenEmoji: null,
	                hoveredEmoji: null,
	                fileUploadError: false,
	                sameEmoji: null,
	                emojiUploadError: [],
	                appOpenNudgeConfig: lodash_1.get(glanceDraftData, 'ociConfigs.appOpenNudgeConfig'),
	                appOpenNotificationConfig: lodash_1.get(glanceDraftData, 'ociConfigs.appOpenNotificationConfig'),
	                overrideWallpaperMode: !isBeautifulWallpaperEnabled,
	                programmaticDetail: lodash_1.get(glanceDraftData, 'Programmatic.programmaticDetail'),
	                eu: _this.state.eu || lodash_1.get(glanceDraftData, 'eu'),
	                valueprop: _this.state.valueProp || lodash_1.get(glanceDraftData, 'valueProp'),
	                dspCampaignData: lodash_1.get(glanceDraftData, 'dspCampaignData')
	            };
	        };
	        _this.getEmojiMapping = function () {
	            if (_this.props.glanceDraftData.peek.tvVideoPeek && _this.props.detailed) {
	                RestService_1["default"].getDraftEmojiMapping("Bearer " + document.cookie.split('glance-studio-session=')[1], _this.props.glanceDraftData.draftId, function (data) {
	                    if (data[0] && data[0].emojis.length > 0) {
	                        var emojis = data[0].emojis.sort(function (a, b) { return a.position - b.position; });
	                        _this.setState(__assign({}, _this.state, { currEmojis: emojis }));
	                    }
	                });
	            }
	        };
	        _this.fetchBubbleById = function () {
	            JerseyRestApiService_1["default"].getBubbleById(_this.props.glanceDraftData.bubbleId)
	                .then(function (response) {
	                _this.setState(__assign({}, _this.state, { bubbles: response }));
	            })["catch"](function (err) {
	                console.log(err);
	            });
	        };
	        // getAvailableRank = async () => {
	        //   if (this.state.rankDetails.length === 0) {
	        //     const response: any = await JerseyRestApiService.getAvailableRank(
	        //       this.props.glanceDraftData.bubbleId,
	        //     );
	        //     this.setState({
	        //       ...this.state,
	        //       rankDetails: response.options.map((item) => ({
	        //         ...item,
	        //         name: Number(item.name),
	        //       })),
	        //     });
	        //   }
	        // };
	        _this.sortBubbleData = function (type) {
	            var result = _this.state.bubbles.filter(function (bubble) { return glanceTypes[type] === glanceTypes[bubble.glanceType]; });
	            return result;
	        };
	        _this.onChange = function (key, e, newValue) {
	            newValue = !newValue || newValue.length == 0 ? null : newValue;
	            if (key == 'title') {
	                var titleLengthLimit = _this.props.glanceDraftData.type === 4 /* SPONSORED */
	                    ? TITLE_LENGTH_LIMIT_SPONSORED
	                    : TITLE_LENGTH_LIMIT_NON_SPONSORED;
	                if (newValue && newValue.length > titleLengthLimit) {
	                    _this.setState(__assign({}, _this.state, { titleExceededSize: newValue.length }));
	                    newValue = newValue.substr(0, titleLengthLimit);
	                }
	                else {
	                    _this.setState(__assign({}, _this.state, { titleExceededSize: undefined }));
	                }
	            }
	            else if (key == 'shortTitle') {
	                if (newValue && newValue.length > SHORT_TITLE_LENGTH_LIMIT) {
	                    _this.setState(__assign({}, _this.state, { shortTitleExceededSize: newValue.length }));
	                    newValue = newValue.substr(0, SHORT_TITLE_LENGTH_LIMIT);
	                }
	                else {
	                    _this.setState(__assign({}, _this.state, { shortTitleExceededSize: undefined }));
	                }
	            }
	            else if (key == 'summary') {
	                if (newValue &&
	                    newValue.length >
	                        (_this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT)) {
	                    _this.setState(__assign({}, _this.state, { summaryExceededSize: newValue.length }));
	                    newValue = newValue.substr(0, _this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT);
	                }
	                else {
	                    _this.setState(__assign({}, _this.state, { summaryExceededSize: undefined }));
	                }
	            }
	            else if (key == 'cheesySummary') {
	                if (newValue &&
	                    newValue.length >
	                        (_this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT)) {
	                    _this.setState(__assign({}, _this.state, { cheesySummaryExceededSize: newValue.length }));
	                    newValue = newValue.substr(0, _this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT);
	                }
	                else {
	                    _this.setState(__assign({}, _this.state, { cheesySummaryExceededSize: undefined }));
	                }
	            }
	            else if (key == 'subText') {
	                if (newValue && newValue.length > LS_SUBTEXT_LIMIT) {
	                    _this.setState(__assign({}, _this.state, { lsSubTextExceededSize: true }));
	                    return;
	                }
	                else {
	                    _this.setState(__assign({}, _this.state, { lsSubTextExceededSize: false }));
	                }
	            }
	            else if (key == 'lockscreen_cta_text') {
	                if (newValue && newValue.length > CTA_TEXT_LENGTH_LIMIT) {
	                    _this.setState(__assign({}, _this.state, { lockscreenCtaTextExceededSize: true }));
	                    return;
	                }
	                else {
	                    _this.setState(__assign({}, _this.state, { lockscreenCtaTextExceededSize: false }));
	                }
	            }
	            else if (key == 'cta_text') {
	                if (newValue && newValue.length > CTA_TEXT_LENGTH_LIMIT) {
	                    _this.setState(__assign({}, _this.state, { ctaTextExceededSize: true }));
	                    return;
	                }
	                else {
	                    _this.setState(__assign({}, _this.state, { ctaTextExceededSize: false }));
	                }
	            }
	            else if (key == 'ctaview_height') {
	                if (newValue &&
	                    newValue != null &&
	                    newValue.length > 0 &&
	                    (Number(newValue) < 10 || Number(newValue) > 100)) {
	                    _this.setState(__assign({}, _this.state, { CtaViewExceededHeight: true }));
	                    return;
	                }
	                else {
	                    _this.setState(__assign({}, _this.state, { CtaViewExceededHeight: false }));
	                }
	            }
	            _this.props.onEdit(key, newValue);
	        };
	        _this.onNudgeConfigUpdate = function (key, subkey, newValue) {
	            var _a;
	            var finalValue = __assign({}, _this.state.appOpenNudgeConfig, (_a = {}, _a[subkey] = newValue, _a));
	            if (key == 'ociConfigs') {
	                _this.setState(__assign({}, _this.state, { appOpenNudgeConfig: finalValue }));
	            }
	            _this.props.onEdit(key, {
	                appOpenNotificationConfig: _this.state.appOpenNotificationConfig,
	                appOpenNudgeConfig: finalValue
	            });
	        };
	        _this.onNudgeNotificationConfigUpdate = function (key, subkey, newValue) {
	            var _a;
	            var finalValue = __assign({}, _this.state.appOpenNotificationConfig, (_a = {}, _a[subkey] = newValue, _a));
	            if (key == 'ociConfigs') {
	                _this.setState(__assign({}, _this.state, { appOpenNotificationConfig: finalValue }));
	            }
	            _this.props.onEdit(key, {
	                appOpenNudgeConfig: _this.state.appOpenNudgeConfig,
	                appOpenNotificationConfig: finalValue
	            });
	        };
	        _this.addBeacon = function () {
	            var draft = _this.props.glanceDraftData;
	            if (_this.state.beaconType != null && _this.state.beaconUrl) {
	                if (!Utils_1["default"].validURL(_this.state.beaconUrl)) {
	                    _this.setState(__assign({}, _this.state, { beaconError: 'Beacon URL is invalid, please check' }));
	                    return '';
	                }
	                var beacon = new glance_datatypes_1.Beacon();
	                beacon.minDurationInSecs = _this.state.minDurationInSecs;
	                beacon.url = _this.state.beaconUrl.trim();
	                beacon.beaconPartner = _this.state.beaconPartner;
	                var beacons = void 0;
	                switch (_this.state.beaconType) {
	                    case types_1.BeaconType.CTA:
	                        beacons =
	                            draft.beacons && draft.beacons.ctaBeacons
	                                ? draft.beacons.ctaBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { ctaBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.VIDEO:
	                        beacons =
	                            draft.beacons && draft.beacons.videoBeacons
	                                ? draft.beacons.videoBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { videoBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.RENDER:
	                        beacons =
	                            draft.beacons && draft.beacons.renderBeacons
	                                ? draft.beacons.renderBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { renderBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.PEEK:
	                        beacons =
	                            draft.beacons && draft.beacons.peekBeacons
	                                ? draft.beacons.peekBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { peekBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.LIKE:
	                        beacons =
	                            draft.beacons && draft.beacons.likeBeacons
	                                ? draft.beacons.likeBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { likeBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.SHARE:
	                        beacons =
	                            draft.beacons && draft.beacons.shareBeacons
	                                ? draft.beacons.shareBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { shareBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.VIDEO_STARTED:
	                        beacons =
	                            draft.beacons && draft.beacons.videoStartedBeacons
	                                ? draft.beacons.videoStartedBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { videoStartedBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.HOLD:
	                        beacons =
	                            draft.beacons && draft.beacons.holdBeacons
	                                ? draft.beacons.holdBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { holdBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.APP_SUBMIT:
	                        beacons =
	                            draft.beacons && draft.beacons.appSubmitBeacons
	                                ? draft.beacons.appSubmitBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { appSubmitBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.INSTALL_NOW:
	                        beacons =
	                            draft.beacons && draft.beacons.installNowBeacons
	                                ? draft.beacons.installNowBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { installNowBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.INSTALL_LATER:
	                        beacons =
	                            draft.beacons && draft.beacons.installLaterBeacons
	                                ? draft.beacons.installLaterBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { installLaterBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.INSTALL_COMPLETE:
	                        beacons =
	                            draft.beacons && draft.beacons.installCompleteBeacons
	                                ? draft.beacons.installCompleteBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { installCompleteBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.APP_OPEN:
	                        beacons =
	                            draft.beacons && draft.beacons.appOpenBeacons
	                                ? draft.beacons.appOpenBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { appOpenBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.GLANCE_STARTED:
	                        beacon.delayDurationInMillis = _this.state.delayDurationInMillis;
	                        beacons =
	                            draft.beacons && draft.beacons.glanceStartedBeacons
	                                ? draft.beacons.glanceStartedBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { glanceStartedBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.PRIVIEW_TAP:
	                        beacons =
	                            draft.beacons && draft.beacons.previewTapBeacons
	                                ? draft.beacons.previewTapBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { previewTapBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.VIDEO_VIEWED:
	                        beacons =
	                            draft.beacons && draft.beacons.videoViewedBeacons
	                                ? draft.beacons.videoViewedBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { videoViewedBeacons: beacons }) }));
	                        break;
	                    case types_1.BeaconType.GLANCE_VIEWED:
	                        beacons =
	                            draft.beacons && draft.beacons.glanceViewedBeacons
	                                ? draft.beacons.glanceViewedBeacons
	                                : [];
	                        _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { glanceViewedBeacons: beacons }) }));
	                        break;
	                    default:
	                        break;
	                }
	                beacons.push(beacon);
	                _this.props.onEdit(types_1.BeaconType[_this.state.beaconType], beacons);
	            }
	            else {
	                _this.setState(__assign({}, _this.state, { beaconError: 'Please enter both type and url' }));
	            }
	        };
	        _this.removeBeacon = function (key, beacon, ind) {
	            beacon = beacon.filter(function (v, i) { return i != ind; });
	            _this.props.onEdit(types_1.BeaconType[key], beacon);
	            switch (key) {
	                case types_1.BeaconType.CTA:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { ctaBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.VIDEO:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { videoBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.RENDER:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { renderBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.PEEK:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { peekBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.LIKE:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { likeBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.SHARE:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { shareBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.VIDEO_STARTED:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { videoStartedBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.HOLD:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { holdBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.APP_SUBMIT:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { appSubmitBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.INSTALL_NOW:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { installNowBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.INSTALL_LATER:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { installLaterBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.INSTALL_COMPLETE:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { installCompleteBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.APP_OPEN:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { appOpenBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.GLANCE_STARTED:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { glanceStartedBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.PRIVIEW_TAP:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { previewTapBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.VIDEO_VIEWED:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { videoViewedBeacons: beacon }) }));
	                    break;
	                case types_1.BeaconType.GLANCE_VIEWED:
	                    _this.setState(__assign({}, _this.state, { beacons: __assign({}, _this.state.beacons, { glanceViewedBeacons: beacon }) }));
	                    break;
	                default:
	                    break;
	            }
	        };
	        _this.handleBeaconTypeChange = function (field, context, value) {
	            _this.setState(__assign({}, _this.state, { beaconType: value, minDurationInSecs: value == types_1.BeaconType.RENDER ||
	                    value == types_1.BeaconType.VIDEO_VIEWED ||
	                    value == types_1.BeaconType.GLANCE_VIEWED
	                    ? _this.state.minDurationInSecs
	                    : 0 }));
	        };
	        _this.handleBeaconUrlChange = function (value) {
	            _this.setState(__assign({}, _this.state, { beaconUrl: value, beaconError: '' }));
	        };
	        _this.handleBeaconPartnerChange = function (field, context, value) {
	            _this.setState(__assign({}, _this.state, { beaconPartner: value }));
	        };
	        _this.handleMinDurationInSecsChange = function (value) {
	            _this.setState(__assign({}, _this.state, { minDurationInSecs: value }));
	        };
	        _this.handleDelayDurationInMillis = function (value) {
	            _this.setState(__assign({}, _this.state, { delayDurationInMillis: value }));
	        };
	        _this.handleImpressionRequired = function (e, newValue) {
	            _this.setState(__assign({}, _this.state, { showTriggerPercentage: true }));
	            if (e.target && e.target.value)
	                _this.onChange('totalImpressionRequired', e, newValue);
	            else
	                _this.props.onEdit('impressionCappingData', null);
	        };
	        _this.handleStoryTypeChange = function (event, value) {
	            _this.props.onEdit('storyType', value);
	        };
	        _this.handleZipCTAChange = function (event, value) { return __awaiter(_this, void 0, void 0, function () {
	            var _a;
	            return __generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        if (!(value == 1)) return [3 /*break*/, 5];
	                        return [4 /*yield*/, this.props.onEdit('ctaUrl', this.props.glanceDraftData.peek.webPeekUrl)];
	                    case 1:
	                        _b.sent();
	                        return [4 /*yield*/, this.props.onEdit('webPeekUrl', null)];
	                    case 2:
	                        _b.sent();
	                        _a = !this.props.glanceDraftData.ctaViewConfig.removeTopPadding;
	                        if (!_a) return [3 /*break*/, 4];
	                        return [4 /*yield*/, this.props.onEdit('ctaview_hide_toppadding', true)];
	                    case 3:
	                        _a = (_b.sent());
	                        _b.label = 4;
	                    case 4:
	                        _a;
	                        return [3 /*break*/, 8];
	                    case 5: return [4 /*yield*/, this.props.onEdit('webPeekUrl', this.props.glanceDraftData.peek.ctaUrl)];
	                    case 6:
	                        _b.sent();
	                        return [4 /*yield*/, this.props.onEdit('ctaUrl', null)];
	                    case 7:
	                        _b.sent();
	                        _b.label = 8;
	                    case 8: return [2 /*return*/];
	                }
	            });
	        }); };
	        _this.handleLanguageLimitChange = function (event, value) {
	            if (value > _this.state.summaryExceededSize) {
	                _this.state.summaryExceededSize = undefined;
	            }
	            if (value > _this.state.cheesySummaryExceededSize) {
	                _this.state.cheesySummaryExceededSize = undefined;
	            }
	            _this.state.summaryLimit = value;
	            _this.props.onEdit('languageLimit', value);
	        };
	        _this.handleSkipSummaryChange = function () {
	            var glanceDraftData = _this.props.glanceDraftData;
	            var canSkipSummary = glanceDraftData.peek && glanceDraftData.peek.canSkipSummary
	                ? false
	                : true;
	            _this.props.onEdit('canSkipSummary', canSkipSummary);
	        };
	        _this.handleShouldUnlockAppInstalled = function (shouldUnlock) {
	            _this.props.onEdit('shouldUnlockAppInstalled', shouldUnlock);
	        };
	        _this.handleCapChange = function (newValue, duration) {
	            newValue = newValue && newValue > 0 ? newValue : null;
	            _this.props.onEdit(duration, newValue);
	        };
	        _this.handleDailyCapChange = function (newValue) {
	            return _this.handleCapChange(newValue, 'dailyCap');
	        };
	        _this.handleWeeklyCapChange = function (newValue) {
	            return _this.handleCapChange(newValue, 'weeklyCap');
	        };
	        _this.handleStickinessChange = function (newValue) {
	            return _this.props.onEdit('stickiness', newValue);
	        };
	        _this.handleTypeChange = function (field, context, value) { return __awaiter(_this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!(value == 1 /* WALLPAPER */ || value == 4 /* SPONSORED */)) return [3 /*break*/, 4];
	                        return [4 /*yield*/, this.props.onEdit('language', null)];
	                    case 1:
	                        _a.sent();
	                        if (!(value == 4 /* SPONSORED */ && this.props.glanceDraftData.isShareable)) return [3 /*break*/, 3];
	                        return [4 /*yield*/, this.props.onEdit('isShareable', false)];
	                    case 2:
	                        _a.sent();
	                        _a.label = 3;
	                    case 3:
	                        if (this.props.glanceDraftData.peek.title &&
	                            this.props.glanceDraftData.peek.title.length >
	                                TITLE_LENGTH_LIMIT_SPONSORED) {
	                            this.onChange('title', context, this.props.glanceDraftData.peek.title.substr(0, TITLE_LENGTH_LIMIT_SPONSORED));
	                        }
	                        _a.label = 4;
	                    case 4:
	                        if (!(this.state.publishValue != 8 /* PUBLISHED */)) return [3 /*break*/, 6];
	                        return [4 /*yield*/, this.props.onEdit('type', value)];
	                    case 5:
	                        _a.sent();
	                        _a.label = 6;
	                    case 6:
	                        if (!(value != 4 /* SPONSORED */)) return [3 /*break*/, 8];
	                        return [4 /*yield*/, this.props.onEdit('isDspCampaign', false)];
	                    case 7:
	                        _a.sent();
	                        _a.label = 8;
	                    case 8: return [2 /*return*/];
	                }
	            });
	        }); };
	        _this.handlePriorityChange = function (field, context, value) {
	            _this.props.onEdit('priority', value);
	        };
	        _this.handleGlanceContextChange = function (field, context, value) {
	            _this.props.onEdit('glanceContextType', value);
	        };
	        _this.handleOmSdkInfoType = function (field, context, value) {
	            _this.props.onEdit('omSdkInfoType', value);
	        };
	        _this.handleCampaignObjectiveChange = function (field, context, value) {
	            _this.props.onEdit('campaignObjective', value);
	        };
	        _this.handleOciAppSelection = function (field, context, value) {
	            var _a = _this.props, studioAppConfig = _a.studioAppConfig, glanceDraftData = _a.glanceDraftData;
	            var apps = studioAppConfig.apps;
	            apps.forEach(function (appItem) {
	                if (appItem.ociTargetable && appItem.packageId === value) {
	                    if (glanceDraftData.peek.webPeekUrl) {
	                        var withoutCtaBecaon = __assign({}, appItem, { clickBeaconUrl: null });
	                        _this.props.onEdit('ociAppSelection', withoutCtaBecaon);
	                    }
	                    else {
	                        _this.props.onEdit('ociAppSelection', appItem);
	                    }
	                    _this.setState(__assign({}, _this.state, { selectedOciAppId: appItem.appId }));
	                }
	            });
	        };
	        _this.handleAppNotification = function (field, targetType, value) {
	            if (targetType === 'notifTemplateId') {
	                _this.props.onEdit('notifTemplateId', value);
	            }
	            else if (targetType === 'd1NotifTemplateId') {
	                _this.props.onEdit('d1NotifTemplateId', value);
	            }
	            else if (targetType === 'ltvNotifTemplateId') {
	                _this.props.onEdit('ltvNotifTemplateId', value);
	            }
	        };
	        _this.handleCtaTypeChange = function (field, context, value) {
	            _this.setState(__assign({}, _this.state, { ctaType: value }));
	            _this.props.onEdit('ctaType', value);
	        };
	        _this.handleGlanceUserAgeFilterChange = function (value, type) { return __awaiter(_this, void 0, void 0, function () {
	            var selectedDay;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        selectedDay = value;
	                        return [4 /*yield*/, this.props.onEdit(type, selectedDay)];
	                    case 1:
	                        _a.sent();
	                        if (type === 'startDay') {
	                            this.props.onEdit('endDay', null);
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        }); };
	        _this.handleBeautifulWallpaperChange = function (e, value) {
	            _this.props.onEdit('isBeautifulWallpaperEnabled', !value);
	        };
	        _this.checkLanguageCategory = function (value) {
	            var glanceDraftData = _this.props.glanceDraftData;
	            if (glanceDraftData.glanceLanguageId == null || value == null) {
	                return true;
	            }
	            if (value === '#tamil_news' &&
	                !(glanceDraftData.glanceLanguageId == 'ta')) {
	                return false;
	            }
	            if (value === '#telugu_news' &&
	                !(glanceDraftData.glanceLanguageId == 'te')) {
	                return false;
	            }
	            return true;
	        };
	        _this.handleCategoryChange = function (chip, remove) {
	            var glanceDraftData = _this.props.glanceDraftData;
	            if (!remove && !_this.checkLanguageCategory(chip.category.id)) {
	                return;
	            }
	            if (_this.state.publishValue != 8 /* PUBLISHED */) {
	                var isSponsored = glanceDraftData.type === 4 /* SPONSORED */;
	                var maxCategory = isSponsored
	                    ? MAX_CATEGORY.SPONSORED
	                    : MAX_CATEGORY.DEFAULT;
	                var newCategories = glanceDraftData.categoryIds;
	                if (remove) {
	                    if (!newCategories) {
	                        return;
	                    }
	                    newCategories = newCategories.filter(function (category) {
	                        return category != chip.id;
	                    });
	                    _this.props.onEdit('categoryIds', newCategories);
	                }
	                else {
	                    if (!newCategories) {
	                        newCategories = [];
	                    }
	                    if (newCategories.length >= maxCategory) {
	                        console.error("More than " + maxCategory + " not allowed");
	                        return;
	                    }
	                    if (newCategories.indexOf(chip.category.id) == -1 &&
	                        _this.state.categoryMap.has(chip.category.id)) {
	                        // if (chip.category.id == "#plus_plus_random" && newCategories.indexOf('#daily_digest') != -1) {
	                        //     return
	                        // }
	                        newCategories = newCategories.concat([chip.category.id]);
	                        _this.props.onEdit('categoryIds', newCategories);
	                    }
	                }
	            }
	        };
	        _this.handleValuePropChange = function (value, region) {
	            _this.props.onEdit('valueProp', { vpId: value, region: region });
	            _this.setState(__assign({}, _this.state, { valueProp: value }));
	        };
	        _this.handleEuChange = function (value, region) {
	            _this.props.onEdit('eu', { euId: value, region: region });
	            _this.setState(__assign({}, _this.state, { valueProp: null }));
	        };
	        _this.handleCityChange = function (chip, remove) {
	            var newCityGroups = _this.state.cityGroups;
	            var newCities = _this.state.cities;
	            if (remove) {
	                if (!newCityGroups || !newCities) {
	                    return;
	                }
	                newCityGroups = newCityGroups.filter(function (cityGroup) {
	                    var chipStr = chip;
	                    if (cityGroup.groupName === chipStr) {
	                        // remove from the existing newCities
	                        newCities = newCities.filter(function (city) {
	                            return !cityGroup.cities.includes(city.id);
	                        });
	                        return false;
	                    }
	                    else {
	                        return true;
	                    }
	                });
	            }
	            else {
	                if (!newCityGroups) {
	                    newCityGroups = [];
	                }
	                if (!newCityGroups.find(function (cityGroup) { return cityGroup.groupName == chip.groupName; })) {
	                    var studioAppConfig_1 = _this.props.studioAppConfig;
	                    chip.cities.filter(function (cityId) {
	                        var city = studioAppConfig_1.cities.find(function (city) { return city.id == cityId; });
	                        if (city) {
	                            newCities = newCities.concat([city]);
	                        }
	                    });
	                    newCityGroups = newCityGroups.concat([chip]);
	                }
	            }
	            _this.props.onEdit('cityIds', newCities.map(function (city) { return city.id; }));
	            _this.setState(__assign({}, _this.state, { cities: newCities }));
	        };
	        _this.handleCarrierChange = function (chip, remove) {
	            var newCarriers = _this.state.carrierMetas;
	            if (remove) {
	                if (!newCarriers) {
	                    return;
	                }
	                newCarriers = newCarriers.filter(function (carrier) {
	                    return carrier.carrierId != chip;
	                });
	                _this.props.onEdit('carriers', newCarriers.map(function (carrier) { return carrier.carrierId; }));
	            }
	            else {
	                if (!newCarriers) {
	                    newCarriers = [];
	                }
	                if (!newCarriers.find(function (carrier) { return carrier.carrierId === chip.carrierId; })) {
	                    newCarriers = newCarriers.concat([chip]);
	                    _this.props.onEdit('carriers', newCarriers.map(function (carrier) { return carrier.carrierId; }));
	                }
	            }
	            _this.setState(__assign({}, _this.state, { carrierMetas: newCarriers }));
	        };
	        _this.handleBubbleChange = function (chip, remove, type) {
	            var newBubbles = _this.state.bubbles;
	            if (remove) {
	                if (!newBubbles) {
	                    return;
	                }
	                newBubbles.map(function (bubble) { return bubble.bubbleId === chip; });
	                if (type == 4 /* SPONSORED */) {
	                    _this.props.onEdit('sponsoredBubbleChange', {
	                        bubbleId: null,
	                        adCoefficient: '',
	                        bucketPriority: null,
	                        eCpm: '',
	                        rankInBubble: null,
	                        rankInBubbleDispay: false
	                    });
	                }
	                else {
	                    _this.props.onEdit('bubbleId', { bubbleId: null });
	                }
	            }
	            else {
	                if (!newBubbles) {
	                    newBubbles = [];
	                }
	                var currentBubble = newBubbles.find(function (bubble) { return bubble.bubbleId == chip.bubbleId; });
	                if (currentBubble) {
	                    if (type == 4 /* SPONSORED */) {
	                        console.log('curr bubble from cardpress', currentBubble);
	                        var adCoefficient = 3;
	                        var bucketPriority = 1;
	                        var eCpm = '';
	                        var rankInBubble = null;
	                        var adCoefficientDisabled = false;
	                        var bucketPriorityDisabled = false;
	                        var eCpmDisabled = false;
	                        var rankInBubbleDisabled = false;
	                        var rankInBubbleDispay = false;
	                        if (currentBubble.adCoefficient || currentBubble.adCoefficient == 0) {
	                            adCoefficient = currentBubble.adCoefficient;
	                            adCoefficientDisabled = true;
	                        }
	                        if (currentBubble.bucketPriority) {
	                            console.log(Utils_1["default"].getBucketPriority(currentBubble.bucketPriority.toString()));
	                            bucketPriority = Utils_1["default"].getBucketPriority(currentBubble.bucketPriority.toString());
	                            bucketPriorityDisabled = true;
	                        }
	                        if (currentBubble.ecpm) {
	                            eCpm = currentBubble.ecpm;
	                            eCpmDisabled = true;
	                        }
	                        if (currentBubble.storyCount > 0) {
	                            rankInBubbleDispay = true;
	                        }
	                        _this.props.onEdit('sponsoredBubbleChange', {
	                            bubbleId: chip.bubbleId,
	                            adCoefficient: adCoefficient,
	                            bucketPriority: bucketPriority,
	                            eCpm: eCpm,
	                            adCoefficientDisabled: adCoefficientDisabled,
	                            bucketPriorityDisabled: bucketPriorityDisabled,
	                            eCpmDisabled: eCpmDisabled,
	                            rankInBubble: rankInBubble,
	                            rankInBubbleDispay: rankInBubbleDispay,
	                            storyCount: currentBubble.storyCount
	                        });
	                    }
	                    else {
	                        _this.props.onEdit('bubbleId', chip);
	                    }
	                }
	            }
	        };
	        _this.handleNegativeTargetChange = function (chip, remove, targetingType) {
	            var newNegativeTargets = _this.state.negativeTargets;
	            if (remove) {
	                if (!newNegativeTargets) {
	                    return;
	                }
	                newNegativeTargets = newNegativeTargets.filter(function (target) {
	                    return target.packageId != chip;
	                });
	                _this.props.onEdit('targetingNegative', [
	                    newNegativeTargets.map(function (target) { return target.packageId; }),
	                    _this.state.negativeTargetingType,
	                    NEGATIVE_TARGET_TYPE.filter(function (type) { return type !== _this.state.negativeTargetingType; }),
	                ]);
	            }
	            else {
	                if (!newNegativeTargets) {
	                    newNegativeTargets = [];
	                }
	                if (!newNegativeTargets.find(function (target) { return target.packageId == chip; })) {
	                    newNegativeTargets = newNegativeTargets.concat([chip]);
	                    _this.props.onEdit('targetingNegative', [
	                        newNegativeTargets.map(function (target) { return target.packageId; }),
	                        _this.state.negativeTargetingType,
	                        NEGATIVE_TARGET_TYPE.filter(function (type) { return type !== _this.state.negativeTargetingType; }),
	                    ]);
	                }
	            }
	            _this.setState(__assign({}, _this.state, { negativeTargets: newNegativeTargets }));
	        };
	        _this.handlePositiveTargetChange = function (chip, remove, targetingType) {
	            var newPositiveTargets = _this.state.positiveTargets;
	            if (remove) {
	                if (!newPositiveTargets) {
	                    return;
	                }
	                newPositiveTargets = newPositiveTargets.filter(function (target) {
	                    return target.packageId != chip;
	                });
	                _this.props.onEdit('targetingPositive', [
	                    newPositiveTargets.map(function (target) { return target.packageId; }),
	                    _this.state.positiveTargetingType,
	                    POSITIVE_TARGET_TYPE.filter(function (type) { return type !== _this.state.positiveTargetingType; }),
	                ]);
	            }
	            else {
	                if (!newPositiveTargets) {
	                    newPositiveTargets = [];
	                }
	                if (!newPositiveTargets.find(function (target) { return target.packageId == chip; })) {
	                    newPositiveTargets = newPositiveTargets.concat([chip]);
	                    _this.props.onEdit('targetingPositive', [
	                        newPositiveTargets.map(function (target) { return target.packageId; }),
	                        _this.state.positiveTargetingType,
	                        POSITIVE_TARGET_TYPE.filter(function (type) { return type !== _this.state.positiveTargetingType; }),
	                    ]);
	                }
	            }
	            _this.setState(__assign({}, _this.state, { positiveTargets: newPositiveTargets }));
	        };
	        _this.handleSegmentChange = function (chip, remove) {
	            var studioAppConfig = _this.props.studioAppConfig;
	            var newSegments = _this.state.segments;
	            if (remove) {
	                if (!newSegments) {
	                    return;
	                }
	                newSegments = newSegments.filter(function (segment) {
	                    return segment.id != chip;
	                });
	                _this.props.onEdit('segmentIds', newSegments.map(function (seg) { return seg.id; }));
	            }
	            else {
	                if (!newSegments) {
	                    newSegments = [];
	                }
	                if (!newSegments.find(function (segment) { return segment.id == chip.id; })) {
	                    var chipSegment = studioAppConfig.sqlSegments.find(function (s) { return s.id == chip.id; });
	                    newSegments = newSegments.concat([chipSegment]);
	                    _this.props.onEdit('segmentIds', newSegments.map(function (seg) { return seg.id; }));
	                }
	            }
	            _this.setState(__assign({}, _this.state, { segments: newSegments }));
	        };
	        _this.handleAntiSegmentChange = function (chip, remove) {
	            var studioAppConfig = _this.props.studioAppConfig;
	            var newSegments = _this.state.antiSegments;
	            if (remove) {
	                if (!newSegments) {
	                    return;
	                }
	                newSegments = newSegments.filter(function (segment) {
	                    return segment.id != chip;
	                });
	                _this.props.onEdit('antiSegmentIds', newSegments.map(function (seg) { return seg.id; }));
	            }
	            else {
	                if (!newSegments) {
	                    newSegments = [];
	                }
	                if (!newSegments.find(function (segment) { return segment.id == chip.id; })) {
	                    var chipSegment = studioAppConfig.sqlSegments.find(function (s) { return s.id == chip.id; });
	                    newSegments = newSegments.concat([chipSegment]);
	                    _this.props.onEdit('antiSegmentIds', newSegments.map(function (seg) { return seg.id; }));
	                }
	            }
	            _this.setState(__assign({}, _this.state, { antiSegments: newSegments }));
	        };
	        _this.onCitySearch = function (chip) {
	            var studioAppConfig = _this.props.studioAppConfig;
	            var cityGroups = studioAppConfig.cityGroups;
	            var cityGroupSource = cityGroups.filter(function (cityGroup) {
	                return (cityGroup.groupName &&
	                    cityGroup.groupName.toLowerCase().startsWith(chip.toLowerCase()));
	            });
	            cityGroupSource = cityGroupSource.slice(0, 10).map(function (item) {
	                var newItem = __assign({}, item);
	                var stateObj = _this.props.cityStates && _this.props.cityStates.find(function (e) { return newItem.cities.indexOf(e.cityId) !== -1; });
	                if (stateObj && stateObj.stateName) {
	                    newItem.groupName = newItem.groupName + " - " + stateObj.stateName;
	                }
	                return newItem;
	            });
	            _this.setState(__assign({}, _this.state, { citySource: cityGroupSource }));
	        };
	        _this.onCarrierSearch = function (chip) {
	            var studioAppConfig = _this.props.studioAppConfig;
	            var carrierMetas = studioAppConfig.carrierMetas;
	            var carrierSource = carrierMetas.filter(function (carrier) {
	                return (carrier.carrierName &&
	                    carrier.carrierName.toLowerCase().startsWith(chip.toLowerCase()));
	            });
	            carrierSource = carrierSource.slice(0, 10);
	            _this.setState(__assign({}, _this.state, { carrierSource: carrierSource }));
	        };
	        _this.onBubbleSearch = function (val) {
	            if (val && val.length >= 3) {
	                JerseyRestApiService_1["default"].getSearchBubbles(val)
	                    .then(function (response) {
	                    _this.setState(__assign({}, _this.state, { bubbles: response.slice() }));
	                })["catch"](function (err) {
	                    console.log(err);
	                });
	            }
	        };
	        _this.onNegativeTargetSearch = function (chip) {
	            var studioAppConfig = _this.props.studioAppConfig;
	            var negativeTargetSource = studioAppConfig.apps.filter(function (targetElement) {
	                return (targetElement &&
	                    targetElement.name &&
	                    targetElement.name.toLowerCase().startsWith(chip.toLowerCase()));
	            });
	            negativeTargetSource = negativeTargetSource.slice(0, 10);
	            _this.setState(__assign({}, _this.state, { negativeTargetSource: negativeTargetSource }));
	        };
	        _this.onPositiveTargetSearch = function (chip) {
	            var studioAppConfig = _this.props.studioAppConfig;
	            var positiveTargetSource = studioAppConfig.apps.filter(function (targetElement) {
	                return (targetElement &&
	                    targetElement.name &&
	                    targetElement.name.toLowerCase().startsWith(chip.toLowerCase()));
	            });
	            positiveTargetSource = positiveTargetSource.slice(0, 10);
	            _this.setState(__assign({}, _this.state, { positiveTargetSource: positiveTargetSource }));
	        };
	        _this.onSegmentSearch = function (chip) {
	            var studioAppConfig = _this.props.studioAppConfig;
	            var segments = studioAppConfig.sqlSegments;
	            var segmentSourceTemp = _this.convertSegmentsToSegmentSources(segments.filter(function (segment) {
	                return ((segment.name &&
	                    segment.name.toLowerCase().indexOf(chip.toLowerCase()) != -1) ||
	                    (segment.displayName &&
	                        segment.displayName.toLowerCase().indexOf(chip.toLowerCase()) != -1));
	            }));
	            segmentSourceTemp = segmentSourceTemp.slice(0, 10);
	            _this.setState(__assign({}, _this.state, { segmentSource: segmentSourceTemp }));
	        };
	        _this.handleTagChange = function (chip, remove) {
	            var glanceDraftData = _this.props.glanceDraftData;
	            var newTags = glanceDraftData.tags;
	            if (remove) {
	                if (!newTags) {
	                    return;
	                }
	                newTags = newTags.filter(function (tag) {
	                    return tag != chip;
	                });
	                _this.props.onEdit('tags', newTags);
	            }
	            else {
	                if (!newTags) {
	                    newTags = [];
	                }
	                if (newTags.indexOf(chip) == -1 && TAG_SOURCE.indexOf(chip) != -1) {
	                    newTags = newTags.concat([chip]);
	                    _this.props.onEdit('tags', newTags);
	                }
	            }
	        };
	        _this.handleCountryChange = function (region, remove) {
	            var glanceDraftData = _this.props.glanceDraftData;
	            if (!_this.props.editable) {
	                return;
	            }
	            var newRegionList = glanceDraftData.preferedRegions;
	            if (remove) {
	                if (!newRegionList) {
	                    return;
	                }
	                newRegionList = newRegionList.filter(function (item) {
	                    return item != region;
	                });
	            }
	            else {
	                if (!newRegionList) {
	                    newRegionList = [];
	                }
	                if (newRegionList.indexOf(region) == -1) {
	                    newRegionList = newRegionList.concat([region]);
	                }
	            }
	            _this.props.onEdit('preferedRegions', newRegionList);
	        };
	        _this.handlePublisherChange = function (e, index, value) {
	            var publisherData = value
	                ? _this.state.publisherDatas.get(value)
	                : null;
	            _this.setState(__assign({}, _this.state, { publisherData: publisherData }));
	            _this.props.onEdit('publisherData', publisherData);
	        };
	        _this.handleShouldUnlock = function (shouldUnlock) {
	            _this.props.onEdit('shouldUnlock', shouldUnlock);
	        };
	        _this.handleOpenInBg = function (openInBg) {
	            _this.props.onEdit('openInBg', openInBg);
	        };
	        _this.handleSdkSubscribedCategoriesFilterChange = function (field, context, value) {
	            _this.props.onEdit('categorySubscriptionStatus', value);
	        };
	        _this.handleTargetForCategoryChange = function (chip, remove) {
	            var glanceDraftData = _this.props.glanceDraftData;
	            var newCategories = glanceDraftData.targetForCategories;
	            if (remove) {
	                if (!newCategories) {
	                    return;
	                }
	                newCategories = newCategories.filter(function (category) {
	                    return category != chip.id;
	                });
	                _this.props.onEdit('targetForCategories', newCategories);
	            }
	            else {
	                if (!newCategories) {
	                    newCategories = [];
	                }
	                if (newCategories.indexOf(chip.category.id) == -1 &&
	                    _this.state.categoryMap.has(chip.category.id)) {
	                    newCategories = newCategories.concat([chip.category.id]);
	                    _this.props.onEdit('targetForCategories', newCategories);
	                }
	            }
	        };
	        _this.handleRenderSessionModeChange = function (field) {
	            if (!field)
	                return;
	            var renderSessionList = [];
	            field.forEach(function (element) {
	                renderSessionList.push(sessionModeMappingSelected[element]);
	            });
	            _this.props.onEdit('renderSessionProperties', renderSessionList);
	        };
	        _this.renderSessionListItems = function () {
	            var _a = (_this.props.glanceDraftData.peek || {}).tvVideoPeek, tvVideoPeek = _a === void 0 ? null : _a;
	            if (tvVideoPeek) {
	                return GLANCE_TV_LIST_OPTIONS.map(function (item) { return ({ value: item.name }); });
	            }
	            if (_this.props.glanceDraftData.type === 4 /* SPONSORED */ &&
	                _this.props.cardType !== 2) {
	                return SESSION_MODE_LIST_OPTIONS.filter(function (elem) {
	                    if (!draftsHelper_1.isArticle(_this.props.glanceDraftData)) {
	                        return elem.value != 'GAME SPLASH';
	                    }
	                    else
	                        return elem;
	                });
	            }
	            else {
	                return SESSION_MODE_LIST_OPTIONS.filter(function (elem) {
	                    if (!draftsHelper_1.isArticle(_this.props.glanceDraftData)) {
	                        return (elem.value != 'IN-GAME REWARDED VIDEOS' &&
	                            elem.value != 'GAME SPLASH');
	                    }
	                    else
	                        return elem.value != 'IN-GAME REWARDED VIDEOS';
	                });
	            }
	        };
	        _this.handleIsShareable = function (isShareable) {
	            _this.props.onEdit('isShareable', isShareable);
	        };
	        _this.handleHomeScreenWorthy = function (homescreenWorthy) {
	            _this.props.onEdit('homescreenWorthy', homescreenWorthy);
	        };
	        _this.handleServingCappingEnabled = function (servingCappingEnabled) {
	            _this.props.onEdit('servingCappingEnabled', servingCappingEnabled);
	        };
	        _this.handleChildLockFlag = function (childlock) {
	            _this.props.onEdit('childlockflag', childlock);
	        };
	        _this.handleUseUnlockNudge = function (childlock) {
	            _this.props.onEdit('useUnlockNudge', childlock);
	        };
	        _this.handleAllowKeyboard = function (allowKeyboard) {
	            _this.props.onEdit('allowKeyboard', allowKeyboard);
	        };
	        _this.handleAllowNativeKeyboard = function (allowNativeKeyboard) {
	            _this.props.onEdit('allowNativeKeyboard', allowNativeKeyboard);
	        };
	        _this.handleDynamicOverlay = function (dynamicOverlay) {
	            _this.props.onEdit('dynamicOverlay', dynamicOverlay);
	        };
	        _this.handleS2sIntegration = function (s2sIntegration) {
	            _this.props.onEdit('s2sIntegration', s2sIntegration);
	        };
	        _this.handleGPayReadiness = function (gPayReadiness) {
	            _this.props.onEdit('gPayReadiness', gPayReadiness);
	        };
	        _this.handleDspRetargeting = function (dspRetargeting) {
	            _this.props.onEdit('dspRetargeting', dspRetargeting);
	        };
	        _this.handleNativeOverflow = function (nativeVideoOverflow) {
	            _this.props.onEdit('nativeVideoOverflow', nativeVideoOverflow);
	        };
	        _this.handleHardwareAccelerated = function (hardwareAccelerated) {
	            _this.props.onEdit('hardwareAccelerated', hardwareAccelerated);
	        };
	        _this.handleIsShoppable = function (isShoppable) {
	            _this.props.onEdit('isShoppable', isShoppable);
	        };
	        _this.handleLoadAndroidJs = function (loadAndroidJs) {
	            _this.props.onEdit('loadAndroidJs', loadAndroidJs);
	        };
	        _this.handleTargetingTypeChange = function (context, targetingType, value) {
	            var _a, _b;
	            if (targetingType === 'negativeTargetingType') {
	                _this.setState(__assign({}, _this.state, (_a = {}, _a[targetingType] = value, _a.negativeTargets = [], _a)));
	            }
	            else if (targetingType === 'positiveTargetingType') {
	                _this.setState(__assign({}, _this.state, (_b = {}, _b[targetingType] = value, _b.positiveTargets = [], _b)));
	            }
	        };
	        _this.handleRankChange = function (e, field, value) {
	            _this.setState(__assign({}, _this.state, { rankInBubble: value }));
	            _this.props.onEdit(field, value);
	        };
	        _this.handleNetworkChange = function (field) {
	            var value = [];
	            field.forEach(function (tuple) {
	                value.push(USER_NETWORK_TYPE[tuple]);
	            });
	            _this.props.onEdit('targetingNetwork', value);
	        };
	        _this.handleEcpmKeyDown = function (e) {
	            if (!((e.keyCode > 95 && e.keyCode < 106) ||
	                (e.keyCode > 47 && e.keyCode < 58) ||
	                e.keyCode == 8 ||
	                e.keyCode == 190)) {
	                e.preventDefault();
	            }
	        };
	        _this.handlectaViewHideTopPadding = function (hideCTAViewTopPad) {
	            _this.props.onEdit('ctaview_hide_toppadding', hideCTAViewTopPad);
	        };
	        _this.handlectaViewHideCrossIcon = function (hideCTAViewCrossIcon) {
	            _this.props.onEdit('ctaview_hide_crossicon', hideCTAViewCrossIcon);
	        };
	        _this.handleBucketPriorityChange = function (field, context, value) {
	            console.log(value);
	            _this.props.onEdit('bucketPriority', value);
	        };
	        _this.onSubmit = function () {
	            _this.props.onSave(_this.state.autoOpenCta);
	        };
	        _this.onOverride = function () {
	            _this.props.onOverride();
	        };
	        _this.onPublish = function () {
	            _this.setState(__assign({}, _this.state, { publishValue: 8 }));
	            _this.props.onPublish();
	        };
	        _this.onRemove = function () {
	            _this.props.onRemove();
	        };
	        _this.onPause = function (value) {
	            _this.props.onPause();
	            _this.props.onEdit('paused', value);
	        };
	        _this.checkRankItemStatus = function (item) {
	            var hasValue = _this.state.renderSessionProperties.length > 0;
	            var hasLockScreen = _this.state.renderSessionProperties.some(function (item) { return item.value === 'LOCKSCREEN'; });
	            if (hasValue && hasLockScreen && item > 1)
	                return true;
	            return false;
	        };
	        _this.handleEmojiClick = function (emoji, e, idx) {
	            _this.setState(__assign({}, _this.state, { showPopover: true, selectedEmoji: {
	                    emoji: emoji,
	                    target: e.currentTarget,
	                    idx: idx
	                } }));
	            RestService_1["default"].getEmojis("Bearer " + document.cookie.split('glance-studio-session=')[1], function (data) {
	                _this.setState(__assign({}, _this.state, { allEmojis: data.slice() }));
	            });
	        };
	        _this.handleReplaceEmoji = function (emoji) {
	            var newEmojis = _this.state.currEmojis.slice();
	            var idx = _this.state.selectedEmoji.idx;
	            newEmojis[idx] = emoji;
	            _this.setState(__assign({}, _this.state, { currEmojis: newEmojis, showPopover: false }), function () {
	                var cache = {};
	                var isSameEmoji = false;
	                newEmojis.forEach(function (emoji) {
	                    if (!cache[emoji.id]) {
	                        cache[emoji.id] = emoji.id;
	                    }
	                    else {
	                        _this.setState(__assign({}, _this.state, { sameEmoji: emoji.id }));
	                        isSameEmoji = true;
	                    }
	                });
	                if (!isSameEmoji) {
	                    _this.setState(__assign({}, _this.state, { sameEmoji: null }));
	                    // call the emoji mapping api with payload
	                    var emojisPayload = _this.state.currEmojis.map(function (emoji, idx) {
	                        return {
	                            id: emoji.id,
	                            position: idx + 1
	                        };
	                    });
	                    var payload = {
	                        glanceId: _this.props.glanceDraftData.draftId,
	                        emojis: emojisPayload
	                    };
	                    RestService_1["default"].submitEmoji("Bearer " + document.cookie.split('glance-studio-session=')[1], payload, function (data) { return console.log('selected', data); });
	                }
	            });
	        };
	        _this.imageSize = function (url) {
	            var img = document.createElement('img');
	            var promise = new Promise(function (resolve, reject) {
	                img.onload = function () {
	                    var width = img.naturalWidth;
	                    var height = img.naturalHeight;
	                    resolve({ width: width, height: height });
	                };
	                img.onerror = reject;
	            });
	            img.src = url;
	            return promise;
	        };
	        _this.handleEmojiSize = function (files) { return __awaiter(_this, void 0, void 0, function () {
	            var url, imageDimensions;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        url = URL.createObjectURL(files);
	                        return [4 /*yield*/, this.imageSize(url)];
	                    case 1:
	                        imageDimensions = _a.sent();
	                        return [2 /*return*/, imageDimensions.height === 48 && imageDimensions.width === 48];
	                }
	            });
	        }); };
	        _this.handleDimensionValidation = function (images) { return __awaiter(_this, void 0, void 0, function () {
	            var imageFiles, len, i, isValid;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        imageFiles = Array.from(images);
	                        len = imageFiles.length;
	                        i = 0;
	                        _a.label = 1;
	                    case 1:
	                        if (!(i < len)) return [3 /*break*/, 4];
	                        return [4 /*yield*/, this.handleEmojiSize(imageFiles[i])];
	                    case 2:
	                        isValid = _a.sent();
	                        if (!isValid)
	                            return [2 /*return*/, false];
	                        _a.label = 3;
	                    case 3:
	                        i++;
	                        return [3 /*break*/, 1];
	                    case 4: return [2 /*return*/, true];
	                }
	            });
	        }); };
	        _this.handleImageSizeValidation = function (images) {
	            var imageArr = Array.from(images).map(function (image) {
	                if (image.size < 1048576)
	                    return true;
	                else
	                    return false;
	            });
	            return imageArr.includes(false);
	        };
	        _this.errorCleanup = function () {
	            setTimeout(function () {
	                _this.setState(__assign({}, _this.state, { emojiUploadError: [] }));
	            }, 6500);
	        };
	        _this.handleFileUploadError = function () {
	            _this.setState(__assign({}, _this.state, { emojiUploadError: [
	                    {
	                        field: '',
	                        message: 'Trying to upload a file of size greater than 1MB which is not permitted'
	                    },
	                ] }), _this.errorCleanup);
	        };
	        _this.handleNumberOfEmojiUpload = function (files) {
	            if (files.length > 10) {
	                _this.setState(__assign({}, _this.state, { emojiUploadError: [
	                        {
	                            field: '',
	                            message: 'Number of files chosen should be less than 10'
	                        },
	                    ] }), _this.errorCleanup);
	                return true;
	            }
	            else
	                return false;
	        };
	        _this.handleFileUpload = function (e) { return __awaiter(_this, void 0, void 0, function () {
	            var newfiles, payload;
	            var _this = this;
	            return __generator(this, function (_a) {
	                newfiles = e.target.files;
	                if (this.handleNumberOfEmojiUpload(newfiles)) {
	                    e.target.value = null;
	                    return [2 /*return*/];
	                }
	                if (this.handleImageSizeValidation(e.target.files)) {
	                    this.handleFileUploadError();
	                    e.target.value = null;
	                    return [2 /*return*/];
	                }
	                payload = new FormData();
	                // @ts-ignore
	                Array.from(newfiles).map(function (file) { return payload.append('emojis', file); });
	                // @ts-ignore
	                payload.append('emojis', payload);
	                RestService_1["default"].uploadEmoji("Bearer " + document.cookie.split('glance-studio-session=')[1], payload, function (data) {
	                    _this.setState(__assign({}, _this.state, { allEmojis: _this.state.allEmojis.concat(data), emojiUploadError: [], fileUploadError: false }));
	                }, function (error) {
	                    if (error) {
	                        if (error.title === 'Constraint Violation') {
	                            _this.setState(__assign({}, _this.state, { emojiUploadError: error.violations }));
	                        }
	                        else {
	                            _this.setState(__assign({}, _this.state, { emojiUploadError: [{ field: '', message: error.detail }] }));
	                        }
	                    }
	                    _this.errorCleanup();
	                });
	                e.target.value = null;
	                return [2 /*return*/];
	            });
	        }); };
	        var publisherDatas = new Map();
	        var _a = _this.props, studioAppConfig = _a.studioAppConfig, glanceDraftData = _a.glanceDraftData;
	        var beacons = glanceDraftData.beacons;
	        var categorySource = [];
	        var categoryMap = new Map();
	        _this.state = {
	            publisherDatas: publisherDatas,
	            categorySource: categorySource,
	            categoryMap: categoryMap,
	            eu: lodash_1.get(glanceDraftData, 'eu'),
	            valueProp: lodash_1.get(glanceDraftData, 'valueProp'),
	            allEus: [],
	            linkType: '',
	            dailyWeeklyCapError: false,
	            beaconType: types_1.BeaconType.RENDER,
	            beaconUrl: null,
	            beaconError: '',
	            minDurationInSecs: 0,
	            delayDurationInMillis: null,
	            beacons: beacons,
	            userNetworkTypes: [],
	            publisherData: null,
	            cities: [],
	            cityGroups: [],
	            citySource: [],
	            carrierMetas: [],
	            carrierSource: [],
	            negativeTargets: [],
	            positiveTargets: [],
	            negativeTargetingType: null,
	            positiveTargetingType: null,
	            negativeTargetSource: [],
	            positiveTargetSource: [],
	            segments: [],
	            bubbles: [],
	            filteredBubbles: [],
	            antiSegments: [],
	            segmentSource: [],
	            publishValue: 0,
	            publishButtonDisability: false,
	            publishButtonTooltipText: '',
	            ctaType: null,
	            sortedBubbles: [],
	            lsSubTextExceededSize: false,
	            renderSessionProperties: rendersessionPropertiesMapping(glanceDraftData),
	            campaignObjectiveList: [],
	            showTriggerPercentage: false,
	            selectedOciAppId: '',
	            CtaViewExceededHeight: false,
	            rankInBubble: 1,
	            storyCount: 0,
	            publishedBubbleId: '',
	            publishedRank: null,
	            overrideWallpaperMode: false,
	            currEmojis: [
	                {
	                    id: 1,
	                    cdnUrl: 'https://glance.l.inmobicdn.net/public/glancetv/emoji/stage/emoji_heart.png',
	                    mediaType: 'PNG'
	                },
	                {
	                    id: 2,
	                    cdnUrl: 'https://glance.l.inmobicdn.net/public/glancetv/emoji/stage/emoji_clap.png',
	                    mediaType: 'PNG'
	                },
	                {
	                    id: 3,
	                    cdnUrl: 'https://glance.l.inmobicdn.net/public/glancetv/emoji/stage/emoji_fire.png',
	                    mediaType: 'PNG'
	                },
	            ],
	            showPopover: false,
	            allEmojis: [],
	            selectedEmoji: {
	                emoji: null,
	                target: null,
	                idx: null
	            },
	            chosenEmoji: null,
	            hoveredEmoji: null,
	            fileUploadError: false,
	            sameEmoji: null,
	            emojiUploadError: [],
	            appOpenNudgeConfig: lodash_1.get(glanceDraftData, 'ociConfigs.appOpenNudgeConfig'),
	            appOpenNotificationConfig: lodash_1.get(glanceDraftData, 'ociConfigs.appOpenNotificationConfig'),
	            programmaticDetail: lodash_1.get(glanceDraftData, 'Programmatic.programmaticDetail'),
	            autoOpenCta: false,
	            dspCampaignData: lodash_1.get(glanceDraftData, 'dspCampaignData')
	        };
	        return _this;
	    }
	    GlanceDraftDetails.prototype.componentDidMount = function () {
	        var initialStateFromProp = this.getInitialStateFromProp(this.props);
	        this.setState(function (state, props) { return (__assign({}, initialStateFromProp)); });
	        this.setEuAndValuePropSource();
	        this.getEmojiMapping();
	    };
	    GlanceDraftDetails.prototype.componentWillReceiveProps = function (nextProps) {
	        var _this = this;
	        var initialStateFromProp = this.getInitialStateFromProp(nextProps);
	        var bubbleId = nextProps.glanceDraftData.bubbleId;
	        this.setState(function (state, props) { return (__assign({}, initialStateFromProp)); });
	        if (bubbleId &&
	            !nextProps.bubbleData &&
	            this.props.detailed &&
	            !this.state.bubbles.some(function (item) { return item.bubbleId === bubbleId; })) {
	            JerseyRestApiService_1["default"].getBubbleById(bubbleId)
	                .then(function (response) {
	                _this.setState(__assign({}, _this.state, { bubbles: _this.state.bubbles.concat([response[bubbleId]]) }));
	            })["catch"](function (err) {
	                console.log(err);
	            });
	        }
	        if (nextProps.bubbleData) {
	            if (!this.state.bubbles.some(function (item) { return item.bubbleId === nextProps.bubbleData.bubbleId; })) {
	                this.setState(__assign({}, this.state, { bubbles: this.state.bubbles.concat([nextProps.bubbleData]) }));
	            }
	        }
	    };
	    GlanceDraftDetails.prototype.componentDidUpdate = function (prevProps) {
	        if (prevProps.detailed !== this.props.detailed &&
	            this.props.detailed &&
	            this.props.glanceDraftData.peek.tvVideoPeek) {
	            this.getEmojiMapping();
	        }
	    };
	    GlanceDraftDetails.prototype.convertSegmentsToSegmentSources = function (segments) {
	        var segmentSource = [];
	        if (!segments) {
	            return segmentSource;
	        }
	        segments.forEach(function (segment) {
	            segmentSource.push({
	                text: segment.name + ' / ' + segment.displayName,
	                id: segment.id
	            });
	        });
	        return segmentSource;
	    };
	    GlanceDraftDetails.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, studioAppConfig = _a.studioAppConfig, glanceDraftData = _a.glanceDraftData, editable = _a.editable;
	        console.log('glanceDraftData', glanceDraftData);
	        var _b = this.state, publishButtonDisability = _b.publishButtonDisability, publishButtonTooltipText = _b.publishButtonTooltipText;
	        var draft = glanceDraftData;
	        var isSponsoredGlance = draft.type === 4 /* SPONSORED */;
	        var isNativeOCI = this.state.ctaType == 2 /* APP_INSTALL */;
	        var userRole = studioAppConfig.currentToken.role;
	        var userLifeTimeFilter = glanceDraftData.userLifeTimeFilter || {
	            startDay: null,
	            endDay: null
	        };
	        var startDay = userLifeTimeFilter.startDay || 1;
	        var startDays = Array.from(Array(8).keys()).map(function (stDay) { return stDay + 1; });
	        var endDays = startDays.filter(function (age) { return age >= startDay && age < 8; });
	        var eCpm = draft.campaignMeta ? draft.campaignMeta.eCpm : null;
	        var TITLE_LENGTH_LIMIT = isSponsoredGlance ? TITLE_LENGTH_LIMIT_SPONSORED : TITLE_LENGTH_LIMIT_NON_SPONSORED;
	        var leftElements = [];
	        var middleElements = [];
	        var rightElements = [];
	        var peekUrl;
	        if (draft.peek) {
	            if (draft.peek.videoUrl) {
	                peekUrl = draft.peek.videoUrl;
	            }
	            else if (draft.peek.webPeekUrl) {
	                peekUrl = draft.peek.webPeekUrl;
	            }
	            else if (draft.peek.ctaUrl) {
	                peekUrl = draft.peek.ctaUrl;
	            }
	        }
	        // Any SPONSORED Glance with isShareable is true then making false.
	        if (draft && isSponsoredGlance && draft.isShareable) {
	            this.props.onEdit('isShareable', false);
	        }
	        if (isSponsoredGlance &&
	            isNativeOCI &&
	            draft.peek &&
	            draft.peek.cta &&
	            draft.peek.cta.autoOpenCtaDurationInSecs !== null &&
	            !this.state.autoOpenCta) {
	            this.setState(__assign({}, this.state, { autoOpenCta: true }));
	        }
	        if (isNativeOCI &&
	            draft.peek &&
	            draft.peek.cta &&
	            draft.peek.cta.autoOpenCtaDurationInSecs !== null &&
	            !isSponsoredGlance) {
	            this.setState(__assign({}, this.state, { autoOpenCta: false }));
	            this.props.onEdit('autoOpenCtaDurationInSecs', null);
	        }
	        if (draft.editMeta.curationReason === null) {
	            draft.editMeta.curationReason = 'landing_page_append_utm';
	        }
	        var isDspCampaign = (draft.dspCampaignData || { isDspCampaign: false }).isDspCampaign;
	        var warningTextGLAM = (draft && draft.glamCampaignData ?
	            React.createElement("div", { style: {
	                    "color": "lightcoral",
	                    "fontWeight": "bold"
	                } },
	                React.createElement("b", null, "Warning:"),
	                " This glance is GLAM published do not edit in studio.") : null);
	        var title = (React.createElement(material_ui_1.TextField, { key: "draft_title", style: __assign({}, draftDetailsStyle_1.styles.width100, { height: '48px' }), hintText: "Draft Title", value: draft.peek && draft.peek.title ? draft.peek.title : '', disabled: !editable, onChange: function (e, newValue) { return _this.onChange('title', e, newValue); }, errorText: this.state.titleExceededSize
	                ? 'Maximum allowed size reached ' + TITLE_LENGTH_LIMIT
	                : null, multiLine: true, hintStyle: { bottom: 'calc(100% - 36px)' }, rows: 2, rowsMax: 2 }));
	        var shortTitle = (React.createElement(material_ui_1.TextField, { key: "draft_shortTitle", style: __assign({}, draftDetailsStyle_1.styles.width100, { height: '48px' }), hintText: "Draft Short Title", value: draft.peek && draft.peek.shortTitle ? draft.peek.shortTitle : '', disabled: !editable, onChange: function (e, newValue) { return _this.onChange('shortTitle', e, newValue); }, errorText: this.state.shortTitleExceededSize
	                ? 'Maximum allowed size reached ' + SHORT_TITLE_LENGTH_LIMIT
	                : null, multiLine: true, hintStyle: { bottom: 'calc(100% - 36px)' }, rows: 2, rowsMax: 2 }));
	        var curationReason = (React.createElement(material_ui_1.TextField, { key: "curation_reason", style: __assign({}, draftDetailsStyle_1.styles.width25), hintText: "Curation Reason", defaultValue: draft.editMeta ? (draft.editMeta.curationReason || 'landing_page_append_utm') : undefined, disabled: !editable, onChange: function (e, newValue) { return _this.onChange('curationReason', e, newValue); } }));
	        var lsSubtext = (React.createElement(material_ui_1.TextField, { key: "subText", style: __assign({}, draftDetailsStyle_1.styles.width25, { marginLeft: '2%' }), hintText: "LS Subtext", defaultValue: draft.peek && draft.peek.subText ? draft.peek.subText : undefined, disabled: !editable, onChange: function (e, newValue) { return _this.onChange('subText', e, newValue); }, errorText: this.state.lsSubTextExceededSize
	                ? "Maximum allowed size is " + LS_SUBTEXT_LIMIT + " Chars"
	                : null }));
	        var contentTagsChips = (React.createElement(material_ui_chip_input_1["default"], { key: "tags", hintText: 'Topics', style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), value: draft.tags ? draft.tags : [], dataSource: TAG_SOURCE, onRequestAdd: function (chip) { return _this.handleTagChange(chip, false); }, onRequestDelete: function (chip, index) { return _this.handleTagChange(chip, true); }, disabled: !editable }));
	        var categoriesValue = [];
	        if (draft.categoryIds) {
	            this.state.categorySource.forEach(function (categorySource) {
	                if (draft.categoryIds.indexOf(categorySource.category.id) != -1) {
	                    categoriesValue.push(categorySource);
	                }
	            });
	        }
	        var topicName = (React.createElement(material_ui_1.TextField, { key: "topicName", style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), defaultValue: draft.topicName ? draft.topicName : undefined, hintText: "Topic Name", disabled: !editable, onChange: function (e, newValue) { return _this.onChange('topicName', e, newValue); } }));
	        var categories = (React.createElement(material_ui_chip_input_1["default"], { key: "categoryIds", hintText: 'Category', style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), value: categoriesValue, dataSource: this.state.categorySource, dataSourceConfig: CATEGORY_SOURCE_CONFIG, onRequestAdd: function (chip) { return _this.handleCategoryChange(chip, false); }, onRequestDelete: function (chip, index) { return _this.handleCategoryChange(chip, true); }, disabled: !editable }));
	        var eu = function (region) {
	            var eus = _this.state.allEus.length > 0
	                ? _this.state.allEus.filter(function (_a) {
	                    var euCountry = _a.country;
	                    return euCountry === Utils_1.regionFilters[region];
	                })
	                : null;
	            var eu = _this.props.glanceDraftData.eus
	                ? _this.props.glanceDraftData.eus.filter(function (eu) { return eu.region === region; })
	                : [];
	            return (React.createElement(material_ui_1.DropDownMenu, { style: __assign({}, draftDetailsStyle_1.styles.width33), disabled: !editable, value: eu.length > 0 ? eu[0].euId : null, onChange: function (e, field, value) { return _this.handleEuChange(value, region); } },
	                React.createElement(material_ui_1.MenuItem, { key: "null", value: null, primaryText: "Select EU" }),
	                eus ? eus.map(function (_a) {
	                    var id = _a.id, name = _a.name;
	                    return (React.createElement(material_ui_1.MenuItem, { key: id, value: id, primaryText: name }));
	                }) : null));
	        };
	        var valueProp = function (region) {
	            var selectedEuObject = _this.props.glanceDraftData.eus
	                ? _this.props.glanceDraftData.eus.filter(function (eu) { return eu.region === region; })
	                : [];
	            var selectedEu = selectedEuObject.length > 0 ? selectedEuObject[0].euId : null;
	            var euData = _this.state.allEus.length > 0
	                ? _this.state.allEus.filter(function (_a) {
	                    var country = _a.country, id = _a.id;
	                    return (country === Utils_1.regionFilters[region] && id === selectedEu);
	                })
	                : [];
	            var valueProps = euData.length > 0 ? euData[0].valueProps : [];
	            var valuePropFromDraft = _this.props.glanceDraftData.valueProps
	                ? _this.props.glanceDraftData.valueProps.filter(function (valueProp) { return valueProp.region === region; })
	                : [];
	            var valueProp = valuePropFromDraft.length > 0 ? valuePropFromDraft[0].vpId : null;
	            var isValuePropSelected = valueProps.length > 0 ? valueProps.map(function (vp) { return vp.id; }).includes(valueProp) : false;
	            var selectedValueProp = isValuePropSelected ? valueProp : null;
	            return (React.createElement(material_ui_1.DropDownMenu, { style: __assign({}, draftDetailsStyle_1.styles.width33), value: selectedValueProp, disabled: !editable, onChange: function (e, field, value) { return _this.handleValuePropChange(value, region); } },
	                React.createElement(material_ui_1.MenuItem, { key: "null", value: null, primaryText: "Select Value Prop" }),
	                valueProps ? valueProps.map(function (_a) {
	                    var id = _a.id, name = _a.name;
	                    return (React.createElement(material_ui_1.MenuItem, { key: id, value: id, primaryText: name }));
	                }) : null));
	        };
	        var getEuValuePropListItem = function (region, index) {
	            var countryName = Utils_1.regionNames[region];
	            var countryCode = Utils_1.regionFilters[region];
	            return countryCode ? (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.euGroup), key: index },
	                React.createElement("p", { style: __assign({}, draftDetailsStyle_1.styles.euCountry) }, countryName),
	                eu(region),
	                valueProp(region))) : null;
	        };
	        var euValuePropList = (this.props.glanceDraftData.preferedRegions &&
	            this.props.glanceDraftData.preferedRegions.length > 0 &&
	            this.props.glanceDraftData.preferedRegions.map(function (region, index) {
	                return (getEuValuePropListItem(region, index));
	            }));
	        var sourceCreatorId = null;
	        if (draft.peek != null &&
	            (draft.peek.nativeVideoUrl || draft.peek.webPeekUrl)) {
	            sourceCreatorId = (React.createElement(material_ui_1.TextField, { key: "sourceCreatorId", style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), defaultValue: draft.sourceCreatorId, hintText: "Roposo Creator ID", disabled: !editable, onChange: function (e, newValue) {
	                    return _this.onChange('sourceCreatorId', e, newValue);
	                } }));
	        }
	        var cities = (React.createElement(material_ui_chip_input_1["default"], { key: "cities", hintText: 'Cities', style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), value: this.state.cityGroups, dataSource: this.state.citySource, dataSourceConfig: CITY_SOURCE_CONFIG, onUpdateInput: function (chip) { return _this.onCitySearch(chip); }, onRequestAdd: function (chip) { return _this.handleCityChange(chip, false); }, onRequestDelete: function (chip, index) { return _this.handleCityChange(chip, true); }, disabled: !editable }));
	        var carriers = (React.createElement(material_ui_chip_input_1["default"], { key: "carriers", hintText: 'Carriers', style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), value: this.state.carrierMetas, dataSource: this.state.carrierSource, dataSourceConfig: CARRIER_SOURCE_CONFIG, onUpdateInput: function (chip) { return _this.onCarrierSearch(chip); }, onRequestAdd: function (chip) { return _this.handleCarrierChange(chip, false); }, onRequestDelete: function (chip) { return _this.handleCarrierChange(chip, true); }, disabled: !editable }));
	        var getRankOptions = function (count) {
	            var rankOptions = [];
	            for (var i = 1; i <= count; i++) {
	                rankOptions.push(React.createElement(material_ui_1.MenuItem, { key: i, value: i, primaryText: i, disabled: _this.checkRankItemStatus(i) }));
	            }
	            return rankOptions;
	        };
	        var isRankDisabled = this.state.rankInBubble > 0 &&
	            this.state.publishValue === 8 /* PUBLISHED */ &&
	            draft.bubbleId === this.state.publishedBubbleId;
	        var isRankNeeded = glanceDraftData.bubbleId &&
	            glanceDraftData.type === 4 /* SPONSORED */ &&
	            ((this.state.bubbles.filter(function (ele) { return ele.bubbleId === glanceDraftData.bubbleId; }).length > 0 &&
	                this.state.bubbles.filter(function (ele) { return ele.bubbleId === glanceDraftData.bubbleId; })[0].storyCount > 0) ||
	                this.state.storyCount > 0);
	        var rank = isRankNeeded && (React.createElement(material_ui_1.DropDownMenu, { disabled: !editable || isRankDisabled, value: glanceDraftData.bubbleId === this.state.publishedBubbleId
	                ? this.state.publishedRank
	                : draft.rankInBubble, key: "rank", autoWidth: true, style: __assign({}, draftDetailsStyle_1.styles.width50, { marginTop: '-8px', width: '50%' }), onChange: function (e, filed, value) {
	                return _this.handleRankChange(e, 'rankInBubble', value);
	            } },
	            React.createElement(material_ui_1.MenuItem, { key: "null", value: null, primaryText: "Select Rank" }),
	            getRankOptions(this.state.bubbles.filter(function (item) { return item.bubbleId === draft.bubbleId; })
	                .length > 0 &&
	                this.state.bubbles.filter(function (item) { return item.bubbleId === draft.bubbleId; })[0].storyCount)));
	        var bubbles = (React.createElement(material_ui_chip_input_1["default"], { key: "bubbles", hintText: 'Select Bubble Qualifier', style: isRankNeeded
	                ? __assign({}, draftDetailsStyle_1.styles.width50, { marginTop: '-8px' }) : __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), value: this.state.bubbles.filter(function (item) { return item.bubbleId === draft.bubbleId; }), dataSource: this.state.bubbles, dataSourceConfig: BUBBLE_SOURCE_CONFIG, onUpdateInput: Utils_1["default"].debounce(function (chip) { return _this.onBubbleSearch(chip); }, 1000), onRequestAdd: function (chip) {
	                return _this.handleBubbleChange(chip, false, draft.type);
	            }, onRequestDelete: function (chip) {
	                return _this.handleBubbleChange(chip, true, draft.type);
	            }, disabled: !editable }));
	        var negativeTargeting = null;
	        var positiveTargeting = null;
	        var negativeAppList = null;
	        var positiveAppList = null;
	        negativeTargeting = (React.createElement(material_ui_1.DropDownMenu, { value: this.state.negativeTargetingType, key: "negativeTargetingType", style: __assign({}, draftDetailsStyle_1.styles.width50, { marginTop: '-8px' }), disabled: !editable, onChange: function (e, feild, value) {
	                return _this.handleTargetingTypeChange(e, 'negativeTargetingType', value);
	            } },
	            React.createElement(material_ui_1.MenuItem, { value: 'absent', primaryText: "Absent" }),
	            React.createElement(material_ui_1.MenuItem, { value: 'anyAbsent', primaryText: "AnyAbsent" })));
	        negativeAppList = (React.createElement(material_ui_chip_input_1["default"], { key: "negativeTargetingApp", hintText: 'Negative Targeting App(s)', style: __assign({}, draftDetailsStyle_1.styles.width50, { marginTop: '-8px' }), value: this.state.negativeTargets, dataSource: this.state.negativeTargetSource, dataSourceConfig: TARGET_SOURCE_CONFIG, onUpdateInput: function (chip) { return _this.onNegativeTargetSearch(chip); }, onRequestAdd: function (chip) {
	                return _this.handleNegativeTargetChange(chip, false, _this.state.negativeTargetingType);
	            }, onRequestDelete: function (chip, index) {
	                return _this.handleNegativeTargetChange(chip, true, _this.state.negativeTargetingType);
	            }, disabled: !editable }));
	        positiveTargeting = (React.createElement(material_ui_1.DropDownMenu, { value: this.state.positiveTargetingType, key: "positiveTargetingType", disabled: !editable, style: __assign({}, draftDetailsStyle_1.styles.width50, { marginTop: '-8px' }), onChange: function (e, feild, value) {
	                return _this.handleTargetingTypeChange(e, 'positiveTargetingType', value);
	            } },
	            React.createElement(material_ui_1.MenuItem, { value: 'present', primaryText: "Present" }),
	            React.createElement(material_ui_1.MenuItem, { value: 'anyPresent', primaryText: "AnyPresent" })));
	        positiveAppList = (React.createElement(material_ui_chip_input_1["default"], { key: "positiveTargetingApp", hintText: 'Positive Targeting App(s)', style: __assign({}, draftDetailsStyle_1.styles.width50, { marginTop: '-8px' }), value: this.state.positiveTargets, dataSource: this.state.positiveTargetSource, dataSourceConfig: TARGET_SOURCE_CONFIG, onUpdateInput: function (chip) { return _this.onPositiveTargetSearch(chip); }, onRequestAdd: function (chip) {
	                return _this.handlePositiveTargetChange(chip, false, _this.state.positiveTargetingType);
	            }, onRequestDelete: function (chip, index) {
	                return _this.handlePositiveTargetChange(chip, true, _this.state.positiveTargetingType);
	            }, disabled: !editable }));
	        var networkTargeting = (
	        // Comment/Uncomment for network targeting
	        React.createElement("div", { style: draftDetailsStyle_1.styles.width100, placeholder: "Network Targeting" },
	            React.createElement(MultiSelectDropdown_1["default"], { label: "", placeholder: "Network Targeting", options: networkTargetingOptions, onChange: this.handleNetworkChange, selectedValue: this.state.userNetworkTypes })));
	        var segments = null;
	        if (!this.state.antiSegments || this.state.antiSegments.length == 0) {
	            segments = (React.createElement(material_ui_chip_input_1["default"], { key: "segments", hintText: 'segments', style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), value: this.convertSegmentsToSegmentSources(this.state.segments), dataSource: this.state.segmentSource, dataSourceConfig: SEGMENT_SOURCE_CONFIG, onUpdateInput: function (chip) { return _this.onSegmentSearch(chip); }, onRequestAdd: function (chip) { return _this.handleSegmentChange(chip, false); }, onRequestDelete: function (chip, index) {
	                    return _this.handleSegmentChange(chip, true);
	                }, disabled: !editable }));
	        }
	        var antiSegments = null;
	        if (!this.state.segments || this.state.segments.length == 0) {
	            antiSegments = (React.createElement(material_ui_chip_input_1["default"], { key: "antiSegments", hintText: 'NOT in Segments', style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), value: this.convertSegmentsToSegmentSources(this.state.antiSegments), dataSource: this.state.segmentSource, dataSourceConfig: SEGMENT_SOURCE_CONFIG, onUpdateInput: function (chip) { return _this.onSegmentSearch(chip); }, onRequestAdd: function (chip) { return _this.handleAntiSegmentChange(chip, false); }, onRequestDelete: function (chip, index) {
	                    return _this.handleAntiSegmentChange(chip, true);
	                }, disabled: !editable }));
	        }
	        var attributionSource = (React.createElement(material_ui_1.TextField, { key: "attribution_source", style: draftDetailsStyle_1.styles.width50, hintText: "Image Attribution", defaultValue: draft.image && draft.image.attribution
	                ? draft.image.attribution.source
	                : undefined, disabled: !editable || this.props.disableAttribution, onChange: function (e, newValue) {
	                return _this.onChange('attribution_source', e, newValue);
	            } }));
	        var contentTags = (React.createElement(material_ui_1.TextField, { key: "tags", style: draftDetailsStyle_1.styles.width50, hintText: "Content Tag", defaultValue: draft.tags && draft.tags[0]
	                ? draft.tags[0]
	                : undefined, disabled: !editable, onChange: function (e, newValue) {
	                return _this.onChange('tags', e, newValue);
	            } }));
	        var peekLink = null;
	        if (this.state.linkType == 'ctaUrl' ||
	            this.state.linkType == 'webPeekUrl') {
	            if (this.state.ctaType == 2 /* APP_INSTALL */ &&
	                !draft.peek.webPeekUrl) {
	                peekLink = (React.createElement("div", null,
	                    React.createElement(material_ui_1.TextField, { key: "InstallLink", style: draftDetailsStyle_1.styles.width100, hintText: "Install Link", defaultValue: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstallCta &&
	                            draft.peek.appCta.appInstallCta.url, disabled: !editable, onChange: function (e, newValue) {
	                            return _this.onChange('InstallLink', e, newValue);
	                        } }),
	                    React.createElement(material_ui_1.TextField, { key: "InstalledLink", style: draftDetailsStyle_1.styles.width100, hintText: "Installed Link", defaultValue: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstalledCta &&
	                            draft.peek.appCta.appInstalledCta.url, disabled: !editable, onChange: function (e, newValue) {
	                            return _this.onChange('InstalledLink', e, newValue);
	                        } }),
	                    React.createElement(material_ui_1.TextField, { key: "InstallingLink", style: draftDetailsStyle_1.styles.width100, hintText: "Installing Link", defaultValue: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstallingCta &&
	                            draft.peek.appCta.appInstallingCta.url, disabled: !editable, onChange: function (e, newValue) {
	                            return _this.onChange('InstallingLink', e, newValue);
	                        } }),
	                    ' '));
	            }
	            else {
	                peekLink = (React.createElement(material_ui_1.TextField, { key: "PeekLink", style: draftDetailsStyle_1.styles.width100, hintText: "Peek Link", defaultValue: peekUrl, disabled: !editable, onChange: function (e, newValue) {
	                        return _this.onChange(_this.state.linkType, e, newValue);
	                    } }));
	            }
	        }
	        var offlinePeekLink = glanceDraftData.type &&
	            (glanceDraftData.type === 4 /* SPONSORED */ ||
	                glanceDraftData.type === 2 /* STORY */) ? (React.createElement(material_ui_1.TextField, { key: "OfflinePeekLink", style: draftDetailsStyle_1.styles.width100, hintText: "Offline Peek Link", disabled: !editable, defaultValue: glanceDraftData.peek && glanceDraftData.peek.offlinePeekUrl
	                ? glanceDraftData.peek.offlinePeekUrl
	                : '', onChange: function (e, newValue) {
	                return _this.onChange('OfflinePeekLink', e, newValue);
	            } })) : null;
	        var videoCtaUrl = null;
	        if (this.state.linkType == 'videoUrl') {
	            peekLink = (React.createElement(material_ui_1.TextField, { key: "PeekLink", style: draftDetailsStyle_1.styles.width100, hintText: "Peek Link", defaultValue: draft.peek && draft.peek.videoUrl ? draft.peek.videoUrl : '', disabled: !editable, onChange: function (e, newValue) {
	                    return _this.onChange(_this.state.linkType, e, newValue);
	                } }));
	            if (this.state.ctaType == 2 /* APP_INSTALL */) {
	                videoCtaUrl = (React.createElement("div", null,
	                    React.createElement(material_ui_1.TextField, { key: "InstallLink", style: draftDetailsStyle_1.styles.width100, hintText: "Install Link", defaultValue: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstallCta &&
	                            draft.peek.appCta.appInstallCta.url, disabled: !editable, onChange: function (e, newValue) {
	                            return _this.onChange('InstallLink', e, newValue);
	                        } }),
	                    React.createElement(material_ui_1.TextField, { key: "InstalledLink", style: draftDetailsStyle_1.styles.width100, hintText: "Installed Link", defaultValue: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstalledCta &&
	                            draft.peek.appCta.appInstalledCta.url, disabled: !editable, onChange: function (e, newValue) {
	                            return _this.onChange('InstalledLink', e, newValue);
	                        } }),
	                    React.createElement(material_ui_1.TextField, { key: "InstallingLink", style: draftDetailsStyle_1.styles.width100, hintText: "Installing Link", defaultValue: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstallingCta &&
	                            draft.peek.appCta.appInstallingCta.url, disabled: !editable, onChange: function (e, newValue) {
	                            return _this.onChange('InstallingLink', e, newValue);
	                        } }),
	                    ' '));
	            }
	            else {
	                videoCtaUrl = (React.createElement(material_ui_1.TextField, { key: "VideoCtaUrl", style: draftDetailsStyle_1.styles.width100, hintText: "VideoCtaUrl", defaultValue: glanceDraftData.peek && glanceDraftData.peek.videoCtaUrl
	                        ? glanceDraftData.peek.videoCtaUrl
	                        : '', onChange: function (e, newValue) {
	                        return _this.onChange('VideoCtaUrl', e, newValue);
	                    } }));
	            }
	        }
	        var isZipCTA = null;
	        if (draft.type === 4 /* SPONSORED */ && this.state.ctaType == 1 /* CTA_URL */ && peekUrl && peekUrl.includes('.zip')) {
	            if (this.state.linkType == 'ctaUrl') {
	                isZipCTA = 1;
	            }
	            else {
	                isZipCTA = 0;
	            }
	        }
	        var zipTypes = isZipCTA != null ? (React.createElement("div", { style: { margin: '10px 0 9px -8px' }, key: "zip_types" },
	            React.createElement(RadioButton_1.RadioButtonGroup, { name: "zipTypes", style: { display: 'inline-flex' }, defaultSelected: isZipCTA, onChange: this.handleZipCTAChange },
	                React.createElement(RadioButton_1.RadioButton, { style: {
	                        float: 'left',
	                        marginLeft: '5px',
	                        display: 'inline-block'
	                    }, value: 0, label: "Webpeek/Native" }),
	                React.createElement(RadioButton_1.RadioButton, { style: {
	                        float: 'left',
	                        marginLeft: '10px',
	                        display: 'inline-block'
	                    }, value: 1, label: "CTAView" })))) : null;
	        var articleCtaUrl = null;
	        if (draftsHelper_1.isArticle(this.props.glanceDraftData) && isZipCTA == null) {
	            articleCtaUrl = (React.createElement(material_ui_1.TextField, { key: "articleCtaUrl", style: draftDetailsStyle_1.styles.width100, hintText: "ArticleCtaUrl", disabled: !editable, defaultValue: glanceDraftData.peek && glanceDraftData.peek.articleCtaUrl
	                    ? glanceDraftData.peek.articleCtaUrl
	                    : '', onChange: function (e, newValue) {
	                    return _this.onChange('ArticleCtaUrl', e, newValue);
	                } }));
	        }
	        var AdPersonalisationList = [
	            'Drive App Installs',
	            'V1_Native OCI',
	            'V1_Google Playstore',
	            'V1_Remarketing- OCI',
	            'V1_Single App OCI',
	        ];
	        var _c = this.props, peekSourceList = _c.peekSourceList, dspPeekSourceList = _c.dspPeekSourceList;
	        var sourceNameList = isDspCampaign ? dspPeekSourceList : peekSourceList;
	        var sourceName = null;
	        if (this.props.glanceDraftData.type === 4 /* SPONSORED */ &&
	            sourceNameList &&
	            sourceNameList.length > 0 &&
	            (isDspCampaign ||
	                (glanceDraftData.campaignMeta &&
	                    glanceDraftData.campaignMeta.objective &&
	                    AdPersonalisationList.includes(glanceDraftData.campaignMeta.objective)))) {
	            if (draft.peek &&
	                draft.peek.sourceName &&
	                !sourceNameList.includes(draft.peek.sourceName)) {
	                this.props.onEdit('source', '');
	            }
	            sourceName = (React.createElement(material_ui_1.DropDownMenu, { key: "source_name", style: __assign({}, draftDetailsStyle_1.styles.width33, { maxWidth: 'none', paddingBottom: '6px', float: 'left', marginLeft: '-24px' }), disabled: !editable, value: draft.peek ? draft.peek.sourceName : undefined, onChange: function (e, feild, value) { return _this.onChange('source', e, value); } },
	                React.createElement(material_ui_1.MenuItem, { key: 'null', value: null, disabled: true, primaryText: "Select Peek Source Name" }),
	                sourceNameList.map(function (name, ind) { return (React.createElement(material_ui_1.MenuItem, { key: ind, value: name, primaryText: name })); })));
	        }
	        else {
	            sourceName = (React.createElement(material_ui_1.TextField, { key: "source_name", style: draftDetailsStyle_1.styles.width33, hintText: "Peek Source Name", defaultValue: draft.peek ? draft.peek.sourceName : undefined, disabled: !editable, onChange: function (e, newValue) { return _this.onChange('source', e, newValue); } }));
	        }
	        var hearts = (React.createElement(material_ui_1.TextField, { key: "heartCount", style: __assign({}, draftDetailsStyle_1.styles.width17, draftDetailsStyle_1.styles.hearts), hintText: "Hearts", defaultValue: draft.peek ? draft.peek.heartCount : undefined, disabled: !editable, onChange: function (e, newValue) { return _this.onChange('hearts', e, newValue); }, type: "number" }));
	        var summary = (React.createElement(material_ui_1.TextField, { key: "summary", style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-5px' }), hintText: "Summary", value: draft.peek && draft.peek.summary ? draft.peek.summary : '', disabled: !editable, multiLine: true, rows: 5, rowsMax: 5, errorText: this.state.summaryExceededSize
	                ? 'Maximum allowed size reached ' +
	                    (this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT)
	                : null, onChange: function (e, newValue) { return _this.onChange('summary', e, newValue); } }));
	        var cheesySummary = (React.createElement(material_ui_1.TextField, { key: "cheesySummary", style: __assign({}, draftDetailsStyle_1.styles.width100, draftDetailsStyle_1.styles.marginBottomOnly), hintText: "Cheesy Summary", value: draft.peek && draft.peek.cheesySummary ? draft.peek.cheesySummary : '', disabled: !editable, multiLine: true, rows: 5, rowsMax: 5, errorText: this.state.cheesySummaryExceededSize
	                ? 'Maximum allowed size reached ' +
	                    (this.state.summaryLimit || DEFAULT_SUMMARY_LENGTH_LIMIT)
	                : null, onChange: function (e, newValue) { return _this.onChange('cheesySummary', e, newValue); } }));
	        var glanceType = (React.createElement("div", null,
	            React.createElement(material_ui_1.DropDownMenu, { key: "glanceTypeSelector", value: glanceDraftData.type ? glanceDraftData.type : 2 /* STORY */, onChange: this.handleTypeChange, style: __assign({}, draftDetailsStyle_1.styles.width50, draftDetailsStyle_1.styles.marginTopLeft, draftDetailsStyle_1.styles.marginTopOnly), disabled: !editable || this.state.publishValue === 8 /* PUBLISHED */ },
	                React.createElement(material_ui_1.MenuItem, { value: 2 /* STORY */, primaryText: "Story" }),
	                React.createElement(material_ui_1.MenuItem, { value: 1 /* WALLPAPER */, primaryText: "Wallpaper" }),
	                React.createElement(material_ui_1.MenuItem, { value: 3 /* RESERVED_STORY */, primaryText: "Reserved Story" }),
	                draft.peek ? (React.createElement(material_ui_1.MenuItem, { value: 4 /* SPONSORED */, primaryText: "Sponsored" })) : null)));
	        var dspCampaign = this.props.glanceDraftData.type === 4 /* SPONSORED */ && (React.createElement(material_ui_1.Toggle, { key: "isDspCampaign", label: "Is DSP", style: __assign({}, draftDetailsStyle_1.styles.width50, { padding: '6px 0 10px 0' }), toggled: lodash_1.get(this.state, 'dspCampaignData.isDspCampaign', false), onToggle: function (e, newValue) {
	                _this.props.onEdit('isDspCampaign', newValue);
	            } }));
	        var priority = draft.type != 1 /* WALLPAPER */ ? (React.createElement("div", null, draft.peek && draft.peek.tvVideoPeek ? (React.createElement("div", null,
	            React.createElement(material_ui_1.DropDownMenu, { key: "priority_changer", value: glanceDraftData.priority, onChange: this.handlePriorityChange, disabled: !editable, style: __assign({}, draftDetailsStyle_1.styles.width50, draftDetailsStyle_1.styles.marginTopLeft, draftDetailsStyle_1.styles.marginTopOnly) },
	                React.createElement(material_ui_1.MenuItem, { value: 9, primaryText: "H1" }),
	                React.createElement(material_ui_1.MenuItem, { value: 8, primaryText: "H2" }),
	                React.createElement(material_ui_1.MenuItem, { value: 7, primaryText: "H3" }),
	                React.createElement(material_ui_1.MenuItem, { value: 6, primaryText: "H4" }),
	                React.createElement(material_ui_1.MenuItem, { value: 5, primaryText: "H5" }),
	                React.createElement(material_ui_1.MenuItem, { value: 4, primaryText: "H6" }),
	                React.createElement(material_ui_1.MenuItem, { value: 3, primaryText: "H7" }),
	                React.createElement(material_ui_1.MenuItem, { value: 2, primaryText: "H8" }),
	                React.createElement(material_ui_1.MenuItem, { value: 1, primaryText: "H9" }),
	                React.createElement(material_ui_1.MenuItem, { value: 0, primaryText: "H10" })),
	            glanceDraftData.priority === draft.priority && (React.createElement("p", { style: draftDetailsStyle_1.styles.alertMessage },
	                React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.yellowA700, hoverColor: colors_1.yellowA700, style: { fontSize: '24px', marginRight: '8px' } }, "info"),
	                "There are already 1 or more cards running at this priority, by publishing this card, the whole order will move by a step.")))) : (React.createElement(material_ui_1.DropDownMenu, { key: "priority_changer", value: glanceDraftData.priority, onChange: this.handlePriorityChange, disabled: !editable, style: __assign({}, draftDetailsStyle_1.styles.width50, draftDetailsStyle_1.styles.marginTopLeft, draftDetailsStyle_1.styles.marginTopOnly) },
	            React.createElement(material_ui_1.MenuItem, { value: 0, primaryText: "Normal Priority" }),
	            React.createElement(material_ui_1.MenuItem, { value: 1, primaryText: "High Priority 1" }),
	            React.createElement(material_ui_1.MenuItem, { value: 2, primaryText: "High Priority 2" }))))) : null;
	        var shouldUnlock = draft.peek && (draft.peek.ctaUrl || draft.peek.videoCtaUrl) ? (React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.clickableChip, key: 'peek_cta', backgroundColor: draft.peek.shouldUnlock ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.handleShouldUnlock(!draft.peek.shouldUnlock);
	            } }, draft.peek.shouldUnlock ? 'CTA After Unlock' : 'CTA On Lockscreen')) : (React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.clickableChip, key: 'peek_cta' }, "No Peek-CTA"));
	        var openInBgCheck = draft.peek &&
	            (draft.peek.ctaUrl || draft.peek.videoCtaUrl) &&
	            draft.peek.cta &&
	            draft.peek.cta.openUrlCta
	            ? draft.peek.cta.openUrlCta.openInBg
	            : false;
	        var openInBg = (React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.clickableChip, key: 'open_in_bg', backgroundColor: openInBgCheck ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.handleOpenInBg(!openInBgCheck);
	            } }, openInBgCheck ? 'Open In Background' : "Don't Open In Background"));
	        var storyType = (React.createElement("div", { style: { margin: '0 0 0 -6px' }, key: "story_type" },
	            React.createElement(RadioButton_1.RadioButtonGroup, { name: "storyType", style: { display: 'inline-flex' }, defaultSelected: draft.storyType, onChange: this.handleStoryTypeChange },
	                React.createElement(RadioButton_1.RadioButton, { style: {
	                        float: 'left',
	                        marginLeft: '5px',
	                        display: 'inline-block'
	                    }, value: 2 /* FEATURE */, label: "Feature", disabled: !editable }),
	                React.createElement(RadioButton_1.RadioButton, { style: {
	                        float: 'left',
	                        marginLeft: '10px',
	                        display: 'inline-block'
	                    }, value: 1 /* NEWS */, label: "News", disabled: !editable }),
	                React.createElement(RadioButton_1.RadioButton, { style: {
	                        float: 'left',
	                        marginLeft: '10px',
	                        display: 'inline-block'
	                    }, value: 3 /* GLANCETV */, label: "GlanceTV", disabled: !editable }))));
	        var stickiness = (React.createElement(material_ui_1.TextField, { key: "stickiness", style: __assign({}, draftDetailsStyle_1.styles.width33, { height: '56px' }), defaultValue: draft.stickinessCount, hintText: "Stickiness", type: "number", onChange: function (e, newValue) {
	                return _this.handleStickinessChange(Number(newValue));
	            } }));
	        var languageLimit = draft && draft.peek ? (React.createElement("div", { style: { margin: '10px 0 9px -8px' }, key: "language_limit" },
	            React.createElement(RadioButton_1.RadioButtonGroup, { name: "languageLimit", style: { display: 'inline-flex' }, defaultSelected: draft && draft.peek ? draft.peek.summaryLimit : null, onChange: this.handleLanguageLimitChange },
	                React.createElement(RadioButton_1.RadioButton, { style: {
	                        float: 'left',
	                        marginLeft: '5px',
	                        display: 'inline-block'
	                    }, value: 150 /* ENG */, label: "English" }),
	                React.createElement(RadioButton_1.RadioButton, { style: {
	                        float: 'left',
	                        marginLeft: '10px',
	                        display: 'inline-block'
	                    }, value: 200 /* HINDI */, label: "Hindi" })))) : null;
	        var sdkSubscribedCategoriesFilter = (React.createElement("div", { style: { float: 'left', marginTop: '2px' }, key: "sdk_subcribed_filter" },
	            React.createElement(material_ui_1.DropDownMenu, { value: glanceDraftData.categorySubscriptionStatus
	                    ? glanceDraftData.categorySubscriptionStatus
	                    : null, onChange: this.handleSdkSubscribedCategoriesFilterChange, disabled: !editable, style: { marginLeft: '-24px' } },
	                React.createElement(material_ui_1.MenuItem, { key: "null", value: null, primaryText: "SDK Subscribed Categories" }),
	                React.createElement(material_ui_1.MenuItem, { key: 1 /* ANY */, value: 1 /* ANY */, primaryText: "At Least 1" }),
	                React.createElement(material_ui_1.MenuItem, { key: 0 /* NONE */, value: 0 /* NONE */, primaryText: "None" }))));
	        var categoryMap = [];
	        studioAppConfig.categories.forEach(function (category) {
	            categoryMap.push(React.createElement(material_ui_1.MenuItem, { key: category.id, value: category.id, primaryText: category.displayName }));
	        });
	        var targetForCategoriesValue = [];
	        if (draft.targetForCategories) {
	            this.state.categorySource.forEach(function (categorySource) {
	                if (draft.targetForCategories.indexOf(categorySource.category.id) != -1) {
	                    targetForCategoriesValue.push(categorySource);
	                }
	            });
	        }
	        var targetForCategory = (React.createElement(material_ui_chip_input_1["default"], { key: "targetForCategories", hintText: 'Not Subscribed to Categories', style: __assign({}, draftDetailsStyle_1.styles.width100, { marginTop: '-8px' }), value: targetForCategoriesValue, dataSource: this.state.categorySource, dataSourceConfig: CATEGORY_SOURCE_CONFIG, onRequestAdd: function (chip) { return _this.handleTargetForCategoryChange(chip, false); }, onRequestDelete: function (chip, index) {
	                return _this.handleTargetForCategoryChange(chip, true);
	            }, disabled: !editable }));
	        var publishers = [];
	        this.state.publisherDatas.forEach(function (publisherData, id) {
	            publishers.push(React.createElement(material_ui_1.MenuItem, { key: publisherData.id, value: publisherData.id, primaryText: publisherData.displayName }));
	        });
	        var publisherOptions = (React.createElement(material_ui_1.DropDownMenu, { "data-store": draft.publisherData, value: draft.publisherData ? draft.publisherData.id : null, onChange: this.handlePublisherChange, key: "publisher", disabled: !editable, style: __assign({}, draftDetailsStyle_1.styles.width33, { marginLeft: '-23px' }) },
	            React.createElement(material_ui_1.MenuItem, { key: "null", value: null, primaryText: "Select Publisher" }),
	            publishers));
	        var ctaText = null;
	        var afterOciAppSelect = null;
	        if (this.state.ctaType == 2 /* APP_INSTALL */) {
	            var menuItems = this.props.studioAppConfig.notificationTemplates
	                .filter(function (template) {
	                if (_this.state.selectedOciAppId) {
	                    return template.appId == _this.state.selectedOciAppId;
	                }
	                else if (glanceDraftData.peek &&
	                    glanceDraftData.peek.appCta &&
	                    glanceDraftData.peek.appCta.appInstallMeta &&
	                    glanceDraftData.peek.appCta.appInstallMeta.appId) {
	                    return (template.appId == glanceDraftData.peek.appCta.appInstallMeta.appId);
	                }
	            })
	                .map(function (item) {
	                return (React.createElement(material_ui_1.MenuItem, { key: item.notifTemplateId, value: item.notifTemplateId, primaryText: item.notifQualifier }));
	            });
	            ctaText = draft.peek && draft.peek.webPeekUrl && (React.createElement(material_ui_1.TextField, { key: "cta_text", style: draftDetailsStyle_1.styles.width25, hintText: "CTA Text", value: draft.peek && draft.peek.cta ? draft.peek.cta.text : '', disabled: !editable, onChange: function (e, newValue) { return _this.onChange('cta_text', e, newValue); }, errorText: this.state.ctaTextExceededSize && true
	                    ? "Maximum allowed size is " + CTA_TEXT_LENGTH_LIMIT
	                    : null }));
	            afterOciAppSelect = (React.createElement("div", null,
	                draft.peek && !draft.peek.webPeekUrl && (React.createElement("div", null,
	                    React.createElement(material_ui_1.TextField, { key: "InstalledCtaText", style: draftDetailsStyle_1.styles.width100, hintText: "Installed Cta Text", defaultValue: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstalledCta &&
	                            draft.peek.appCta.appInstalledCta.ctaDisplay &&
	                            draft.peek.appCta.appInstalledCta.ctaDisplay.ctaDisplayText &&
	                            draft.peek.appCta.appInstalledCta.ctaDisplay.ctaDisplayText
	                                .text
	                            ? draft.peek.appCta.appInstalledCta.ctaDisplay
	                                .ctaDisplayText.text
	                            : undefined, disabled: !editable, onChange: function (e, newValue) {
	                            return _this.onChange('InstalledCtaText', e, newValue);
	                        } }),
	                    React.createElement(material_ui_1.TextField, { key: "AppName", style: draftDetailsStyle_1.styles.width100, hintText: "App Name", defaultValue: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstallMeta
	                            ? draft.peek.appCta.appInstallMeta.appName
	                            : undefined, disabled: !editable, onChange: function (e, newValue) {
	                            return _this.onChange('AppName', e, newValue);
	                        } }))),
	                React.createElement("div", null,
	                    React.createElement(material_ui_1.DropDownMenu, { value: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstallMeta &&
	                            draft.peek.appCta.appInstallMeta.notifTemplateId
	                            ? draft.peek.appCta.appInstallMeta.notifTemplateId
	                            : '', onChange: function (e, feild, value) {
	                            return _this.handleAppNotification(e, 'notifTemplateId', value);
	                        }, disabled: !editable, style: __assign({}, draftDetailsStyle_1.styles.width50, draftDetailsStyle_1.styles.marginTopLeft) },
	                        React.createElement(material_ui_1.MenuItem, { value: '', primaryText: "Select D0 Template" }),
	                        menuItems),
	                    React.createElement(material_ui_1.DropDownMenu, { value: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstallMeta &&
	                            draft.peek.appCta.appInstallMeta.d1NotifTemplateId
	                            ? draft.peek.appCta.appInstallMeta.d1NotifTemplateId
	                            : '', disabled: !editable, onChange: function (e, feild, value) {
	                            return _this.handleAppNotification(e, 'd1NotifTemplateId', value);
	                        }, style: __assign({}, draftDetailsStyle_1.styles.width50, draftDetailsStyle_1.styles.marginTopLeft) },
	                        React.createElement(material_ui_1.MenuItem, { value: '', primaryText: "Select D1 Template" }),
	                        menuItems),
	                    React.createElement(material_ui_1.DropDownMenu, { value: draft.peek &&
	                            draft.peek.appCta &&
	                            draft.peek.appCta.appInstallMeta &&
	                            draft.peek.appCta.appInstallMeta.ltvNotifTemplateId
	                            ? draft.peek.appCta.appInstallMeta.ltvNotifTemplateId
	                            : '', disabled: !editable, onChange: function (e, feild, value) {
	                            return _this.handleAppNotification(e, 'ltvNotifTemplateId', value);
	                        }, style: __assign({}, draftDetailsStyle_1.styles.width50, draftDetailsStyle_1.styles.marginTopLeft) },
	                        React.createElement(material_ui_1.MenuItem, { value: '', primaryText: "Select LTV Template" }),
	                        menuItems)),
	                !draft.peek.webPeekUrl && (React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.clickableChip, key: 'should_unlock_installed', backgroundColor: draft.peek &&
	                        draft.peek.appCta &&
	                        draft.peek.appCta.appInstalledCta &&
	                        draft.peek.appCta.appInstalledCta.shouldUnlock
	                        ? colors_1.blue300
	                        : null, onTouchTap: function () {
	                        _this.handleShouldUnlockAppInstalled(!draft.peek.appCta.appInstalledCta.shouldUnlock);
	                    } }, draft.peek.appCta.appInstalledCta.shouldUnlock
	                    ? 'App Installed CTA After Unlock'
	                    : 'App Installed CTA On Lockscreen'))));
	        }
	        else {
	            ctaText = (React.createElement(material_ui_1.TextField, { key: "cta_text", style: __assign({}, draftDetailsStyle_1.styles.width20, { marginLeft: '1%' }), hintText: "CTA Text", value: draft.peek && draft.peek.cta ? draft.peek.cta.text : '', disabled: !editable, onChange: function (e, newValue) { return _this.onChange('cta_text', e, newValue); }, errorText: this.state.ctaTextExceededSize && true
	                    ? "Maximum allowed size is " + CTA_TEXT_LENGTH_LIMIT
	                    : null }));
	        }
	        var lockscreenCtaText = (React.createElement(material_ui_1.TextField, { key: "lockscreen_cta_text", style: __assign({}, draftDetailsStyle_1.styles.width25, { marginLeft: '2%' }), hintText: "LS CTA Text", value: draft.peek && draft.peek.lockscreenCtaText
	                ? draft.peek.lockscreenCtaText
	                : '', disabled: !editable, onChange: function (e, newValue) {
	                return _this.onChange('lockscreen_cta_text', e, newValue);
	            }, errorText: this.state.lockscreenCtaTextExceededSize
	                ? "Maximum allowed size is " + CTA_TEXT_LENGTH_LIMIT
	                : null }));
	        var CtaViewConfigHeight = draft.type === 4 /* SPONSORED */ && isZipCTA == 0 ? null : (React.createElement(material_ui_1.TextField, { key: "ctaview_height", style: __assign({}, draftDetailsStyle_1.styles.width25), defaultValue: draft.ctaViewConfig && draft.ctaViewConfig.height
	                ? draft.ctaViewConfig.height
	                : null, hintText: "CTA View height", disabled: !editable, type: "number", onChange: function (e, newValue) { return _this.onChange('ctaview_height', e, newValue); }, errorText: this.state.CtaViewExceededHeight ? "Allowed range 10-100" : null }));
	        var ctaViewHideTopPadding = draft.type === 4 /* SPONSORED */ && isZipCTA == 0 ? null : (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip, { marginLeft: '10px' }), key: 'ctaview_hide_toppadding', backgroundColor: draft.ctaViewConfig && draft.ctaViewConfig.removeTopPadding
	                ? colors_1.blue300
	                : null, onTouchTap: function () {
	                _this.handlectaViewHideTopPadding(!(draft.ctaViewConfig && draft.ctaViewConfig.removeTopPadding));
	            } }, draft.ctaViewConfig && draft.ctaViewConfig.removeTopPadding
	            ? 'CTA View hide top padding'
	            : 'CTA View show top padding'));
	        var ctaViewHideCrossIcon = draft.type === 4 /* SPONSORED */ && isZipCTA == 0 ? null : (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip, { marginLeft: '10px' }), key: 'ctaview_hide_crossicon', backgroundColor: draft.ctaViewConfig && draft.ctaViewConfig.hideCrossIcon
	                ? colors_1.blue300
	                : null, onTouchTap: function () {
	                _this.handlectaViewHideCrossIcon(!(draft.ctaViewConfig && draft.ctaViewConfig.hideCrossIcon));
	            } }, draft.ctaViewConfig && draft.ctaViewConfig.hideCrossIcon
	            ? 'CTA View hide cross icon'
	            : 'CTA View show cross icon'));
	        var canSkipSummary = draft.peek ? (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip, { margin: '0 20px 0 -2px' }), key: 'skip_summary_changer', labelColor: draft.peek.canSkipSummary ? draftDetailsStyle_1.skipSummaryLabelColor : null, backgroundColor: draft.peek.canSkipSummary ? draftDetailsStyle_1.skipSummaryBackgroundColor : null, onTouchTap: function () {
	                _this.handleSkipSummaryChange();
	            } }, draft.peek.canSkipSummary ? 'Can skip summary' : 'Cannot skip summary')) : null;
	        var isFcapsDisabled = function () {
	            return (glanceDraftData.bubbleId &&
	                draft.type === 4 /* SPONSORED */ &&
	                (_this.state.storyCount > 0 ||
	                    (_this.state.bubbles.filter(function (item) { return item.bubbleId === draft.bubbleId; })
	                        .length > 0 &&
	                        _this.state.bubbles.filter(function (item) { return item.bubbleId === draft.bubbleId; })[0].storyCount > 0)) &&
	                _this.state.rankInBubble !== 1);
	        };
	        var dailyCap = (React.createElement(material_ui_1.TextField, { disabled: isFcapsDisabled(), key: "dailyCap", style: { width: '33%', marginTop: '-8px' }, value: draft.frequencyCaps && draft.frequencyCaps.daily
	                ? draft.frequencyCaps.daily
	                : '', hintText: "Daily Cap", type: "number", onChange: function (e, newValue) { return _this.handleDailyCapChange(Number(newValue)); } }));
	        var weeklyCap = (React.createElement(material_ui_1.TextField, { disabled: isFcapsDisabled(), key: "weeklyCap", style: { width: '33%', marginTop: '-8px', float: 'right' }, value: draft.frequencyCaps && draft.frequencyCaps.weekly
	                ? draft.frequencyCaps.weekly
	                : '', hintText: "Weekly Cap", type: "number", onChange: function (e, newValue) { return _this.handleWeeklyCapChange(Number(newValue)); } }));
	        var sessionMode = (React.createElement("div", null,
	            React.createElement(MultiSelectDropdown_1["default"], { label: "", placeholder: "Session Mode", options: this.renderSessionListItems(), onChange: this.handleRenderSessionModeChange, selectedValue: this.state.renderSessionProperties, key: "renderSessionProperties", isDisabled: true, rankInBubble: this.state.rankInBubble })));
	        var OCIAppList = function () {
	            var selectedValue = null;
	            if (glanceDraftData.peek && glanceDraftData.peek.appCta) {
	                selectedValue = JSON.parse(JSON.stringify(glanceDraftData.peek.appCta.appInstallMeta));
	            }
	            else {
	                return null;
	            }
	            var studioAppConfig = _this.props.studioAppConfig;
	            var apps = studioAppConfig.apps;
	            var filteredAppList = apps.filter(function (appItem) {
	                return (appItem.logoUrl &&
	                    appItem.category &&
	                    appItem.title &&
	                    appItem.ociTargetable);
	            });
	            filteredAppList.sort(function (app1, app2) {
	                return app1.name.toLowerCase().localeCompare(app2.name.toLowerCase());
	            });
	            return (React.createElement("div", null,
	                React.createElement(material_ui_1.DropDownMenu, { value: selectedValue && selectedValue.packageName, onChange: _this.handleOciAppSelection, disabled: !editable, style: __assign({}, draftDetailsStyle_1.styles.width50, draftDetailsStyle_1.styles.marginTopLeft) },
	                    React.createElement(material_ui_1.MenuItem, { value: null, primaryText: "Select OCI App" }),
	                    filteredAppList.map(function (appItem) {
	                        return (React.createElement(material_ui_1.MenuItem, { key: "endDay-" + appItem.appId, value: appItem.packageId, primaryText: appItem.name }));
	                    }))));
	        };
	        var AutoOpenCta, AutoOpenCtaDurationInSecs;
	        AutoOpenCta = (React.createElement(material_ui_1.Toggle, { key: "autoOpenCta", label: "Auto Open CTA", style: draftDetailsStyle_1.styles.width50, toggled: lodash_1.get(this.state, 'autoOpenCta', false), onToggle: function (e, newValue) {
	                _this.setState(__assign({}, _this.state, { autoOpenCta: newValue }));
	                if (!newValue) {
	                    _this.props.onEdit('autoOpenCtaDurationInSecs', null);
	                }
	            } }));
	        AutoOpenCtaDurationInSecs = this.state.autoOpenCta && (React.createElement(material_ui_1.TextField, { key: "autoOpenCtaDurationInSecs", style: draftDetailsStyle_1.styles.width45, hintText: "CTA Duration In Secs", type: "number", defaultValue: draft.peek.cta && draft.peek.cta.autoOpenCtaDurationInSecs !== null
	                ? draft.peek.cta.autoOpenCtaDurationInSecs
	                : undefined, onChange: function (e, newValue) {
	                return _this.props.onEdit('autoOpenCtaDurationInSecs', newValue);
	            } }));
	        var AutoOpenWrapper = isNativeOCI && isSponsoredGlance && (React.createElement("div", { style: {
	                display: 'flex',
	                flexDirection: 'row',
	                flexGrow: 1,
	                flexWrap: 'wrap',
	                justifyContent: 'space-between',
	                alignItems: 'flex-end',
	                height: '48px'
	            } },
	            AutoOpenCta,
	            AutoOpenCtaDurationInSecs));
	        var NudgeWebUrl = (React.createElement(material_ui_1.TextField, { key: "weburl", style: draftDetailsStyle_1.styles.width100, hintText: "Web Url", type: "string", value: lodash_1.get(this.state, 'appOpenNudgeConfig.weburl', ''), onChange: function (e, newValue) {
	                return _this.onNudgeConfigUpdate('ociConfigs', 'weburl', newValue);
	            } }));
	        var NudgeCtaText = (React.createElement(material_ui_1.TextField, { key: "nudgeCtaText", style: draftDetailsStyle_1.styles.width100, hintText: "Nudge Cta Text", type: "string", value: lodash_1.get(this.state, 'appOpenNudgeConfig.nudgeCtaText', ''), onChange: function (e, newValue) {
	                return _this.onNudgeConfigUpdate('ociConfigs', 'nudgeCtaText', newValue);
	            } }));
	        var NudgeDescription = (React.createElement(material_ui_1.TextField, { key: "nudgeDescription", style: draftDetailsStyle_1.styles.width100, hintText: "Nudge Description", type: "string", value: lodash_1.get(this.state, 'appOpenNudgeConfig.nudgeDescription', ''), onChange: function (e, newValue) {
	                return _this.onNudgeConfigUpdate('ociConfigs', 'nudgeDescription', newValue);
	            } }));
	        var NudgeMode = (React.createElement(material_ui_1.TextField, { key: "nudgeMode", type: "number", style: draftDetailsStyle_1.styles.width50, hintText: "Nudge Mode", value: lodash_1.get(this.state, 'appOpenNudgeConfig.nudgeMode', ''), onChange: function (e, newValue) {
	                return _this.onNudgeConfigUpdate('ociConfigs', 'nudgeMode', newValue);
	            } }));
	        var ShowNudge = (React.createElement(material_ui_1.Toggle, { key: "showNudge", label: "Show Nudge", style: draftDetailsStyle_1.styles.width50, toggled: lodash_1.get(this.state, 'appOpenNudgeConfig.showNudge', ''), onToggle: function (e, newValue) {
	                return _this.onNudgeConfigUpdate('ociConfigs', 'showNudge', newValue);
	            } }));
	        var isHardWareAcceleration = (React.createElement(material_ui_1.Toggle, { key: "hwe", label: "Is HardWare Acceleration", style: draftDetailsStyle_1.styles.width50, toggled: lodash_1.get(this.state, 'appOpenNudgeConfig.hwe', ''), onToggle: function (e, newValue) {
	                return _this.onNudgeConfigUpdate('ociConfigs', 'hwe', newValue);
	            } }));
	        var isBeautifulWallpaper = (function () {
	            var showBeautifulWallpaperFlag = Utils_1["default"].getEnvDetails() !== 'prod';
	            return (React.createElement(react_lightweight_tooltip_1.Tooltip, { content: "Turning ON will override beautiful wallpapers / Wallpaper Mode i.e. the image in this glance will be used on lock screen instead of the beautiful wallpaper", styles: __assign({}, draftDetailsStyle_1.styles.tooltipStyle, { wrapper: __assign({}, draftDetailsStyle_1.styles.tooltipStyle.wrapper, draftDetailsStyle_1.styles.width100, { display: "" + (showBeautifulWallpaperFlag ? 'table' : 'none') }) }) },
	                React.createElement(material_ui_1.Toggle, { key: "overrideWallpaperMode", label: "Override Wallpaper Mode", style: __assign({}, draftDetailsStyle_1.styles.width50), toggled: _this.state.overrideWallpaperMode, onToggle: _this.handleBeautifulWallpaperChange })));
	        })();
	        var notificationEnabled = (React.createElement(material_ui_1.Toggle, { key: "enabled", label: "Notification Enabled", style: draftDetailsStyle_1.styles.width50, toggled: lodash_1.get(this.state, 'appOpenNotificationConfig.enabled', ''), onToggle: function (e, newValue) {
	                return _this.onNudgeNotificationConfigUpdate('ociConfigs', 'enabled', newValue);
	            } }));
	        var notificationIconUrl = (React.createElement(material_ui_1.TextField, { key: "iconUrl", type: "string", style: draftDetailsStyle_1.styles.width100, hintText: "Icon URL", value: lodash_1.get(this.state, 'appOpenNotificationConfig.iconUrl', ''), onChange: function (e, newValue) {
	                return _this.onNudgeNotificationConfigUpdate('ociConfigs', 'iconUrl', newValue);
	            } }));
	        var notificationTitle = (React.createElement(material_ui_1.TextField, { key: "Title", type: "string", style: draftDetailsStyle_1.styles.width100, hintText: "Notification Title", value: lodash_1.get(this.state, 'appOpenNotificationConfig.title', ''), onChange: function (e, newValue) {
	                return _this.onNudgeNotificationConfigUpdate('ociConfigs', 'title', newValue);
	            } }));
	        var notificationDescription = (React.createElement(material_ui_1.TextField, { key: "description", type: "string", style: draftDetailsStyle_1.styles.width100, hintText: "Notification Description", value: lodash_1.get(this.state, 'appOpenNotificationConfig.description', ''), onChange: function (e, newValue) {
	                return _this.onNudgeNotificationConfigUpdate('ociConfigs', 'description', newValue);
	            } }));
	        var notificationCtaText = (React.createElement(material_ui_1.TextField, { key: "ctaText", type: "string", style: draftDetailsStyle_1.styles.width100, hintText: "Notification CtaText", value: lodash_1.get(this.state, 'appOpenNotificationConfig.ctaText', ''), onChange: function (e, newValue) {
	                return _this.onNudgeNotificationConfigUpdate('ociConfigs', 'ctaText', newValue);
	            } }));
	        var channelType, cappingPacingCheck, advertiserId, creativeId;
	        if (isSponsoredGlance) {
	            channelType = (React.createElement(material_ui_1.DropDownMenu, { key: "channelType", value: draft.programmaticDetail
	                    ? draft.programmaticDetail.channelType
	                    : 0 /* DIRECT */, onChange: function (e, newValue) {
	                    _this.props.onEdit('channelType', newValue);
	                }, disabled: !editable, style: __assign({}, draftDetailsStyle_1.styles.width50, draftDetailsStyle_1.styles.marginTopLeft, draftDetailsStyle_1.styles.marginTopOnly) },
	                React.createElement(material_ui_1.MenuItem, { primaryText: 'Direct', key: "Direct", value: 0 /* DIRECT */ }),
	                React.createElement(material_ui_1.MenuItem, { primaryText: 'Programmatic', key: "Programmatic", value: 1 /* PROGRAMMATIC */ })));
	            if (draft.programmaticDetail &&
	                draft.programmaticDetail.channelType === 1 /* PROGRAMMATIC */) {
	                cappingPacingCheck = (React.createElement(material_ui_1.Toggle, { key: "cappingPacingCheck", label: "capping Pacing Check", type: "boolean", style: draftDetailsStyle_1.styles.width45, toggled: (draft.programmaticDetail &&
	                        draft.programmaticDetail.cappingPacingCheck) ||
	                        false, onToggle: function (e, newValue) {
	                        _this.props.onEdit('cappingPacingCheck', newValue);
	                    } }));
	                advertiserId = (React.createElement(material_ui_1.TextField, { key: "advertiserId", type: "string", style: draftDetailsStyle_1.styles.width100, hintText: "advertiser Id", value: (draft.programmaticDetail &&
	                        draft.programmaticDetail.advertiserId) ||
	                        '', onChange: function (e, newValue) {
	                        _this.props.onEdit('advertiserId', newValue);
	                    } }));
	                creativeId = (React.createElement(material_ui_1.TextField, { key: "creativeId", type: "string", style: draftDetailsStyle_1.styles.width100, hintText: "creativeId", value: (draft.programmaticDetail &&
	                        draft.programmaticDetail.creativeId) ||
	                        '', onChange: function (e, newValue) {
	                        _this.props.onEdit('creativeId', newValue);
	                    } }));
	            }
	        }
	        var selectedObjective = null;
	        var selectedEcpm = null;
	        var selectedGlroId = '';
	        if (glanceDraftData.campaignMeta) {
	            if (glanceDraftData.campaignMeta.objective) {
	                selectedObjective = glanceDraftData.campaignMeta.objective;
	            }
	            if (glanceDraftData.campaignMeta.eCpm) {
	                selectedEcpm = glanceDraftData.campaignMeta.eCpm;
	            }
	            if (glanceDraftData.campaignMeta.glroId) {
	                selectedGlroId = glanceDraftData.campaignMeta.glroId;
	            }
	        }
	        var campaignObjective = draft.peek && 4 /* SPONSORED */ === draft.type && !isDspCampaign ? (React.createElement("div", null,
	            React.createElement(material_ui_1.DropDownMenu, { value: selectedObjective, onChange: this.handleCampaignObjectiveChange, disabled: !editable, style: __assign({}, draftDetailsStyle_1.styles.width40, draftDetailsStyle_1.styles.marginTopLeft) },
	                React.createElement(material_ui_1.MenuItem, { value: null, primaryText: "Campaign Objective", style: draftDetailsStyle_1.styles.dropdownHeader }),
	                this.state.campaignObjectiveList
	                    ? this.state.campaignObjectiveList.map(function (objective) {
	                        return (React.createElement(material_ui_1.MenuItem, { key: objective, value: objective, primaryText: objective }));
	                    })
	                    : null),
	            React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.spacedRow) },
	                React.createElement(material_ui_1.TextField, { type: "number", key: "adCoefficient", style: __assign({}, draftDetailsStyle_1.styles.width33, { marginLeft: '5px' }), hintText: "Ad. Coefficient", value: draft.adCoefficient, disabled: !editable || this.props.adCoefficientDisabled, onChange: function (e, newValue) {
	                        return _this.props.onEdit('adCoefficient', newValue);
	                    }, errorText: draft.adCoefficient % 1 == 0 ? null : 'Please enter an integer' }),
	                React.createElement(material_ui_1.DropDownMenu, { style: __assign({}, draftDetailsStyle_1.styles.width33), value: draft.bucketPriority, disabled: !editable || this.props.bucketPriorityDisabled, onChange: this.handleBucketPriorityChange },
	                    React.createElement(material_ui_1.MenuItem, { key: "house", value: 0 /* HOUSE */, primaryText: "House" }),
	                    React.createElement(material_ui_1.MenuItem, { key: "price", value: 1 /* PRICE_PRIORITY */, primaryText: "Price Priority" }),
	                    React.createElement(material_ui_1.MenuItem, { key: "low", value: 2 /* LOW_PRIORITY */, primaryText: "Low Priority" }),
	                    React.createElement(material_ui_1.MenuItem, { key: "high", value: 3 /* HIGH_PRIORITY */, primaryText: "High Priority" }),
	                    React.createElement(material_ui_1.MenuItem, { key: "sponsorship", value: 4 /* SPONSORSHIP */, primaryText: "Sponsorship" }),
	                    React.createElement(material_ui_1.MenuItem, { key: "none", value: null, primaryText: "Bucket Priority", disabled: true })),
	                React.createElement(material_ui_1.TextField, { type: "number", key: "campaignEcpm", style: __assign({}, draftDetailsStyle_1.styles.width33, { marginLeft: '5px' }), value: eCpm, disabled: this.props.ecpmDisabled, hintText: "Campaign eCPM", onChange: function (e, newValue) {
	                        return _this.onChange('campaignEcpm', e, newValue);
	                    }, errorText: eCpm < 0.01 ? 'must be greater than or equal to 0.01' : null })))) : null;
	        var campaignObjectiveDSP = draft.peek &&
	            4 /* SPONSORED */ === draft.type &&
	            isDspCampaign ? (React.createElement("div", null,
	            React.createElement(material_ui_1.DropDownMenu, { value: selectedObjective, onChange: this.handleCampaignObjectiveChange, disabled: !editable, style: __assign({}, draftDetailsStyle_1.styles.width40, draftDetailsStyle_1.styles.marginTopLeft) },
	                React.createElement(material_ui_1.MenuItem, { value: null, primaryText: "Campaign Objective", style: draftDetailsStyle_1.styles.dropdownHeader }),
	                AdPersonalisationList.map(function (objective) {
	                    return (React.createElement(material_ui_1.MenuItem, { key: objective, value: objective, primaryText: objective }));
	                })),
	            React.createElement(material_ui_1.DropDownMenu, { style: __assign({}, draftDetailsStyle_1.styles.width33), value: draft.bucketPriority, disabled: !editable || this.props.bucketPriorityDisabled, onChange: this.handleBucketPriorityChange },
	                React.createElement(material_ui_1.MenuItem, { key: "house", value: 0 /* HOUSE */, primaryText: "House" }),
	                React.createElement(material_ui_1.MenuItem, { key: "price", value: 1 /* PRICE_PRIORITY */, primaryText: "Price Priority" }),
	                React.createElement(material_ui_1.MenuItem, { key: "low", value: 2 /* LOW_PRIORITY */, primaryText: "Low Priority" }),
	                React.createElement(material_ui_1.MenuItem, { key: "high", value: 3 /* HIGH_PRIORITY */, primaryText: "High Priority" }),
	                React.createElement(material_ui_1.MenuItem, { key: "sponsorship", value: 4 /* SPONSORSHIP */, primaryText: "Sponsorship" }),
	                React.createElement(material_ui_1.MenuItem, { key: "none", value: null, primaryText: "Bucket Priority", disabled: true })))) : null;
	        var OmSdkInfoFields = glanceDraftData.peek && glanceDraftData.peek.nativeVideoUrl ? (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.width100, draftDetailsStyle_1.styles.spacedRow) },
	            React.createElement(material_ui_1.DropDownMenu, { style: __assign({}, draftDetailsStyle_1.styles.width33, { marginLeft: '-23px' }), value: glanceDraftData.omSdkInfo &&
	                    glanceDraftData.omSdkInfo.type != null
	                    ? glanceDraftData.omSdkInfo.type
	                    : null, disabled: !editable, onChange: this.handleOmSdkInfoType },
	                React.createElement(material_ui_1.MenuItem, { value: null, primaryText: "OMSDK Type" }),
	                React.createElement(material_ui_1.MenuItem, { key: "Advertiser", value: 0 /* ADVERTISER */, primaryText: "Advertiser" }),
	                React.createElement(material_ui_1.MenuItem, { key: "Sponsored", value: 1 /* SPONSORED */, primaryText: "Sponsored" })),
	            React.createElement(material_ui_1.TextField, { key: "validationUrl", style: __assign({}, draftDetailsStyle_1.styles.width20, draftDetailsStyle_1.styles.flagButton), defaultValue: glanceDraftData.omSdkInfo &&
	                    glanceDraftData.omSdkInfo.validationUrl
	                    ? glanceDraftData.omSdkInfo.validationUrl
	                    : '', hintText: "Validation Url", onChange: function (e, newValue) {
	                    return _this.onChange('validationUrl', e, newValue);
	                } }),
	            React.createElement(material_ui_1.TextField, { key: "verificationParam", style: __assign({}, draftDetailsStyle_1.styles.width25, draftDetailsStyle_1.styles.flagButton), defaultValue: glanceDraftData.omSdkInfo &&
	                    glanceDraftData.omSdkInfo.verificationParam
	                    ? glanceDraftData.omSdkInfo.verificationParam
	                    : '', hintText: "Verification Param", onChange: function (e, newValue) {
	                    return _this.onChange('verificationParam', e, newValue);
	                } }),
	            React.createElement(material_ui_1.TextField, { key: "vendorKey", style: __assign({}, draftDetailsStyle_1.styles.width20, draftDetailsStyle_1.styles.flagButton), defaultValue: glanceDraftData.omSdkInfo && glanceDraftData.omSdkInfo.vendorKey
	                    ? glanceDraftData.omSdkInfo.vendorKey
	                    : '', hintText: "Vendor Key", onChange: function (e, newValue) { return _this.onChange('vendorKey', e, newValue); } }))) : null;
	        var glanceContext = (React.createElement(material_ui_1.DropDownMenu, { style: __assign({}, draftDetailsStyle_1.styles.width33, { marginLeft: '-23px' }), value: glanceDraftData.peek && glanceDraftData.peek.glanceContext != null
	                ? glanceDraftData.peek.glanceContext
	                : null, disabled: !editable, onChange: this.handleGlanceContextChange },
	            React.createElement(material_ui_1.MenuItem, { value: null, primaryText: "GlanceContext" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Live", value: 0 /* LIVE */, primaryText: "Live" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Featured", value: 1 /* FEATURED */, primaryText: "Featured" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Launch", value: 2 /* LAUNCH */, primaryText: "Launch" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Nearby", value: 3 /* NEARBY */, primaryText: "Nearby" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Exclusive", value: 8 /* EXCLUSIVE */, primaryText: "Exclusive" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Fun", value: 9 /* FUN */, primaryText: "Fun" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Hatke", value: 7 /* HATKE */, primaryText: "Hatke" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Hot", value: 5 /* HOT */, primaryText: "Hot" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Popular", value: 10 /* POPULAR */, primaryText: "Popular" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Viral", value: 4 /* VIRAL */, primaryText: "Viral" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Trending", value: 6 /* TRENDING */, primaryText: "Trending" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Breaking News", value: 11 /* BREAKING_NEWS */, primaryText: "Breaking News" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Category", value: 12 /* CATEGORY */, primaryText: "Category" }),
	            React.createElement(material_ui_1.MenuItem, { key: "Shopping", value: 13 /* SHOPPING */, primaryText: "Shopping" })));
	        function glance_context(context) {
	            switch (context) {
	                case 0:
	                    return 'Live';
	                case 1:
	                    return 'Featured';
	                case 2:
	                    return 'Launch';
	                case 3:
	                    return 'Nearby';
	                case 4:
	                    return 'Viral';
	                case 5:
	                    return 'Hot';
	                case 6:
	                    return 'Trending';
	                case 7:
	                    return 'Hatke';
	                case 8:
	                    return 'Exclusive';
	                case 9:
	                    return 'Fun';
	                case 10:
	                    return 'Popular';
	                case 11:
	                    return 'Breaking News';
	                case 12:
	                    return 'Category';
	                case 13:
	                    return 'Shopping';
	                default:
	                    return 'GlanceContext';
	            }
	        }
	        var ctaType = null;
	        if (glanceDraftData.type &&
	            (glanceDraftData.type === 4 /* SPONSORED */ ||
	                glanceDraftData.type === 2 /* STORY */)) {
	            ctaType = (React.createElement(material_ui_1.DropDownMenu, { style: __assign({}, draftDetailsStyle_1.styles.width33, { marginLeft: '-24px' }), value: glanceDraftData.peek && glanceDraftData.peek.ctaType != null
	                    ? glanceDraftData.peek.ctaType
	                    : 1 /* CTA_URL */, onChange: this.handleCtaTypeChange, disabled: !editable },
	                React.createElement(material_ui_1.MenuItem, { key: "OPEN_URL", value: 1 /* CTA_URL */, primaryText: "OPEN_URL" }),
	                React.createElement(material_ui_1.MenuItem, { key: "INSTALL_APP", value: 2 /* APP_INSTALL */, primaryText: "INSTALL_APP" })));
	        }
	        var error = (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.emojiErrorCont) },
	            React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.errorCont) },
	                React.createElement(Ban_1.Ban, null)),
	            React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.errorCont) },
	                React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.errorBold) }, "Error"),
	                React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.errorMessage) }, "Same emojis selected"))));
	        var emoji = this.props.glanceDraftData.peek.tvVideoPeek && (React.createElement("div", { style: {
	                display: 'flex',
	                height: '48px',
	                alignItems: 'flex-end'
	            } },
	            this.state.currEmojis.map(function (emoji, idx) { return (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.contextualEmoji, (_this.state.sameEmoji === emoji.id && __assign({}, draftDetailsStyle_1.styles.errorBorder))), key: "" + emoji.id + idx, onClick: function (e) { return _this.handleEmojiClick(emoji, e, idx); }, onMouseEnter: function () {
	                    return _this.setState(__assign({}, _this.state, { hoveredEmoji: idx }));
	                }, onMouseLeave: function () {
	                    return _this.setState(__assign({}, _this.state, { hoveredEmoji: null }));
	                } },
	                emoji.mediaType === EMOJI_FORMAT.LOTTIE ? (React.createElement(LottieWrapper_1.LottieAnimation, { url: emoji.cdnUrl })) : (React.createElement("img", { src: emoji.cdnUrl, width: '32px', height: '32px', alt: '', style: {
	                        // borderRadius: '50%',
	                        objectFit: 'contain'
	                    } })),
	                React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.emojiHoverWrapper, (_this.state.hoveredEmoji !== null &&
	                        _this.state.hoveredEmoji === idx && {
	                        visibility: 'visible'
	                    })) },
	                    React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.emojiEditWrapper, { justifyContent: 'center' }) },
	                        React.createElement(Pencil_1.Pencil, null))))); }),
	            React.createElement(Popover_1["default"], { open: this.state.showPopover, anchorEl: this.state.selectedEmoji.target, anchorOrigin: { horizontal: 'right', vertical: 'top' }, targetOrigin: { horizontal: 'left', vertical: 'bottom' }, onRequestClose: function () {
	                    return _this.setState(__assign({}, _this.state, { showPopover: false, emojiUploadError: [] }));
	                }, style: __assign({}, draftDetailsStyle_1.styles.popoverStyle) },
	                React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.popoverUpper) },
	                    React.createElement("span", { style: __assign({}, draftDetailsStyle_1.styles.emojiHeading) }, "Select an emoji"),
	                    React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.fileuploadImg) },
	                        React.createElement("label", { htmlFor: "file-input", style: { marginBottom: 0 } },
	                            React.createElement(FileUpload_1.FileUpload, null)),
	                        React.createElement("input", { id: "file-input", type: "file", accept: ".png,.svg,.json,.gif", style: { display: 'none' }, multiple: true, onChange: function (e) {
	                                _this.handleFileUpload(e);
	                            } }))),
	                React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.popoverEmojiContainer) },
	                    React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.popoverCenter) },
	                        React.createElement(material_ui_1.Divider, { style: __assign({}, draftDetailsStyle_1.styles.popoverhr) }),
	                        this.state.emojiUploadError.length > 0 && (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.emojiUploadErrorMessageContainer) }, this.state.emojiUploadError.map(function (error) { return (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.emojiUploadErrorMessage) }, error.message)); }))),
	                        React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.emojiPopoverContainer) }, this.state.allEmojis.length > 0 &&
	                            this.state.allEmojis.map(function (emoji) { return (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.emojiStyling) },
	                                emoji.mediaType === EMOJI_FORMAT.LOTTIE ? (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.emojiInnerMargin), onClick: function () {
	                                        return _this.setState(__assign({}, _this.state, { chosenEmoji: emoji }));
	                                    } },
	                                    React.createElement(LottieWrapper_1.LottieAnimation, { url: emoji.cdnUrl }))) : (React.createElement("img", { src: emoji.cdnUrl, width: '32px', height: '32px', onClick: function () {
	                                        return _this.setState(__assign({}, _this.state, { chosenEmoji: emoji }));
	                                    }, alt: "", style: __assign({}, draftDetailsStyle_1.styles.popoverEmojimr, { objectFit: 'contain' }) })),
	                                _this.state.chosenEmoji &&
	                                    _this.state.chosenEmoji.id === emoji.id && (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.chosenEmoji) },
	                                    React.createElement(Selected_1.Selected, null))))); }))),
	                    React.createElement("div", null,
	                        this.state.fileUploadError && (React.createElement("div", { style: { textAlign: 'center' } }, " File Upload error ")),
	                        React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.popoverButtonContainer) },
	                            React.createElement("button", { style: __assign({}, draftDetailsStyle_1.styles.popoverCancelBtn), onClick: function () {
	                                    return _this.setState(__assign({}, _this.state, { showPopover: false, emojiUploadError: [] }));
	                                } }, "Cancel"),
	                            React.createElement("button", { style: __assign({}, draftDetailsStyle_1.styles.popoverReplaceBtn), onClick: function () {
	                                    return _this.handleReplaceEmoji(_this.state.chosenEmoji);
	                                } }, "Replace")))))));
	        var gamPgAdUnitId = isSponsoredGlance && (React.createElement(material_ui_1.TextField, { key: "gamPgAdUnitId", style: draftDetailsStyle_1.styles.width100, hintText: "GAM PG Adunit Id", defaultValue: draft.gamPgAdUnitId, onChange: function (e, newValue) { return _this.onChange('gamPgAdUnitId', e, newValue); } }));
	        var isShoppable = (React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.clickableChip, key: 'isShoppable', backgroundColor: draft.isShoppable ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.handleIsShoppable(!draft.isShoppable);
	            } }, draft.isShoppable ? 'Shoppable' : 'Not Shoppable'));
	        var shoppableData = null;
	        if (glanceDraftData.type && glanceDraftData.isShoppable) {
	            shoppableData = (React.createElement("div", null,
	                React.createElement(material_ui_1.TextField, { key: "iconToolTip", style: draftDetailsStyle_1.styles.width100, hintText: "Icon Tool Tip", defaultValue: draft.shoppableData.iconToolTip, onChange: function (e, newValue) {
	                        return _this.onChange('iconToolTip', e, newValue);
	                    } }),
	                React.createElement(material_ui_1.TextField, { key: "iconImageUrl", style: draftDetailsStyle_1.styles.width100, hintText: "Icon Image Url", defaultValue: draft.shoppableData.iconImageUrl, onChange: function (e, newValue) {
	                        return _this.onChange('iconImageUrl', e, newValue);
	                    } }),
	                React.createElement(material_ui_1.TextField, { key: "shoppingUrl", style: draftDetailsStyle_1.styles.width100, hintText: "Shopping Url", defaultValue: draft.shoppableData.shoppingUrl, onChange: function (e, newValue) {
	                        return _this.onChange('shoppingUrl', e, newValue);
	                    } }),
	                React.createElement(material_ui_1.TextField, { key: "offlineShoppingZipUrl", style: draftDetailsStyle_1.styles.width100, hintText: "Offline Shopping Zip Url", defaultValue: draft.shoppableData.offlineShoppingZipUrl, onChange: function (e, newValue) {
	                        return _this.onChange('offlineShoppingZipUrl', e, newValue);
	                    } })));
	        }
	        var userAgeFilterTpl = (React.createElement(material_ui_1.GridList, { cellHeight: "auto" },
	            React.createElement(material_ui_1.GridTile, null,
	                React.createElement(material_ui_1.SelectField, { value: userLifeTimeFilter && userLifeTimeFilter.startDay !== null
	                        ? userLifeTimeFilter.startDay
	                        : null, onChange: function (field, context, value) {
	                        return _this.handleGlanceUserAgeFilterChange(value, 'startDay');
	                    } },
	                    React.createElement(material_ui_1.MenuItem, { key: "startDay--1", value: null, primaryText: "All Users" }),
	                    startDays.map(function (stday) { return (React.createElement(material_ui_1.MenuItem, { key: "startDay-" + stday, value: stday, primaryText: stday <= 7 ? stday : stday - 1 + "+" })); }))),
	            React.createElement(material_ui_1.GridTile, null,
	                React.createElement(material_ui_1.SelectField, { value: userLifeTimeFilter && userLifeTimeFilter.endDay
	                        ? userLifeTimeFilter.endDay
	                        : null, disabled: !userLifeTimeFilter.startDay ||
	                        userLifeTimeFilter.startDay === 8 ||
	                        userLifeTimeFilter.startDay === -1, onChange: function (feild, context, value) {
	                        return _this.handleGlanceUserAgeFilterChange(value, 'endDay');
	                    } },
	                    React.createElement(material_ui_1.MenuItem, { key: "engDay-null", value: null, primaryText: "End Day" }),
	                    endDays.map(function (endDay) { return (React.createElement(material_ui_1.MenuItem, { key: "endDay-" + endDay, value: endDay, primaryText: endDay })); })))));
	        var shareContent = (React.createElement("div", null,
	            React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip, (isSponsoredGlance
	                    ? { opacity: 0.4, pointerEvents: 'none' }
	                    : {})), key: 'is_shareable', backgroundColor: draft.isShareable ? colors_1.blue300 : null, onTouchTap: function () {
	                    !isSponsoredGlance && _this.handleIsShareable(!draft.isShareable);
	                } }, draft.isShareable ? 'Shareable' : 'Not Shareable'),
	            React.createElement(material_ui_1.TextField, { key: "ShareUrl", style: draftDetailsStyle_1.styles.width83, hintText: "Share Url", defaultValue: draft.shareUrl, disabled: !draft.isShareable, onChange: function (e, newValue) { return _this.onChange('shareUrl', e, newValue); } })));
	        var homescreenWorthyElem = (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip), key: 'homescreenWorthy', backgroundColor: draft.homescreenWorthy ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.handleHomeScreenWorthy(!draft.homescreenWorthy);
	            } }, draft.homescreenWorthy ? 'Homescreenworthy' : 'Not Homescreenworthy'));
	        var allowKeyboardElem = (React.createElement(react_lightweight_tooltip_1.Tooltip, { content: "Keep this off for using the virtual keyboard", styles: __assign({}, draftDetailsStyle_1.styles.width33, draftDetailsStyle_1.styles.tooltipStyle) },
	            React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip), key: 'allowKeyboard', backgroundColor: draft.allowKeyboard ? colors_1.blue300 : null, onTouchTap: function () {
	                    _this.handleAllowKeyboard(!draft.allowKeyboard);
	                } }, 'Allow Keyboard < 8.19')));
	        var allowNativeKeyboardElem = (React.createElement(react_lightweight_tooltip_1.Tooltip, { content: "Keep this off for using the virtual keyboard", styles: __assign({}, draftDetailsStyle_1.styles.width33, draftDetailsStyle_1.styles.tooltipStyle) },
	            React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip), key: 'allowNativeKeyboard', backgroundColor: draft.allowNativeKeyboard ? colors_1.blue300 : null, onTouchTap: function () {
	                    _this.handleAllowNativeKeyboard(!draft.allowNativeKeyboard);
	                } }, 'Allow Keyboard >= 8.19')));
	        var dynamicOverlayElem = (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip), key: 'dynamicOverlay', backgroundColor: draft.dynamicOverlay ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.handleDynamicOverlay(!draft.dynamicOverlay);
	            } }, draft.dynamicOverlay ? 'Dynamic Overlay' : 'No Dynamic Overlay'));
	        var gPayReadinessElem = (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip), key: 'gPayReadiness', backgroundColor: draft.targeting && draft.targeting.requiresGPayReadiness
	                ? colors_1.blue300
	                : null, onTouchTap: function () {
	                _this.handleGPayReadiness(draft.targeting && draft.targeting.requiresGPayReadiness
	                    ? !draft.targeting.requiresGPayReadiness
	                    : true);
	            } }, draft.targeting && draft.targeting.requiresGPayReadiness
	            ? 'GPay Required'
	            : 'GPay Not Required'));
	        var childLockFlagElem = (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip), key: 'childlockflag', backgroundColor: draft.targeting && draft.targeting.childLockFlag ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.handleChildLockFlag(draft.targeting && draft.targeting.childLockFlag
	                    ? !draft.targeting.childLockFlag
	                    : true);
	            } }, draft.targeting && draft.targeting.childLockFlag
	            ? 'Childlock flag Off'
	            : 'Childlock flag On'));
	        var useUnlockNudgeElem = isSponsoredGlance && (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip), key: 'useUnlockNudge', backgroundColor: draft && draft.useUnlockNudge ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.handleUseUnlockNudge(draft && draft.useUnlockNudge
	                    ? !draft.useUnlockNudge
	                    : true);
	            } }, draft && draft.useUnlockNudge
	            ? 'Unlock Nudge'
	            : 'No Unlock Nudge'));
	        var dspRetargetingElem = glanceDraftData.type && glanceDraftData.type == 4 /* SPONSORED */ ? (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip), key: 'dspRetargeting', backgroundColor: draft.targeting && draft.targeting.enableDSPRetargeting
	                ? colors_1.blue300
	                : null, onTouchTap: function () {
	                _this.handleDspRetargeting(draft.targeting && draft.targeting.enableDSPRetargeting
	                    ? !draft.targeting.enableDSPRetargeting
	                    : true);
	            } }, draft.targeting && draft.targeting.enableDSPRetargeting
	            ? 'DSP Retargeting'
	            : 'No DSP Retargeting')) : null;
	        var getFileFormat = function (url) {
	            return url
	                .split(/\#|\?/)[0]
	                .split('.')
	                .pop()
	                .trim();
	        };
	        var showNativeOverflow = draft.peek &&
	            draft.peek.videoUrl &&
	            (getFileFormat(draft.peek.videoUrl) === 'mp4' ||
	                getFileFormat(draft.peek.videoUrl) === 'webm');
	        var videoOverflowElem = showNativeOverflow ? (React.createElement("div", null,
	            React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.clickableChip, key: 'shouldOverflow', backgroundColor: draft.peek.nativeVideoOverflow ? colors_1.blue300 : null, onTouchTap: function () {
	                    _this.handleNativeOverflow(!draft.peek.nativeVideoOverflow);
	                } }, draft.peek.nativeVideoOverflow ? 'Native Overflow' : 'No Overflow'))) : null;
	        var hardwareAccelerated = draft.peek && draft.peek.webPeekUrl ? (React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.clickableChip, key: 'hardware_accelerated', backgroundColor: draft.peek.hardwareAccelerated ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.handleHardwareAccelerated(!draft.peek.hardwareAccelerated);
	            } }, draft.peek.hardwareAccelerated
	            ? 'Advanced peek webview'
	            : 'Not advanced peek webview')) : null;
	        var loadAndroidJs = draft.peek && !draft.peek.webPeekUrl ? (React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.clickableChip, key: 'load_android_js', backgroundColor: draft.peek.loadAndroidJs ? colors_1.blue300 : null, onTouchTap: function () {
	                _this.handleLoadAndroidJs(!draft.peek.loadAndroidJs);
	            } }, draft.peek.loadAndroidJs
	            ? 'Advanced CTA webview'
	            : 'Not advanced CTA webview')) : null;
	        var s2sIntegration = !draft.beaconsInfo
	            ? false
	            : draft.beaconsInfo.s2sIntegration;
	        var beaconEntry = glanceDraftData.type &&
	            (glanceDraftData.type === 4 /* SPONSORED */ ||
	                glanceDraftData.type === 2 /* STORY */) ? (React.createElement("div", { style: {
	                display: 'flex',
	                flexDirection: 'row',
	                flexGrow: 1,
	                flexWrap: 'wrap',
	                justifyContent: 'space-between',
	                alignItems: 'flex-end'
	            } },
	            React.createElement(material_ui_1.TextField, { key: "BeaconUrl", errorText: this.state.beaconError || null, style: __assign({}, draftDetailsStyle_1.styles.width100, { float: 'left' }), hintText: "BeaconUrl", onChange: function (e, newValue) { return _this.handleBeaconUrlChange(newValue); }, defaultValue: this.state.beaconUrl, multiLine: true, rows: 1, rowsMax: 4 }),
	            React.createElement(material_ui_1.DropDownMenu, { value: this.state.beaconType, style: __assign({}, draftDetailsStyle_1.styles.width33, { maxWidth: 'none', paddingBottom: '6px', float: 'left', marginLeft: '-24px' }), disabled: !editable, onChange: this.handleBeaconTypeChange },
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.RENDER, primaryText: "Render Beacon" }),
	                this.state.linkType == 'videoUrl' ? (React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.VIDEO, primaryText: "Video Beacon" })) : null,
	                this.state.linkType == 'videoUrl' ||
	                    (glanceDraftData.peek && glanceDraftData.peek.videoCtaUrl) ||
	                    this.state.linkType == 'ctaUrl' ||
	                    this.state.linkType == 'webPeekUrl' ? (React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.CTA, primaryText: "Cta Beacon" })) : null,
	                draft.peek ? (React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.PEEK, primaryText: "Peek Beacon" })) : null,
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.LIKE, primaryText: "Like Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.SHARE, primaryText: "Share Beacon" }),
	                glanceDraftData.type === 4 /* SPONSORED */ && (React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.VIDEO_STARTED, primaryText: "Video Started Beacon" })),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.HOLD, primaryText: "Hold Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.APP_SUBMIT, primaryText: "App Submit Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.INSTALL_NOW, primaryText: "Install Now Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.INSTALL_LATER, primaryText: "Install Later Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.INSTALL_COMPLETE, primaryText: "Install Complete Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.APP_OPEN, primaryText: "App Open Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.GLANCE_STARTED, primaryText: "Glance Started Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.PRIVIEW_TAP, primaryText: "Priview Tap Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.VIDEO_VIEWED, primaryText: "Video Viewed Beacon" }),
	                React.createElement(material_ui_1.MenuItem, { value: types_1.BeaconType.GLANCE_VIEWED, primaryText: "Glance Viewed Beacon" })),
	            React.createElement(material_ui_1.DropDownMenu, { value: this.state.beaconPartner, style: __assign({}, draftDetailsStyle_1.styles.width33, { width: '35%', maxWidth: 'none', paddingBottom: '6px', float: 'left', marginLeft: '-24px' }), disabled: !editable, onChange: this.handleBeaconPartnerChange },
	                React.createElement(material_ui_1.MenuItem, { value: '', primaryText: "Tracking Partner" }),
	                Constants_1["default"].BEACON_PARTNERS.map(function (each) { return (React.createElement(material_ui_1.MenuItem, { value: each, primaryText: each })); })),
	            this.state.beaconType === types_1.BeaconType.GLANCE_STARTED && (React.createElement(material_ui_1.TextField, { key: "DelayDurationInMillis", style: __assign({ maxWidth: 'none' }, draftDetailsStyle_1.styles.width17, { float: 'left' }), hintText: "Delay(ms)", type: "number", onChange: function (e, newValue) {
	                    return _this.handleDelayDurationInMillis(Number(newValue));
	                }, defaultValue: this.state.delayDurationInMillis })),
	            React.createElement(material_ui_1.TextField, { key: "MinDurationInSecs", disabled: !(this.state.beaconType == types_1.BeaconType.RENDER ||
	                    this.state.beaconType == types_1.BeaconType.VIDEO_VIEWED ||
	                    this.state.beaconType == types_1.BeaconType.GLANCE_VIEWED), style: __assign({ maxWidth: 'none' }, draftDetailsStyle_1.styles.width17, { float: 'left' }), hintText: "duration", type: "number", onChange: function (e, newValue) {
	                    return _this.handleMinDurationInSecsChange(Number(newValue));
	                }, defaultValue: this.state.minDurationInSecs }),
	            React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip, draftDetailsStyle_1.styles.width17, { height: 'fit-content', textAlign: 'center', margin: '12px 0 6px 4px' }), onTouchTap: this.addBeacon }, "ADD"),
	            this.state.beacons ? (React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.clickableChip, { height: 'fit-content', margin: '12px 0 6px 4px' }), key: 's2sIntegration', backgroundColor: s2sIntegration ? colors_1.blue300 : null, onTouchTap: function () {
	                    _this.handleS2sIntegration(!s2sIntegration);
	                } }, s2sIntegration
	                ? 'S2S Integration Enabled'
	                : 'S2S Integration Disabled')) : null)) : null;
	        var totalImpressionRequired = (React.createElement(material_ui_1.TextField, { key: "totalImpressionRequired", style: __assign({}, draftDetailsStyle_1.styles.width50), defaultValue: draft.impressionCappingData &&
	                draft.impressionCappingData.totalImpressionRequired
	                ? draft.impressionCappingData.totalImpressionRequired
	                : null, hintText: "Total Impression Required", type: "number", onChange: function (e, newValue) { return _this.handleImpressionRequired(e, newValue); }, disabled: !draft.impressionCappingData &&
	                this.state.publishValue === 8 /* PUBLISHED */ }));
	        var glanceTimer = (React.createElement("div", null,
	            React.createElement(material_ui_1.TextField, { key: "glanceTimer", style: __assign({}, draftDetailsStyle_1.styles.width50), defaultValue: draft.glanceBubbleDetails && draft.glanceBubbleDetails.glanceTimer
	                    ? draft.glanceBubbleDetails.glanceTimer / 1000
	                    : null, hintText: "Glance Timer (in sec)", disabled: !editable, onChange: function (e, newValue) { return _this.onChange('glanceTimer', e, newValue); }, type: "number" })));
	        var triggerPercentage = this.state.showTriggerPercentage ||
	            (draft.impressionCappingData &&
	                draft.impressionCappingData.totalImpressionRequired) ? (React.createElement("div", { style: draftDetailsStyle_1.styles.servingCappingWrapper },
	            React.createElement(material_ui_1.TextField, { key: "triggerPercentage", style: __assign({}, draftDetailsStyle_1.styles.width45, draftDetailsStyle_1.styles.flagButton), defaultValue: draft.impressionCappingData &&
	                    draft.impressionCappingData.triggerPercentage
	                    ? draft.impressionCappingData.triggerPercentage
	                    : null, type: "percentage", hintText: "Trigger Percentage", onChange: function (e, newValue) {
	                    return _this.onChange('triggerPercentage', e, newValue);
	                } }),
	            React.createElement(material_ui_1.Chip, { style: __assign({}, draftDetailsStyle_1.styles.chipStyle, draftDetailsStyle_1.styles.width45), key: 'servingCappingEnabled', backgroundColor: draft.impressionCappingData.servingCappingEnabled ? colors_1.blue300 : null, onTouchTap: function () {
	                    _this.handleServingCappingEnabled(!draft.impressionCappingData.servingCappingEnabled);
	                } }, draft.impressionCappingData.servingCappingEnabled
	                ? 'Serving Capping Enable'
	                : 'Serving Capping Disable'))) : null;
	        var beaconTable = this.state.beacons &&
	            glanceDraftData.type &&
	            (glanceDraftData.type == 4 /* SPONSORED */ ||
	                glanceDraftData.type == 2 /* STORY */) ? (React.createElement(Table_1.Table, { key: "beaconTable", multiSelectable: false, selectable: false, style: __assign({}, draftDetailsStyle_1.styles.width100, { height: '100%', display: 'inline-block' }) },
	            React.createElement(Table_1.TableHeader, { key: "beaconTableHeader", style: __assign({}, draftDetailsStyle_1.styles.width100), adjustForCheckbox: false, displaySelectAll: false },
	                React.createElement(Table_1.TableHeaderColumn, { style: {
	                        maxWidth: '150px',
	                        wordWrap: 'break-word',
	                        padding: '0px 10px 0 0'
	                    } },
	                    "Beacon type",
	                    React.createElement("br", null),
	                    "and partner"),
	                React.createElement(Table_1.TableHeaderColumn, { style: {
	                        width: '300px',
	                        maxWidth: '300px',
	                        wordWrap: 'break-word',
	                        padding: '0 10px',
	                        textAlign: 'center'
	                    } }, "Beacon Url"),
	                React.createElement(Table_1.TableHeaderColumn, { style: {
	                        width: '26px',
	                        wordWrap: 'break-word',
	                        padding: '0 10px'
	                    } }),
	                React.createElement(Table_1.TableHeaderColumn, { style: {
	                        width: '100px',
	                        maxWidth: '100px',
	                        wordWrap: 'break-word',
	                        paddingLeft: 0
	                    } }, "Duration(Minimum/Delay)"),
	                React.createElement(Table_1.TableHeaderColumn, { style: {
	                        width: '80px',
	                        maxWidth: '80px',
	                        wordWrap: 'break-word',
	                        padding: '0 10px'
	                    } })),
	            React.createElement(Table_1.TableBody, { key: "beaconTableBody", displayRowCheckbox: false, style: __assign({}, draftDetailsStyle_1.styles.width100) },
	                this.state.beacons && this.state.beacons.renderBeacons
	                    ? this.state.beacons.renderBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.RENDER, beaconList: glanceDraftData.beacons.renderBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.videoBeacons
	                    ? this.state.beacons.videoBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.VIDEO, beaconList: glanceDraftData.beacons.videoBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.peekBeacons
	                    ? this.state.beacons.peekBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.PEEK, beaconList: glanceDraftData.beacons.peekBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.ctaBeacons
	                    ? this.state.beacons.ctaBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.CTA, beaconList: glanceDraftData.beacons.ctaBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.likeBeacons
	                    ? this.state.beacons.likeBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.LIKE, beaconList: glanceDraftData.beacons.likeBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.shareBeacons
	                    ? this.state.beacons.shareBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.SHARE, beaconList: glanceDraftData.beacons.shareBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.videoStartedBeacons
	                    ? this.state.beacons.videoStartedBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.VIDEO_STARTED, beaconList: glanceDraftData.beacons.videoStartedBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.holdBeacons
	                    ? this.state.beacons.holdBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.HOLD, beaconList: glanceDraftData.beacons.holdBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.appSubmitBeacons
	                    ? this.state.beacons.appSubmitBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.APP_SUBMIT, beaconList: glanceDraftData.beacons.appSubmitBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.installNowBeacons
	                    ? this.state.beacons.installNowBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.INSTALL_NOW, beaconList: glanceDraftData.beacons.installNowBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.installLaterBeacons
	                    ? this.state.beacons.installLaterBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.INSTALL_LATER, beaconList: glanceDraftData.beacons.installLaterBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.installCompleteBeacons
	                    ? this.state.beacons.installCompleteBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.INSTALL_COMPLETE, beaconList: glanceDraftData.beacons.installCompleteBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.appOpenBeacons
	                    ? this.state.beacons.appOpenBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.APP_OPEN, beaconList: glanceDraftData.beacons.appOpenBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.glanceStartedBeacons
	                    ? this.state.beacons.glanceStartedBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.GLANCE_STARTED, beaconList: glanceDraftData.beacons.glanceStartedBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.previewTapBeacons
	                    ? this.state.beacons.previewTapBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.PRIVIEW_TAP, beaconList: glanceDraftData.beacons.previewTapBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.videoViewedBeacons
	                    ? this.state.beacons.videoViewedBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.VIDEO_VIEWED, beaconList: glanceDraftData.beacons.videoViewedBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null,
	                this.state.beacons && this.state.beacons.glanceViewedBeacons
	                    ? this.state.beacons.glanceViewedBeacons.map(function (n, i) {
	                        return (React.createElement(BeaconTableRow_1["default"], { beaconType: types_1.BeaconType.GLANCE_VIEWED, beaconList: glanceDraftData.beacons.glanceViewedBeacons, index: i, beaconItem: n, removeBeacon: _this.removeBeacon, s2sFlag: s2sIntegration }));
	                    })
	                    : null))) : null;
	        var emojiSection = (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
	            glanceContext,
	            " ",
	            emoji,
	            " ",
	            this.state.sameEmoji && error));
	        var publishSection = (React.createElement("div", { style: { display: 'flex', padding: '5px 0px' } },
	            publisherOptions,
	            stickiness));
	        if (isDspCampaign) {
	            leftElements.push(title, shortTitle, summary, cheesySummary, priority, shouldUnlock, openInBg, glanceType, dspCampaign, glanceTimer);
	        }
	        else {
	            leftElements.push(warningTextGLAM, title, shortTitle, summary, cheesySummary, priority, shouldUnlock, openInBg, glanceType, dspCampaign, storyType, totalImpressionRequired, triggerPercentage, glanceTimer);
	        }
	        if (isDspCampaign) {
	            middleElements.push(peekLink, zipTypes, curationReason, lsSubtext, lockscreenCtaText, ctaText, afterOciAppSelect, sourceName, attributionSource, negativeAppList, negativeTargeting, positiveAppList, positiveTargeting, networkTargeting, bubbles, rank, campaignObjectiveDSP, canSkipSummary, sessionMode, publisherOptions, React.createElement(OCIAppList, null), NudgeWebUrl, NudgeCtaText, NudgeDescription, ShowNudge, isBeautifulWallpaper, // Not listed
	            NudgeMode, notificationEnabled, notificationIconUrl, notificationTitle, notificationDescription, notificationCtaText, shoppableData, // Not listed
	            useUnlockNudgeElem);
	        }
	        else {
	            middleElements.push(peekLink, offlinePeekLink, videoCtaUrl, zipTypes, articleCtaUrl, curationReason, lsSubtext, lockscreenCtaText, ctaText, afterOciAppSelect, CtaViewConfigHeight, ctaViewHideTopPadding, ctaViewHideCrossIcon, sourceName, hearts, attributionSource, contentTags, categories, euValuePropList, sourceCreatorId, cities, carriers, negativeAppList, negativeTargeting, positiveAppList, positiveTargeting, networkTargeting, segments, bubbles, rank, topicName, campaignObjective, languageLimit, canSkipSummary, dailyCap, weeklyCap, sessionMode, emojiSection, publishSection, antiSegments, beaconTable, beaconEntry, OmSdkInfoFields, ctaType, userAgeFilterTpl, targetForCategory, sdkSubscribedCategoriesFilter, shareContent, React.createElement(OCIAppList, null), AutoOpenWrapper, NudgeWebUrl, NudgeCtaText, NudgeDescription, ShowNudge, isHardWareAcceleration, isBeautifulWallpaper, NudgeMode, notificationEnabled, notificationIconUrl, notificationTitle, notificationDescription, notificationCtaText, channelType, cappingPacingCheck, advertiserId, creativeId, gamPgAdUnitId, homescreenWorthyElem, allowKeyboardElem, allowNativeKeyboardElem, dynamicOverlayElem, gPayReadinessElem, dspRetargetingElem, videoOverflowElem, hardwareAccelerated, loadAndroidJs, isShoppable, childLockFlagElem, shoppableData, useUnlockNudgeElem);
	        }
	        var nonDSPCountryFlags = [
	            { name: 'USA', code: 1 /* US */ },
	            { name: 'India', code: 2 /* IN */ },
	            { name: 'Indonesia', code: 5 /* ID */ },
	            { name: 'Australia', code: 24 /* AU */ },
	            { name: 'New Zealand', code: 25 /* NZ */ },
	            { name: 'Philippines', code: 11 /* PH */ },
	            { name: 'Singapore', code: 14 /* SG */ },
	            { name: 'Cambodia', code: 7 /* KH */ },
	            { name: 'Myanmar', code: 8 /* MM */ },
	            { name: 'Thailand', code: 15 /* TH */ },
	            { name: 'Vietnam', code: 17 /* VN */ },
	            { name: 'Malaysia', code: 10 /* MY */ },
	            { name: 'Global', code: 99 /* GLOBAL */ },
	            { name: 'Islamic', code: 97 /* ISLAMIC */ },
	            { name: 'Non Islamic', code: 98 /* NON_ISLAMIC */ },
	            { name: 'Mexico', code: 26 /* MX */ },
	            { name: 'Brazil', code: 27 /* BR */ },
	            { name: 'Colombia', code: 28 /* CO */ },
	            { name: 'Japan', code: 29 /* JP */ },
	            { name: 'Austria', code: 30 /* AT */ },
	            { name: 'Germany', code: 31 /* DE */ },
	            { name: 'Nigeria', code: 32 /* NG */ },
	        ];
	        var dspCountryFlags = [
	            { name: 'India', code: 2 /* IN */ },
	            { name: 'Indonesia', code: 5 /* ID */ },
	        ];
	        var countryFlags = isDspCampaign ? dspCountryFlags : nonDSPCountryFlags;
	        var isSelectedCountry = function (region) {
	            return draft.preferedRegions
	                ? draft.preferedRegions.indexOf(region) != -1
	                : false;
	        };
	        var countryListElm = (React.createElement("div", { style: draftDetailsStyle_1.styles.countryContainer }, countryFlags.map(function (country, countryIndex) {
	            return (React.createElement("span", { key: "country-" + countryIndex, style: isSelectedCountry(country.code)
	                    ? draftDetailsStyle_1.styles.selectedCountry
	                    : draftDetailsStyle_1.styles.unSelectedCountry, onClick: function (e) {
	                    _this.handleCountryChange(country.code, isSelectedCountry(country.code));
	                } }, country.name));
	        })));
	        if (isDspCampaign) {
	            rightElements.push(React.createElement("div", { style: { float: 'right' }, key: "actionButtons" },
	                React.createElement(material_ui_1.IconButton, { key: "saveButton", onClick: this.onSubmit, style: draftDetailsStyle_1.styles.actionButton, disabled: !editable || this.props.pristine },
	                    React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: this.props.pristine ? colors_1.grey500 : colors_1.indigo500, style: { fontSize: '2em' } }, "save")),
	                React.createElement(material_ui_1.IconButton, { key: "infoButton", onClick: this.onOverride, style: draftDetailsStyle_1.styles.actionButton, disabled: !editable || !this.props.pristine || userRole != 0 /* ADMIN */, tooltip: !this.props.pristine
	                        ? 'Save Pending'
	                        : userRole != 0 /* ADMIN */
	                            ? 'Not allowed'
	                            : null },
	                    React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.grey500, hoverColor: colors_1.cyan500, style: { fontSize: '2em' } }, "sync")),
	                React.createElement(material_ui_1.IconButton, { key: "publishButton", onClick: function () {
	                        _this.props.onPublish();
	                    }, style: draftDetailsStyle_1.styles.actionButton, disabled: publishButtonDisability, tooltip: publishButtonTooltipText },
	                    React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.grey500, hoverColor: colors_1.green500, style: { fontSize: '2em' } }, "publish")),
	                React.createElement(material_ui_1.IconButton, { key: "deleteButton", onClick: this.onRemove, style: draftDetailsStyle_1.styles.actionButton, disabled: !editable || userRole == 3 /* DESIGNER */ },
	                    React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.grey500, hoverColor: colors_1.red500, style: { fontSize: '2em' } }, "delete"))));
	        }
	        else {
	            rightElements.push(React.createElement("div", { style: { float: 'right' }, key: "actionButtons" },
	                React.createElement(material_ui_1.IconButton, { key: "saveButton", onClick: this.onSubmit, style: draftDetailsStyle_1.styles.actionButton, disabled: !editable || this.props.pristine },
	                    React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: this.props.pristine ? colors_1.grey500 : colors_1.indigo500, style: { fontSize: '2em' } }, "save")),
	                React.createElement(material_ui_1.IconButton, { key: "infoButton", onClick: this.onOverride, style: draftDetailsStyle_1.styles.actionButton, disabled: !editable || !this.props.pristine || userRole != 0 /* ADMIN */, tooltip: !this.props.pristine
	                        ? 'Save Pending'
	                        : userRole != 0 /* ADMIN */
	                            ? 'Not allowed'
	                            : null },
	                    React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.grey500, hoverColor: colors_1.cyan500, style: { fontSize: '2em' } }, "sync")),
	                React.createElement(material_ui_1.IconButton, { key: "publishButton", onClick: function () {
	                        _this.props.onPublish();
	                    }, style: draftDetailsStyle_1.styles.actionButton, disabled: publishButtonDisability, tooltip: publishButtonTooltipText },
	                    React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.grey500, hoverColor: colors_1.green500, style: { fontSize: '2em' } }, "publish")),
	                React.createElement(material_ui_1.IconButton, { key: "deleteButton", onClick: this.onRemove, style: draftDetailsStyle_1.styles.actionButton, disabled: !editable || userRole == 3 /* DESIGNER */ },
	                    React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.grey500, hoverColor: colors_1.red500, style: { fontSize: '2em' } }, "delete")),
	                React.createElement(material_ui_1.IconButton, { key: "pauseButton", onClick: function () { return _this.onPause(!draft.paused); }, style: draftDetailsStyle_1.styles.actionButton, disabled: draft.paused == null || !editable || userRole == 3 /* DESIGNER */, tooltip: draft.paused ? 'Resume Campaign' : 'Pause Campaign' },
	                    React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.grey500, hoverColor: colors_1.red500, style: { fontSize: '2em' } }, draft.paused ? 'replay' : 'pause'))));
	        }
	        if (this.props.detailed) {
	            return (React.createElement("div", { style: draftDetailsStyle_1.styles.width100 },
	                React.createElement("form", { className: "form", style: draftDetailsStyle_1.styles.form, onSubmit: this.onSubmit },
	                    React.createElement("div", { style: draftDetailsStyle_1.styles.detailsFull }, countryListElm),
	                    React.createElement("div", { style: draftDetailsStyle_1.styles.detailsLeft }, leftElements),
	                    React.createElement("div", { style: draftDetailsStyle_1.styles.detailsMiddle }, middleElements),
	                    React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.detailsRight) }, rightElements))));
	        }
	        else {
	            return (React.createElement("div", { style: draftDetailsStyle_1.styles.width100, "data-store": this.props },
	                React.createElement("div", { style: draftDetailsStyle_1.styles.leftDiv },
	                    React.createElement("div", null,
	                        React.createElement("span", { style: draftDetailsStyle_1.styles.spanLabel }, "Title: "),
	                        React.createElement("span", null, draft.peek ? draft.peek.title : ''),
	                        React.createElement("span", { style: __assign({}, draftDetailsStyle_1.styles.spanLabel, { marginLeft: '20px' }) },
	                            "ID:",
	                            React.createElement("a", { target: "_blank", href: '/#/' +
	                                    this.props.role +
	                                    '/drafts/draftIds/' +
	                                    draft.draftId }, draft.draftId)),
	                        draft.paused ? (React.createElement("span", { style: __assign({}, draftDetailsStyle_1.styles.disclaimer) }, "Campaign Paused")) : null),
	                    React.createElement("div", null,
	                        React.createElement("span", { style: draftDetailsStyle_1.styles.spanLabel }, "Short Title: "),
	                        React.createElement("span", null, draft.peek ? draft.peek.shortTitle : ''),
	                        React.createElement("span", { style: __assign({}, draftDetailsStyle_1.styles.spanLabel, { marginLeft: '20px' }) },
	                            "ID: ",
	                            draft.draftId),
	                        draft.peek && (React.createElement("span", { style: __assign({}, draftDetailsStyle_1.styles.spanLabel, { marginLeft: '20px' }) }, draft.peek.liveVideoPeek
	                            ? 'PeekType: Live'
	                            : draft.peek.nativeVideoUrl
	                                ? 'PeekType: Native'
	                                : ''))),
	                    warningTextGLAM,
	                    React.createElement("div", { style: { display: 'block' } },
	                        React.createElement("span", { style: draftDetailsStyle_1.styles.spanLabel }, "Peek Url:"),
	                        peekUrl ? (React.createElement("span", null,
	                            React.createElement("a", { href: peekUrl, target: "_blank" }, Utils_1["default"].truncate(peekUrl, 50)))) : null),
	                    draft.peek && draft.peek.summary ? (React.createElement("div", { style: { display: 'block' } },
	                        React.createElement("span", { style: draftDetailsStyle_1.styles.spanLabel }, "Summary: "),
	                        React.createElement("span", null, Utils_1["default"].truncate(draft.peek.summary, 75)))) : null,
	                    React.createElement("div", { style: { display: 'block' } },
	                        React.createElement("span", { style: __assign({}, draftDetailsStyle_1.styles.spanLabel) }, "Categories: "),
	                        React.createElement("span", { style: { display: 'inline-block', flexWrap: 'wrap' } }, draft.categoryIds
	                            ? draft.categoryIds.map(function (categoryId) {
	                                var category = _this.state.categoryMap.get(categoryId);
	                                var displayName = category == null
	                                    ? 'Not Supported'
	                                    : category.displayName;
	                                return (React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.readableChip, labelStyle: { lineHeight: '1.5em' }, key: categoryId }, displayName));
	                            })
	                            : 'None'),
	                        draft.priority > 0 ? (React.createElement("span", { style: {
	                                display: 'inline-block',
	                                flexWrap: 'wrap',
	                                marginLeft: '20px'
	                            } },
	                            React.createElement(material_ui_1.Chip //style={styles.highPriority}
	                            , { backgroundColor: draftDetailsStyle_1.highPriorityBackgroundColor, labelColor: draftDetailsStyle_1.highPriorityLabelColor, labelStyle: { lineHeight: '1.5em' } },
	                                draft.priority === 1 && 'High Priority 1',
	                                draft.priority === 2 && 'High Priority 2',
	                                draft.priority === 3 && 'Fixed Position 1'))) : null,
	                        draft.peek && draft.peek.ctaUrl ? (draft.peek.shouldUnlock ? (React.createElement("span", { style: {
	                                display: 'inline-block',
	                                flexWrap: 'wrap',
	                                marginLeft: '20px'
	                            } },
	                            React.createElement(material_ui_1.Chip, { backgroundColor: colors_1.blue300, labelStyle: { lineHeight: '1.5em' } }, "After Unlock"))) : (React.createElement("span", { style: {
	                                display: 'inline-block',
	                                flexWrap: 'wrap',
	                                marginLeft: '20px'
	                            } },
	                            React.createElement(material_ui_1.Chip //backgroundColor={blue300} //labelColor={highPriorityLabelColor}
	                            , { labelStyle: { lineHeight: '1.5em' } }, "On Lockscreen")))) : null),
	                    React.createElement("div", null,
	                        React.createElement("span", { style: draftDetailsStyle_1.styles.spanLabel }, "Session Mode: "),
	                        draft &&
	                            Utils_1["default"].getRenderSessionData(draft).map(function (renderSession) {
	                                return (React.createElement(material_ui_1.Chip, { style: draftDetailsStyle_1.styles.readableChip, labelStyle: { lineHeight: '1.5em' }, key: renderSession }, exports.sessionModeMapping[renderSession]));
	                            }),
	                        glanceDraftData.peek &&
	                            glanceDraftData.peek.glanceContext != null ? (React.createElement("span", null,
	                            React.createElement("span", { style: __assign({}, draftDetailsStyle_1.styles.spanLabel, { marginLeft: '20px' }) },
	                                "Glance Context:",
	                                ' '),
	                            React.createElement("span", null, glance_context(glanceDraftData.peek.glanceContext)))) : null,
	                        draft.publisherData ? (React.createElement("span", null,
	                            React.createElement("span", { style: __assign({}, draftDetailsStyle_1.styles.spanLabel, { marginLeft: '20px' }) },
	                                "Publisher:",
	                                ' '),
	                            React.createElement("span", null, draft.publisherData.displayName))) : null)),
	                React.createElement("div", { style: draftDetailsStyle_1.styles.rightTopCornerDiv },
	                    !this.props.pristine ? (React.createElement("div", { style: __assign({}, draftDetailsStyle_1.styles.disclaimer) }, "Some changes not saved")) : null,
	                    React.createElement("div", { style: { display: 'inline-block', margin: '0 10px' } },
	                        "Source: ",
	                        draft.peek ? draft.peek.sourceName : ''),
	                    React.createElement("div", { style: { display: 'inline-block', margin: '0 10px' } },
	                        draft.peek ? Utils_1["default"].getReadableNumber(draft.peek.heartCount) : '',
	                        ' ',
	                        React.createElement(material_ui_1.FontIcon, { className: "material-icons", color: colors_1.grey500, style: { fontSize: '1em' } }, "favorite")),
	                    React.createElement("div", { style: { display: 'inline-block', margin: '0 10px' } }, countryFlags.map(function (country) {
	                        return (isSelectedCountry(country.code) && (React.createElement("span", { style: draftDetailsStyle_1.styles.selectedCountry }, country.name)));
	                    })))));
	        }
	    };
	    return GlanceDraftDetails;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(GlanceDraftDetails);


/***/ },

/***/ 1011:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var GlanceRegionPublish_1 = __webpack_require__(428);
	var glance_datatypes_1 = __webpack_require__(67);
	var Tabs_1 = __webpack_require__(210);
	var Utils_1 = __webpack_require__(17);
	var Dialog_1 = __webpack_require__(55);
	var FlatButton_1 = __webpack_require__(49);
	var Constants_1 = __webpack_require__(111);
	var RestService_1 = __webpack_require__(32);
	var Snackbar_1 = __webpack_require__(42);
	var colors_1 = __webpack_require__(18);
	var GIONEE_PARTNER_ID = '59458435b8034886b62dbe672e010e064ab5aecf';
	var styles = {
	    width100: {
	        width: '100%',
	        maxWidth: 'none'
	    },
	    width50: {
	        width: '50%',
	        maxWidth: 'none'
	    },
	    dataTimeStyle: {
	        display: 'inline-block',
	        width: '50%'
	    },
	    inputStyle: {
	        color: '#505050',
	        fontSize: '0.9em'
	    },
	    region: {
	        marginLeft: '2px auto',
	        display: 'inline-block'
	    },
	    regionTab: {
	        minWidth: '70px',
	        fontSize: '12px'
	    },
	    wrapper: {
	        width: '100%',
	        display: 'flex',
	        justifyContent: 'flex-end'
	    },
	    container: {
	        backgroundColor: '#FFE59E',
	        padding: '19px',
	        borderRadius: '4px',
	        width: '386px'
	    },
	    warningText: {
	        fontSize: '14px',
	        fontWeight: 'normal',
	        lineHeight: '160%',
	        color: '#000000',
	        marginBottom: '20px'
	    },
	    warningTitle: {
	        fontSize: '14px',
	        fontWeight: 'bold',
	        lineHeight: '160%',
	        color: '#000000'
	    },
	    warningHeader: {
	        display: 'flex',
	        marginBottom: '8px'
	    },
	    warningIcon: {
	        fontSize: '24px',
	        marginRight: '8px'
	    }
	};
	function regionSort(a, b) {
	    if (a > b) {
	        return -1;
	    }
	    else {
	        return 1;
	    }
	}
	var LoadState;
	(function (LoadState) {
	    LoadState[LoadState["Loading"] = 0] = "Loading";
	    LoadState[LoadState["Loaded"] = 1] = "Loaded";
	    LoadState[LoadState["Failed"] = 2] = "Failed";
	})(LoadState || (LoadState = {}));
	var GlancePublishComponent = /** @class */ (function (_super) {
	    __extends(GlancePublishComponent, _super);
	    function GlancePublishComponent(props) {
	        var _this = _super.call(this, props) || this;
	        _this.defaultValues = {
	            durationUnit: 1 /* DAYS */,
	            duration: 2,
	            startTimeType: GlanceRegionPublish_1.StartTimeType.NOW,
	            startDate: new Date(),
	            startTime: new Date()
	        };
	        _this.userLevelDefaultValues = {
	            enabled: true,
	            durationUnit: 1 /* DAYS */,
	            duration: 1
	        };
	        _this.partnerMap = new Map();
	        _this.onTargetingRuleDeleted = function (index) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.activeRegion);
	            var _a = currentRegionPublishMeta.selectedSegmentRulesList, selectedSegmentRulesNew = _a === void 0 ? [] : _a;
	            selectedSegmentRulesNew.splice(index, 1);
	            currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedSegmentRulesList: selectedSegmentRulesNew });
	            regionPublishMeta.set(_this.activeRegion, currentRegionPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.onSegmentRuleSelected = function (value, isAdd, index) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.activeRegion);
	            var _a = currentRegionPublishMeta.selectedSegmentRulesList, selectedSegmentRulesNew = _a === void 0 ? [] : _a;
	            if (isAdd) {
	                if (selectedSegmentRulesNew[index]) {
	                    selectedSegmentRulesNew[index].push(value);
	                }
	                else {
	                    selectedSegmentRulesNew[index] = [value];
	                }
	            }
	            else {
	                selectedSegmentRulesNew[index] = selectedSegmentRulesNew[index].filter(function (selSeg) { return selSeg.ruleId !== value; });
	            }
	            currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedSegmentRulesList: selectedSegmentRulesNew });
	            regionPublishMeta.set(_this.activeRegion, currentRegionPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        _this.onSegmentRuleFromGambit = function (rule) {
	            _this.setState(__assign({}, _this.state, { segmentRules: _this.state.segmentRules.concat([rule]) }));
	        };
	        _this.onPartingTimeUpdate = function (enabled, schedule) {
	            var regionPublishMeta = _this.state.regionPublishMeta;
	            var currentRegionPublishMeta = regionPublishMeta.get(_this.activeRegion);
	            if (!enabled) {
	                schedule = null;
	            }
	            var newPublishMeta = __assign({}, currentRegionPublishMeta, { partingSchedule: schedule, isPartedGlance: enabled });
	            regionPublishMeta.set(_this.activeRegion, newPublishMeta);
	            _this.setState(__assign({}, _this.state, { regionPublishMeta: regionPublishMeta }));
	        };
	        var sortedPreferedRegions = null;
	        var defaultRegion = null;
	        if (_this.props.draft.preferedRegions) {
	            sortedPreferedRegions = _this.props.draft.preferedRegions.sort(function (a, b) {
	                return regionSort(a, b);
	            });
	            defaultRegion = sortedPreferedRegions[0];
	        }
	        var partnerSources = new Map();
	        var abPartitions = new Map();
	        var partnerMap = _this.partnerMap;
	        _this.props.studioAppConf.partners.forEach(function (partner) {
	            partnerMap.set(partner.partnerId, partner);
	        });
	        Utils_1.allRegions.forEach(function (region) {
	            partnerSources.set(region, []);
	            abPartitions.set(region, []);
	        });
	        _this.props.studioAppConf.partnerMetas.forEach(function (item) {
	            var partner = partnerMap.get(item.partnerId);
	            item.supportedRegions.forEach(function (region) {
	                partnerSources.set(region, partnerSources.get(region).concat([
	                    {
	                        text: partner.name,
	                        value: partner
	                    },
	                ]));
	            });
	            item.abConfigs
	                ? item.abConfigs.forEach(function (abConfig) {
	                    abPartitions.set(abConfig.region, abPartitions.get(abConfig.region).concat([
	                        {
	                            partnerId: partner.partnerId,
	                            abTag: abConfig.id
	                        },
	                    ]));
	                })
	                : '';
	        });
	        var regionPublishMeta = new Map();
	        Utils_1.allRegions.forEach(function (region) {
	            regionPublishMeta.set(region, {
	                partnerSources: partnerSources.get(region),
	                abMappings: abPartitions.get(region)
	            });
	        });
	        var segmentRules = (_this.props.studioAppConf.segmentTargetingRule);
	        _this.state = {
	            loadState: LoadState.Loading,
	            regionPublishMeta: regionPublishMeta,
	            snackBarOpen: false,
	            snackBarMessage: '',
	            shortTitleCheck: true,
	            cheesySummaryCheck: true,
	            publishInProgress: false,
	            segmentRules: segmentRules
	        };
	        _this.activeRegion = defaultRegion;
	        _this.handleActiveRegion = _this.handleActiveRegion.bind(_this);
	        _this.handlerPartnerAdd = _this.handlerPartnerAdd.bind(_this);
	        _this.handlerPartnerDelete = _this.handlerPartnerDelete.bind(_this);
	        _this.handlerABPartitionAdd = _this.handlerABPartitionAdd.bind(_this);
	        _this.handlerABParitionDelete = _this.handlerABParitionDelete.bind(_this);
	        _this.durationUpdate = _this.durationUpdate.bind(_this);
	        _this.onUserLevelDurationUpdate = _this.onUserLevelDurationUpdate.bind(_this);
	        _this.onPartingTimeUpdate = _this.onPartingTimeUpdate.bind(_this);
	        _this.startTimeUpdate = _this.startTimeUpdate.bind(_this);
	        _this.onPublishConfirm = _this.onPublishConfirm.bind(_this);
	        _this.closeSnackbar = _this.closeSnackbar.bind(_this);
	        _this.updateData = _this.updateData.bind(_this);
	        _this.handleExperimentVariantSelected = _this.handleExperimentVariantSelected.bind(_this);
	        _this.handleExperimentSelected = _this.handleExperimentSelected.bind(_this);
	        _this.handleExperimentVariantDelete = _this.handleExperimentVariantDelete.bind(_this);
	        return _this;
	    }
	    GlancePublishComponent.prototype.componentDidMount = function () {
	        this.updateData();
	    };
	    GlancePublishComponent.prototype.updateData = function () {
	        var _this = this;
	        var that = this;
	        that.setState(__assign({}, that.state, { loadState: LoadState.Loading }));
	        RestService_1["default"].getPublishMeta(this.props.draft.draftId, function (metas) {
	            if (metas == null) {
	                that.setState(__assign({}, that.state, { loadState: LoadState.Failed }));
	            }
	            else {
	                var regionPublishMeta_1 = _this.state.regionPublishMeta;
	                metas.forEach(function (meta) {
	                    var publishMeta = regionPublishMeta_1.get(meta.region);
	                    var regionPublishedTo = publishMeta.publishedTo;
	                    if (!regionPublishedTo) {
	                        regionPublishedTo = [];
	                    }
	                    var partner = _this.partnerMap.get(meta.partnerId);
	                    regionPublishedTo.push(partner);
	                    var partnerSources = publishMeta.partnerSources.filter(function (partnerSource) {
	                        return regionPublishedTo.indexOf(partnerSource.value) == -1;
	                    });
	                    regionPublishMeta_1.set(meta.region, __assign({}, publishMeta, { publishedTo: regionPublishedTo, partnerSources: partnerSources, publishTo: [] }));
	                });
	                that.setState(__assign({}, that.state, { regionPublishMeta: regionPublishMeta_1, loadState: LoadState.Loaded }));
	            }
	        });
	    };
	    GlancePublishComponent.prototype.handlerPartnerAdd = function (chip) {
	        if (chip.value.partnerId == GIONEE_PARTNER_ID && this.props.draft.peek) {
	            if (!this.props.draft.peek.shortTitle) {
	                this.state.shortTitleCheck = false;
	                this.setState(__assign({}, this.state));
	                return;
	            }
	            if (!this.props.draft.peek.cheesySummary) {
	                this.state.cheesySummaryCheck = false;
	                this.setState(__assign({}, this.state));
	                return;
	            }
	        }
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        var publishToPartners = currentRegionPublishMeta.publishTo;
	        if (!publishToPartners) {
	            publishToPartners = [];
	        }
	        if (publishToPartners.indexOf(chip) == -1 &&
	            currentRegionPublishMeta.partnerSources.indexOf(chip) != -1) {
	            this.state.shortTitleCheck = true;
	            this.state.cheesySummaryCheck = true;
	            publishToPartners = publishToPartners.concat([chip]);
	            var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { publishTo: publishToPartners, publishToSelected: chip.value.partnerId });
	            if (publishToPartners.length != 1 ||
	                !(publishToPartners[0].value.partnerId ==
	                    Constants_1.Partners.SAMSUNG_ANDROID_PARTNER_ID ||
	                    publishToPartners[0].value.partnerId == Constants_1.Partners.TEST_PARTNER_ID)) {
	                newCurrentRegionPublishMeta = __assign({}, newCurrentRegionPublishMeta, { userLevelDurationEnabled: false, userLevelDuration: undefined, userLevelDurationUnit: undefined });
	            }
	            regionPublishMeta.set(this.activeRegion, newCurrentRegionPublishMeta);
	            this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	        }
	    };
	    GlancePublishComponent.prototype.handleExperimentSelected = function (experimentId) {
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        var selectedExperimentMeta = null;
	        if (currentRegionPublishMeta.selectedExperiments) {
	            selectedExperimentMeta = currentRegionPublishMeta.selectedExperiments[0];
	        }
	        var experiments = [];
	        if (experimentId) {
	            var selectedExperiment = this.props.experiments.get(experimentId);
	            experiments = [
	                __assign({}, selectedExperimentMeta, { id: experimentId, variantId: selectedExperimentMeta
	                        ? selectedExperimentMeta.variantId
	                        : selectedExperiment.control.id }),
	            ];
	        }
	        currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedExperiments: experiments, selectedExperimentMetas: experiments.slice() });
	        regionPublishMeta.set(this.activeRegion, currentRegionPublishMeta);
	        this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	    };
	    GlancePublishComponent.prototype.handleExperimentVariantSelected = function (variantId, experimentId) {
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        var selectedExperiment = null;
	        var selectedExperimentMetas = currentRegionPublishMeta.selectedExperimentMetas;
	        selectedExperiment = {
	            id: experimentId,
	            variantId: variantId
	        };
	        var alreadyExists = currentRegionPublishMeta.selectedExperimentMetas.indexOf(selectedExperiment);
	        if (alreadyExists == -1) {
	            selectedExperimentMetas.push(selectedExperiment);
	        }
	        selectedExperiment = __assign({}, selectedExperiment, { variantId: variantId });
	        currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedExperimentMetas: selectedExperimentMetas });
	        regionPublishMeta.set(this.activeRegion, currentRegionPublishMeta);
	        this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	    };
	    GlancePublishComponent.prototype.handleExperimentVariantDelete = function (chip, experimentId) {
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        var selectedExperiments = currentRegionPublishMeta.selectedExperimentMetas.filter(function (item) {
	            return item.variantId != chip.id;
	        });
	        currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { selectedExperimentMetas: selectedExperiments });
	        regionPublishMeta.set(this.activeRegion, currentRegionPublishMeta);
	        this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	    };
	    GlancePublishComponent.prototype.handlerABPartitionAdd = function (chip) {
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        var currentABSelectedMappings = currentRegionPublishMeta.abSelectedMappings;
	        var currentABSelected = currentRegionPublishMeta.abSelected;
	        if (!currentABSelectedMappings) {
	            currentABSelectedMappings = [];
	        }
	        if (!currentABSelected) {
	            currentABSelected = [];
	        }
	        currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { abSelected: currentABSelected.concat([chip]), abSelectedMappings: currentABSelectedMappings.concat([chip]) });
	        regionPublishMeta.set(this.activeRegion, currentRegionPublishMeta);
	        this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	    };
	    GlancePublishComponent.prototype.handlerPartnerDelete = function (chip) {
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        if (!currentRegionPublishMeta.publishTo) {
	            return;
	        }
	        var publishToPartners = currentRegionPublishMeta.publishTo.filter(function (item) {
	            return item.value.partnerId != chip.partnerId;
	        });
	        var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { publishTo: publishToPartners, publishToSelected: null });
	        regionPublishMeta.set(this.activeRegion, newCurrentRegionPublishMeta);
	        this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	    };
	    GlancePublishComponent.prototype.handlerABParitionDelete = function (chip) {
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        var newABSelectedMappings = currentRegionPublishMeta.abSelectedMappings.filter(function (abMapping) { return abMapping != chip; });
	        var newABSelected = currentRegionPublishMeta.abSelected.filter(function (abMapping) { return abMapping != chip; });
	        currentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { abSelected: newABSelected, abSelectedMappings: newABSelectedMappings });
	        regionPublishMeta.set(this.activeRegion, currentRegionPublishMeta);
	        this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	    };
	    GlancePublishComponent.prototype.onPublishConfirm = function () {
	        this.setState(__assign({}, this.state, { publishInProgress: true }));
	        console.log('publish', this.state.regionPublishMeta.get(this.activeRegion));
	        var publishMeta = this.state.regionPublishMeta.get(this.activeRegion);
	        if (publishMeta.selectedExperiments &&
	            publishMeta.selectedExperiments.length > 0 &&
	            publishMeta.selectedExperimentMetas.length == 0) {
	            this.setState(__assign({}, this.state, { snackBarOpen: true, snackBarMessage: 'Select at least 1 variant for publishing' }));
	            return;
	        }
	        var startTimeObj;
	        var startTimeType = publishMeta.startTimeType
	            ? publishMeta.startTimeType
	            : this.defaultValues.startTimeType;
	        if (startTimeType == GlanceRegionPublish_1.StartTimeType.NOW) {
	            startTimeObj = new glance_datatypes_1.StartTime({
	                absoluteTime: new glance_datatypes_1.AbsoluteTime({
	                    timeInSecs: Math.round(new Date().getTime() / 1000)
	                })
	            });
	        }
	        else {
	            var startDate = publishMeta.startDate
	                ? publishMeta.startDate
	                : this.defaultValues.startDate;
	            var startTime = publishMeta.startTime
	                ? publishMeta.startTime
	                : this.defaultValues.startTime;
	            startTimeObj = new glance_datatypes_1.StartTime({
	                relativeTime: new glance_datatypes_1.RelativeTime({
	                    year: startDate.getFullYear(),
	                    month: startDate.getMonth() + 1,
	                    date: startDate.getDate(),
	                    hour: startTime.getHours(),
	                    minute: startTime.getMinutes()
	                })
	            });
	        }
	        var userLevelDuration = this.userLevelDefaultValues.enabled
	            ? new glance_datatypes_1.Duration({
	                unit: this.userLevelDefaultValues.durationUnit,
	                length: this.userLevelDefaultValues.duration
	            })
	            : null;
	        var glanceTime = new glance_datatypes_1.GlanceTime({
	            duration: new glance_datatypes_1.Duration({
	                unit: publishMeta.durationUnit
	                    ? publishMeta.durationUnit
	                    : this.defaultValues.durationUnit,
	                length: publishMeta.duration
	                    ? publishMeta.duration
	                    : this.defaultValues.duration
	            }),
	            startTime: startTimeObj,
	            userLevelDuration: userLevelDuration
	        });
	        var partners = [];
	        publishMeta.publishTo.forEach(function (source) {
	            partners.push(source.value);
	        });
	        var that = this;
	        var partnerIds = partners.map(function (partner) { return partner.partnerId; });
	        var hasProlongedExpiry = this.props.draft.type == 2 /* STORY */ &&
	            !Utils_1["default"].isExpiryRelaxed(partnerIds) &&
	            ((glanceTime.duration.unit == 1 /* DAYS */ &&
	                glanceTime.duration.length > 30) ||
	                (glanceTime.duration.unit == 0 /* HOURS */ &&
	                    glanceTime.duration.length > 720));
	        var isContentCards = this.props.draft.categoryIds.includes(Constants_1["default"].CONTENT_FOR_APPS);
	        var userName = this.props.studioAppConf.currentToken.user.email.split('@')[0];
	        var isContentCardAdmin = isContentCards && Constants_1["default"].CONTENT_CARDS_ADMINS.includes(userName);
	        // don't show error is type is story, category is '#content_for_apps' & user is part of content card admins
	        if (hasProlongedExpiry && !isContentCardAdmin) {
	            if (this.props.draft.frequencyCaps == null ||
	                this.props.draft.frequencyCaps.weekly == null ||
	                this.props.draft.frequencyCaps.weekly > 5) {
	                that.setState(__assign({}, that.state, { snackBarOpen: true, snackBarMessage: 'Duration Cannot be more than 72 hours for glances without frequency cap' }));
	                return;
	            }
	        }
	        RestService_1["default"].publishDraft(this.props.draft.draftId, this.activeRegion, partners, glanceTime, publishMeta.selectedExperimentMetas, publishMeta.selectedSegmentRulesList, publishMeta.isPartedGlance, publishMeta.partingSchedule, function (result, error) {
	            if (result) {
	                that.setState(__assign({}, that.state, { snackBarOpen: true, publishInProgress: false, snackBarMessage: 'Glance Published Successfully' }));
	            }
	            if (error) {
	                that.setState(__assign({}, that.state, { snackBarOpen: true, publishInProgress: false, snackBarMessage: 'Glance Publishing Failed' }));
	            }
	            that.updateData();
	        });
	    };
	    GlancePublishComponent.prototype.handleActiveRegion = function (region) {
	        this.activeRegion = region;
	        this.setState(__assign({}, this.state));
	    };
	    GlancePublishComponent.prototype.durationUpdate = function (unit, value) {
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { duration: value, durationUnit: unit });
	        regionPublishMeta.set(this.activeRegion, newCurrentRegionPublishMeta);
	        this.defaultValues = __assign({}, this.defaultValues, { duration: value, durationUnit: unit });
	        this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	    };
	    GlancePublishComponent.prototype.onUserLevelDurationUpdate = function (enabled, unit, value) {
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        if (!enabled) {
	            unit = null;
	            value = null;
	        }
	        this.userLevelDefaultValues = {
	            enabled: enabled,
	            duration: value,
	            durationUnit: unit
	        };
	        var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { userLevelDuration: value, userLevelDurationUnit: unit, userLevelDurationEnabled: enabled });
	        regionPublishMeta.set(this.activeRegion, newCurrentRegionPublishMeta);
	        this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	    };
	    GlancePublishComponent.prototype.startTimeUpdate = function (type, startDate, startTime) {
	        var regionPublishMeta = this.state.regionPublishMeta;
	        var currentRegionPublishMeta = regionPublishMeta.get(this.activeRegion);
	        var newCurrentRegionPublishMeta = __assign({}, currentRegionPublishMeta, { startTimeType: type, startDate: startDate, startTime: startTime });
	        regionPublishMeta.set(this.activeRegion, newCurrentRegionPublishMeta);
	        this.defaultValues = __assign({}, this.defaultValues, { startTimeType: type, startDate: startDate, startTime: startTime });
	        this.setState(__assign({}, this.state, { regionPublishMeta: regionPublishMeta }));
	    };
	    GlancePublishComponent.prototype.closeSnackbar = function () {
	        this.setState(__assign({}, this.state, { snackBarOpen: false }));
	    };
	    GlancePublishComponent.prototype.render = function () {
	        var _this = this;
	        var draft = this.props.draft;
	        var isDspCampaign = (draft.dspCampaignData || { isDspCampaign: false }).isDspCampaign;
	        var sortedPreferedRegions = this.sortedPreferedRegions;
	        var activeRegion = this.activeRegion;
	        if (draft.preferedRegions && draft.preferedRegions.length > 0) {
	            var newSortedPreferedRegions = draft.preferedRegions.sort(function (a, b) {
	                return regionSort(a, b);
	            });
	            if (newSortedPreferedRegions != this.sortedPreferedRegions) {
	                this.sortedPreferedRegions = newSortedPreferedRegions;
	                sortedPreferedRegions = newSortedPreferedRegions;
	                this.activeRegion = newSortedPreferedRegions[0];
	                activeRegion = newSortedPreferedRegions[0];
	            }
	        }
	        var currentRegionPublishMeta = sortedPreferedRegions
	            ? this.state.regionPublishMeta.get(activeRegion)
	            : null;
	        var publishActions = [];
	        publishActions.push(React.createElement(FlatButton_1["default"], { label: "Cancel", primary: true, onClick: this.props.closeDialog }));
	        var tabs = [];
	        if (sortedPreferedRegions) {
	            publishActions.push(React.createElement(FlatButton_1["default"], { label: 'Publish for ' + Utils_1["default"].getReadableRegionName(activeRegion), primary: true, disabled: this.state.publishInProgress ||
	                    !sortedPreferedRegions ||
	                    !currentRegionPublishMeta.publishTo ||
	                    currentRegionPublishMeta.publishTo.length == 0, onClick: this.onPublishConfirm }));
	            sortedPreferedRegions.forEach(function (region) {
	                tabs.push(React.createElement(Tabs_1.Tab, { key: region, label: React.createElement("span", { key: region }, Utils_1.regionNames[region]), value: region, style: styles.regionTab },
	                    React.createElement(GlanceRegionPublish_1.GlanceRegionPublish, { key: region, region: region, regionPublishMeta: currentRegionPublishMeta, defaultValues: _this.defaultValues, userLevelDefaultValues: _this.userLevelDefaultValues, partnerAdded: _this.handlerPartnerAdd, partnerRemoved: _this.handlerPartnerDelete, experimentAdded: _this.handleExperimentSelected, variantSelected: _this.handleExperimentVariantSelected, variantRemoved: _this.handleExperimentVariantDelete, onDurationUpdate: _this.durationUpdate, onStartTimeUpdate: _this.startTimeUpdate, onUserLevelDurationUpdate: _this.onUserLevelDurationUpdate, onPartingTimeUpdate: _this.onPartingTimeUpdate, shortTitleCheck: _this.state.shortTitleCheck, cheesySummaryCheck: _this.state.cheesySummaryCheck, partnerMetas: _this.props.studioAppConf.partnerMetas, draft: _this.props.draft, experiments: _this.props.experiments, segmentRules: _this.state.segmentRules, onSegmentRuleSelected: _this.onSegmentRuleSelected, addSegmentRuleFromGambit: _this.onSegmentRuleFromGambit, onTargetingRuleDeleted: _this.onTargetingRuleDeleted, isSettingsView: false, isDspCampaign: isDspCampaign })));
	            });
	        }
	        return (React.createElement("div", null,
	            React.createElement(Dialog_1["default"], { modal: false, open: this.props.open, onRequestClose: this.props.closeDialog, actions: publishActions, autoScrollBodyContent: true, contentStyle: { maxWidth: '1200px', width: '90%' } }, sortedPreferedRegions && this.state.loadState == LoadState.Loaded ? (React.createElement("div", null,
	                React.createElement(Tabs_1.Tabs, { value: activeRegion, onChange: this.handleActiveRegion }, tabs))) : (React.createElement("div", null,
	                !sortedPreferedRegions ? (React.createElement("div", { style: { display: 'flex', margin: '0px auto', color: colors_1.red500 } },
	                    ' ',
	                    "Add a region to draft first",
	                    ' ')) : (''),
	                !(this.state.loadState == LoadState.Loaded) ? (React.createElement("div", { style: { display: 'flex', margin: '0px auto' } }, this.state.loadState == LoadState.Loading
	                    ? 'Loading... '
	                    : 'Loaded, but some error occured. Please try to refresh.')) : ('')))),
	            React.createElement(Snackbar_1["default"], { open: this.state.snackBarOpen, message: this.state.snackBarMessage, onRequestClose: this.closeSnackbar })));
	    };
	    return GlancePublishComponent;
	}(React.Component));
	exports["default"] = GlancePublishComponent;


/***/ },

/***/ 1012:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	var React = __webpack_require__(1);
	__webpack_require__(424);
	var react_responsive_carousel_1 = __webpack_require__(401);
	var GlanceThumbnail = /** @class */ (function (_super) {
	    __extends(GlanceThumbnail, _super);
	    function GlanceThumbnail(props) {
	        return _super.call(this, props) || this;
	    }
	    GlanceThumbnail.prototype.render = function () {
	        var glanceThumbnail = (React.createElement("div", { width: '100%', height: '100%', key: 'glance-thumb-0' },
	            React.createElement("img", { width: this.props.width ? this.props.width : '100%', src: this.props.imageUrl, title: 'Glance Thumbnail Comes here', style: this.props.imageStyle })));
	        var glanceThumbnailWithOverlay = this.props.overlayImageUrl ? (React.createElement("div", { width: '100%', key: 'overlay-image-0' },
	            React.createElement("span", null,
	                React.createElement("img", { src: this.props.imageUrl, style: { margin: 'auto', display: 'block', position: 'relative', top: 0, left: 0 } }),
	                React.createElement("img", { width: '100%', src: this.props.overlayImageUrl, style: { margin: 'auto', display: 'block', position: 'absolute', top: 0, left: 0 } })))) : null;
	        var bingeGlanceThumbnail = this.props.bingeImageUrl ? (React.createElement("img", { width: '100%', key: 'binge-image-0', src: this.props.bingeImageUrl, style: this.props.imageStyle })) : null;
	        var images = [];
	        images.push(glanceThumbnail);
	        if (glanceThumbnailWithOverlay != null && this.props.shouldShowCarousal) {
	            images.push(glanceThumbnailWithOverlay);
	        }
	        if (bingeGlanceThumbnail != null && this.props.shouldShowCarousal) {
	            images.push(bingeGlanceThumbnail);
	        }
	        return (React.createElement(react_responsive_carousel_1.Carousel, { showThumbs: false, showStatus: false, autoPlay: true, infiniteLoop: true && this.props.shouldShowCarousal, showIndicators: false }, images));
	    };
	    return GlanceThumbnail;
	}(React.Component));
	exports["default"] = GlanceThumbnail;


/***/ },

/***/ 1013:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var react_lottie_1 = __webpack_require__(893);
	var RestService_1 = __webpack_require__(32);
	var LottieAnimation = /** @class */ (function (_super) {
	    __extends(LottieAnimation, _super);
	    function LottieAnimation(props) {
	        var _this = _super.call(this, props) || this;
	        _this.dataHandler = function (result) {
	            _this.setState({
	                lottieData: result
	            });
	        };
	        _this.setData = function () {
	            RestService_1["default"].getCDNData(function (result) {
	                // console.log(result);
	                _this.dataHandler(result);
	            }, _this.props.url);
	        };
	        _this.state = {
	            lottieData: null
	        };
	        return _this;
	    }
	    LottieAnimation.prototype.componentDidMount = function () {
	        this.setData();
	    };
	    LottieAnimation.prototype.render = function () {
	        return (React.createElement(react_lottie_1["default"], { options: {
	                loop: true,
	                autoplay: true,
	                animationData: this.state.lottieData,
	                rendererSettings: {
	                    preserveAspectRatio: 'xMidYMid slice'
	                }
	            }, height: 32, width: 32 }));
	    };
	    return LottieAnimation;
	}(React.Component));
	exports.LottieAnimation = LottieAnimation;


/***/ },

/***/ 1014:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var material_ui_1 = __webpack_require__(38);
	var colors_1 = __webpack_require__(18);
	var React = __webpack_require__(1);
	var draftDetailsStyle_1 = __webpack_require__(247);
	var css = {
	    main: {
	        display: 'flex',
	        flexDirection: 'column',
	        justifyContent: 'space-between'
	    },
	    table: {
	        display: 'flex',
	        flexDirection: 'row',
	        justifyContent: 'flex-start'
	    },
	    tableRowColumn: {
	        width: '120px',
	        display: 'flex',
	        flexDirection: 'row',
	        justifyContent: 'space-between'
	    },
	    column: {
	        width: '135px',
	        textTransform: 'capitalize'
	    },
	    dropDown: {
	        display: 'flex',
	        flexDirection: 'row',
	        justifyContent: 'flex-start',
	        alignItems: 'flex-end',
	        width: '100%',
	        flexWrap: 'wrap'
	    },
	    dropDownMenu: {
	        width: '160px',
	        height: '45px',
	        margin: '10px 20px 10px 0',
	        paddingLeft: '0'
	    },
	    schedule: {
	        display: 'flex',
	        flexDirection: 'row',
	        justifyContent: 'flex-start',
	        width: 'fit-content',
	        alignItems: 'flex-end',
	        border: 'grey solid 1px',
	        borderRadius: '10px',
	        margin: '10px'
	    },
	    textField: {
	        width: '60px',
	        padding: '10px'
	    },
	    autoWidth: {
	        width: 'auto'
	    },
	    paddingLeft0: { paddingLeft: '0' },
	    to: { padding: '0 5px' }
	};
	var DAYS = [
	    'MONDAY',
	    'TUESDAY',
	    'WEDNESDAY',
	    'THURSDAY',
	    'FRIDAY',
	    'SATURDAY',
	    'SUNDAY',
	];
	var PartingTimeSelection = /** @class */ (function (_super) {
	    __extends(PartingTimeSelection, _super);
	    function PartingTimeSelection(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleSelectedDayChange = function (event, index, value) {
	            _this.setState(__assign({}, _this.state, { selectedDay: value }));
	        };
	        _this.updateAllDays = function () {
	            var selectedDayData = _this.props.partingSchedule[_this.state.selectedDay];
	            Object.keys(_this.props.partingSchedule).forEach(function (eachDay) {
	                selectedDayData.forEach(function (selTime, index) {
	                    _this.props.handlePartingDataChange(eachDay, index, selTime.startTime, selTime.endTime);
	                });
	            });
	        };
	        _this.handleTimeChange = function (type, event, value) {
	            var index = event.currentTarget.dataset.index;
	            var startTime, endTime;
	            if (type === 'start') {
	                startTime = value;
	                endTime = _this.props.partingSchedule[_this.state.selectedDay][index]
	                    .endTime;
	            }
	            if (type === 'end') {
	                endTime = value;
	                startTime = _this.props.partingSchedule[_this.state.selectedDay][index]
	                    .startTime;
	            }
	            if (startTime <= 24 && endTime <= 24) {
	                _this.props.handlePartingDataChange(_this.state.selectedDay, index, startTime, endTime);
	            }
	            if (_this.state.isAllDaysSelected) {
	                _this.updateAllDays();
	            }
	        };
	        _this.removeSlot = function (event) {
	            var index = event.currentTarget.dataset.index;
	            if (_this.state.isAllDaysSelected) {
	                Object.keys(_this.props.partingSchedule).forEach(function (eachDay) {
	                    _this.props.handleRemoveSlot(eachDay, index);
	                });
	            }
	            else {
	                _this.props.handleRemoveSlot(_this.state.selectedDay, index);
	            }
	        };
	        _this.addMoreSlot = function (e) {
	            var newIndex = _this.props.partingSchedule[_this.state.selectedDay].length;
	            if (_this.state.isAllDaysSelected) {
	                Object.keys(_this.props.partingSchedule).forEach(function (eachDay) {
	                    _this.props.handlePartingDataChange(eachDay, newIndex, 0, 0);
	                });
	            }
	            else {
	                _this.props.handlePartingDataChange(_this.state.selectedDay, newIndex, 0, 0);
	            }
	        };
	        _this.toggleAllDays = function (checked) {
	            _this.setState(__assign({}, _this.state, { isAllDaysSelected: checked }));
	            _this.updateAllDays();
	        };
	        _this.state = {
	            selectedDay: 'MONDAY',
	            slotsArray: _this.props.partingSchedule['MONDAY']
	        };
	        return _this;
	    }
	    PartingTimeSelection.prototype.render = function () {
	        var _this = this;
	        var daysElement = [];
	        var _a = this.props, partingSchedule = _a.partingSchedule, isPartedGlance = _a.isPartedGlance;
	        Object.keys(partingSchedule).forEach(function (key) {
	            daysElement.push(React.createElement(material_ui_1.TableRow, null,
	                React.createElement("div", { style: css.table },
	                    React.createElement(material_ui_1.TableRowColumn, { style: css.column }, key),
	                    partingSchedule[key].map(function (slot) { return (React.createElement(material_ui_1.TableRowColumn, { style: css.tableRowColumn },
	                        React.createElement("div", null,
	                            slot.startTime,
	                            ":00"),
	                        " - ",
	                        React.createElement("div", null,
	                            slot.endTime,
	                            ":00"))); }))));
	        });
	        return (React.createElement("div", { style: css.main },
	            React.createElement(material_ui_1.TableBody, { key: "partingTimeTableBody", displayRowCheckbox: false, style: __assign({}, draftDetailsStyle_1.styles.width100) }, daysElement),
	            React.createElement(material_ui_1.Toggle, { label: "All Days", labelPosition: "right", onToggle: function (e, checked) { return _this.toggleAllDays(checked); }, style: { width: '130px' } }),
	            React.createElement("div", { style: css.dropDown },
	                React.createElement(material_ui_1.DropDownMenu, { value: this.state.selectedDay, onChange: this.handleSelectedDayChange, style: css.dropDownMenu },
	                    React.createElement(material_ui_1.MenuItem, { value: null, primaryText: 'Day' }),
	                    DAYS.map(function (item) {
	                        return (React.createElement(material_ui_1.MenuItem, { value: item, primaryText: item, style: css.paddingLeft0 }));
	                    })),
	                partingSchedule[this.state.selectedDay].map(function (slot, key) { return (React.createElement("div", { style: css.schedule },
	                    React.createElement(material_ui_1.TextField, { key: "startTime", value: slot.startTime, inputStyle: { width: '100%' }, "data-index": key, onChange: function (e, value) {
	                            _this.handleTimeChange('start', e, value);
	                        }, style: css.textField, type: "number", fullWidth: false }),
	                    React.createElement("p", { style: css.to }, " to "),
	                    React.createElement(material_ui_1.TextField, { key: "endTime", value: slot.endTime, name: "endTime", "data-index": key, onChange: function (e, value) {
	                            _this.handleTimeChange('end', e, value);
	                        }, style: css.textField, type: "number", fullWidth: false }),
	                    React.createElement(material_ui_1.FontIcon, { onClick: _this.removeSlot, "data-index": key, className: "material-icons", color: colors_1.grey500, style: { width: '26px', height: '32px', margin: '0 20px' } }, "delete"))); }),
	                React.createElement(material_ui_1.FontIcon, { onClick: this.addMoreSlot, className: "material-icons", color: colors_1.cyan500, style: {
	                        width: '26px',
	                        height: '48px',
	                        padding: '0',
	                        margin: '0 20px'
	                    } }, "add_box"))));
	    };
	    return PartingTimeSelection;
	}(React.Component));
	exports["default"] = PartingTimeSelection;


/***/ },

/***/ 1015:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var colors_1 = __webpack_require__(18);
	exports.selectedColor = colors_1.blue300;
	exports.warningColor = colors_1.yellowA700;
	exports.styles = {
	    chip: {
	        margin: 3
	    },
	    footer: {
	        position: 'fixed',
	        bottom: '0px',
	        paddingBottom: '10px',
	        paddingTop: '10px',
	        zIndex: 10,
	        width: '90%',
	        display: 'inline-flex',
	        justifyContent: 'center',
	        zoom: 0.8,
	        maxWidth: '1750px',
	        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, visibility 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
	    },
	    regionTab: {
	        minWidth: '70px',
	        fontSize: '12px'
	    },
	    loadMoreStyleContainer: {
	        margin: '10px 0px',
	        textAlign: 'center'
	    },
	    draftLinkForm: {
	        display: "grid",
	        gridGap: "10px",
	        gridTemplateColumns: "1fr 50px",
	        gridTemplateRows: "1fr 1fr"
	    },
	    draftLinkText: {
	        width: 'auto',
	        minWidth: 'none',
	        overflow: 'hidden',
	        gridColumn: 1,
	        gridRow: 1
	    },
	    alertMessage: {
	        color: '#E0B32D',
	        display: 'flex',
	        alignItems: 'flex-start',
	        gridColumn: 1,
	        gridRow: 2
	    },
	    draftCTA: {
	        gridColumn: 2,
	        gridRowStart: 1,
	        gridRowEnd: 3,
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        paddingBottom: "30px"
	    }
	};
	exports["default"] = exports.styles;


/***/ },

/***/ 1016:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	var React = __webpack_require__(1);
	var material_ui_1 = __webpack_require__(38);
	var Utils_1 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var styles = {
	    dialogContentStyle: {
	        width: '400px'
	    },
	    addNewButton: {
	        position: 'absolute',
	        zIndex: 1
	    }
	};
	var EditSegmentQuery = /** @class */ (function (_super) {
	    __extends(EditSegmentQuery, _super);
	    function EditSegmentQuery(props) {
	        var _this = _super.call(this, props) || this;
	        _this.onSegmentQueryChange = function (key, value) {
	            var _a;
	            _this.setState(__assign({}, _this.state, (_a = {}, _a[key] = value, _a)));
	        };
	        _this.editSegmentQuery = function (a) {
	            var _a = _this.state, segmentQuery = _a.segmentQuery, email = _a.email, segmentExpiryDate = _a.segmentExpiryDate, endAt = _a.endAt;
	            var _b = _this.props, segmentQueryData = _b.segmentQueryData, updateSegmentQuery = _b.updateSegmentQuery, showSnackbarMessage = _b.showSnackbarMessage;
	            var source = segmentQueryData.source;
	            if ((!segmentQuery && source && (source === "query" || source === "staticquery"))) {
	                showSnackbarMessage("Query field is mandatory for " + source + " source.");
	                return;
	            }
	            _this.setState(__assign({}, _this.state, { processing: true }));
	            var payload = {
	                segmentId: segmentQueryData.segmentId,
	                query: segmentQuery ? segmentQuery.replace(/[\r\n]+/gm, ' ') : '',
	                lastUpdatedBy: _this.props.studioAppConfig.currentToken.user.name,
	                expireAt: Utils_1["default"].getDateInYyyyMmDd(segmentExpiryDate),
	                endAt: Utils_1["default"].getDateInYyyyMmDd(endAt),
	                email: email
	            };
	            updateSegmentQuery(payload);
	        };
	        _this.handleEndAt = function (value) {
	            var expiry = new Date(value);
	            expiry.setDate(expiry.getDate() + 1);
	            _this.setState(__assign({}, _this.state, { segmentExpiryDate: expiry, endAt: value }));
	        };
	        _this.handleExpiryDate = function (value) {
	            var _a = _this.props.segmentQueryData, source = _a.source, expireAt = _a.expireAt;
	            var expireAtObj = new Date(expireAt);
	            if (source === "staticquery") {
	                if (expireAtObj > _this.props.today) {
	                    _this.onSegmentQueryChange('segmentExpiryDate', value);
	                }
	                else {
	                    _this.props.showSnackbarMessage("No Modifications!! Today's date is passed the expiration date");
	                    _this.onSegmentQueryChange('segmentExpiryDate', expireAtObj);
	                }
	            }
	            else
	                _this.onSegmentQueryChange('segmentExpiryDate', expireAtObj);
	        };
	        var segmentQueryData = _this.props.segmentQueryData;
	        _this.state = {
	            processing: false,
	            segmentQuery: segmentQueryData.query,
	            segmentExpiryDate: new Date(segmentQueryData.expireAt),
	            email: segmentQueryData.email,
	            endAt: new Date(segmentQueryData.endAt)
	        };
	        return _this;
	    }
	    EditSegmentQuery.prototype.componentWillReceiveProps = function (nextProps) {
	        var _this = this;
	        var handleClose = nextProps.handleClose, segmentQueryData = nextProps.segmentQueryData;
	        this.setState(function (state, props) { return (__assign({}, _this.state, { segmentQuery: segmentQueryData.query, email: segmentQueryData.email, segmentExpiryDate: new Date(segmentQueryData.expireAt), endAt: new Date(segmentQueryData.endAt), processing: false })); });
	    };
	    EditSegmentQuery.prototype.render = function () {
	        var _this = this;
	        var _a = this.state, segmentQuery = _a.segmentQuery, email = _a.email, processing = _a.processing, segmentExpiryDate = _a.segmentExpiryDate, endAt = _a.endAt;
	        var _b = this.props, handleClose = _b.handleClose, editDialogOpen = _b.editDialogOpen, segmentQueryData = _b.segmentQueryData, addMonths = _b.addMonths, today = _b.today;
	        var endDate = new Date(segmentQueryData.endAt);
	        var expiryAt = new Date(segmentQueryData.expireAt);
	        var todayDate = new Date();
	        todayDate.setHours(0, 0, 0, 0);
	        var actions = [
	            React.createElement(material_ui_1.FlatButton, { label: "Cancel", primary: true, onClick: handleClose }),
	            React.createElement(material_ui_1.FlatButton, { label: "Update", primary: true, onClick: this.editSegmentQuery, disabled: processing }),
	        ];
	        return (React.createElement(material_ui_1.Dialog, { actions: actions, modal: false, open: editDialogOpen, onRequestClose: handleClose, autoScrollBodyContent: true, contentStyle: styles.dialogContentStyle },
	            React.createElement(material_ui_1.TextField, { id: "segmentId", fullWidth: true, value: segmentQueryData.segmentId, floatingLabelText: "Segment Id", disabled: true }),
	            React.createElement(material_ui_1.TextField, { id: "segmentName", fullWidth: true, value: segmentQueryData.segmentName, floatingLabelText: "Segment Name", disabled: true }),
	            React.createElement(material_ui_1.TextField, { id: "target", fullWidth: true, value: segmentQueryData.target, floatingLabelText: "Target", disabled: true }),
	            React.createElement(material_ui_1.TextField, { id: "source", fullWidth: true, value: segmentQueryData.source, floatingLabelText: "Source", disabled: true }),
	            segmentQueryData.source != "staticquery" ?
	                React.createElement("div", null,
	                    React.createElement("div", null, "Starts At:"),
	                    React.createElement(material_ui_1.DatePicker, { value: new Date(segmentQueryData.startAt), container: "inline", fullWidth: true, disabled: true }),
	                    React.createElement("div", null, "Ends At:"),
	                    React.createElement(material_ui_1.DatePicker, { value: new Date(endAt), maxDate: addMonths(today), container: "inline", fullWidth: true, onChange: function (_e, value) { return _this.handleEndAt(value); }, disabled: segmentQueryData.source === 'staticquery' || endDate < todayDate }))
	                : React.createElement("div", null,
	                    React.createElement("div", null, "Run Date:"),
	                    React.createElement(material_ui_1.DatePicker, { value: new Date(segmentQueryData.startAt), hintText: "Run Date", container: "inline", fullWidth: true, disabled: true })),
	            React.createElement("div", null, "Expiry Date:"),
	            React.createElement(material_ui_1.DatePicker, { value: new Date(segmentExpiryDate), maxDate: addMonths(today), hintText: "Expiry Date", container: "inline", fullWidth: true, onChange: function (_e, value) { return _this.handleExpiryDate(value); }, disabled: segmentQueryData.source !== 'staticquery' || expiryAt < todayDate }),
	            React.createElement(material_ui_1.TextField, { id: "editQuery", floatingLabelText: "Query", value: segmentQuery, multiLine: true, rows: 3, fullWidth: true, rowsMax: 4, disabled: processing, onChange: function (e, value) {
	                    return _this.onSegmentQueryChange('segmentQuery', value);
	                } }),
	            React.createElement(material_ui_1.TextField, { id: "editEmail", fullWidth: true, value: email, floatingLabelText: "Email Address", onChange: function (e, value) { return _this.onSegmentQueryChange('email', value); } }),
	            React.createElement(material_ui_1.Toggle, { label: "Status", toggled: segmentQueryData.active, disabled: true })));
	    };
	    return EditSegmentQuery;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(EditSegmentQuery);


/***/ },

/***/ 1017:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	exports.__esModule = true;
	__webpack_require__(110);
	var React = __webpack_require__(1);
	var react_bootstrap_table_1 = __webpack_require__(217);
	var material_ui_1 = __webpack_require__(38);
	var EditSegmentQuery_1 = __webpack_require__(1016);
	var JerseyRestApiService_1 = __webpack_require__(83);
	var Snackbar_1 = __webpack_require__(42);
	var Utils_1 = __webpack_require__(17);
	var react_redux_1 = __webpack_require__(24);
	var styles = {
	    dialogContentStyle: {
	        width: '400px'
	    },
	    addNewButton: {
	        position: 'absolute',
	        zIndex: 1
	    },
	    SegmentSource: {
	        marginleft: '-24px'
	    },
	    SegmentTarget: {
	        marginLeft: '-24px'
	    }
	};
	var SegmentQuery = /** @class */ (function (_super) {
	    __extends(SegmentQuery, _super);
	    function SegmentQuery(props) {
	        var _this = _super.call(this, props) || this;
	        _this.setUser = function () {
	            if (_this.props.studioAppConfig) {
	                _this.setState(__assign({}, _this.state, { createdBy: _this.props.studioAppConfig.currentToken.user.name, email: _this.props.studioAppConfig.currentToken.user.email }));
	            }
	        };
	        _this.getSegmentQuery = function () {
	            JerseyRestApiService_1["default"].getSegmentQueries()
	                .then(function (response) {
	                _this.setState(__assign({}, _this.state, { segmentQuery: response }));
	            })["catch"](function (err) {
	                _this.setState(__assign({}, _this.state, { segmentQuery: [
	                        {
	                            segmentId: 'cs_d10e403fa4',
	                            segmentName: 'tamil subscribers',
	                            source: 'query',
	                            target: 'GLANCE FEED',
	                            createdAt: '2019-11-13T08:35:14.214638Z',
	                            updatedAt: '2019-11-13T08:35:14.214682Z',
	                            startAt: '2019-11-13',
	                            endAt: '2019-12-13',
	                            expireAt: '2019-13-13',
	                            active: false,
	                            query: "select userid from glance_analytics_prod_in.user_pq u  where enabledstate=true and contains(preferredcategories,'#tamil') and date(process_date)=DATE(CURRENT_TIMESTAMP - Interval '1' day)",
	                            createdBy: 'abcd'
	                        },
	                        {
	                            segmentId: 'cs_db5f20c267',
	                            segmentName: 'hindi subscribers',
	                            source: 'query',
	                            target: 'GLANCE FEED',
	                            createdAt: '2019-11-13T08:35:36.004438Z',
	                            updatedAt: '2019-11-13T08:35:36.004482Z',
	                            startAt: '2019-11-13',
	                            endAt: '2019-12-13',
	                            expireAt: '2019-13-13',
	                            active: false,
	                            query: "select userid from glance_analytics_prod_in.user_pq u  where enabledstate=true and contains(preferredcategories,'#hindi') and date(process_date)=DATE(CURRENT_TIMESTAMP - Interval '1' day)",
	                            createdBy: 'abcd'
	                        },
	                    ] }));
	            });
	        };
	        _this.getAllSegmentSource = function () {
	            JerseyRestApiService_1["default"].getAllSegmentSource()
	                .then(function (response) {
	                _this.setState(__assign({}, _this.state, { segmentSources: response }));
	            })["catch"](function (err) {
	                _this.setState(__assign({}, _this.state, { segmentSources: [] }));
	            });
	        };
	        _this.getAllSegmentTargets = function () {
	            JerseyRestApiService_1["default"].getAllSegmentTargets()
	                .then(function (response) {
	                _this.setState(__assign({}, _this.state, { segmentTargets: response }));
	            })["catch"](function (err) {
	                _this.setState(__assign({}, _this.state, { segmentTargets: [] }));
	            });
	        };
	        _this.handleClose = function () {
	            _this.setState(__assign({}, _this.state, { dialogOpen: false }));
	        };
	        _this.handleEditClose = function () {
	            _this.setState(__assign({}, _this.state, { editDialogOpen: false }));
	        };
	        _this.handleSnackbarClose = function () {
	            _this.setState(__assign({}, _this.state, { openSnackBar: false }));
	        };
	        _this.showSnackbarMessage = function (message) {
	            _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: message }));
	        };
	        _this.reset = function () {
	            var today = _this.state.today;
	            _this.setState(__assign({}, _this.state, { dialogOpen: false, name: '', source: null, target: null, query: '', startAt: today, endAt: today, expireAt: null }));
	        };
	        _this.openCreateSegmentQueryModal = function () {
	            _this.setState(__assign({}, _this.state, { dialogOpen: true }));
	        };
	        _this.createSegmentQuery = function () {
	            var _a = _this.state, name = _a.name, source = _a.source, query = _a.query, target = _a.target, startAt = _a.startAt, endAt = _a.endAt, expireAt = _a.expireAt, createdBy = _a.createdBy, email = _a.email;
	            if (!source) {
	                _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: 'Please select query source' }));
	                return;
	            }
	            else if ((source === "query" || source === "staticquery") && !query) {
	                _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: "Query field is mandatory for " + source + " source." }));
	                return;
	            }
	            _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: 'Creating new segment query...' }));
	            var expiry;
	            if (source !== "staticquery") {
	                expiry = new Date(endAt);
	                expiry.setDate(expiry.getDate() + 1);
	            }
	            else if (expireAt) {
	                expiry = new Date(expireAt);
	            }
	            else {
	                _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: 'Expiry Date is Mandatory for Static query' }));
	                return;
	            }
	            if (!email) {
	                _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: 'Email field is mandatory for all sources.' }));
	                return;
	            }
	            if (!target) {
	                _this.setState(__assign({}, _this.state, { openSnackBar: true, snackBarMessage: 'Please select query target.' }));
	                return;
	            }
	            var payload = {
	                segmentName: name,
	                source: source,
	                target: target,
	                query: query.replace(/[\r\n]+/gm, ' '),
	                startAt: Utils_1["default"].getDateInYyyyMmDd(startAt),
	                endAt: Utils_1["default"].getDateInYyyyMmDd(endAt),
	                expireAt: Utils_1["default"].getDateInYyyyMmDd(expiry),
	                email: email,
	                createdBy: createdBy
	            };
	            JerseyRestApiService_1["default"].addSegmentQuery(payload)
	                .then(function (response) {
	                _this.setState(__assign({}, _this.state, { dialogOpen: false, source: null, target: null, name: '', query: '', snackBarMessage: response.segmentId + ' successfully created' }));
	                _this.getSegmentQuery();
	                _this.reset();
	            })["catch"](function (err) {
	                _this.reset();
	            });
	        };
	        _this.updateSegmentQuery = function (payload) {
	            JerseyRestApiService_1["default"].updateSegmentQuery(payload)
	                .then(function (response) {
	                _this.setState(__assign({}, _this.state, { editDialogOpen: false, snackBarMessage: response.segmentId + ' successfully Updated' }));
	                _this.getSegmentQuery();
	                _this.reset();
	            })["catch"](function (err) {
	                _this.reset();
	            });
	        };
	        _this.onSegmentQueryChange = function (key, value) {
	            var _a;
	            _this.setState(__assign({}, _this.state, (_a = {}, _a[key] = value, _a)));
	        };
	        _this.formatStatus = function (cell) {
	            return cell ? 'Active' : 'Inactive';
	        };
	        _this.formatOverflow = function (cell) {
	            return (React.createElement("div", { style: {
	                    overflow: 'visible',
	                    whiteSpace: 'normal'
	                } }, cell));
	        };
	        _this.onClickProductSelected = function (cell, row, rowIndex) {
	            console.log('Product : ', row);
	            _this.setState(__assign({}, _this.state, { editDialogOpen: true, selectedSegmentQuery: row }));
	        };
	        _this.cellButton = function (cell, row, enumObject, rowIndex) {
	            return (React.createElement("div", { style: {
	                    overflow: 'visible',
	                    whiteSpace: 'normal',
	                    color: 'rgb(0, 188, 212)',
	                    cursor: 'pointer'
	                }, onClick: function () { return _this.onClickProductSelected(cell, row, rowIndex); } }, cell));
	        };
	        _this.handleRunDate = function (value) {
	            _this.setState(__assign({}, _this.state, { startAt: value, endAt: value }));
	        };
	        _this.addMonths = function (value) {
	            var date = new Date(value);
	            date.setMonth(date.getMonth() + 3);
	            return date;
	        };
	        _this.handleSourceChange = function (value) {
	            _this.setState(__assign({}, _this.state, { endAt: _this.state.startAt, expireAt: null, source: value }));
	        };
	        _this.handleTargetChange = function (value) {
	            _this.setState(__assign({}, _this.state, { endAt: _this.state.startAt, expireAt: null, target: value }));
	        };
	        _this.state = {
	            segmentQuery: [],
	            segmentSources: [],
	            segmentTargets: [],
	            openSnackBar: false,
	            snackBarMessage: '',
	            dialogOpen: false,
	            editDialogOpen: false,
	            isCreating: false,
	            name: '',
	            source: null,
	            target: null,
	            query: '',
	            startAt: new Date(),
	            endAt: new Date(),
	            expireAt: null,
	            createdBy: '',
	            email: _this.props.studioAppConfig.currentToken.user.email,
	            selectedSegmentQuery: {},
	            today: new Date()
	        };
	        return _this;
	    }
	    SegmentQuery.prototype.componentDidMount = function () {
	        this.setUser();
	        this.getSegmentQuery();
	        this.getAllSegmentSource();
	        this.getAllSegmentTargets();
	    };
	    SegmentQuery.prototype.render = function () {
	        var _this = this;
	        var _a = this.state, segmentQuery = _a.segmentQuery, segmentSources = _a.segmentSources, segmentTargets = _a.segmentTargets, dialogOpen = _a.dialogOpen, editDialogOpen = _a.editDialogOpen, isCreating = _a.isCreating, name = _a.name, source = _a.source, target = _a.target, query = _a.query, startAt = _a.startAt, endAt = _a.endAt, expireAt = _a.expireAt, email = _a.email, selectedSegmentQuery = _a.selectedSegmentQuery, today = _a.today;
	        var actions = [
	            React.createElement(material_ui_1.FlatButton, { label: "Cancel", primary: true, onTouchTap: this.handleClose }),
	            React.createElement(material_ui_1.FlatButton, { label: "Create", primary: true, onTouchTap: this.createSegmentQuery, disabled: isCreating }),
	        ];
	        return (React.createElement("div", { style: { marginTop: '40px', width: '100%' } },
	            React.createElement("div", { style: styles.addNewButton },
	                React.createElement(material_ui_1.RaisedButton, { primary: true, label: "Add New Query", onTouchTap: this.openCreateSegmentQueryModal })),
	            React.createElement("div", null,
	                React.createElement(react_bootstrap_table_1.BootstrapTable, { ref: "table", data: segmentQuery, hover: true, search: { type: 'TextSearch' }, pagination: true },
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { isKey: true, dataField: "segmentId", width: "10%", height: "100px", dataFormat: this.cellButton.bind(this) }, "Segment ID"),
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "segmentName", width: "12%", dataFormat: this.formatOverflow }, "Segment Name"),
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "startAt", width: "10%", dataFormat: this.formatOverflow }, "Start At"),
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "endAt", width: "10%", dataFormat: this.formatOverflow }, "End At"),
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "expireAt", width: "10%", dataFormat: this.formatOverflow }, "Expiry Date"),
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "active", dataFormat: this.formatStatus, width: "8%" }, "Status"),
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "createdBy", width: "10%", dataFormat: this.formatOverflow }, "Created By"),
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "source", width: "8%", dataFormat: this.formatOverflow }, "Source"),
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "target", width: "8%", dataFormat: this.formatOverflow }, "Target"),
	                    React.createElement(react_bootstrap_table_1.TableHeaderColumn, { dataField: "query", width: "30%", dataFormat: this.formatOverflow }, "Query")),
	                React.createElement(Snackbar_1["default"], { open: this.state.openSnackBar, message: this.state.snackBarMessage, autoHideDuration: 2000 })),
	            React.createElement(material_ui_1.Dialog, { actions: actions, modal: false, open: dialogOpen, onRequestClose: this.handleClose, autoScrollBodyContent: true, contentStyle: styles.dialogContentStyle },
	                React.createElement(material_ui_1.TextField, { id: "segmentName", fullWidth: true, value: name, floatingLabelText: "Segment Name", onChange: function (e, value) { return _this.onSegmentQueryChange('name', value); } }),
	                React.createElement(material_ui_1.DropDownMenu, { value: target, onChange: function (field, context, value) { return _this.handleTargetChange(value); }, className: "dropDownMenu" },
	                    React.createElement(material_ui_1.MenuItem, { value: null, primaryText: "Select Target" }),
	                    segmentTargets
	                        .map(function (segmentTarget) {
	                        return (React.createElement(material_ui_1.MenuItem, { key: "target-" + segmentTarget, value: segmentTarget, primaryText: segmentTarget }));
	                    })),
	                React.createElement(material_ui_1.DropDownMenu, { value: source, onChange: function (field, context, value) { return _this.handleSourceChange(value); }, className: "dropDownMenu" },
	                    React.createElement(material_ui_1.MenuItem, { value: null, primaryText: "Select Source" }),
	                    segmentSources
	                        .map(function (segmentSource) {
	                        return (React.createElement(material_ui_1.MenuItem, { key: "source-" + segmentSource, value: segmentSource, primaryText: segmentSource }));
	                    })),
	                this.state.source != "staticquery" ?
	                    React.createElement("div", null,
	                        React.createElement("div", null, "Starts At:"),
	                        React.createElement(material_ui_1.DatePicker, { value: startAt, minDate: today, hintText: "Starts At", container: "inline", fullWidth: true, onChange: function (e, value) { return _this.onSegmentQueryChange('startAt', value); } }),
	                        React.createElement("div", null, "Ends At:"),
	                        React.createElement(material_ui_1.DatePicker, { value: endAt, minDate: startAt, maxDate: this.addMonths(today), hintText: "Ends At", container: "inline", fullWidth: true, onChange: function (e, value) { return _this.onSegmentQueryChange('endAt', value); } }))
	                    :
	                        React.createElement("div", null,
	                            React.createElement("div", null, "Run Date:"),
	                            React.createElement(material_ui_1.DatePicker, { value: startAt, minDate: today, hintText: "Run Date", container: "inline", fullWidth: true, onChange: function (_e, value) { return _this.handleRunDate(value); } }),
	                            React.createElement("div", null, "Expiry Date:"),
	                            React.createElement(material_ui_1.DatePicker, { value: expireAt, minDate: today, maxDate: this.addMonths(today), container: "inline", fullWidth: true, onChange: function (_e, value) { return _this.onSegmentQueryChange('expireAt', value); }, disabled: this.state.source != "staticquery" ? true : false })),
	                React.createElement(material_ui_1.TextField, { id: "createQuery", floatingLabelText: "Query", value: query, multiLine: true, rows: 3, fullWidth: true, rowsMax: 4, onChange: function (e, value) { return _this.onSegmentQueryChange('query', value); } }),
	                React.createElement(material_ui_1.TextField, { id: "createEmail", fullWidth: true, value: email, floatingLabelText: "Email Address", onChange: function (e, value) { return _this.onSegmentQueryChange('email', value); } }),
	                React.createElement(material_ui_1.Toggle, { label: "Status", toggled: false, disabled: true })),
	            React.createElement(EditSegmentQuery_1["default"], { editDialogOpen: editDialogOpen, handleClose: this.handleEditClose, updateSegmentQuery: this.updateSegmentQuery, segmentQueryData: selectedSegmentQuery, showSnackbarMessage: this.showSnackbarMessage, addMonths: this.addMonths, today: today }),
	            React.createElement(Snackbar_1["default"], { open: this.state.openSnackBar, message: this.state.snackBarMessage, onRequestClose: this.handleSnackbarClose, autoHideDuration: 2000 })));
	    };
	    return SegmentQuery;
	}(React.Component));
	var mapStateToProps = function (state) {
	    return {
	        studioAppConfig: state.studioAppConfig
	    };
	};
	exports["default"] = react_redux_1.connect(mapStateToProps)(SegmentQuery);


/***/ },

/***/ 1018:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var actionTypes_1 = __webpack_require__(426);
	var Constants_1 = __webpack_require__(111);
	var initialStudioAppConfigState = {
	    cdnPrefix: Constants_1["default"].CDN_PREFIX,
	    currentToken: {},
	    partners: [],
	    partnerMetas: [],
	    publishers: [],
	    categories: [],
	    experiments: [],
	    cities: [],
	    segments: [],
	    glanceLanguages: [],
	    sqlSegments: [],
	    segmentTargetingRule: [],
	    apps: [],
	    bubbles: [],
	    carrierMetas: []
	};
	function studioAppConfig(state, action) {
	    if (state === void 0) { state = initialStudioAppConfigState; }
	    switch (action.type) {
	        case actionTypes_1.FETCH_STUDIO_APP_CONF_SUCCESS:
	            return action.studioAppConfig;
	        case actionTypes_1.FETCH_STUDIO_APP_CONF_IS_LOADING:
	        case actionTypes_1.FETCH_STUDIO_APP_CONF_HAS_ERRORED:
	        default:
	            return state;
	    }
	}
	exports.studioAppConfig = studioAppConfig;


/***/ },

/***/ 1019:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var redux_1 = __webpack_require__(245);
	var draftsReducer_1 = __webpack_require__(1018);
	var rootReducer = redux_1.combineReducers({
	    studioAppConfig: draftsReducer_1.studioAppConfig
	});
	exports["default"] = rootReducer;


/***/ },

/***/ 1020:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	exports.__esModule = true;
	var redux_1 = __webpack_require__(245);
	var reducers_1 = __webpack_require__(1019);
	var redux_thunk_1 = __webpack_require__(957);
	function configureStore(initialState) {
	    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
	    return redux_1.createStore(reducers_1["default"], initialState, composeEnhancers(redux_1.applyMiddleware(redux_thunk_1["default"])));
	}
	exports["default"] = configureStore;


/***/ }

});


// WEBPACK FOOTER //
// main.js